export default [
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T17:39:55.000Z',
        end_time: '2026-07-29T17:40:55.000Z',
        latitude: 37.788396,
        longitude: -122.3871403,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T17:39:55.000Z',
        end_time: '2026-07-29T17:40:55.000Z',
        latitude: 37.788396,
        longitude: -122.3871403,
        density: 52.63157894736842,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T17:39:55.000Z',
        end_time: '2026-07-29T17:40:55.000Z',
        latitude: 37.788396,
        longitude: -122.3871403,
        density: 72.52543201709108,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T17:37:55.000Z',
        end_time: '2026-07-29T17:38:55.000Z',
        latitude: 37.7884457,
        longitude: -122.3871038,
        density: 44.73684210526316,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T17:37:55.000Z',
        end_time: '2026-07-29T17:38:55.000Z',
        latitude: 37.7884457,
        longitude: -122.3871038,
        density: 35.20388547049888,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T17:37:55.000Z',
        end_time: '2026-07-29T17:38:55.000Z',
        latitude: 37.7884457,
        longitude: -122.3871038,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T17:33:55.000Z',
        end_time: '2026-07-29T17:38:55.000Z',
        latitude: 37.78835,
        longitude: -122.38715,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T17:33:55.000Z',
        end_time: '2026-07-29T17:38:55.000Z',
        latitude: 37.78835,
        longitude: -122.38715,
        density: 45.26315789473684,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T17:33:55.000Z',
        end_time: '2026-07-29T17:38:55.000Z',
        latitude: 37.78835,
        longitude: -122.38715,
        density: 40.77082926408999,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T17:36:55.000Z',
        end_time: '2026-07-29T17:37:55.000Z',
        latitude: 37.7884463,
        longitude: -122.387124,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T17:36:55.000Z',
        end_time: '2026-07-29T17:37:55.000Z',
        latitude: 37.7884463,
        longitude: -122.387124,
        density: 26.31578947368421,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T17:36:55.000Z',
        end_time: '2026-07-29T17:37:55.000Z',
        latitude: 37.7884463,
        longitude: -122.387124,
        density: 54.66589306762408,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T17:35:55.000Z',
        end_time: '2026-07-29T17:36:55.000Z',
        latitude: 37.788427,
        longitude: -122.3871277,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T17:35:55.000Z',
        end_time: '2026-07-29T17:36:55.000Z',
        latitude: 37.788427,
        longitude: -122.3871277,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T17:35:55.000Z',
        end_time: '2026-07-29T17:36:55.000Z',
        latitude: 37.788427,
        longitude: -122.3871277,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T17:34:55.000Z',
        end_time: '2026-07-29T17:35:55.000Z',
        latitude: 37.7884512,
        longitude: -122.3871162,
        density: 92.10526315789474,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T17:34:55.000Z',
        end_time: '2026-07-29T17:35:55.000Z',
        latitude: 37.7884512,
        longitude: -122.3871162,
        density: 78.43126621888356,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T17:34:55.000Z',
        end_time: '2026-07-29T17:35:55.000Z',
        latitude: 37.7884512,
        longitude: -122.3871162,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T17:28:55.000Z',
        end_time: '2026-07-29T17:33:55.000Z',
        latitude: 37.7883833,
        longitude: -122.3873,
        density: 70,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T17:28:55.000Z',
        end_time: '2026-07-29T17:33:55.000Z',
        latitude: 37.7883833,
        longitude: -122.3873,
        density: 44.50233643675759,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T17:32:55.000Z',
        end_time: '2026-07-29T17:33:55.000Z',
        latitude: 37.7886585,
        longitude: -122.3864938,
        density: 73.68421052631578,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T17:32:55.000Z',
        end_time: '2026-07-29T17:33:55.000Z',
        latitude: 37.7886585,
        longitude: -122.3864938,
        density: 73.05311300351,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T17:32:55.000Z',
        end_time: '2026-07-29T17:33:55.000Z',
        latitude: 37.7886585,
        longitude: -122.3864938,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T17:28:55.000Z',
        end_time: '2026-07-29T17:33:55.000Z',
        latitude: 37.7883833,
        longitude: -122.3873,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T17:31:55.000Z',
        end_time: '2026-07-29T17:32:55.000Z',
        latitude: 37.7883308,
        longitude: -122.3872505,
        density: 92.10526315789474,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T17:31:55.000Z',
        end_time: '2026-07-29T17:32:55.000Z',
        latitude: 37.7883308,
        longitude: -122.3872505,
        density: 74.05989280675689,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T17:31:55.000Z',
        end_time: '2026-07-29T17:32:55.000Z',
        latitude: 37.7883308,
        longitude: -122.3872505,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T17:30:55.000Z',
        end_time: '2026-07-29T17:31:55.000Z',
        latitude: 37.7885122,
        longitude: -122.3870025,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T17:30:55.000Z',
        end_time: '2026-07-29T17:31:55.000Z',
        latitude: 37.7885122,
        longitude: -122.3870025,
        density: 57.89473684210527,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T17:30:55.000Z',
        end_time: '2026-07-29T17:31:55.000Z',
        latitude: 37.7885122,
        longitude: -122.3870025,
        density: 81.63348587934112,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T17:29:55.000Z',
        end_time: '2026-07-29T17:30:55.000Z',
        latitude: 37.788318,
        longitude: -122.3872507,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T17:29:55.000Z',
        end_time: '2026-07-29T17:30:55.000Z',
        latitude: 37.788318,
        longitude: -122.3872507,
        density: 44.73684210526316,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T17:29:55.000Z',
        end_time: '2026-07-29T17:30:55.000Z',
        latitude: 37.788318,
        longitude: -122.3872507,
        density: 62.727191185894256,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T17:23:55.000Z',
        end_time: '2026-07-29T17:28:55.000Z',
        latitude: 37.78845,
        longitude: -122.3870167,
        density: 2.631578947368421,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T17:27:55.000Z',
        end_time: '2026-07-29T17:28:55.000Z',
        latitude: 37.7885807,
        longitude: -122.3868375,
        density: 23.684210526315788,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T17:27:55.000Z',
        end_time: '2026-07-29T17:28:55.000Z',
        latitude: 37.7885807,
        longitude: -122.3868375,
        density: 14.909864052875657,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T17:27:55.000Z',
        end_time: '2026-07-29T17:28:55.000Z',
        latitude: 37.7885807,
        longitude: -122.3868375,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T17:23:55.000Z',
        end_time: '2026-07-29T17:28:55.000Z',
        latitude: 37.78845,
        longitude: -122.3870167,
        density: 72.63157894736842,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T17:23:55.000Z',
        end_time: '2026-07-29T17:28:55.000Z',
        latitude: 37.78845,
        longitude: -122.3870167,
        density: 43.69992478269976,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T17:26:55.000Z',
        end_time: '2026-07-29T17:27:55.000Z',
        latitude: 37.7884163,
        longitude: -122.3871827,
        density: 100,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T17:26:55.000Z',
        end_time: '2026-07-29T17:27:55.000Z',
        latitude: 37.7884163,
        longitude: -122.3871827,
        density: 80,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T17:26:55.000Z',
        end_time: '2026-07-29T17:27:55.000Z',
        latitude: 37.7884163,
        longitude: -122.3871827,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T17:25:55.000Z',
        end_time: '2026-07-29T17:26:55.000Z',
        latitude: 37.7884635,
        longitude: -122.3870988,
        density: 13.157894736842104,
        density_threshold: 5,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T17:25:55.000Z',
        end_time: '2026-07-29T17:26:55.000Z',
        latitude: 37.7884635,
        longitude: -122.3870988,
        density: 81.57894736842105,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T17:25:55.000Z',
        end_time: '2026-07-29T17:26:55.000Z',
        latitude: 37.7884635,
        longitude: -122.3870988,
        density: 92.55376181242374,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T17:24:55.000Z',
        end_time: '2026-07-29T17:25:55.000Z',
        latitude: 37.7884763,
        longitude: -122.3870647,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T17:24:55.000Z',
        end_time: '2026-07-29T17:25:55.000Z',
        latitude: 37.7884763,
        longitude: -122.3870647,
        density: 94.73684210526315,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T17:24:55.000Z',
        end_time: '2026-07-29T17:25:55.000Z',
        latitude: 37.7884763,
        longitude: -122.3870647,
        density: 79.26034935615156,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T17:18:55.000Z',
        end_time: '2026-07-29T17:23:55.000Z',
        latitude: 37.78835,
        longitude: -122.3871167,
        density: 74.21052631578947,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T17:18:55.000Z',
        end_time: '2026-07-29T17:23:55.000Z',
        latitude: 37.78835,
        longitude: -122.3871167,
        density: 59.655993477514635,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T17:18:55.000Z',
        end_time: '2026-07-29T17:23:55.000Z',
        latitude: 37.78835,
        longitude: -122.3871167,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T17:21:55.000Z',
        end_time: '2026-07-29T17:22:55.000Z',
        latitude: 37.7883712,
        longitude: -122.3871553,
        density: 47.368421052631575,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T17:21:55.000Z',
        end_time: '2026-07-29T17:22:55.000Z',
        latitude: 37.7883712,
        longitude: -122.3871553,
        density: 57.743497445313935,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T17:21:55.000Z',
        end_time: '2026-07-29T17:22:55.000Z',
        latitude: 37.7883712,
        longitude: -122.3871553,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T17:20:55.000Z',
        end_time: '2026-07-29T17:21:55.000Z',
        latitude: 37.7882782,
        longitude: -122.387301,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T17:20:55.000Z',
        end_time: '2026-07-29T17:21:55.000Z',
        latitude: 37.7882782,
        longitude: -122.387301,
        density: 89.47368421052632,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T17:20:55.000Z',
        end_time: '2026-07-29T17:21:55.000Z',
        latitude: 37.7882782,
        longitude: -122.387301,
        density: 100,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T17:19:55.000Z',
        end_time: '2026-07-29T17:20:55.000Z',
        latitude: 37.7878508,
        longitude: -122.3891253,
        density: 97.36842105263158,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T17:19:55.000Z',
        end_time: '2026-07-29T17:20:55.000Z',
        latitude: 37.7878508,
        longitude: -122.3891253,
        density: 69.65854895856023,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T17:19:55.000Z',
        end_time: '2026-07-29T17:20:55.000Z',
        latitude: 37.7878508,
        longitude: -122.3891253,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T17:18:55.000Z',
        end_time: '2026-07-29T17:19:55.000Z',
        latitude: 37.7882943,
        longitude: -122.3871525,
        density: 97.36842105263158,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T17:18:55.000Z',
        end_time: '2026-07-29T17:19:55.000Z',
        latitude: 37.7882943,
        longitude: -122.3871525,
        density: 77.47717020486739,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T17:18:55.000Z',
        end_time: '2026-07-29T17:19:55.000Z',
        latitude: 37.7882943,
        longitude: -122.3871525,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T17:17:55.000Z',
        end_time: '2026-07-29T17:18:55.000Z',
        latitude: 37.7883923,
        longitude: -122.3870528,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T17:13:55.000Z',
        end_time: '2026-07-29T17:18:55.000Z',
        latitude: 37.7882833,
        longitude: -122.3871333,
        density: 0.5263157894736842,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T17:17:55.000Z',
        end_time: '2026-07-29T17:18:55.000Z',
        latitude: 37.7883923,
        longitude: -122.3870528,
        density: 86.8421052631579,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T17:17:55.000Z',
        end_time: '2026-07-29T17:18:55.000Z',
        latitude: 37.7883923,
        longitude: -122.3870528,
        density: 100,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T17:13:55.000Z',
        end_time: '2026-07-29T17:18:55.000Z',
        latitude: 37.7882833,
        longitude: -122.3871333,
        density: 86.31578947368422,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T17:13:55.000Z',
        end_time: '2026-07-29T17:18:55.000Z',
        latitude: 37.7882833,
        longitude: -122.3871333,
        density: 100,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T17:16:55.000Z',
        end_time: '2026-07-29T17:17:55.000Z',
        latitude: 37.7884615,
        longitude: -122.387096,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T17:16:55.000Z',
        end_time: '2026-07-29T17:17:55.000Z',
        latitude: 37.7884615,
        longitude: -122.387096,
        density: 68.42105263157895,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T17:16:55.000Z',
        end_time: '2026-07-29T17:17:55.000Z',
        latitude: 37.7884615,
        longitude: -122.387096,
        density: 53.130137963278436,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T17:15:55.000Z',
        end_time: '2026-07-29T17:16:55.000Z',
        latitude: 37.7885195,
        longitude: -122.3870847,
        density: 78.94736842105263,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T17:15:55.000Z',
        end_time: '2026-07-29T17:16:55.000Z',
        latitude: 37.7885195,
        longitude: -122.3870847,
        density: 52.03242372664808,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T17:15:55.000Z',
        end_time: '2026-07-29T17:16:55.000Z',
        latitude: 37.7885195,
        longitude: -122.3870847,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T17:14:55.000Z',
        end_time: '2026-07-29T17:15:55.000Z',
        latitude: 37.7885747,
        longitude: -122.3871305,
        density: 100,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T17:14:55.000Z',
        end_time: '2026-07-29T17:15:55.000Z',
        latitude: 37.7885747,
        longitude: -122.3871305,
        density: 74.32627533434047,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T17:14:55.000Z',
        end_time: '2026-07-29T17:15:55.000Z',
        latitude: 37.7885747,
        longitude: -122.3871305,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T17:08:55.000Z',
        end_time: '2026-07-29T17:13:55.000Z',
        latitude: 37.7885667,
        longitude: -122.3871333,
        density: 58.94736842105262,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T17:08:55.000Z',
        end_time: '2026-07-29T17:13:55.000Z',
        latitude: 37.7885667,
        longitude: -122.3871333,
        density: 67.81870484726117,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T17:12:55.000Z',
        end_time: '2026-07-29T17:13:55.000Z',
        latitude: 37.7885405,
        longitude: -122.3870892,
        density: 81.57894736842105,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T17:12:55.000Z',
        end_time: '2026-07-29T17:13:55.000Z',
        latitude: 37.7885405,
        longitude: -122.3870892,
        density: 87.6324440739551,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T17:12:55.000Z',
        end_time: '2026-07-29T17:13:55.000Z',
        latitude: 37.7885405,
        longitude: -122.3870892,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T17:08:55.000Z',
        end_time: '2026-07-29T17:13:55.000Z',
        latitude: 37.7885667,
        longitude: -122.3871333,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T17:11:55.000Z',
        end_time: '2026-07-29T17:12:55.000Z',
        latitude: 37.7886577,
        longitude: -122.3870443,
        density: 71.05263157894737,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T17:11:55.000Z',
        end_time: '2026-07-29T17:12:55.000Z',
        latitude: 37.7886577,
        longitude: -122.3870443,
        density: 96.07413578400862,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T17:11:55.000Z',
        end_time: '2026-07-29T17:12:55.000Z',
        latitude: 37.7886577,
        longitude: -122.3870443,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T17:10:55.000Z',
        end_time: '2026-07-29T17:11:55.000Z',
        latitude: 37.7884638,
        longitude: -122.3871102,
        density: 76.31578947368422,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T17:10:55.000Z',
        end_time: '2026-07-29T17:11:55.000Z',
        latitude: 37.7884638,
        longitude: -122.3871102,
        density: 56.52146850517363,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T17:10:55.000Z',
        end_time: '2026-07-29T17:11:55.000Z',
        latitude: 37.7884638,
        longitude: -122.3871102,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T17:09:55.000Z',
        end_time: '2026-07-29T17:10:55.000Z',
        latitude: 37.7884733,
        longitude: -122.3871407,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T17:09:55.000Z',
        end_time: '2026-07-29T17:10:55.000Z',
        latitude: 37.7884733,
        longitude: -122.3871407,
        density: 50,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T17:09:55.000Z',
        end_time: '2026-07-29T17:10:55.000Z',
        latitude: 37.7884733,
        longitude: -122.3871407,
        density: 35.024243630261374,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T17:08:55.000Z',
        end_time: '2026-07-29T17:09:55.000Z',
        latitude: 37.7885062,
        longitude: -122.3871933,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T17:08:55.000Z',
        end_time: '2026-07-29T17:09:55.000Z',
        latitude: 37.7885062,
        longitude: -122.3871933,
        density: 15.789473684210526,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T17:08:55.000Z',
        end_time: '2026-07-29T17:09:55.000Z',
        latitude: 37.7885062,
        longitude: -122.3871933,
        density: 26.20143558217257,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T17:03:55.000Z',
        end_time: '2026-07-29T17:08:55.000Z',
        latitude: 37.7884833,
        longitude: -122.3871833,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T17:03:55.000Z',
        end_time: '2026-07-29T17:08:55.000Z',
        latitude: 37.7884833,
        longitude: -122.3871833,
        density: 75.26315789473685,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T17:03:55.000Z',
        end_time: '2026-07-29T17:08:55.000Z',
        latitude: 37.7884833,
        longitude: -122.3871833,
        density: 79.59479307711293,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T17:07:55.000Z',
        end_time: '2026-07-29T17:08:55.000Z',
        latitude: 37.7884545,
        longitude: -122.3871718,
        density: 86.8421052631579,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T17:07:55.000Z',
        end_time: '2026-07-29T17:08:55.000Z',
        latitude: 37.7884545,
        longitude: -122.3871718,
        density: 90.04949582451991,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T17:07:55.000Z',
        end_time: '2026-07-29T17:08:55.000Z',
        latitude: 37.7884545,
        longitude: -122.3871718,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T17:06:55.000Z',
        end_time: '2026-07-29T17:07:55.000Z',
        latitude: 37.7884497,
        longitude: -122.3871115,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T17:06:55.000Z',
        end_time: '2026-07-29T17:07:55.000Z',
        latitude: 37.7884497,
        longitude: -122.3871115,
        density: 84.21052631578947,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T17:06:55.000Z',
        end_time: '2026-07-29T17:07:55.000Z',
        latitude: 37.7884497,
        longitude: -122.3871115,
        density: 100,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T17:05:55.000Z',
        end_time: '2026-07-29T17:06:55.000Z',
        latitude: 37.788501,
        longitude: -122.3870682,
        density: 73.68421052631578,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T17:05:55.000Z',
        end_time: '2026-07-29T17:06:55.000Z',
        latitude: 37.788501,
        longitude: -122.3870682,
        density: 46.12183368570292,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T17:05:55.000Z',
        end_time: '2026-07-29T17:06:55.000Z',
        latitude: 37.788501,
        longitude: -122.3870682,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T17:04:55.000Z',
        end_time: '2026-07-29T17:05:55.000Z',
        latitude: 37.7884637,
        longitude: -122.3870483,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T17:04:55.000Z',
        end_time: '2026-07-29T17:05:55.000Z',
        latitude: 37.7884637,
        longitude: -122.3870483,
        density: 34.21052631578947,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T17:04:55.000Z',
        end_time: '2026-07-29T17:05:55.000Z',
        latitude: 37.7884637,
        longitude: -122.3870483,
        density: 47.76044810548419,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T17:03:55.000Z',
        end_time: '2026-07-29T17:04:55.000Z',
        latitude: 37.7884822,
        longitude: -122.38693,
        density: 97.36842105263158,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T17:03:55.000Z',
        end_time: '2026-07-29T17:04:55.000Z',
        latitude: 37.7884822,
        longitude: -122.38693,
        density: 100,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T17:03:55.000Z',
        end_time: '2026-07-29T17:04:55.000Z',
        latitude: 37.7884822,
        longitude: -122.38693,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T17:02:55.000Z',
        end_time: '2026-07-29T17:03:55.000Z',
        latitude: 37.788452,
        longitude: -122.386893,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T16:58:55.000Z',
        end_time: '2026-07-29T17:03:55.000Z',
        latitude: 37.7884667,
        longitude: -122.3869333,
        density: 0.5263157894736842,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T17:02:55.000Z',
        end_time: '2026-07-29T17:03:55.000Z',
        latitude: 37.788452,
        longitude: -122.386893,
        density: 78.94736842105263,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T17:02:55.000Z',
        end_time: '2026-07-29T17:03:55.000Z',
        latitude: 37.788452,
        longitude: -122.386893,
        density: 68.92858925643178,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T16:58:55.000Z',
        end_time: '2026-07-29T17:03:55.000Z',
        latitude: 37.7884667,
        longitude: -122.3869333,
        density: 61.578947368421055,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T16:58:55.000Z',
        end_time: '2026-07-29T17:03:55.000Z',
        latitude: 37.7884667,
        longitude: -122.3869333,
        density: 87.86675175882043,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T17:01:55.000Z',
        end_time: '2026-07-29T17:02:55.000Z',
        latitude: 37.7886243,
        longitude: -122.3870087,
        density: 2.631578947368421,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T17:01:55.000Z',
        end_time: '2026-07-29T17:02:55.000Z',
        latitude: 37.7886243,
        longitude: -122.3870087,
        density: 89.47368421052632,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T17:01:55.000Z',
        end_time: '2026-07-29T17:02:55.000Z',
        latitude: 37.7886243,
        longitude: -122.3870087,
        density: 82.43668904634046,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T17:00:55.000Z',
        end_time: '2026-07-29T17:01:55.000Z',
        latitude: 37.7886462,
        longitude: -122.3870837,
        density: 84.21052631578947,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T17:00:55.000Z',
        end_time: '2026-07-29T17:01:55.000Z',
        latitude: 37.7886462,
        longitude: -122.3870837,
        density: 55.01082290726012,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T17:00:55.000Z',
        end_time: '2026-07-29T17:01:55.000Z',
        latitude: 37.7886462,
        longitude: -122.3870837,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:59:55.000Z',
        end_time: '2026-07-29T17:00:55.000Z',
        latitude: 37.788573,
        longitude: -122.3872185,
        density: 39.473684210526315,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:59:55.000Z',
        end_time: '2026-07-29T17:00:55.000Z',
        latitude: 37.788573,
        longitude: -122.3872185,
        density: 39.898480945295844,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:59:55.000Z',
        end_time: '2026-07-29T17:00:55.000Z',
        latitude: 37.788573,
        longitude: -122.3872185,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:58:55.000Z',
        end_time: '2026-07-29T16:59:55.000Z',
        latitude: 37.788502,
        longitude: -122.3870702,
        density: 15.789473684210526,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:58:55.000Z',
        end_time: '2026-07-29T16:59:55.000Z',
        latitude: 37.788502,
        longitude: -122.3870702,
        density: 40.251945297225205,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:58:55.000Z',
        end_time: '2026-07-29T16:59:55.000Z',
        latitude: 37.788502,
        longitude: -122.3870702,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T16:53:55.000Z',
        end_time: '2026-07-29T16:58:55.000Z',
        latitude: 37.7885,
        longitude: -122.3870667,
        density: 88.94736842105263,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T16:53:55.000Z',
        end_time: '2026-07-29T16:58:55.000Z',
        latitude: 37.7885,
        longitude: -122.3870667,
        density: 98.4569849435302,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:57:55.000Z',
        end_time: '2026-07-29T16:58:55.000Z',
        latitude: 37.7884245,
        longitude: -122.3869677,
        density: 50,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:57:55.000Z',
        end_time: '2026-07-29T16:58:55.000Z',
        latitude: 37.7884245,
        longitude: -122.3869677,
        density: 62.69823525699093,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:57:55.000Z',
        end_time: '2026-07-29T16:58:55.000Z',
        latitude: 37.7884245,
        longitude: -122.3869677,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T16:53:55.000Z',
        end_time: '2026-07-29T16:58:55.000Z',
        latitude: 37.7885,
        longitude: -122.3870667,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:56:55.000Z',
        end_time: '2026-07-29T16:57:55.000Z',
        latitude: 37.7884688,
        longitude: -122.3870742,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:56:55.000Z',
        end_time: '2026-07-29T16:57:55.000Z',
        latitude: 37.7884688,
        longitude: -122.3870742,
        density: 97.36842105263158,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:56:55.000Z',
        end_time: '2026-07-29T16:57:55.000Z',
        latitude: 37.7884688,
        longitude: -122.3870742,
        density: 100,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:55:55.000Z',
        end_time: '2026-07-29T16:56:55.000Z',
        latitude: 37.7885025,
        longitude: -122.3872633,
        density: 97.36842105263158,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:55:55.000Z',
        end_time: '2026-07-29T16:56:55.000Z',
        latitude: 37.7885025,
        longitude: -122.3872633,
        density: 100,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:55:55.000Z',
        end_time: '2026-07-29T16:56:55.000Z',
        latitude: 37.7885025,
        longitude: -122.3872633,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:54:55.000Z',
        end_time: '2026-07-29T16:55:55.000Z',
        latitude: 37.788596,
        longitude: -122.3871475,
        density: 100,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:54:55.000Z',
        end_time: '2026-07-29T16:55:55.000Z',
        latitude: 37.788596,
        longitude: -122.3871475,
        density: 97.15032425323696,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:54:55.000Z',
        end_time: '2026-07-29T16:55:55.000Z',
        latitude: 37.788596,
        longitude: -122.3871475,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:53:55.000Z',
        end_time: '2026-07-29T16:54:55.000Z',
        latitude: 37.788537,
        longitude: -122.3871082,
        density: 100,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:53:55.000Z',
        end_time: '2026-07-29T16:54:55.000Z',
        latitude: 37.788537,
        longitude: -122.3871082,
        density: 80,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:53:55.000Z',
        end_time: '2026-07-29T16:54:55.000Z',
        latitude: 37.788537,
        longitude: -122.3871082,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:52:55.000Z',
        end_time: '2026-07-29T16:53:55.000Z',
        latitude: 37.7885417,
        longitude: -122.3871393,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:52:55.000Z',
        end_time: '2026-07-29T16:53:55.000Z',
        latitude: 37.7885417,
        longitude: -122.3871393,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:52:55.000Z',
        end_time: '2026-07-29T16:53:55.000Z',
        latitude: 37.7885417,
        longitude: -122.3871393,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T16:48:55.000Z',
        end_time: '2026-07-29T16:53:55.000Z',
        latitude: 37.7885167,
        longitude: -122.3871167,
        density: 59.473684210526315,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T16:48:55.000Z',
        end_time: '2026-07-29T16:53:55.000Z',
        latitude: 37.7885167,
        longitude: -122.3871167,
        density: 76.68480777955321,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T16:48:55.000Z',
        end_time: '2026-07-29T16:53:55.000Z',
        latitude: 37.7885167,
        longitude: -122.3871167,
        density: 1.0526315789473684,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:51:55.000Z',
        end_time: '2026-07-29T16:52:55.000Z',
        latitude: 37.7885432,
        longitude: -122.3871512,
        density: 5.263157894736842,
        density_threshold: 5,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:51:55.000Z',
        end_time: '2026-07-29T16:52:55.000Z',
        latitude: 37.7885432,
        longitude: -122.3871512,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:51:55.000Z',
        end_time: '2026-07-29T16:52:55.000Z',
        latitude: 37.7885432,
        longitude: -122.3871512,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:50:55.000Z',
        end_time: '2026-07-29T16:51:55.000Z',
        latitude: 37.7885232,
        longitude: -122.3871327,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:50:55.000Z',
        end_time: '2026-07-29T16:51:55.000Z',
        latitude: 37.7885232,
        longitude: -122.3871327,
        density: 94.73684210526315,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:50:55.000Z',
        end_time: '2026-07-29T16:51:55.000Z',
        latitude: 37.7885232,
        longitude: -122.3871327,
        density: 100,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:49:55.000Z',
        end_time: '2026-07-29T16:50:55.000Z',
        latitude: 37.7885553,
        longitude: -122.3871033,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:49:55.000Z',
        end_time: '2026-07-29T16:50:55.000Z',
        latitude: 37.7885553,
        longitude: -122.3871033,
        density: 97.36842105263158,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:49:55.000Z',
        end_time: '2026-07-29T16:50:55.000Z',
        latitude: 37.7885553,
        longitude: -122.3871033,
        density: 84.14865541629408,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:48:55.000Z',
        end_time: '2026-07-29T16:49:55.000Z',
        latitude: 37.7885835,
        longitude: -122.3870433,
        density: 97.36842105263158,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:48:55.000Z',
        end_time: '2026-07-29T16:49:55.000Z',
        latitude: 37.7885835,
        longitude: -122.3870433,
        density: 86.43078662719567,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:48:55.000Z',
        end_time: '2026-07-29T16:49:55.000Z',
        latitude: 37.7885835,
        longitude: -122.3870433,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:47:55.000Z',
        end_time: '2026-07-29T16:48:55.000Z',
        latitude: 37.7885478,
        longitude: -122.3875568,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T16:43:55.000Z',
        end_time: '2026-07-29T16:48:55.000Z',
        latitude: 37.7885833,
        longitude: -122.3870167,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:47:55.000Z',
        end_time: '2026-07-29T16:48:55.000Z',
        latitude: 37.7885478,
        longitude: -122.3875568,
        density: 73.68421052631578,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:47:55.000Z',
        end_time: '2026-07-29T16:48:55.000Z',
        latitude: 37.7885478,
        longitude: -122.3875568,
        density: 75.07746129075578,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T16:43:55.000Z',
        end_time: '2026-07-29T16:48:55.000Z',
        latitude: 37.7885833,
        longitude: -122.3870167,
        density: 68.42105263157895,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T16:43:55.000Z',
        end_time: '2026-07-29T16:48:55.000Z',
        latitude: 37.7885833,
        longitude: -122.3870167,
        density: 94.65575496806737,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:46:55.000Z',
        end_time: '2026-07-29T16:47:55.000Z',
        latitude: 37.788402,
        longitude: -122.3872135,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:46:55.000Z',
        end_time: '2026-07-29T16:47:55.000Z',
        latitude: 37.788402,
        longitude: -122.3872135,
        density: 23.684210526315788,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:46:55.000Z',
        end_time: '2026-07-29T16:47:55.000Z',
        latitude: 37.788402,
        longitude: -122.3872135,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:45:55.000Z',
        end_time: '2026-07-29T16:46:55.000Z',
        latitude: 37.7882428,
        longitude: -122.3868805,
        density: 89.47368421052632,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:45:55.000Z',
        end_time: '2026-07-29T16:46:55.000Z',
        latitude: 37.7882428,
        longitude: -122.3868805,
        density: 99.89323126079778,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:45:55.000Z',
        end_time: '2026-07-29T16:46:55.000Z',
        latitude: 37.7882428,
        longitude: -122.3868805,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:44:55.000Z',
        end_time: '2026-07-29T16:45:55.000Z',
        latitude: 37.7885207,
        longitude: -122.3871902,
        density: 94.73684210526315,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:44:55.000Z',
        end_time: '2026-07-29T16:45:55.000Z',
        latitude: 37.7885207,
        longitude: -122.3871902,
        density: 100,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:44:55.000Z',
        end_time: '2026-07-29T16:45:55.000Z',
        latitude: 37.7885207,
        longitude: -122.3871902,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:43:55.000Z',
        end_time: '2026-07-29T16:44:55.000Z',
        latitude: 37.7886608,
        longitude: -122.3898415,
        density: 60.526315789473685,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:43:55.000Z',
        end_time: '2026-07-29T16:44:55.000Z',
        latitude: 37.7886608,
        longitude: -122.3898415,
        density: 55.7434609093202,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:43:55.000Z',
        end_time: '2026-07-29T16:44:55.000Z',
        latitude: 37.7886608,
        longitude: -122.3898415,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T16:38:55.000Z',
        end_time: '2026-07-29T16:43:55.000Z',
        latitude: 37.7886667,
        longitude: -122.3899667,
        density: 18.421052631578945,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T16:38:55.000Z',
        end_time: '2026-07-29T16:43:55.000Z',
        latitude: 37.7886667,
        longitude: -122.3899667,
        density: 8.939669519322518,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:42:55.000Z',
        end_time: '2026-07-29T16:43:55.000Z',
        latitude: 37.7884467,
        longitude: -122.3870053,
        density: 60.526315789473685,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:42:55.000Z',
        end_time: '2026-07-29T16:43:55.000Z',
        latitude: 37.7884467,
        longitude: -122.3870053,
        density: 69.95170969593235,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:42:55.000Z',
        end_time: '2026-07-29T16:43:55.000Z',
        latitude: 37.7884467,
        longitude: -122.3870053,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T16:38:55.000Z',
        end_time: '2026-07-29T16:43:55.000Z',
        latitude: 37.7886667,
        longitude: -122.3899667,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:41:55.000Z',
        end_time: '2026-07-29T16:42:55.000Z',
        latitude: 37.7884693,
        longitude: -122.387082,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:41:55.000Z',
        end_time: '2026-07-29T16:42:55.000Z',
        latitude: 37.7884693,
        longitude: -122.387082,
        density: 31.57894736842105,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:41:55.000Z',
        end_time: '2026-07-29T16:42:55.000Z',
        latitude: 37.7884693,
        longitude: -122.387082,
        density: 7.5729675727035435,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:40:55.000Z',
        end_time: '2026-07-29T16:41:55.000Z',
        latitude: 37.7884623,
        longitude: -122.3871072,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:40:55.000Z',
        end_time: '2026-07-29T16:41:55.000Z',
        latitude: 37.7884623,
        longitude: -122.3871072,
        density: 17.151167776836076,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:40:55.000Z',
        end_time: '2026-07-29T16:41:55.000Z',
        latitude: 37.7884623,
        longitude: -122.3871072,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:39:55.000Z',
        end_time: '2026-07-29T16:40:55.000Z',
        latitude: 37.7884828,
        longitude: -122.3871263,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:39:55.000Z',
        end_time: '2026-07-29T16:40:55.000Z',
        latitude: 37.7884828,
        longitude: -122.3871263,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:39:55.000Z',
        end_time: '2026-07-29T16:40:55.000Z',
        latitude: 37.7884828,
        longitude: -122.3871263,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:38:55.000Z',
        end_time: '2026-07-29T16:39:55.000Z',
        latitude: 37.7885232,
        longitude: -122.3872457,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:38:55.000Z',
        end_time: '2026-07-29T16:39:55.000Z',
        latitude: 37.7885232,
        longitude: -122.3872457,
        density: 15.84494124978682,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:38:55.000Z',
        end_time: '2026-07-29T16:39:55.000Z',
        latitude: 37.7885232,
        longitude: -122.3872457,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T16:33:55.000Z',
        end_time: '2026-07-29T16:38:55.000Z',
        latitude: 37.7885167,
        longitude: -122.38725,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:37:55.000Z',
        end_time: '2026-07-29T16:38:55.000Z',
        latitude: 37.7887178,
        longitude: -122.3877713,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:37:55.000Z',
        end_time: '2026-07-29T16:38:55.000Z',
        latitude: 37.7887178,
        longitude: -122.3877713,
        density: 18.787674316432906,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:37:55.000Z',
        end_time: '2026-07-29T16:38:55.000Z',
        latitude: 37.7887178,
        longitude: -122.3877713,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T16:33:55.000Z',
        end_time: '2026-07-29T16:38:55.000Z',
        latitude: 37.7885167,
        longitude: -122.38725,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T16:33:55.000Z',
        end_time: '2026-07-29T16:38:55.000Z',
        latitude: 37.7885167,
        longitude: -122.38725,
        density: 6.2259259393164745,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:36:55.000Z',
        end_time: '2026-07-29T16:37:55.000Z',
        latitude: 37.7885328,
        longitude: -122.3874648,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:36:55.000Z',
        end_time: '2026-07-29T16:37:55.000Z',
        latitude: 37.7885328,
        longitude: -122.3874648,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:36:55.000Z',
        end_time: '2026-07-29T16:37:55.000Z',
        latitude: 37.7885328,
        longitude: -122.3874648,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:35:55.000Z',
        end_time: '2026-07-29T16:36:55.000Z',
        latitude: 37.7884683,
        longitude: -122.3871567,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:35:55.000Z',
        end_time: '2026-07-29T16:36:55.000Z',
        latitude: 37.7884683,
        longitude: -122.3871567,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:35:55.000Z',
        end_time: '2026-07-29T16:36:55.000Z',
        latitude: 37.7884683,
        longitude: -122.3871567,
        density: 12.297892740921359,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:34:55.000Z',
        end_time: '2026-07-29T16:35:55.000Z',
        latitude: 37.7884625,
        longitude: -122.3872503,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:34:55.000Z',
        end_time: '2026-07-29T16:35:55.000Z',
        latitude: 37.7884625,
        longitude: -122.3872503,
        density: 15.339169743933251,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:34:55.000Z',
        end_time: '2026-07-29T16:35:55.000Z',
        latitude: 37.7884625,
        longitude: -122.3872503,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:33:55.000Z',
        end_time: '2026-07-29T16:34:55.000Z',
        latitude: 37.7893592,
        longitude: -122.3899872,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:33:55.000Z',
        end_time: '2026-07-29T16:34:55.000Z',
        latitude: 37.7893592,
        longitude: -122.3899872,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:33:55.000Z',
        end_time: '2026-07-29T16:34:55.000Z',
        latitude: 37.7893592,
        longitude: -122.3899872,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:32:55.000Z',
        end_time: '2026-07-29T16:33:55.000Z',
        latitude: 37.7887723,
        longitude: -122.387213,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T16:28:55.000Z',
        end_time: '2026-07-29T16:33:55.000Z',
        latitude: 37.7891833,
        longitude: -122.38935,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:32:55.000Z',
        end_time: '2026-07-29T16:33:55.000Z',
        latitude: 37.7887723,
        longitude: -122.387213,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:32:55.000Z',
        end_time: '2026-07-29T16:33:55.000Z',
        latitude: 37.7887723,
        longitude: -122.387213,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T16:28:55.000Z',
        end_time: '2026-07-29T16:33:55.000Z',
        latitude: 37.7891833,
        longitude: -122.38935,
        density: 1.0526315789473684,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T16:28:55.000Z',
        end_time: '2026-07-29T16:33:55.000Z',
        latitude: 37.7891833,
        longitude: -122.38935,
        density: 29.20075293670639,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:31:55.000Z',
        end_time: '2026-07-29T16:32:55.000Z',
        latitude: 37.7886258,
        longitude: -122.3870078,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:31:55.000Z',
        end_time: '2026-07-29T16:32:55.000Z',
        latitude: 37.7886258,
        longitude: -122.3870078,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:31:55.000Z',
        end_time: '2026-07-29T16:32:55.000Z',
        latitude: 37.7886258,
        longitude: -122.3870078,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:30:55.000Z',
        end_time: '2026-07-29T16:31:55.000Z',
        latitude: 37.788489,
        longitude: -122.3871567,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:30:55.000Z',
        end_time: '2026-07-29T16:31:55.000Z',
        latitude: 37.788489,
        longitude: -122.3871567,
        density: 4.9524031157962645,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:30:55.000Z',
        end_time: '2026-07-29T16:31:55.000Z',
        latitude: 37.788489,
        longitude: -122.3871567,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:29:55.000Z',
        end_time: '2026-07-29T16:30:55.000Z',
        latitude: 37.7882825,
        longitude: -122.3869718,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:29:55.000Z',
        end_time: '2026-07-29T16:30:55.000Z',
        latitude: 37.7882825,
        longitude: -122.3869718,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:29:55.000Z',
        end_time: '2026-07-29T16:30:55.000Z',
        latitude: 37.7882825,
        longitude: -122.3869718,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:28:55.000Z',
        end_time: '2026-07-29T16:29:55.000Z',
        latitude: 37.788546,
        longitude: -122.3871768,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:28:55.000Z',
        end_time: '2026-07-29T16:29:55.000Z',
        latitude: 37.788546,
        longitude: -122.3871768,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:28:55.000Z',
        end_time: '2026-07-29T16:29:55.000Z',
        latitude: 37.788546,
        longitude: -122.3871768,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T16:23:56.000Z',
        end_time: '2026-07-29T16:28:56.000Z',
        latitude: 37.7885667,
        longitude: -122.38715,
        density: 1.5789473684210527,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T16:23:56.000Z',
        end_time: '2026-07-29T16:28:56.000Z',
        latitude: 37.7885667,
        longitude: -122.38715,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T16:23:56.000Z',
        end_time: '2026-07-29T16:28:56.000Z',
        latitude: 37.7885667,
        longitude: -122.38715,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:27:55.000Z',
        end_time: '2026-07-29T16:28:55.000Z',
        latitude: 37.7888008,
        longitude: -122.3882917,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:27:55.000Z',
        end_time: '2026-07-29T16:28:55.000Z',
        latitude: 37.7888008,
        longitude: -122.3882917,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:27:55.000Z',
        end_time: '2026-07-29T16:28:55.000Z',
        latitude: 37.7888008,
        longitude: -122.3882917,
        density: 16.037855125739213,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:26:55.000Z',
        end_time: '2026-07-29T16:27:55.000Z',
        latitude: 37.7886447,
        longitude: -122.3875235,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:26:55.000Z',
        end_time: '2026-07-29T16:27:55.000Z',
        latitude: 37.7886447,
        longitude: -122.3875235,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:26:55.000Z',
        end_time: '2026-07-29T16:27:55.000Z',
        latitude: 37.7886447,
        longitude: -122.3875235,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:25:56.000Z',
        end_time: '2026-07-29T16:26:56.000Z',
        latitude: 37.7884565,
        longitude: -122.3872517,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:25:56.000Z',
        end_time: '2026-07-29T16:26:56.000Z',
        latitude: 37.7884565,
        longitude: -122.3872517,
        density: 6.450412752590875,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:25:56.000Z',
        end_time: '2026-07-29T16:26:56.000Z',
        latitude: 37.7884565,
        longitude: -122.3872517,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:24:56.000Z',
        end_time: '2026-07-29T16:25:56.000Z',
        latitude: 37.7884927,
        longitude: -122.3874848,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:24:56.000Z',
        end_time: '2026-07-29T16:25:56.000Z',
        latitude: 37.7884927,
        longitude: -122.3874848,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:24:56.000Z',
        end_time: '2026-07-29T16:25:56.000Z',
        latitude: 37.7884927,
        longitude: -122.3874848,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:23:56.000Z',
        end_time: '2026-07-29T16:24:56.000Z',
        latitude: 37.788431,
        longitude: -122.386856,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:23:56.000Z',
        end_time: '2026-07-29T16:24:56.000Z',
        latitude: 37.788431,
        longitude: -122.386856,
        density: 11.885471281052453,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:23:56.000Z',
        end_time: '2026-07-29T16:24:56.000Z',
        latitude: 37.788431,
        longitude: -122.386856,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:22:56.000Z',
        end_time: '2026-07-29T16:23:56.000Z',
        latitude: 37.7882653,
        longitude: -122.3852602,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:22:56.000Z',
        end_time: '2026-07-29T16:23:56.000Z',
        latitude: 37.7882653,
        longitude: -122.3852602,
        density: 6.664969911685379,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:22:56.000Z',
        end_time: '2026-07-29T16:23:56.000Z',
        latitude: 37.7882653,
        longitude: -122.3852602,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T16:18:56.000Z',
        end_time: '2026-07-29T16:23:56.000Z',
        latitude: 37.7884167,
        longitude: -122.3868333,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T16:18:56.000Z',
        end_time: '2026-07-29T16:23:56.000Z',
        latitude: 37.7884167,
        longitude: -122.3868333,
        density: 24.369441064788916,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T16:18:56.000Z',
        end_time: '2026-07-29T16:23:56.000Z',
        latitude: 37.7884167,
        longitude: -122.3868333,
        density: 1.5789473684210527,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:21:56.000Z',
        end_time: '2026-07-29T16:22:56.000Z',
        latitude: 37.7884788,
        longitude: -122.3869958,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:21:56.000Z',
        end_time: '2026-07-29T16:22:56.000Z',
        latitude: 37.7884788,
        longitude: -122.3869958,
        density: 26.31578947368421,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:21:56.000Z',
        end_time: '2026-07-29T16:22:56.000Z',
        latitude: 37.7884788,
        longitude: -122.3869958,
        density: 33.13177479362328,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:20:56.000Z',
        end_time: '2026-07-29T16:21:56.000Z',
        latitude: 37.7883152,
        longitude: -122.3868487,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:20:56.000Z',
        end_time: '2026-07-29T16:21:56.000Z',
        latitude: 37.7883152,
        longitude: -122.3868487,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:20:56.000Z',
        end_time: '2026-07-29T16:21:56.000Z',
        latitude: 37.7883152,
        longitude: -122.3868487,
        density: 27.55919496573963,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:19:56.000Z',
        end_time: '2026-07-29T16:20:56.000Z',
        latitude: 37.7883293,
        longitude: -122.3869793,
        density: 7.894736842105263,
        density_threshold: 5,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:19:56.000Z',
        end_time: '2026-07-29T16:20:56.000Z',
        latitude: 37.7883293,
        longitude: -122.3869793,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:19:56.000Z',
        end_time: '2026-07-29T16:20:56.000Z',
        latitude: 37.7883293,
        longitude: -122.3869793,
        density: 4.051966493509558,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:18:56.000Z',
        end_time: '2026-07-29T16:19:56.000Z',
        latitude: 37.7884488,
        longitude: -122.3870772,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:18:56.000Z',
        end_time: '2026-07-29T16:19:56.000Z',
        latitude: 37.7884488,
        longitude: -122.3870772,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:18:56.000Z',
        end_time: '2026-07-29T16:19:56.000Z',
        latitude: 37.7884488,
        longitude: -122.3870772,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:17:56.000Z',
        end_time: '2026-07-29T16:18:56.000Z',
        latitude: 37.788689,
        longitude: -122.3867168,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T16:13:56.000Z',
        end_time: '2026-07-29T16:18:56.000Z',
        latitude: 37.78845,
        longitude: -122.3870667,
        density: 0.5263157894736842,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:17:56.000Z',
        end_time: '2026-07-29T16:18:56.000Z',
        latitude: 37.788689,
        longitude: -122.3867168,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:17:56.000Z',
        end_time: '2026-07-29T16:18:56.000Z',
        latitude: 37.788689,
        longitude: -122.3867168,
        density: 8.880668813045833,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T16:13:56.000Z',
        end_time: '2026-07-29T16:18:56.000Z',
        latitude: 37.78845,
        longitude: -122.3870667,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T16:13:56.000Z',
        end_time: '2026-07-29T16:18:56.000Z',
        latitude: 37.78845,
        longitude: -122.3870667,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:16:56.000Z',
        end_time: '2026-07-29T16:17:56.000Z',
        latitude: 37.7883603,
        longitude: -122.3870043,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:16:56.000Z',
        end_time: '2026-07-29T16:17:56.000Z',
        latitude: 37.7883603,
        longitude: -122.3870043,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:16:56.000Z',
        end_time: '2026-07-29T16:17:56.000Z',
        latitude: 37.7883603,
        longitude: -122.3870043,
        density: 24.758013074510586,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:15:56.000Z',
        end_time: '2026-07-29T16:16:56.000Z',
        latitude: 37.7884038,
        longitude: -122.3870253,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:15:56.000Z',
        end_time: '2026-07-29T16:16:56.000Z',
        latitude: 37.7884038,
        longitude: -122.3870253,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:15:56.000Z',
        end_time: '2026-07-29T16:16:56.000Z',
        latitude: 37.7884038,
        longitude: -122.3870253,
        density: 2.631578947368421,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:14:56.000Z',
        end_time: '2026-07-29T16:15:56.000Z',
        latitude: 37.7884498,
        longitude: -122.3870578,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:14:56.000Z',
        end_time: '2026-07-29T16:15:56.000Z',
        latitude: 37.7884498,
        longitude: -122.3870578,
        density: 16.28013020054819,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:14:56.000Z',
        end_time: '2026-07-29T16:15:56.000Z',
        latitude: 37.7884498,
        longitude: -122.3870578,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:13:56.000Z',
        end_time: '2026-07-29T16:14:56.000Z',
        latitude: 37.7883747,
        longitude: -122.387041,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:13:56.000Z',
        end_time: '2026-07-29T16:14:56.000Z',
        latitude: 37.7883747,
        longitude: -122.387041,
        density: 23.594141943095117,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:13:56.000Z',
        end_time: '2026-07-29T16:14:56.000Z',
        latitude: 37.7883747,
        longitude: -122.387041,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T16:08:56.000Z',
        end_time: '2026-07-29T16:13:56.000Z',
        latitude: 37.7883667,
        longitude: -122.3870333,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T16:08:56.000Z',
        end_time: '2026-07-29T16:13:56.000Z',
        latitude: 37.7883667,
        longitude: -122.3870333,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:12:56.000Z',
        end_time: '2026-07-29T16:13:56.000Z',
        latitude: 37.788448,
        longitude: -122.3870803,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:12:56.000Z',
        end_time: '2026-07-29T16:13:56.000Z',
        latitude: 37.788448,
        longitude: -122.3870803,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:12:56.000Z',
        end_time: '2026-07-29T16:13:56.000Z',
        latitude: 37.788448,
        longitude: -122.3870803,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T16:08:56.000Z',
        end_time: '2026-07-29T16:13:56.000Z',
        latitude: 37.7883667,
        longitude: -122.3870333,
        density: 2.631578947368421,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:11:56.000Z',
        end_time: '2026-07-29T16:12:56.000Z',
        latitude: 37.788461,
        longitude: -122.3871032,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:11:56.000Z',
        end_time: '2026-07-29T16:12:56.000Z',
        latitude: 37.788461,
        longitude: -122.3871032,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:11:56.000Z',
        end_time: '2026-07-29T16:12:56.000Z',
        latitude: 37.788461,
        longitude: -122.3871032,
        density: 3.1132290758682046,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:10:56.000Z',
        end_time: '2026-07-29T16:11:56.000Z',
        latitude: 37.7884285,
        longitude: -122.3871242,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:10:56.000Z',
        end_time: '2026-07-29T16:11:56.000Z',
        latitude: 37.7884285,
        longitude: -122.3871242,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:10:56.000Z',
        end_time: '2026-07-29T16:11:56.000Z',
        latitude: 37.7884285,
        longitude: -122.3871242,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:09:56.000Z',
        end_time: '2026-07-29T16:10:56.000Z',
        latitude: 37.788399,
        longitude: -122.3871545,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:09:56.000Z',
        end_time: '2026-07-29T16:10:56.000Z',
        latitude: 37.788399,
        longitude: -122.3871545,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:09:56.000Z',
        end_time: '2026-07-29T16:10:56.000Z',
        latitude: 37.788399,
        longitude: -122.3871545,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:08:56.000Z',
        end_time: '2026-07-29T16:09:56.000Z',
        latitude: 37.7884958,
        longitude: -122.3871353,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:08:56.000Z',
        end_time: '2026-07-29T16:09:56.000Z',
        latitude: 37.7884958,
        longitude: -122.3871353,
        density: 18.453668113041385,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:08:56.000Z',
        end_time: '2026-07-29T16:09:56.000Z',
        latitude: 37.7884958,
        longitude: -122.3871353,
        density: 13.157894736842104,
        density_threshold: 5,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T16:03:56.000Z',
        end_time: '2026-07-29T16:08:56.000Z',
        latitude: 37.7884833,
        longitude: -122.38715,
        density: 2.1052631578947367,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T16:03:56.000Z',
        end_time: '2026-07-29T16:08:56.000Z',
        latitude: 37.7884833,
        longitude: -122.38715,
        density: 12.785541410178734,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:07:56.000Z',
        end_time: '2026-07-29T16:08:56.000Z',
        latitude: 37.7884375,
        longitude: -122.387124,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:07:56.000Z',
        end_time: '2026-07-29T16:08:56.000Z',
        latitude: 37.7884375,
        longitude: -122.387124,
        density: 9.245064976834062,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:07:56.000Z',
        end_time: '2026-07-29T16:08:56.000Z',
        latitude: 37.7884375,
        longitude: -122.387124,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T16:03:56.000Z',
        end_time: '2026-07-29T16:08:56.000Z',
        latitude: 37.7884833,
        longitude: -122.38715,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:06:56.000Z',
        end_time: '2026-07-29T16:07:56.000Z',
        latitude: 37.7885383,
        longitude: -122.3870195,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:06:56.000Z',
        end_time: '2026-07-29T16:07:56.000Z',
        latitude: 37.7885383,
        longitude: -122.3870195,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:06:56.000Z',
        end_time: '2026-07-29T16:07:56.000Z',
        latitude: 37.7885383,
        longitude: -122.3870195,
        density: 1.0080711175442891,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:05:56.000Z',
        end_time: '2026-07-29T16:06:56.000Z',
        latitude: 37.7885263,
        longitude: -122.3871192,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:05:56.000Z',
        end_time: '2026-07-29T16:06:56.000Z',
        latitude: 37.7885263,
        longitude: -122.3871192,
        density: 10.526315789473683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:05:56.000Z',
        end_time: '2026-07-29T16:06:56.000Z',
        latitude: 37.7885263,
        longitude: -122.3871192,
        density: 23.85369460311326,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:04:56.000Z',
        end_time: '2026-07-29T16:05:56.000Z',
        latitude: 37.7884815,
        longitude: -122.386864,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:04:56.000Z',
        end_time: '2026-07-29T16:05:56.000Z',
        latitude: 37.7884815,
        longitude: -122.386864,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:04:56.000Z',
        end_time: '2026-07-29T16:05:56.000Z',
        latitude: 37.7884815,
        longitude: -122.386864,
        density: 4.881689481420506,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:03:56.000Z',
        end_time: '2026-07-29T16:04:56.000Z',
        latitude: 37.788499,
        longitude: -122.3871635,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:03:56.000Z',
        end_time: '2026-07-29T16:04:56.000Z',
        latitude: 37.788499,
        longitude: -122.3871635,
        density: 23.691864864322476,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:03:56.000Z',
        end_time: '2026-07-29T16:04:56.000Z',
        latitude: 37.788499,
        longitude: -122.3871635,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:02:56.000Z',
        end_time: '2026-07-29T16:03:56.000Z',
        latitude: 37.788453,
        longitude: -122.3870718,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T15:58:56.000Z',
        end_time: '2026-07-29T16:03:56.000Z',
        latitude: 37.7885,
        longitude: -122.3871667,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:02:56.000Z',
        end_time: '2026-07-29T16:03:56.000Z',
        latitude: 37.788453,
        longitude: -122.3870718,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:02:56.000Z',
        end_time: '2026-07-29T16:03:56.000Z',
        latitude: 37.788453,
        longitude: -122.3870718,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T15:58:56.000Z',
        end_time: '2026-07-29T16:03:56.000Z',
        latitude: 37.7885,
        longitude: -122.3871667,
        density: 1.5789473684210527,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T15:58:56.000Z',
        end_time: '2026-07-29T16:03:56.000Z',
        latitude: 37.7885,
        longitude: -122.3871667,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:01:56.000Z',
        end_time: '2026-07-29T16:02:56.000Z',
        latitude: 37.7884328,
        longitude: -122.3870555,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:01:56.000Z',
        end_time: '2026-07-29T16:02:56.000Z',
        latitude: 37.7884328,
        longitude: -122.3870555,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:01:56.000Z',
        end_time: '2026-07-29T16:02:56.000Z',
        latitude: 37.7884328,
        longitude: -122.3870555,
        density: 28.041798556572278,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T16:00:56.000Z',
        end_time: '2026-07-29T16:01:56.000Z',
        latitude: 37.7884417,
        longitude: -122.3870555,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T16:00:56.000Z',
        end_time: '2026-07-29T16:01:56.000Z',
        latitude: 37.7884417,
        longitude: -122.3870555,
        density: 2.9567041672095895,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T16:00:56.000Z',
        end_time: '2026-07-29T16:01:56.000Z',
        latitude: 37.7884417,
        longitude: -122.3870555,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:59:56.000Z',
        end_time: '2026-07-29T16:00:56.000Z',
        latitude: 37.7885133,
        longitude: -122.3872053,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:59:56.000Z',
        end_time: '2026-07-29T16:00:56.000Z',
        latitude: 37.7885133,
        longitude: -122.3872053,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:59:56.000Z',
        end_time: '2026-07-29T16:00:56.000Z',
        latitude: 37.7885133,
        longitude: -122.3872053,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T15:53:56.000Z',
        end_time: '2026-07-29T15:58:56.000Z',
        latitude: 37.78845,
        longitude: -122.3870833,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T15:53:56.000Z',
        end_time: '2026-07-29T15:58:56.000Z',
        latitude: 37.78845,
        longitude: -122.3870833,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:57:56.000Z',
        end_time: '2026-07-29T15:58:56.000Z',
        latitude: 37.7884235,
        longitude: -122.38699,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:57:56.000Z',
        end_time: '2026-07-29T15:58:56.000Z',
        latitude: 37.7884235,
        longitude: -122.38699,
        density: 12.28251425273102,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:57:56.000Z',
        end_time: '2026-07-29T15:58:56.000Z',
        latitude: 37.7884235,
        longitude: -122.38699,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T15:53:56.000Z',
        end_time: '2026-07-29T15:58:56.000Z',
        latitude: 37.78845,
        longitude: -122.3870833,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:56:56.000Z',
        end_time: '2026-07-29T15:57:56.000Z',
        latitude: 37.7882032,
        longitude: -122.3860777,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:56:56.000Z',
        end_time: '2026-07-29T15:57:56.000Z',
        latitude: 37.7882032,
        longitude: -122.3860777,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:56:56.000Z',
        end_time: '2026-07-29T15:57:56.000Z',
        latitude: 37.7882032,
        longitude: -122.3860777,
        density: 17.014648337412588,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:55:56.000Z',
        end_time: '2026-07-29T15:56:56.000Z',
        latitude: 37.7884202,
        longitude: -122.3870163,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:55:56.000Z',
        end_time: '2026-07-29T15:56:56.000Z',
        latitude: 37.7884202,
        longitude: -122.3870163,
        density: 14.10052123031674,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:55:56.000Z',
        end_time: '2026-07-29T15:56:56.000Z',
        latitude: 37.7884202,
        longitude: -122.3870163,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:54:56.000Z',
        end_time: '2026-07-29T15:55:56.000Z',
        latitude: 37.7884263,
        longitude: -122.3870087,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:54:56.000Z',
        end_time: '2026-07-29T15:55:56.000Z',
        latitude: 37.7884263,
        longitude: -122.3870087,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:54:56.000Z',
        end_time: '2026-07-29T15:55:56.000Z',
        latitude: 37.7884263,
        longitude: -122.3870087,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T15:48:56.000Z',
        end_time: '2026-07-29T15:53:56.000Z',
        latitude: 37.7884,
        longitude: -122.38695,
        density: 3.1578947368421053,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T15:48:56.000Z',
        end_time: '2026-07-29T15:53:56.000Z',
        latitude: 37.7884,
        longitude: -122.38695,
        density: 4.674797039997677,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:52:56.000Z',
        end_time: '2026-07-29T15:53:56.000Z',
        latitude: 37.7884638,
        longitude: -122.3870915,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:52:56.000Z',
        end_time: '2026-07-29T15:53:56.000Z',
        latitude: 37.7884638,
        longitude: -122.3870915,
        density: 15.636071078946646,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:52:56.000Z',
        end_time: '2026-07-29T15:53:56.000Z',
        latitude: 37.7884638,
        longitude: -122.3870915,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T15:48:56.000Z',
        end_time: '2026-07-29T15:53:56.000Z',
        latitude: 37.7884,
        longitude: -122.38695,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:51:56.000Z',
        end_time: '2026-07-29T15:52:56.000Z',
        latitude: 37.788473,
        longitude: -122.3870843,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:51:56.000Z',
        end_time: '2026-07-29T15:52:56.000Z',
        latitude: 37.788473,
        longitude: -122.3870843,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:51:56.000Z',
        end_time: '2026-07-29T15:52:56.000Z',
        latitude: 37.788473,
        longitude: -122.3870843,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:50:56.000Z',
        end_time: '2026-07-29T15:51:56.000Z',
        latitude: 37.7884447,
        longitude: -122.387058,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:50:56.000Z',
        end_time: '2026-07-29T15:51:56.000Z',
        latitude: 37.7884447,
        longitude: -122.387058,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:50:56.000Z',
        end_time: '2026-07-29T15:51:56.000Z',
        latitude: 37.7884447,
        longitude: -122.387058,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:49:56.000Z',
        end_time: '2026-07-29T15:50:56.000Z',
        latitude: 37.788466,
        longitude: -122.3870058,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:49:56.000Z',
        end_time: '2026-07-29T15:50:56.000Z',
        latitude: 37.788466,
        longitude: -122.3870058,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:49:56.000Z',
        end_time: '2026-07-29T15:50:56.000Z',
        latitude: 37.788466,
        longitude: -122.3870058,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:48:56.000Z',
        end_time: '2026-07-29T15:49:56.000Z',
        latitude: 37.7884883,
        longitude: -122.3870227,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:48:56.000Z',
        end_time: '2026-07-29T15:49:56.000Z',
        latitude: 37.7884883,
        longitude: -122.3870227,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:48:56.000Z',
        end_time: '2026-07-29T15:49:56.000Z',
        latitude: 37.7884883,
        longitude: -122.3870227,
        density: 8.818473728508014,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T15:43:56.000Z',
        end_time: '2026-07-29T15:48:56.000Z',
        latitude: 37.7884833,
        longitude: -122.3869833,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:47:56.000Z',
        end_time: '2026-07-29T15:48:56.000Z',
        latitude: 37.7883988,
        longitude: -122.3866945,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:47:56.000Z',
        end_time: '2026-07-29T15:48:56.000Z',
        latitude: 37.7883988,
        longitude: -122.3866945,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:47:56.000Z',
        end_time: '2026-07-29T15:48:56.000Z',
        latitude: 37.7883988,
        longitude: -122.3866945,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T15:43:56.000Z',
        end_time: '2026-07-29T15:48:56.000Z',
        latitude: 37.7884833,
        longitude: -122.3869833,
        density: 0.5263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T15:43:56.000Z',
        end_time: '2026-07-29T15:48:56.000Z',
        latitude: 37.7884833,
        longitude: -122.3869833,
        density: 3.4326148329019572,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:46:56.000Z',
        end_time: '2026-07-29T15:47:56.000Z',
        latitude: 37.7884682,
        longitude: -122.3870245,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:46:56.000Z',
        end_time: '2026-07-29T15:47:56.000Z',
        latitude: 37.7884682,
        longitude: -122.3870245,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:46:56.000Z',
        end_time: '2026-07-29T15:47:56.000Z',
        latitude: 37.7884682,
        longitude: -122.3870245,
        density: 9.784430550401254,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:45:56.000Z',
        end_time: '2026-07-29T15:46:56.000Z',
        latitude: 37.7884162,
        longitude: -122.3870602,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:45:56.000Z',
        end_time: '2026-07-29T15:46:56.000Z',
        latitude: 37.7884162,
        longitude: -122.3870602,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:45:56.000Z',
        end_time: '2026-07-29T15:46:56.000Z',
        latitude: 37.7884162,
        longitude: -122.3870602,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:44:56.000Z',
        end_time: '2026-07-29T15:45:56.000Z',
        latitude: 37.7884267,
        longitude: -122.3870985,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:44:56.000Z',
        end_time: '2026-07-29T15:45:56.000Z',
        latitude: 37.7884267,
        longitude: -122.3870985,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:44:56.000Z',
        end_time: '2026-07-29T15:45:56.000Z',
        latitude: 37.7884267,
        longitude: -122.3870985,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T15:38:56.000Z',
        end_time: '2026-07-29T15:43:56.000Z',
        latitude: 37.7884833,
        longitude: -122.3869833,
        density: 0.5263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T15:38:56.000Z',
        end_time: '2026-07-29T15:43:56.000Z',
        latitude: 37.7884833,
        longitude: -122.3869833,
        density: 19.61378762235361,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:42:56.000Z',
        end_time: '2026-07-29T15:43:56.000Z',
        latitude: 37.7884345,
        longitude: -122.3871028,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:42:56.000Z',
        end_time: '2026-07-29T15:43:56.000Z',
        latitude: 37.7884345,
        longitude: -122.3871028,
        density: 18.308123126915138,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:42:56.000Z',
        end_time: '2026-07-29T15:43:56.000Z',
        latitude: 37.7884345,
        longitude: -122.3871028,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T15:38:56.000Z',
        end_time: '2026-07-29T15:43:56.000Z',
        latitude: 37.7884833,
        longitude: -122.3869833,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:41:56.000Z',
        end_time: '2026-07-29T15:42:56.000Z',
        latitude: 37.7884507,
        longitude: -122.387109,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:41:56.000Z',
        end_time: '2026-07-29T15:42:56.000Z',
        latitude: 37.7884507,
        longitude: -122.387109,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:41:56.000Z',
        end_time: '2026-07-29T15:42:56.000Z',
        latitude: 37.7884507,
        longitude: -122.387109,
        density: 1.0804339110272565,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:40:56.000Z',
        end_time: '2026-07-29T15:41:56.000Z',
        latitude: 37.7884578,
        longitude: -122.3871012,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:40:56.000Z',
        end_time: '2026-07-29T15:41:56.000Z',
        latitude: 37.7884578,
        longitude: -122.3871012,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:40:56.000Z',
        end_time: '2026-07-29T15:41:56.000Z',
        latitude: 37.7884578,
        longitude: -122.3871012,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:39:56.000Z',
        end_time: '2026-07-29T15:40:56.000Z',
        latitude: 37.7883937,
        longitude: -122.387151,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:39:56.000Z',
        end_time: '2026-07-29T15:40:56.000Z',
        latitude: 37.7883937,
        longitude: -122.387151,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:39:56.000Z',
        end_time: '2026-07-29T15:40:56.000Z',
        latitude: 37.7883937,
        longitude: -122.387151,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:38:56.000Z',
        end_time: '2026-07-29T15:39:56.000Z',
        latitude: 37.788387,
        longitude: -122.3872187,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:38:56.000Z',
        end_time: '2026-07-29T15:39:56.000Z',
        latitude: 37.788387,
        longitude: -122.3872187,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:38:56.000Z',
        end_time: '2026-07-29T15:39:56.000Z',
        latitude: 37.788387,
        longitude: -122.3872187,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T15:33:56.000Z',
        end_time: '2026-07-29T15:38:56.000Z',
        latitude: 37.7883833,
        longitude: -122.3872,
        density: 2.1052631578947367,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T15:33:56.000Z',
        end_time: '2026-07-29T15:38:56.000Z',
        latitude: 37.7883833,
        longitude: -122.3872,
        density: 11.039826804665275,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:37:56.000Z',
        end_time: '2026-07-29T15:38:56.000Z',
        latitude: 37.7883773,
        longitude: -122.3872378,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:37:56.000Z',
        end_time: '2026-07-29T15:38:56.000Z',
        latitude: 37.7883773,
        longitude: -122.3872378,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:37:56.000Z',
        end_time: '2026-07-29T15:38:56.000Z',
        latitude: 37.7883773,
        longitude: -122.3872378,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T15:33:56.000Z',
        end_time: '2026-07-29T15:38:56.000Z',
        latitude: 37.7883833,
        longitude: -122.3872,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:36:56.000Z',
        end_time: '2026-07-29T15:37:56.000Z',
        latitude: 37.7884898,
        longitude: -122.3870835,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:36:56.000Z',
        end_time: '2026-07-29T15:37:56.000Z',
        latitude: 37.7884898,
        longitude: -122.3870835,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:36:56.000Z',
        end_time: '2026-07-29T15:37:56.000Z',
        latitude: 37.7884898,
        longitude: -122.3870835,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:35:56.000Z',
        end_time: '2026-07-29T15:36:56.000Z',
        latitude: 37.788477,
        longitude: -122.3870847,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:35:56.000Z',
        end_time: '2026-07-29T15:36:56.000Z',
        latitude: 37.788477,
        longitude: -122.3870847,
        density: 2.1658499908142748,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:35:56.000Z',
        end_time: '2026-07-29T15:36:56.000Z',
        latitude: 37.788477,
        longitude: -122.3870847,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:34:56.000Z',
        end_time: '2026-07-29T15:35:56.000Z',
        latitude: 37.7885067,
        longitude: -122.3870923,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:34:56.000Z',
        end_time: '2026-07-29T15:35:56.000Z',
        latitude: 37.7885067,
        longitude: -122.3870923,
        density: 20.945127741309744,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:34:56.000Z',
        end_time: '2026-07-29T15:35:56.000Z',
        latitude: 37.7885067,
        longitude: -122.3870923,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:33:56.000Z',
        end_time: '2026-07-29T15:34:56.000Z',
        latitude: 37.7884713,
        longitude: -122.3870882,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:33:56.000Z',
        end_time: '2026-07-29T15:34:56.000Z',
        latitude: 37.7884713,
        longitude: -122.3870882,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:33:56.000Z',
        end_time: '2026-07-29T15:34:56.000Z',
        latitude: 37.7884713,
        longitude: -122.3870882,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:32:56.000Z',
        end_time: '2026-07-29T15:33:56.000Z',
        latitude: 37.788467,
        longitude: -122.3871282,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:32:56.000Z',
        end_time: '2026-07-29T15:33:56.000Z',
        latitude: 37.788467,
        longitude: -122.3871282,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:32:56.000Z',
        end_time: '2026-07-29T15:33:56.000Z',
        latitude: 37.788467,
        longitude: -122.3871282,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T15:28:56.000Z',
        end_time: '2026-07-29T15:33:56.000Z',
        latitude: 37.78845,
        longitude: -122.3870833,
        density: 1.0526315789473684,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T15:28:56.000Z',
        end_time: '2026-07-29T15:33:56.000Z',
        latitude: 37.78845,
        longitude: -122.3870833,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T15:28:56.000Z',
        end_time: '2026-07-29T15:33:56.000Z',
        latitude: 37.78845,
        longitude: -122.3870833,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:31:56.000Z',
        end_time: '2026-07-29T15:32:56.000Z',
        latitude: 37.7884097,
        longitude: -122.3871403,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:31:56.000Z',
        end_time: '2026-07-29T15:32:56.000Z',
        latitude: 37.7884097,
        longitude: -122.3871403,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:31:56.000Z',
        end_time: '2026-07-29T15:32:56.000Z',
        latitude: 37.7884097,
        longitude: -122.3871403,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:30:56.000Z',
        end_time: '2026-07-29T15:31:56.000Z',
        latitude: 37.788449,
        longitude: -122.387108,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:30:56.000Z',
        end_time: '2026-07-29T15:31:56.000Z',
        latitude: 37.788449,
        longitude: -122.387108,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:30:56.000Z',
        end_time: '2026-07-29T15:31:56.000Z',
        latitude: 37.788449,
        longitude: -122.387108,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:29:56.000Z',
        end_time: '2026-07-29T15:30:56.000Z',
        latitude: 37.7885147,
        longitude: -122.3869603,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:29:56.000Z',
        end_time: '2026-07-29T15:30:56.000Z',
        latitude: 37.7885147,
        longitude: -122.3869603,
        density: 30.327156107799176,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:29:56.000Z',
        end_time: '2026-07-29T15:30:56.000Z',
        latitude: 37.7885147,
        longitude: -122.3869603,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T15:23:56.000Z',
        end_time: '2026-07-29T15:28:56.000Z',
        latitude: 37.7883667,
        longitude: -122.38735,
        density: 1.0526315789473684,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T15:23:56.000Z',
        end_time: '2026-07-29T15:28:56.000Z',
        latitude: 37.7883667,
        longitude: -122.38735,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:27:56.000Z',
        end_time: '2026-07-29T15:28:56.000Z',
        latitude: 37.7884262,
        longitude: -122.3871075,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:27:56.000Z',
        end_time: '2026-07-29T15:28:56.000Z',
        latitude: 37.7884262,
        longitude: -122.3871075,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:27:56.000Z',
        end_time: '2026-07-29T15:28:56.000Z',
        latitude: 37.7884262,
        longitude: -122.3871075,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T15:23:56.000Z',
        end_time: '2026-07-29T15:28:56.000Z',
        latitude: 37.7883667,
        longitude: -122.38735,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:26:56.000Z',
        end_time: '2026-07-29T15:27:56.000Z',
        latitude: 37.7884085,
        longitude: -122.3870622,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:26:56.000Z',
        end_time: '2026-07-29T15:27:56.000Z',
        latitude: 37.7884085,
        longitude: -122.3870622,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:26:56.000Z',
        end_time: '2026-07-29T15:27:56.000Z',
        latitude: 37.7884085,
        longitude: -122.3870622,
        density: 7.303760556025121,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:25:56.000Z',
        end_time: '2026-07-29T15:26:56.000Z',
        latitude: 37.7883918,
        longitude: -122.3871682,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:25:56.000Z',
        end_time: '2026-07-29T15:26:56.000Z',
        latitude: 37.7883918,
        longitude: -122.3871682,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:25:56.000Z',
        end_time: '2026-07-29T15:26:56.000Z',
        latitude: 37.7883918,
        longitude: -122.3871682,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:24:56.000Z',
        end_time: '2026-07-29T15:25:56.000Z',
        latitude: 37.7883492,
        longitude: -122.3872857,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:24:56.000Z',
        end_time: '2026-07-29T15:25:56.000Z',
        latitude: 37.7883492,
        longitude: -122.3872857,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:24:56.000Z',
        end_time: '2026-07-29T15:25:56.000Z',
        latitude: 37.7883492,
        longitude: -122.3872857,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T15:18:56.000Z',
        end_time: '2026-07-29T15:23:56.000Z',
        latitude: 37.78845,
        longitude: -122.3871333,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T15:18:56.000Z',
        end_time: '2026-07-29T15:23:56.000Z',
        latitude: 37.78845,
        longitude: -122.3871333,
        density: 12.591083696754724,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:22:56.000Z',
        end_time: '2026-07-29T15:23:56.000Z',
        latitude: 37.788411,
        longitude: -122.3871953,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:22:56.000Z',
        end_time: '2026-07-29T15:23:56.000Z',
        latitude: 37.788411,
        longitude: -122.3871953,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:22:56.000Z',
        end_time: '2026-07-29T15:23:56.000Z',
        latitude: 37.788411,
        longitude: -122.3871953,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T15:18:56.000Z',
        end_time: '2026-07-29T15:23:56.000Z',
        latitude: 37.78845,
        longitude: -122.3871333,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:21:56.000Z',
        end_time: '2026-07-29T15:22:56.000Z',
        latitude: 37.7883968,
        longitude: -122.3872562,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:21:56.000Z',
        end_time: '2026-07-29T15:22:56.000Z',
        latitude: 37.7883968,
        longitude: -122.3872562,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:21:56.000Z',
        end_time: '2026-07-29T15:22:56.000Z',
        latitude: 37.7883968,
        longitude: -122.3872562,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:20:56.000Z',
        end_time: '2026-07-29T15:21:56.000Z',
        latitude: 37.7884002,
        longitude: -122.3871558,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:20:56.000Z',
        end_time: '2026-07-29T15:21:56.000Z',
        latitude: 37.7884002,
        longitude: -122.3871558,
        density: 11.75456714061772,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:20:56.000Z',
        end_time: '2026-07-29T15:21:56.000Z',
        latitude: 37.7884002,
        longitude: -122.3871558,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:19:56.000Z',
        end_time: '2026-07-29T15:20:56.000Z',
        latitude: 37.7883913,
        longitude: -122.3871828,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:19:56.000Z',
        end_time: '2026-07-29T15:20:56.000Z',
        latitude: 37.7883913,
        longitude: -122.3871828,
        density: 36.10660535802826,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:19:56.000Z',
        end_time: '2026-07-29T15:20:56.000Z',
        latitude: 37.7883913,
        longitude: -122.3871828,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:17:56.000Z',
        end_time: '2026-07-29T15:18:56.000Z',
        latitude: 37.7884503,
        longitude: -122.3870705,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:17:56.000Z',
        end_time: '2026-07-29T15:18:56.000Z',
        latitude: 37.7884503,
        longitude: -122.3870705,
        density: 7.784674797780104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:17:56.000Z',
        end_time: '2026-07-29T15:18:56.000Z',
        latitude: 37.7884503,
        longitude: -122.3870705,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T15:13:56.000Z',
        end_time: '2026-07-29T15:18:56.000Z',
        latitude: 37.7884,
        longitude: -122.3871,
        density: 3.1578947368421053,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T15:13:56.000Z',
        end_time: '2026-07-29T15:18:56.000Z',
        latitude: 37.7884,
        longitude: -122.3871,
        density: 30.604835504177462,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T15:13:56.000Z',
        end_time: '2026-07-29T15:18:56.000Z',
        latitude: 37.7884,
        longitude: -122.3871,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:16:56.000Z',
        end_time: '2026-07-29T15:17:56.000Z',
        latitude: 37.7881837,
        longitude: -122.387626,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:16:56.000Z',
        end_time: '2026-07-29T15:17:56.000Z',
        latitude: 37.7881837,
        longitude: -122.387626,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:16:56.000Z',
        end_time: '2026-07-29T15:17:56.000Z',
        latitude: 37.7881837,
        longitude: -122.387626,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:15:56.000Z',
        end_time: '2026-07-29T15:16:56.000Z',
        latitude: 37.788096,
        longitude: -122.3876293,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:15:56.000Z',
        end_time: '2026-07-29T15:16:56.000Z',
        latitude: 37.788096,
        longitude: -122.3876293,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:15:56.000Z',
        end_time: '2026-07-29T15:16:56.000Z',
        latitude: 37.788096,
        longitude: -122.3876293,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:14:56.000Z',
        end_time: '2026-07-29T15:15:56.000Z',
        latitude: 37.7878335,
        longitude: -122.3866098,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:14:56.000Z',
        end_time: '2026-07-29T15:15:56.000Z',
        latitude: 37.7878335,
        longitude: -122.3866098,
        density: 26.20138358309653,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:14:56.000Z',
        end_time: '2026-07-29T15:15:56.000Z',
        latitude: 37.7878335,
        longitude: -122.3866098,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T15:08:56.000Z',
        end_time: '2026-07-29T15:13:56.000Z',
        latitude: 37.7877333,
        longitude: -122.3860167,
        density: 0.5263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T15:08:56.000Z',
        end_time: '2026-07-29T15:13:56.000Z',
        latitude: 37.7877333,
        longitude: -122.3860167,
        density: 16.10874868156727,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:12:56.000Z',
        end_time: '2026-07-29T15:13:56.000Z',
        latitude: 37.7889282,
        longitude: -122.3879028,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:12:56.000Z',
        end_time: '2026-07-29T15:13:56.000Z',
        latitude: 37.7889282,
        longitude: -122.3879028,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:12:56.000Z',
        end_time: '2026-07-29T15:13:56.000Z',
        latitude: 37.7889282,
        longitude: -122.3879028,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T15:08:56.000Z',
        end_time: '2026-07-29T15:13:56.000Z',
        latitude: 37.7877333,
        longitude: -122.3860167,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:11:56.000Z',
        end_time: '2026-07-29T15:12:56.000Z',
        latitude: 37.7891493,
        longitude: -122.3882545,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:11:56.000Z',
        end_time: '2026-07-29T15:12:56.000Z',
        latitude: 37.7891493,
        longitude: -122.3882545,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:11:56.000Z',
        end_time: '2026-07-29T15:12:56.000Z',
        latitude: 37.7891493,
        longitude: -122.3882545,
        density: 0.5124750164695824,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:10:56.000Z',
        end_time: '2026-07-29T15:11:56.000Z',
        latitude: 37.7890992,
        longitude: -122.388002,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:10:56.000Z',
        end_time: '2026-07-29T15:11:56.000Z',
        latitude: 37.7890992,
        longitude: -122.388002,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:10:56.000Z',
        end_time: '2026-07-29T15:11:56.000Z',
        latitude: 37.7890992,
        longitude: -122.388002,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:09:56.000Z',
        end_time: '2026-07-29T15:10:56.000Z',
        latitude: 37.7890992,
        longitude: -122.388002,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:09:56.000Z',
        end_time: '2026-07-29T15:10:56.000Z',
        latitude: 37.7890992,
        longitude: -122.388002,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:09:56.000Z',
        end_time: '2026-07-29T15:10:56.000Z',
        latitude: 37.7890992,
        longitude: -122.388002,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T15:03:56.000Z',
        end_time: '2026-07-29T15:08:56.000Z',
        latitude: 37.7890833,
        longitude: -122.388,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:07:56.000Z',
        end_time: '2026-07-29T15:08:56.000Z',
        latitude: 37.7884813,
        longitude: -122.3870702,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:07:56.000Z',
        end_time: '2026-07-29T15:08:56.000Z',
        latitude: 37.7884813,
        longitude: -122.3870702,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:07:56.000Z',
        end_time: '2026-07-29T15:08:56.000Z',
        latitude: 37.7884813,
        longitude: -122.3870702,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T15:03:56.000Z',
        end_time: '2026-07-29T15:08:56.000Z',
        latitude: 37.7890833,
        longitude: -122.388,
        density: 16.842105263157894,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T15:03:56.000Z',
        end_time: '2026-07-29T15:08:56.000Z',
        latitude: 37.7890833,
        longitude: -122.388,
        density: 21.227292225142005,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:06:56.000Z',
        end_time: '2026-07-29T15:07:56.000Z',
        latitude: 37.7889393,
        longitude: -122.3853297,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:06:56.000Z',
        end_time: '2026-07-29T15:07:56.000Z',
        latitude: 37.7889393,
        longitude: -122.3853297,
        density: 26.31578947368421,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:06:56.000Z',
        end_time: '2026-07-29T15:07:56.000Z',
        latitude: 37.7889393,
        longitude: -122.3853297,
        density: 24.250057808870785,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:05:56.000Z',
        end_time: '2026-07-29T15:06:56.000Z',
        latitude: 37.7889518,
        longitude: -122.3844032,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:05:56.000Z',
        end_time: '2026-07-29T15:06:56.000Z',
        latitude: 37.7889518,
        longitude: -122.3844032,
        density: 26.31578947368421,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:05:56.000Z',
        end_time: '2026-07-29T15:06:56.000Z',
        latitude: 37.7889518,
        longitude: -122.3844032,
        density: 24.74405513516309,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:04:56.000Z',
        end_time: '2026-07-29T15:05:56.000Z',
        latitude: 37.7885555,
        longitude: -122.3864313,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:04:56.000Z',
        end_time: '2026-07-29T15:05:56.000Z',
        latitude: 37.7885555,
        longitude: -122.3864313,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:04:56.000Z',
        end_time: '2026-07-29T15:05:56.000Z',
        latitude: 37.7885555,
        longitude: -122.3864313,
        density: 22.13338071124061,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:03:56.000Z',
        end_time: '2026-07-29T15:04:56.000Z',
        latitude: 37.7883862,
        longitude: -122.3872638,
        density: 23.684210526315788,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:03:56.000Z',
        end_time: '2026-07-29T15:04:56.000Z',
        latitude: 37.7883862,
        longitude: -122.3872638,
        density: 45.75689606371849,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:03:56.000Z',
        end_time: '2026-07-29T15:04:56.000Z',
        latitude: 37.7883862,
        longitude: -122.3872638,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:02:56.000Z',
        end_time: '2026-07-29T15:03:56.000Z',
        latitude: 37.7884162,
        longitude: -122.3871743,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T14:58:56.000Z',
        end_time: '2026-07-29T15:03:56.000Z',
        latitude: 37.7883833,
        longitude: -122.3872333,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:02:56.000Z',
        end_time: '2026-07-29T15:03:56.000Z',
        latitude: 37.7884162,
        longitude: -122.3871743,
        density: 26.31578947368421,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:02:56.000Z',
        end_time: '2026-07-29T15:03:56.000Z',
        latitude: 37.7884162,
        longitude: -122.3871743,
        density: 1.8247139008203739,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T14:58:56.000Z',
        end_time: '2026-07-29T15:03:56.000Z',
        latitude: 37.7883833,
        longitude: -122.3872333,
        density: 8.421052631578947,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T14:58:56.000Z',
        end_time: '2026-07-29T15:03:56.000Z',
        latitude: 37.7883833,
        longitude: -122.3872333,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:01:56.000Z',
        end_time: '2026-07-29T15:02:56.000Z',
        latitude: 37.7884362,
        longitude: -122.3871407,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:01:56.000Z',
        end_time: '2026-07-29T15:02:56.000Z',
        latitude: 37.7884362,
        longitude: -122.3871407,
        density: 15.789473684210526,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:01:56.000Z',
        end_time: '2026-07-29T15:02:56.000Z',
        latitude: 37.7884362,
        longitude: -122.3871407,
        density: 7.9214109651215905,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T15:00:57.000Z',
        end_time: '2026-07-29T15:01:57.000Z',
        latitude: 37.7884272,
        longitude: -122.386995,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T15:00:57.000Z',
        end_time: '2026-07-29T15:01:57.000Z',
        latitude: 37.7884272,
        longitude: -122.386995,
        density: 11.76785765893586,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T15:00:57.000Z',
        end_time: '2026-07-29T15:01:57.000Z',
        latitude: 37.7884272,
        longitude: -122.386995,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:59:56.000Z',
        end_time: '2026-07-29T15:00:56.000Z',
        latitude: 37.789666,
        longitude: -122.3779325,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:59:56.000Z',
        end_time: '2026-07-29T15:00:56.000Z',
        latitude: 37.789666,
        longitude: -122.3779325,
        density: 11.330540368199964,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:59:56.000Z',
        end_time: '2026-07-29T15:00:56.000Z',
        latitude: 37.789666,
        longitude: -122.3779325,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:57:57.000Z',
        end_time: '2026-07-29T14:58:57.000Z',
        latitude: 37.78843,
        longitude: -122.3870865,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T14:53:57.000Z',
        end_time: '2026-07-29T14:58:57.000Z',
        latitude: 37.7884,
        longitude: -122.3870167,
        density: 5.7894736842105265,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T14:53:57.000Z',
        end_time: '2026-07-29T14:58:57.000Z',
        latitude: 37.7884,
        longitude: -122.3870167,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:57:57.000Z',
        end_time: '2026-07-29T14:58:57.000Z',
        latitude: 37.78843,
        longitude: -122.3870865,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:57:57.000Z',
        end_time: '2026-07-29T14:58:57.000Z',
        latitude: 37.78843,
        longitude: -122.3870865,
        density: 5.328144802385474,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T14:53:57.000Z',
        end_time: '2026-07-29T14:58:57.000Z',
        latitude: 37.7884,
        longitude: -122.3870167,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:56:57.000Z',
        end_time: '2026-07-29T14:57:57.000Z',
        latitude: 37.7884233,
        longitude: -122.3872502,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:56:57.000Z',
        end_time: '2026-07-29T14:57:57.000Z',
        latitude: 37.7884233,
        longitude: -122.3872502,
        density: 20.76286072592471,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:56:57.000Z',
        end_time: '2026-07-29T14:57:57.000Z',
        latitude: 37.7884233,
        longitude: -122.3872502,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:55:57.000Z',
        end_time: '2026-07-29T14:56:57.000Z',
        latitude: 37.7884725,
        longitude: -122.3871553,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:55:57.000Z',
        end_time: '2026-07-29T14:56:57.000Z',
        latitude: 37.7884725,
        longitude: -122.3871553,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:55:57.000Z',
        end_time: '2026-07-29T14:56:57.000Z',
        latitude: 37.7884725,
        longitude: -122.3871553,
        density: 21.091225290609604,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:54:57.000Z',
        end_time: '2026-07-29T14:55:57.000Z',
        latitude: 37.7884333,
        longitude: -122.3871157,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:54:57.000Z',
        end_time: '2026-07-29T14:55:57.000Z',
        latitude: 37.7884333,
        longitude: -122.3871157,
        density: 33.1951173298305,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:54:57.000Z',
        end_time: '2026-07-29T14:55:57.000Z',
        latitude: 37.7884333,
        longitude: -122.3871157,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:53:57.000Z',
        end_time: '2026-07-29T14:54:57.000Z',
        latitude: 37.7884042,
        longitude: -122.3871942,
        density: 10.526315789473683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:53:57.000Z',
        end_time: '2026-07-29T14:54:57.000Z',
        latitude: 37.7884042,
        longitude: -122.3871942,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:53:57.000Z',
        end_time: '2026-07-29T14:54:57.000Z',
        latitude: 37.7884042,
        longitude: -122.3871942,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:52:57.000Z',
        end_time: '2026-07-29T14:53:57.000Z',
        latitude: 37.7884438,
        longitude: -122.3869928,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T14:48:57.000Z',
        end_time: '2026-07-29T14:53:57.000Z',
        latitude: 37.7883833,
        longitude: -122.3872167,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:52:57.000Z',
        end_time: '2026-07-29T14:53:57.000Z',
        latitude: 37.7884438,
        longitude: -122.3869928,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:52:57.000Z',
        end_time: '2026-07-29T14:53:57.000Z',
        latitude: 37.7884438,
        longitude: -122.3869928,
        density: 2.555612213465195,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T14:48:57.000Z',
        end_time: '2026-07-29T14:53:57.000Z',
        latitude: 37.7883833,
        longitude: -122.3872167,
        density: 6.842105263157896,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T14:48:57.000Z',
        end_time: '2026-07-29T14:53:57.000Z',
        latitude: 37.7883833,
        longitude: -122.3872167,
        density: 20.052414453528215,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:51:57.000Z',
        end_time: '2026-07-29T14:52:57.000Z',
        latitude: 37.788469,
        longitude: -122.3869448,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:51:57.000Z',
        end_time: '2026-07-29T14:52:57.000Z',
        latitude: 37.788469,
        longitude: -122.3869448,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:51:57.000Z',
        end_time: '2026-07-29T14:52:57.000Z',
        latitude: 37.788469,
        longitude: -122.3869448,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:50:57.000Z',
        end_time: '2026-07-29T14:51:57.000Z',
        latitude: 37.7884532,
        longitude: -122.3871083,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:50:57.000Z',
        end_time: '2026-07-29T14:51:57.000Z',
        latitude: 37.7884532,
        longitude: -122.3871083,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:50:57.000Z',
        end_time: '2026-07-29T14:51:57.000Z',
        latitude: 37.7884532,
        longitude: -122.3871083,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:49:57.000Z',
        end_time: '2026-07-29T14:50:57.000Z',
        latitude: 37.7884678,
        longitude: -122.3871587,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:49:57.000Z',
        end_time: '2026-07-29T14:50:57.000Z',
        latitude: 37.7884678,
        longitude: -122.3871587,
        density: 13.369578518251277,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:49:57.000Z',
        end_time: '2026-07-29T14:50:57.000Z',
        latitude: 37.7884678,
        longitude: -122.3871587,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T14:43:57.000Z',
        end_time: '2026-07-29T14:48:57.000Z',
        latitude: 37.78845,
        longitude: -122.3871167,
        density: 7.368421052631578,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T14:43:57.000Z',
        end_time: '2026-07-29T14:48:57.000Z',
        latitude: 37.78845,
        longitude: -122.3871167,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:47:57.000Z',
        end_time: '2026-07-29T14:48:57.000Z',
        latitude: 37.7884662,
        longitude: -122.3871425,
        density: 31.57894736842105,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:47:57.000Z',
        end_time: '2026-07-29T14:48:57.000Z',
        latitude: 37.7884662,
        longitude: -122.3871425,
        density: 53.37737724061229,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:47:57.000Z',
        end_time: '2026-07-29T14:48:57.000Z',
        latitude: 37.7884662,
        longitude: -122.3871425,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T14:43:57.000Z',
        end_time: '2026-07-29T14:48:57.000Z',
        latitude: 37.78845,
        longitude: -122.3871167,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:46:57.000Z',
        end_time: '2026-07-29T14:47:57.000Z',
        latitude: 37.7884793,
        longitude: -122.3871415,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:46:57.000Z',
        end_time: '2026-07-29T14:47:57.000Z',
        latitude: 37.7884793,
        longitude: -122.3871415,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:46:57.000Z',
        end_time: '2026-07-29T14:47:57.000Z',
        latitude: 37.7884793,
        longitude: -122.3871415,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:45:57.000Z',
        end_time: '2026-07-29T14:46:57.000Z',
        latitude: 37.7884905,
        longitude: -122.3871593,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:45:57.000Z',
        end_time: '2026-07-29T14:46:57.000Z',
        latitude: 37.7884905,
        longitude: -122.3871593,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:45:57.000Z',
        end_time: '2026-07-29T14:46:57.000Z',
        latitude: 37.7884905,
        longitude: -122.3871593,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:44:57.000Z',
        end_time: '2026-07-29T14:45:57.000Z',
        latitude: 37.7884878,
        longitude: -122.3871523,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:44:57.000Z',
        end_time: '2026-07-29T14:45:57.000Z',
        latitude: 37.7884878,
        longitude: -122.3871523,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:44:57.000Z',
        end_time: '2026-07-29T14:45:57.000Z',
        latitude: 37.7884878,
        longitude: -122.3871523,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T14:38:57.000Z',
        end_time: '2026-07-29T14:43:57.000Z',
        latitude: 37.7884833,
        longitude: -122.3870333,
        density: 6.315789473684211,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T14:38:57.000Z',
        end_time: '2026-07-29T14:43:57.000Z',
        latitude: 37.7884833,
        longitude: -122.3870333,
        density: 10.877532896271617,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:42:57.000Z',
        end_time: '2026-07-29T14:43:57.000Z',
        latitude: 37.7885147,
        longitude: -122.3871278,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:42:57.000Z',
        end_time: '2026-07-29T14:43:57.000Z',
        latitude: 37.7885147,
        longitude: -122.3871278,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:42:57.000Z',
        end_time: '2026-07-29T14:43:57.000Z',
        latitude: 37.7885147,
        longitude: -122.3871278,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T14:38:57.000Z',
        end_time: '2026-07-29T14:43:57.000Z',
        latitude: 37.7884833,
        longitude: -122.3870333,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:41:57.000Z',
        end_time: '2026-07-29T14:42:57.000Z',
        latitude: 37.7885232,
        longitude: -122.3871048,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:41:57.000Z',
        end_time: '2026-07-29T14:42:57.000Z',
        latitude: 37.7885232,
        longitude: -122.3871048,
        density: 15.789473684210526,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:41:57.000Z',
        end_time: '2026-07-29T14:42:57.000Z',
        latitude: 37.7885232,
        longitude: -122.3871048,
        density: 18.254589856120486,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:40:57.000Z',
        end_time: '2026-07-29T14:41:57.000Z',
        latitude: 37.7884392,
        longitude: -122.3872153,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:40:57.000Z',
        end_time: '2026-07-29T14:41:57.000Z',
        latitude: 37.7884392,
        longitude: -122.3872153,
        density: 20.196932217430962,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:40:57.000Z',
        end_time: '2026-07-29T14:41:57.000Z',
        latitude: 37.7884392,
        longitude: -122.3872153,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:39:57.000Z',
        end_time: '2026-07-29T14:40:57.000Z',
        latitude: 37.7885277,
        longitude: -122.3871317,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:39:57.000Z',
        end_time: '2026-07-29T14:40:57.000Z',
        latitude: 37.7885277,
        longitude: -122.3871317,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:39:57.000Z',
        end_time: '2026-07-29T14:40:57.000Z',
        latitude: 37.7885277,
        longitude: -122.3871317,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:38:57.000Z',
        end_time: '2026-07-29T14:39:57.000Z',
        latitude: 37.788514,
        longitude: -122.387114,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:38:57.000Z',
        end_time: '2026-07-29T14:39:57.000Z',
        latitude: 37.788514,
        longitude: -122.387114,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:38:57.000Z',
        end_time: '2026-07-29T14:39:57.000Z',
        latitude: 37.788514,
        longitude: -122.387114,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:37:57.000Z',
        end_time: '2026-07-29T14:38:57.000Z',
        latitude: 37.7884467,
        longitude: -122.3869842,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T14:33:57.000Z',
        end_time: '2026-07-29T14:38:57.000Z',
        latitude: 37.7885,
        longitude: -122.3871,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:37:57.000Z',
        end_time: '2026-07-29T14:38:57.000Z',
        latitude: 37.7884467,
        longitude: -122.3869842,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:37:57.000Z',
        end_time: '2026-07-29T14:38:57.000Z',
        latitude: 37.7884467,
        longitude: -122.3869842,
        density: 26.094467112682167,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T14:33:57.000Z',
        end_time: '2026-07-29T14:38:57.000Z',
        latitude: 37.7885,
        longitude: -122.3871,
        density: 20,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T14:33:57.000Z',
        end_time: '2026-07-29T14:38:57.000Z',
        latitude: 37.7885,
        longitude: -122.3871,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:36:57.000Z',
        end_time: '2026-07-29T14:37:57.000Z',
        latitude: 37.7880607,
        longitude: -122.3863443,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:36:57.000Z',
        end_time: '2026-07-29T14:37:57.000Z',
        latitude: 37.7880607,
        longitude: -122.3863443,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:36:57.000Z',
        end_time: '2026-07-29T14:37:57.000Z',
        latitude: 37.7880607,
        longitude: -122.3863443,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:35:57.000Z',
        end_time: '2026-07-29T14:36:57.000Z',
        latitude: 37.7885205,
        longitude: -122.3872067,
        density: 36.84210526315789,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:35:57.000Z',
        end_time: '2026-07-29T14:36:57.000Z',
        latitude: 37.7885205,
        longitude: -122.3872067,
        density: 11.865019363739204,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:35:57.000Z',
        end_time: '2026-07-29T14:36:57.000Z',
        latitude: 37.7885205,
        longitude: -122.3872067,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:34:57.000Z',
        end_time: '2026-07-29T14:35:57.000Z',
        latitude: 37.7885,
        longitude: -122.387224,
        density: 26.31578947368421,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:34:57.000Z',
        end_time: '2026-07-29T14:35:57.000Z',
        latitude: 37.7885,
        longitude: -122.387224,
        density: 17.245130850221347,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:34:57.000Z',
        end_time: '2026-07-29T14:35:57.000Z',
        latitude: 37.7885,
        longitude: -122.387224,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T14:28:57.000Z',
        end_time: '2026-07-29T14:33:57.000Z',
        latitude: 37.7885333,
        longitude: -122.38715,
        density: 18.947368421052634,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T14:28:57.000Z',
        end_time: '2026-07-29T14:33:57.000Z',
        latitude: 37.7885333,
        longitude: -122.38715,
        density: 47.98772208542262,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:32:57.000Z',
        end_time: '2026-07-29T14:33:57.000Z',
        latitude: 37.7884857,
        longitude: -122.3870315,
        density: 10.526315789473683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:32:57.000Z',
        end_time: '2026-07-29T14:33:57.000Z',
        latitude: 37.7884857,
        longitude: -122.3870315,
        density: 22.24890002644262,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:32:57.000Z',
        end_time: '2026-07-29T14:33:57.000Z',
        latitude: 37.7884857,
        longitude: -122.3870315,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T14:28:57.000Z',
        end_time: '2026-07-29T14:33:57.000Z',
        latitude: 37.7885333,
        longitude: -122.38715,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:31:57.000Z',
        end_time: '2026-07-29T14:32:57.000Z',
        latitude: 37.7884657,
        longitude: -122.3868587,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:31:57.000Z',
        end_time: '2026-07-29T14:32:57.000Z',
        latitude: 37.7884657,
        longitude: -122.3868587,
        density: 18.421052631578945,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:31:57.000Z',
        end_time: '2026-07-29T14:32:57.000Z',
        latitude: 37.7884657,
        longitude: -122.3868587,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:30:57.000Z',
        end_time: '2026-07-29T14:31:57.000Z',
        latitude: 37.7885293,
        longitude: -122.3869487,
        density: 26.31578947368421,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:30:57.000Z',
        end_time: '2026-07-29T14:31:57.000Z',
        latitude: 37.7885293,
        longitude: -122.3869487,
        density: 8.154155978160073,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:30:57.000Z',
        end_time: '2026-07-29T14:31:57.000Z',
        latitude: 37.7885293,
        longitude: -122.3869487,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:29:57.000Z',
        end_time: '2026-07-29T14:30:57.000Z',
        latitude: 37.788424,
        longitude: -122.386816,
        density: 10.526315789473683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:29:57.000Z',
        end_time: '2026-07-29T14:30:57.000Z',
        latitude: 37.788424,
        longitude: -122.386816,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:29:57.000Z',
        end_time: '2026-07-29T14:30:57.000Z',
        latitude: 37.788424,
        longitude: -122.386816,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T14:23:57.000Z',
        end_time: '2026-07-29T14:28:57.000Z',
        latitude: 37.7884667,
        longitude: -122.387,
        density: 6.315789473684211,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T14:23:57.000Z',
        end_time: '2026-07-29T14:28:57.000Z',
        latitude: 37.7884667,
        longitude: -122.387,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:27:57.000Z',
        end_time: '2026-07-29T14:28:57.000Z',
        latitude: 37.7884727,
        longitude: -122.3871472,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:27:57.000Z',
        end_time: '2026-07-29T14:28:57.000Z',
        latitude: 37.7884727,
        longitude: -122.3871472,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:27:57.000Z',
        end_time: '2026-07-29T14:28:57.000Z',
        latitude: 37.7884727,
        longitude: -122.3871472,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T14:23:57.000Z',
        end_time: '2026-07-29T14:28:57.000Z',
        latitude: 37.7884667,
        longitude: -122.387,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:26:57.000Z',
        end_time: '2026-07-29T14:27:57.000Z',
        latitude: 37.7884203,
        longitude: -122.3870613,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:26:57.000Z',
        end_time: '2026-07-29T14:27:57.000Z',
        latitude: 37.7884203,
        longitude: -122.3870613,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:26:57.000Z',
        end_time: '2026-07-29T14:27:57.000Z',
        latitude: 37.7884203,
        longitude: -122.3870613,
        density: 16.454658075000296,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:25:57.000Z',
        end_time: '2026-07-29T14:26:57.000Z',
        latitude: 37.7884288,
        longitude: -122.3870843,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:25:57.000Z',
        end_time: '2026-07-29T14:26:57.000Z',
        latitude: 37.7884288,
        longitude: -122.3870843,
        density: 2.29414022068368,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:25:57.000Z',
        end_time: '2026-07-29T14:26:57.000Z',
        latitude: 37.7884288,
        longitude: -122.3870843,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:24:57.000Z',
        end_time: '2026-07-29T14:25:57.000Z',
        latitude: 37.7884455,
        longitude: -122.3870978,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:24:57.000Z',
        end_time: '2026-07-29T14:25:57.000Z',
        latitude: 37.7884455,
        longitude: -122.3870978,
        density: 9.115987414811716,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:24:57.000Z',
        end_time: '2026-07-29T14:25:57.000Z',
        latitude: 37.7884455,
        longitude: -122.3870978,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:22:57.000Z',
        end_time: '2026-07-29T14:23:57.000Z',
        latitude: 37.7884942,
        longitude: -122.3868217,
        density: 23.684210526315788,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:22:57.000Z',
        end_time: '2026-07-29T14:23:57.000Z',
        latitude: 37.7884942,
        longitude: -122.3868217,
        density: 30.707459134544997,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:22:57.000Z',
        end_time: '2026-07-29T14:23:57.000Z',
        latitude: 37.7884942,
        longitude: -122.3868217,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T14:18:57.000Z',
        end_time: '2026-07-29T14:23:57.000Z',
        latitude: 37.7884833,
        longitude: -122.3870333,
        density: 24.210526315789473,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T14:18:57.000Z',
        end_time: '2026-07-29T14:23:57.000Z',
        latitude: 37.7884833,
        longitude: -122.3870333,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T14:18:57.000Z',
        end_time: '2026-07-29T14:23:57.000Z',
        latitude: 37.7884833,
        longitude: -122.3870333,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:21:57.000Z',
        end_time: '2026-07-29T14:22:57.000Z',
        latitude: 37.7884635,
        longitude: -122.3872808,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:21:57.000Z',
        end_time: '2026-07-29T14:22:57.000Z',
        latitude: 37.7884635,
        longitude: -122.3872808,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:21:57.000Z',
        end_time: '2026-07-29T14:22:57.000Z',
        latitude: 37.7884635,
        longitude: -122.3872808,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:20:57.000Z',
        end_time: '2026-07-29T14:21:57.000Z',
        latitude: 37.7884703,
        longitude: -122.387064,
        density: 21.052631578947366,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:20:57.000Z',
        end_time: '2026-07-29T14:21:57.000Z',
        latitude: 37.7884703,
        longitude: -122.387064,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:20:57.000Z',
        end_time: '2026-07-29T14:21:57.000Z',
        latitude: 37.7884703,
        longitude: -122.387064,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:19:57.000Z',
        end_time: '2026-07-29T14:20:57.000Z',
        latitude: 37.7884328,
        longitude: -122.3870207,
        density: 36.84210526315789,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:19:57.000Z',
        end_time: '2026-07-29T14:20:57.000Z',
        latitude: 37.7884328,
        longitude: -122.3870207,
        density: 16.266903175381863,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:19:57.000Z',
        end_time: '2026-07-29T14:20:57.000Z',
        latitude: 37.7884328,
        longitude: -122.3870207,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:18:57.000Z',
        end_time: '2026-07-29T14:19:57.000Z',
        latitude: 37.788445,
        longitude: -122.3870727,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:18:57.000Z',
        end_time: '2026-07-29T14:19:57.000Z',
        latitude: 37.788445,
        longitude: -122.3870727,
        density: 31.57894736842105,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:18:57.000Z',
        end_time: '2026-07-29T14:19:57.000Z',
        latitude: 37.788445,
        longitude: -122.3870727,
        density: 39.277507076715025,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T14:13:57.000Z',
        end_time: '2026-07-29T14:18:57.000Z',
        latitude: 37.7884333,
        longitude: -122.3870833,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:17:57.000Z',
        end_time: '2026-07-29T14:18:57.000Z',
        latitude: 37.7884302,
        longitude: -122.3871113,
        density: 23.684210526315788,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:17:57.000Z',
        end_time: '2026-07-29T14:18:57.000Z',
        latitude: 37.7884302,
        longitude: -122.3871113,
        density: 51.59761999675134,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:17:57.000Z',
        end_time: '2026-07-29T14:18:57.000Z',
        latitude: 37.7884302,
        longitude: -122.3871113,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T14:13:57.000Z',
        end_time: '2026-07-29T14:18:57.000Z',
        latitude: 37.7884333,
        longitude: -122.3870833,
        density: 18.947368421052634,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T14:13:57.000Z',
        end_time: '2026-07-29T14:18:57.000Z',
        latitude: 37.7884333,
        longitude: -122.3870833,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:16:57.000Z',
        end_time: '2026-07-29T14:17:57.000Z',
        latitude: 37.7884182,
        longitude: -122.3871908,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:16:57.000Z',
        end_time: '2026-07-29T14:17:57.000Z',
        latitude: 37.7884182,
        longitude: -122.3871908,
        density: 15.789473684210526,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:16:57.000Z',
        end_time: '2026-07-29T14:17:57.000Z',
        latitude: 37.7884182,
        longitude: -122.3871908,
        density: 22.36933579319517,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:15:57.000Z',
        end_time: '2026-07-29T14:16:57.000Z',
        latitude: 37.7884438,
        longitude: -122.3870977,
        density: 23.684210526315788,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:15:57.000Z',
        end_time: '2026-07-29T14:16:57.000Z',
        latitude: 37.7884438,
        longitude: -122.3870977,
        density: 4.9908132164350185,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:15:57.000Z',
        end_time: '2026-07-29T14:16:57.000Z',
        latitude: 37.7884438,
        longitude: -122.3870977,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:14:57.000Z',
        end_time: '2026-07-29T14:15:57.000Z',
        latitude: 37.788435,
        longitude: -122.3871053,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:14:57.000Z',
        end_time: '2026-07-29T14:15:57.000Z',
        latitude: 37.788435,
        longitude: -122.3871053,
        density: 36.37466902721207,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:14:57.000Z',
        end_time: '2026-07-29T14:15:57.000Z',
        latitude: 37.788435,
        longitude: -122.3871053,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:12:57.000Z',
        end_time: '2026-07-29T14:13:57.000Z',
        latitude: 37.7884983,
        longitude: -122.386995,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:12:57.000Z',
        end_time: '2026-07-29T14:13:57.000Z',
        latitude: 37.7884983,
        longitude: -122.386995,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:12:57.000Z',
        end_time: '2026-07-29T14:13:57.000Z',
        latitude: 37.7884983,
        longitude: -122.386995,
        density: 1.3100147614412716,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T14:08:57.000Z',
        end_time: '2026-07-29T14:13:57.000Z',
        latitude: 37.7884333,
        longitude: -122.38695,
        density: 1.5789473684210527,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T14:08:57.000Z',
        end_time: '2026-07-29T14:13:57.000Z',
        latitude: 37.7884333,
        longitude: -122.38695,
        density: 16.698285276497966,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T14:08:57.000Z',
        end_time: '2026-07-29T14:13:57.000Z',
        latitude: 37.7884333,
        longitude: -122.38695,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:11:57.000Z',
        end_time: '2026-07-29T14:12:57.000Z',
        latitude: 37.78851,
        longitude: -122.3869958,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:11:57.000Z',
        end_time: '2026-07-29T14:12:57.000Z',
        latitude: 37.78851,
        longitude: -122.3869958,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:11:57.000Z',
        end_time: '2026-07-29T14:12:57.000Z',
        latitude: 37.78851,
        longitude: -122.3869958,
        density: 7.673252373890575,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:10:57.000Z',
        end_time: '2026-07-29T14:11:57.000Z',
        latitude: 37.7885508,
        longitude: -122.3867298,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:10:57.000Z',
        end_time: '2026-07-29T14:11:57.000Z',
        latitude: 37.7885508,
        longitude: -122.3867298,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:10:57.000Z',
        end_time: '2026-07-29T14:11:57.000Z',
        latitude: 37.7885508,
        longitude: -122.3867298,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:09:57.000Z',
        end_time: '2026-07-29T14:10:57.000Z',
        latitude: 37.7885478,
        longitude: -122.3865305,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:09:57.000Z',
        end_time: '2026-07-29T14:10:57.000Z',
        latitude: 37.7885478,
        longitude: -122.3865305,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:09:57.000Z',
        end_time: '2026-07-29T14:10:57.000Z',
        latitude: 37.7885478,
        longitude: -122.3865305,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T14:03:57.000Z',
        end_time: '2026-07-29T14:08:57.000Z',
        latitude: 37.7886333,
        longitude: -122.38575,
        density: 3.1578947368421053,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T14:03:57.000Z',
        end_time: '2026-07-29T14:08:57.000Z',
        latitude: 37.7886333,
        longitude: -122.38575,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T14:03:57.000Z',
        end_time: '2026-07-29T14:08:57.000Z',
        latitude: 37.7886333,
        longitude: -122.38575,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:07:57.000Z',
        end_time: '2026-07-29T14:08:57.000Z',
        latitude: 37.7885043,
        longitude: -122.3867795,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:07:57.000Z',
        end_time: '2026-07-29T14:08:57.000Z',
        latitude: 37.7885043,
        longitude: -122.3867795,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:07:57.000Z',
        end_time: '2026-07-29T14:08:57.000Z',
        latitude: 37.7885043,
        longitude: -122.3867795,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:06:57.000Z',
        end_time: '2026-07-29T14:07:57.000Z',
        latitude: 37.7884553,
        longitude: -122.3869475,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:06:57.000Z',
        end_time: '2026-07-29T14:07:57.000Z',
        latitude: 37.7884553,
        longitude: -122.3869475,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:06:57.000Z',
        end_time: '2026-07-29T14:07:57.000Z',
        latitude: 37.7884553,
        longitude: -122.3869475,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:05:57.000Z',
        end_time: '2026-07-29T14:06:57.000Z',
        latitude: 37.7884702,
        longitude: -122.3868423,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:05:57.000Z',
        end_time: '2026-07-29T14:06:57.000Z',
        latitude: 37.7884702,
        longitude: -122.3868423,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:05:57.000Z',
        end_time: '2026-07-29T14:06:57.000Z',
        latitude: 37.7884702,
        longitude: -122.3868423,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:04:57.000Z',
        end_time: '2026-07-29T14:05:57.000Z',
        latitude: 37.7885277,
        longitude: -122.386932,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:04:57.000Z',
        end_time: '2026-07-29T14:05:57.000Z',
        latitude: 37.7885277,
        longitude: -122.386932,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:04:57.000Z',
        end_time: '2026-07-29T14:05:57.000Z',
        latitude: 37.7885277,
        longitude: -122.386932,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:03:57.000Z',
        end_time: '2026-07-29T14:04:57.000Z',
        latitude: 37.7884388,
        longitude: -122.3871198,
        density: 15.789473684210526,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:03:57.000Z',
        end_time: '2026-07-29T14:04:57.000Z',
        latitude: 37.7884388,
        longitude: -122.3871198,
        density: 10.364574164286616,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:03:57.000Z',
        end_time: '2026-07-29T14:04:57.000Z',
        latitude: 37.7884388,
        longitude: -122.3871198,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:02:57.000Z',
        end_time: '2026-07-29T14:03:57.000Z',
        latitude: 37.7884253,
        longitude: -122.387294,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T13:58:57.000Z',
        end_time: '2026-07-29T14:03:57.000Z',
        latitude: 37.7884,
        longitude: -122.3868833,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:02:57.000Z',
        end_time: '2026-07-29T14:03:57.000Z',
        latitude: 37.7884253,
        longitude: -122.387294,
        density: 31.57894736842105,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:02:57.000Z',
        end_time: '2026-07-29T14:03:57.000Z',
        latitude: 37.7884253,
        longitude: -122.387294,
        density: 19.80347871875059,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T13:58:57.000Z',
        end_time: '2026-07-29T14:03:57.000Z',
        latitude: 37.7884,
        longitude: -122.3868833,
        density: 30,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T13:58:57.000Z',
        end_time: '2026-07-29T14:03:57.000Z',
        latitude: 37.7884,
        longitude: -122.3868833,
        density: 21.47511359449797,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:01:57.000Z',
        end_time: '2026-07-29T14:02:57.000Z',
        latitude: 37.7884463,
        longitude: -122.3870082,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:01:57.000Z',
        end_time: '2026-07-29T14:02:57.000Z',
        latitude: 37.7884463,
        longitude: -122.3870082,
        density: 31.57894736842105,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:01:57.000Z',
        end_time: '2026-07-29T14:02:57.000Z',
        latitude: 37.7884463,
        longitude: -122.3870082,
        density: 7.487575307112646,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T14:00:57.000Z',
        end_time: '2026-07-29T14:01:57.000Z',
        latitude: 37.7884337,
        longitude: -122.3867498,
        density: 36.84210526315789,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T14:00:57.000Z',
        end_time: '2026-07-29T14:01:57.000Z',
        latitude: 37.7884337,
        longitude: -122.3867498,
        density: 33.26029905057168,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T14:00:57.000Z',
        end_time: '2026-07-29T14:01:57.000Z',
        latitude: 37.7884337,
        longitude: -122.3867498,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:59:57.000Z',
        end_time: '2026-07-29T14:00:57.000Z',
        latitude: 37.7884337,
        longitude: -122.3870543,
        density: 23.684210526315788,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:59:57.000Z',
        end_time: '2026-07-29T14:00:57.000Z',
        latitude: 37.7884337,
        longitude: -122.3870543,
        density: 27.430097092688964,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:59:57.000Z',
        end_time: '2026-07-29T14:00:57.000Z',
        latitude: 37.7884337,
        longitude: -122.3870543,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:58:57.000Z',
        end_time: '2026-07-29T13:59:57.000Z',
        latitude: 37.7884552,
        longitude: -122.387068,
        density: 26.31578947368421,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:58:57.000Z',
        end_time: '2026-07-29T13:59:57.000Z',
        latitude: 37.7884552,
        longitude: -122.387068,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:58:57.000Z',
        end_time: '2026-07-29T13:59:57.000Z',
        latitude: 37.7884552,
        longitude: -122.387068,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T13:53:57.000Z',
        end_time: '2026-07-29T13:58:57.000Z',
        latitude: 37.78845,
        longitude: -122.38705,
        density: 22.105263157894736,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T13:53:57.000Z',
        end_time: '2026-07-29T13:58:57.000Z',
        latitude: 37.78845,
        longitude: -122.38705,
        density: 10.025872584675934,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:57:57.000Z',
        end_time: '2026-07-29T13:58:57.000Z',
        latitude: 37.788467,
        longitude: -122.3869958,
        density: 23.684210526315788,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:57:57.000Z',
        end_time: '2026-07-29T13:58:57.000Z',
        latitude: 37.788467,
        longitude: -122.3869958,
        density: 37.60117027498565,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:57:57.000Z',
        end_time: '2026-07-29T13:58:57.000Z',
        latitude: 37.788467,
        longitude: -122.3869958,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T13:53:57.000Z',
        end_time: '2026-07-29T13:58:57.000Z',
        latitude: 37.78845,
        longitude: -122.38705,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:56:57.000Z',
        end_time: '2026-07-29T13:57:57.000Z',
        latitude: 37.7884288,
        longitude: -122.387015,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:56:57.000Z',
        end_time: '2026-07-29T13:57:57.000Z',
        latitude: 37.7884288,
        longitude: -122.387015,
        density: 31.57894736842105,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:56:57.000Z',
        end_time: '2026-07-29T13:57:57.000Z',
        latitude: 37.7884288,
        longitude: -122.387015,
        density: 7.202909379038513,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:55:57.000Z',
        end_time: '2026-07-29T13:56:57.000Z',
        latitude: 37.7884472,
        longitude: -122.3870963,
        density: 23.684210526315788,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:55:57.000Z',
        end_time: '2026-07-29T13:56:57.000Z',
        latitude: 37.7884472,
        longitude: -122.3870963,
        density: 2.0932330521357976,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:55:57.000Z',
        end_time: '2026-07-29T13:56:57.000Z',
        latitude: 37.7884472,
        longitude: -122.3870963,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:54:57.000Z',
        end_time: '2026-07-29T13:55:57.000Z',
        latitude: 37.7884457,
        longitude: -122.3871175,
        density: 26.31578947368421,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:54:57.000Z',
        end_time: '2026-07-29T13:55:57.000Z',
        latitude: 37.7884457,
        longitude: -122.3871175,
        density: 34.46199863750487,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:54:57.000Z',
        end_time: '2026-07-29T13:55:57.000Z',
        latitude: 37.7884457,
        longitude: -122.3871175,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T13:48:57.000Z',
        end_time: '2026-07-29T13:53:57.000Z',
        latitude: 37.7884333,
        longitude: -122.3871,
        density: 36.31578947368421,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T13:48:57.000Z',
        end_time: '2026-07-29T13:53:57.000Z',
        latitude: 37.7884333,
        longitude: -122.3871,
        density: 47.74954721971362,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:52:57.000Z',
        end_time: '2026-07-29T13:53:57.000Z',
        latitude: 37.788448,
        longitude: -122.3870745,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:52:57.000Z',
        end_time: '2026-07-29T13:53:57.000Z',
        latitude: 37.788448,
        longitude: -122.3870745,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:52:57.000Z',
        end_time: '2026-07-29T13:53:57.000Z',
        latitude: 37.788448,
        longitude: -122.3870745,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T13:48:57.000Z',
        end_time: '2026-07-29T13:53:57.000Z',
        latitude: 37.7884333,
        longitude: -122.3871,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:51:57.000Z',
        end_time: '2026-07-29T13:52:57.000Z',
        latitude: 37.7884505,
        longitude: -122.3871277,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:51:57.000Z',
        end_time: '2026-07-29T13:52:57.000Z',
        latitude: 37.7884505,
        longitude: -122.3871277,
        density: 44.73684210526316,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:51:57.000Z',
        end_time: '2026-07-29T13:52:57.000Z',
        latitude: 37.7884505,
        longitude: -122.3871277,
        density: 51.15904646489005,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:50:57.000Z',
        end_time: '2026-07-29T13:51:57.000Z',
        latitude: 37.7884543,
        longitude: -122.3871778,
        density: 65.78947368421053,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:50:57.000Z',
        end_time: '2026-07-29T13:51:57.000Z',
        latitude: 37.7884543,
        longitude: -122.3871778,
        density: 59.592640418730404,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:50:57.000Z',
        end_time: '2026-07-29T13:51:57.000Z',
        latitude: 37.7884543,
        longitude: -122.3871778,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:49:57.000Z',
        end_time: '2026-07-29T13:50:57.000Z',
        latitude: 37.7884445,
        longitude: -122.3871938,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:49:57.000Z',
        end_time: '2026-07-29T13:50:57.000Z',
        latitude: 37.7884445,
        longitude: -122.3871938,
        density: 47.368421052631575,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:49:57.000Z',
        end_time: '2026-07-29T13:50:57.000Z',
        latitude: 37.7884445,
        longitude: -122.3871938,
        density: 25.271266475919973,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:47:57.000Z',
        end_time: '2026-07-29T13:48:57.000Z',
        latitude: 37.7884338,
        longitude: -122.3871442,
        density: 21.052631578947366,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:47:57.000Z',
        end_time: '2026-07-29T13:48:57.000Z',
        latitude: 37.7884338,
        longitude: -122.3871442,
        density: 47.64775469053333,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:47:57.000Z',
        end_time: '2026-07-29T13:48:57.000Z',
        latitude: 37.7884338,
        longitude: -122.3871442,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T13:43:57.000Z',
        end_time: '2026-07-29T13:48:57.000Z',
        latitude: 37.78845,
        longitude: -122.3874667,
        density: 9.473684210526317,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T13:43:57.000Z',
        end_time: '2026-07-29T13:48:57.000Z',
        latitude: 37.78845,
        longitude: -122.3874667,
        density: 28.91653819972926,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T13:43:57.000Z',
        end_time: '2026-07-29T13:48:57.000Z',
        latitude: 37.78845,
        longitude: -122.3874667,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:46:57.000Z',
        end_time: '2026-07-29T13:47:57.000Z',
        latitude: 37.7884345,
        longitude: -122.3870482,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:46:57.000Z',
        end_time: '2026-07-29T13:47:57.000Z',
        latitude: 37.7884345,
        longitude: -122.3870482,
        density: 15.789473684210526,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:46:57.000Z',
        end_time: '2026-07-29T13:47:57.000Z',
        latitude: 37.7884345,
        longitude: -122.3870482,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:45:57.000Z',
        end_time: '2026-07-29T13:46:57.000Z',
        latitude: 37.7884642,
        longitude: -122.3871372,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:45:57.000Z',
        end_time: '2026-07-29T13:46:57.000Z',
        latitude: 37.7884642,
        longitude: -122.3871372,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:45:57.000Z',
        end_time: '2026-07-29T13:46:57.000Z',
        latitude: 37.7884642,
        longitude: -122.3871372,
        density: 10.00889619332162,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:44:57.000Z',
        end_time: '2026-07-29T13:45:57.000Z',
        latitude: 37.788488,
        longitude: -122.3871332,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:44:57.000Z',
        end_time: '2026-07-29T13:45:57.000Z',
        latitude: 37.788488,
        longitude: -122.3871332,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:44:57.000Z',
        end_time: '2026-07-29T13:45:57.000Z',
        latitude: 37.788488,
        longitude: -122.3871332,
        density: 31.756059323529474,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T13:38:57.000Z',
        end_time: '2026-07-29T13:43:57.000Z',
        latitude: 37.7884667,
        longitude: -122.3870667,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T13:38:57.000Z',
        end_time: '2026-07-29T13:43:57.000Z',
        latitude: 37.7884667,
        longitude: -122.3870667,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T13:38:57.000Z',
        end_time: '2026-07-29T13:43:57.000Z',
        latitude: 37.7884667,
        longitude: -122.3870667,
        density: 4.902900864073198,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:42:57.000Z',
        end_time: '2026-07-29T13:43:57.000Z',
        latitude: 37.7884543,
        longitude: -122.38712,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:42:57.000Z',
        end_time: '2026-07-29T13:43:57.000Z',
        latitude: 37.7884543,
        longitude: -122.38712,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:42:57.000Z',
        end_time: '2026-07-29T13:43:57.000Z',
        latitude: 37.7884543,
        longitude: -122.38712,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:41:57.000Z',
        end_time: '2026-07-29T13:42:57.000Z',
        latitude: 37.7885647,
        longitude: -122.3870865,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:41:57.000Z',
        end_time: '2026-07-29T13:42:57.000Z',
        latitude: 37.7885647,
        longitude: -122.3870865,
        density: 18.421052631578945,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:41:57.000Z',
        end_time: '2026-07-29T13:42:57.000Z',
        latitude: 37.7885647,
        longitude: -122.3870865,
        density: 38.01692597017835,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:40:57.000Z',
        end_time: '2026-07-29T13:41:57.000Z',
        latitude: 37.7885655,
        longitude: -122.387201,
        density: 26.31578947368421,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:40:57.000Z',
        end_time: '2026-07-29T13:41:57.000Z',
        latitude: 37.7885655,
        longitude: -122.387201,
        density: 27.57201781235984,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:40:57.000Z',
        end_time: '2026-07-29T13:41:57.000Z',
        latitude: 37.7885655,
        longitude: -122.387201,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:39:57.000Z',
        end_time: '2026-07-29T13:40:57.000Z',
        latitude: 37.7885827,
        longitude: -122.3872155,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:39:57.000Z',
        end_time: '2026-07-29T13:40:57.000Z',
        latitude: 37.7885827,
        longitude: -122.3872155,
        density: 22.12217421308989,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:39:57.000Z',
        end_time: '2026-07-29T13:40:57.000Z',
        latitude: 37.7885827,
        longitude: -122.3872155,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T13:33:58.000Z',
        end_time: '2026-07-29T13:38:58.000Z',
        latitude: 37.7885167,
        longitude: -122.3871667,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T13:33:58.000Z',
        end_time: '2026-07-29T13:38:58.000Z',
        latitude: 37.7885167,
        longitude: -122.3871667,
        density: 3.1578947368421053,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T13:33:58.000Z',
        end_time: '2026-07-29T13:38:58.000Z',
        latitude: 37.7885167,
        longitude: -122.3871667,
        density: 20.871209846093773,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:37:57.000Z',
        end_time: '2026-07-29T13:38:57.000Z',
        latitude: 37.7884647,
        longitude: -122.3870825,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:37:57.000Z',
        end_time: '2026-07-29T13:38:57.000Z',
        latitude: 37.7884647,
        longitude: -122.3870825,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:37:57.000Z',
        end_time: '2026-07-29T13:38:57.000Z',
        latitude: 37.7884647,
        longitude: -122.3870825,
        density: 17.042083186995626,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:36:57.000Z',
        end_time: '2026-07-29T13:37:57.000Z',
        latitude: 37.788461,
        longitude: -122.3870605,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:36:57.000Z',
        end_time: '2026-07-29T13:37:57.000Z',
        latitude: 37.788461,
        longitude: -122.3870605,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:36:57.000Z',
        end_time: '2026-07-29T13:37:57.000Z',
        latitude: 37.788461,
        longitude: -122.3870605,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:35:57.000Z',
        end_time: '2026-07-29T13:36:57.000Z',
        latitude: 37.7884052,
        longitude: -122.3869947,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:35:57.000Z',
        end_time: '2026-07-29T13:36:57.000Z',
        latitude: 37.7884052,
        longitude: -122.3869947,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:35:57.000Z',
        end_time: '2026-07-29T13:36:57.000Z',
        latitude: 37.7884052,
        longitude: -122.3869947,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:34:57.000Z',
        end_time: '2026-07-29T13:35:57.000Z',
        latitude: 37.7885928,
        longitude: -122.3871857,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:34:57.000Z',
        end_time: '2026-07-29T13:35:57.000Z',
        latitude: 37.7885928,
        longitude: -122.3871857,
        density: 19.157893954183653,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:34:57.000Z',
        end_time: '2026-07-29T13:35:57.000Z',
        latitude: 37.7885928,
        longitude: -122.3871857,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T13:28:58.000Z',
        end_time: '2026-07-29T13:33:58.000Z',
        latitude: 37.7884833,
        longitude: -122.3871333,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T13:28:58.000Z',
        end_time: '2026-07-29T13:33:58.000Z',
        latitude: 37.7884833,
        longitude: -122.3871333,
        density: 29.07246591822452,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:32:58.000Z',
        end_time: '2026-07-29T13:33:58.000Z',
        latitude: 37.7886417,
        longitude: -122.3871683,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:32:58.000Z',
        end_time: '2026-07-29T13:33:58.000Z',
        latitude: 37.7886417,
        longitude: -122.3871683,
        density: 14.026742137370519,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:32:58.000Z',
        end_time: '2026-07-29T13:33:58.000Z',
        latitude: 37.7886417,
        longitude: -122.3871683,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T13:28:58.000Z',
        end_time: '2026-07-29T13:33:58.000Z',
        latitude: 37.7884833,
        longitude: -122.3871333,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:31:58.000Z',
        end_time: '2026-07-29T13:32:58.000Z',
        latitude: 37.78854,
        longitude: -122.3869817,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:31:58.000Z',
        end_time: '2026-07-29T13:32:58.000Z',
        latitude: 37.78854,
        longitude: -122.3869817,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:31:58.000Z',
        end_time: '2026-07-29T13:32:58.000Z',
        latitude: 37.78854,
        longitude: -122.3869817,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:30:58.000Z',
        end_time: '2026-07-29T13:31:58.000Z',
        latitude: 37.7887048,
        longitude: -122.3872127,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:30:58.000Z',
        end_time: '2026-07-29T13:31:58.000Z',
        latitude: 37.7887048,
        longitude: -122.3872127,
        density: 15.789473684210526,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:30:58.000Z',
        end_time: '2026-07-29T13:31:58.000Z',
        latitude: 37.7887048,
        longitude: -122.3872127,
        density: 10.910475034708583,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:29:58.000Z',
        end_time: '2026-07-29T13:30:58.000Z',
        latitude: 37.788683,
        longitude: -122.3871468,
        density: 15.789473684210526,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:29:58.000Z',
        end_time: '2026-07-29T13:30:58.000Z',
        latitude: 37.788683,
        longitude: -122.3871468,
        density: 14.676258952098523,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:29:58.000Z',
        end_time: '2026-07-29T13:30:58.000Z',
        latitude: 37.788683,
        longitude: -122.3871468,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T13:23:58.000Z',
        end_time: '2026-07-29T13:28:58.000Z',
        latitude: 37.7886167,
        longitude: -122.3872,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:27:58.000Z',
        end_time: '2026-07-29T13:28:58.000Z',
        latitude: 37.7885158,
        longitude: -122.3871162,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:27:58.000Z',
        end_time: '2026-07-29T13:28:58.000Z',
        latitude: 37.7885158,
        longitude: -122.3871162,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:27:58.000Z',
        end_time: '2026-07-29T13:28:58.000Z',
        latitude: 37.7885158,
        longitude: -122.3871162,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T13:23:58.000Z',
        end_time: '2026-07-29T13:28:58.000Z',
        latitude: 37.7886167,
        longitude: -122.3872,
        density: 1.0526315789473684,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T13:23:58.000Z',
        end_time: '2026-07-29T13:28:58.000Z',
        latitude: 37.7886167,
        longitude: -122.3872,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:26:58.000Z',
        end_time: '2026-07-29T13:27:58.000Z',
        latitude: 37.7885638,
        longitude: -122.3870925,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:26:58.000Z',
        end_time: '2026-07-29T13:27:58.000Z',
        latitude: 37.7885638,
        longitude: -122.3870925,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:26:58.000Z',
        end_time: '2026-07-29T13:27:58.000Z',
        latitude: 37.7885638,
        longitude: -122.3870925,
        density: 29.271294772779804,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:25:58.000Z',
        end_time: '2026-07-29T13:26:58.000Z',
        latitude: 37.7885168,
        longitude: -122.3871282,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:25:58.000Z',
        end_time: '2026-07-29T13:26:58.000Z',
        latitude: 37.7885168,
        longitude: -122.3871282,
        density: 11.277263016956743,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:25:58.000Z',
        end_time: '2026-07-29T13:26:58.000Z',
        latitude: 37.7885168,
        longitude: -122.3871282,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:24:58.000Z',
        end_time: '2026-07-29T13:25:58.000Z',
        latitude: 37.7885202,
        longitude: -122.3870725,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:24:58.000Z',
        end_time: '2026-07-29T13:25:58.000Z',
        latitude: 37.7885202,
        longitude: -122.3870725,
        density: 15.46647978889359,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:24:58.000Z',
        end_time: '2026-07-29T13:25:58.000Z',
        latitude: 37.7885202,
        longitude: -122.3870725,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:23:58.000Z',
        end_time: '2026-07-29T13:24:58.000Z',
        latitude: 37.7884912,
        longitude: -122.387169,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:23:58.000Z',
        end_time: '2026-07-29T13:24:58.000Z',
        latitude: 37.7884912,
        longitude: -122.387169,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:23:58.000Z',
        end_time: '2026-07-29T13:24:58.000Z',
        latitude: 37.7884912,
        longitude: -122.387169,
        density: 24.767533318762528,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T13:18:58.000Z',
        end_time: '2026-07-29T13:23:58.000Z',
        latitude: 37.7885,
        longitude: -122.3871667,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:22:58.000Z',
        end_time: '2026-07-29T13:23:58.000Z',
        latitude: 37.7885078,
        longitude: -122.3871482,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:22:58.000Z',
        end_time: '2026-07-29T13:23:58.000Z',
        latitude: 37.7885078,
        longitude: -122.3871482,
        density: 37.67776953693135,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:22:58.000Z',
        end_time: '2026-07-29T13:23:58.000Z',
        latitude: 37.7885078,
        longitude: -122.3871482,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T13:18:58.000Z',
        end_time: '2026-07-29T13:23:58.000Z',
        latitude: 37.7885,
        longitude: -122.3871667,
        density: 12.105263157894736,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T13:18:58.000Z',
        end_time: '2026-07-29T13:23:58.000Z',
        latitude: 37.7885,
        longitude: -122.3871667,
        density: 38.55752871264863,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:21:58.000Z',
        end_time: '2026-07-29T13:22:58.000Z',
        latitude: 37.7885383,
        longitude: -122.387225,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:21:58.000Z',
        end_time: '2026-07-29T13:22:58.000Z',
        latitude: 37.7885383,
        longitude: -122.387225,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:21:58.000Z',
        end_time: '2026-07-29T13:22:58.000Z',
        latitude: 37.7885383,
        longitude: -122.387225,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:20:58.000Z',
        end_time: '2026-07-29T13:21:58.000Z',
        latitude: 37.7885488,
        longitude: -122.3871537,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:20:58.000Z',
        end_time: '2026-07-29T13:21:58.000Z',
        latitude: 37.7885488,
        longitude: -122.3871537,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:20:58.000Z',
        end_time: '2026-07-29T13:21:58.000Z',
        latitude: 37.7885488,
        longitude: -122.3871537,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:19:58.000Z',
        end_time: '2026-07-29T13:20:58.000Z',
        latitude: 37.7885692,
        longitude: -122.3871745,
        density: 18.421052631578945,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:19:58.000Z',
        end_time: '2026-07-29T13:20:58.000Z',
        latitude: 37.7885692,
        longitude: -122.3871745,
        density: 42.82516907950304,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:19:58.000Z',
        end_time: '2026-07-29T13:20:58.000Z',
        latitude: 37.7885692,
        longitude: -122.3871745,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T13:13:58.000Z',
        end_time: '2026-07-29T13:18:58.000Z',
        latitude: 37.7887,
        longitude: -122.3872,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:17:58.000Z',
        end_time: '2026-07-29T13:18:58.000Z',
        latitude: 37.7887315,
        longitude: -122.3871675,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:17:58.000Z',
        end_time: '2026-07-29T13:18:58.000Z',
        latitude: 37.7887315,
        longitude: -122.3871675,
        density: 25.157753464733155,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:17:58.000Z',
        end_time: '2026-07-29T13:18:58.000Z',
        latitude: 37.7887315,
        longitude: -122.3871675,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T13:13:58.000Z',
        end_time: '2026-07-29T13:18:58.000Z',
        latitude: 37.7887,
        longitude: -122.3872,
        density: 3.1578947368421053,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T13:13:58.000Z',
        end_time: '2026-07-29T13:18:58.000Z',
        latitude: 37.7887,
        longitude: -122.3872,
        density: 19.591367227052366,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:16:58.000Z',
        end_time: '2026-07-29T13:17:58.000Z',
        latitude: 37.7885675,
        longitude: -122.3871138,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:16:58.000Z',
        end_time: '2026-07-29T13:17:58.000Z',
        latitude: 37.7885675,
        longitude: -122.3871138,
        density: 10.269496846431911,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:16:58.000Z',
        end_time: '2026-07-29T13:17:58.000Z',
        latitude: 37.7885675,
        longitude: -122.3871138,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:15:58.000Z',
        end_time: '2026-07-29T13:16:58.000Z',
        latitude: 37.7886207,
        longitude: -122.387167,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:15:58.000Z',
        end_time: '2026-07-29T13:16:58.000Z',
        latitude: 37.7886207,
        longitude: -122.387167,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:15:58.000Z',
        end_time: '2026-07-29T13:16:58.000Z',
        latitude: 37.7886207,
        longitude: -122.387167,
        density: 9.212628300540405,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:14:58.000Z',
        end_time: '2026-07-29T13:15:58.000Z',
        latitude: 37.7885978,
        longitude: -122.3871968,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:14:58.000Z',
        end_time: '2026-07-29T13:15:58.000Z',
        latitude: 37.7885978,
        longitude: -122.3871968,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:14:58.000Z',
        end_time: '2026-07-29T13:15:58.000Z',
        latitude: 37.7885978,
        longitude: -122.3871968,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:12:58.000Z',
        end_time: '2026-07-29T13:13:58.000Z',
        latitude: 37.7884612,
        longitude: -122.3870692,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T13:08:58.000Z',
        end_time: '2026-07-29T13:13:58.000Z',
        latitude: 37.7884333,
        longitude: -122.3870667,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:12:58.000Z',
        end_time: '2026-07-29T13:13:58.000Z',
        latitude: 37.7884612,
        longitude: -122.3870692,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:12:58.000Z',
        end_time: '2026-07-29T13:13:58.000Z',
        latitude: 37.7884612,
        longitude: -122.3870692,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T13:08:58.000Z',
        end_time: '2026-07-29T13:13:58.000Z',
        latitude: 37.7884333,
        longitude: -122.3870667,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T13:08:58.000Z',
        end_time: '2026-07-29T13:13:58.000Z',
        latitude: 37.7884333,
        longitude: -122.3870667,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:11:58.000Z',
        end_time: '2026-07-29T13:12:58.000Z',
        latitude: 37.7884738,
        longitude: -122.3871492,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:11:58.000Z',
        end_time: '2026-07-29T13:12:58.000Z',
        latitude: 37.7884738,
        longitude: -122.3871492,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:11:58.000Z',
        end_time: '2026-07-29T13:12:58.000Z',
        latitude: 37.7884738,
        longitude: -122.3871492,
        density: 27.56640238128406,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:10:58.000Z',
        end_time: '2026-07-29T13:11:58.000Z',
        latitude: 37.788458,
        longitude: -122.3871893,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:10:58.000Z',
        end_time: '2026-07-29T13:11:58.000Z',
        latitude: 37.788458,
        longitude: -122.3871893,
        density: 1.2205840409924655,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:10:58.000Z',
        end_time: '2026-07-29T13:11:58.000Z',
        latitude: 37.788458,
        longitude: -122.3871893,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:09:58.000Z',
        end_time: '2026-07-29T13:10:58.000Z',
        latitude: 37.7883768,
        longitude: -122.3871147,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:09:58.000Z',
        end_time: '2026-07-29T13:10:58.000Z',
        latitude: 37.7883768,
        longitude: -122.3871147,
        density: 16.563302731352852,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:09:58.000Z',
        end_time: '2026-07-29T13:10:58.000Z',
        latitude: 37.7883768,
        longitude: -122.3871147,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:08:58.000Z',
        end_time: '2026-07-29T13:09:58.000Z',
        latitude: 37.7884125,
        longitude: -122.3871152,
        density: 18.421052631578945,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:08:58.000Z',
        end_time: '2026-07-29T13:09:58.000Z',
        latitude: 37.7884125,
        longitude: -122.3871152,
        density: 22.25503312146517,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:08:58.000Z',
        end_time: '2026-07-29T13:09:58.000Z',
        latitude: 37.7884125,
        longitude: -122.3871152,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T13:03:58.000Z',
        end_time: '2026-07-29T13:08:58.000Z',
        latitude: 37.7884,
        longitude: -122.3871167,
        density: 2.1052631578947367,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T13:03:58.000Z',
        end_time: '2026-07-29T13:08:58.000Z',
        latitude: 37.7884,
        longitude: -122.3871167,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:07:58.000Z',
        end_time: '2026-07-29T13:08:58.000Z',
        latitude: 37.7884272,
        longitude: -122.3871657,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:07:58.000Z',
        end_time: '2026-07-29T13:08:58.000Z',
        latitude: 37.7884272,
        longitude: -122.3871657,
        density: 23.531241208318075,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:07:58.000Z',
        end_time: '2026-07-29T13:08:58.000Z',
        latitude: 37.7884272,
        longitude: -122.3871657,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T13:03:58.000Z',
        end_time: '2026-07-29T13:08:58.000Z',
        latitude: 37.7884,
        longitude: -122.3871167,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:06:58.000Z',
        end_time: '2026-07-29T13:07:58.000Z',
        latitude: 37.7884543,
        longitude: -122.3871315,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:06:58.000Z',
        end_time: '2026-07-29T13:07:58.000Z',
        latitude: 37.7884543,
        longitude: -122.3871315,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:06:58.000Z',
        end_time: '2026-07-29T13:07:58.000Z',
        latitude: 37.7884543,
        longitude: -122.3871315,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:05:58.000Z',
        end_time: '2026-07-29T13:06:58.000Z',
        latitude: 37.7884183,
        longitude: -122.3871198,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:05:58.000Z',
        end_time: '2026-07-29T13:06:58.000Z',
        latitude: 37.7884183,
        longitude: -122.3871198,
        density: 9.296475186556957,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:05:58.000Z',
        end_time: '2026-07-29T13:06:58.000Z',
        latitude: 37.7884183,
        longitude: -122.3871198,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:04:58.000Z',
        end_time: '2026-07-29T13:05:58.000Z',
        latitude: 37.788495,
        longitude: -122.387199,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:04:58.000Z',
        end_time: '2026-07-29T13:05:58.000Z',
        latitude: 37.788495,
        longitude: -122.387199,
        density: 28.17671552470378,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:04:58.000Z',
        end_time: '2026-07-29T13:05:58.000Z',
        latitude: 37.788495,
        longitude: -122.387199,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:03:58.000Z',
        end_time: '2026-07-29T13:04:58.000Z',
        latitude: 37.7885305,
        longitude: -122.3871507,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:03:58.000Z',
        end_time: '2026-07-29T13:04:58.000Z',
        latitude: 37.7885305,
        longitude: -122.3871507,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:03:58.000Z',
        end_time: '2026-07-29T13:04:58.000Z',
        latitude: 37.7885305,
        longitude: -122.3871507,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:02:58.000Z',
        end_time: '2026-07-29T13:03:58.000Z',
        latitude: 37.7884542,
        longitude: -122.3871237,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:02:58.000Z',
        end_time: '2026-07-29T13:03:58.000Z',
        latitude: 37.7884542,
        longitude: -122.3871237,
        density: 22.651919283017165,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:02:58.000Z',
        end_time: '2026-07-29T13:03:58.000Z',
        latitude: 37.7884542,
        longitude: -122.3871237,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T12:58:58.000Z',
        end_time: '2026-07-29T13:03:58.000Z',
        latitude: 37.7885167,
        longitude: -122.38715,
        density: 1.0526315789473684,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T12:58:58.000Z',
        end_time: '2026-07-29T13:03:58.000Z',
        latitude: 37.7885167,
        longitude: -122.38715,
        density: 25.2324245214039,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T12:58:58.000Z',
        end_time: '2026-07-29T13:03:58.000Z',
        latitude: 37.7885167,
        longitude: -122.38715,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:01:58.000Z',
        end_time: '2026-07-29T13:02:58.000Z',
        latitude: 37.7884687,
        longitude: -122.3871232,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:01:58.000Z',
        end_time: '2026-07-29T13:02:58.000Z',
        latitude: 37.7884687,
        longitude: -122.3871232,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:01:58.000Z',
        end_time: '2026-07-29T13:02:58.000Z',
        latitude: 37.7884687,
        longitude: -122.3871232,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T13:00:58.000Z',
        end_time: '2026-07-29T13:01:58.000Z',
        latitude: 37.787974,
        longitude: -122.3873447,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T13:00:58.000Z',
        end_time: '2026-07-29T13:01:58.000Z',
        latitude: 37.787974,
        longitude: -122.3873447,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T13:00:58.000Z',
        end_time: '2026-07-29T13:01:58.000Z',
        latitude: 37.787974,
        longitude: -122.3873447,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:59:58.000Z',
        end_time: '2026-07-29T13:00:58.000Z',
        latitude: 37.788447,
        longitude: -122.3871252,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:59:58.000Z',
        end_time: '2026-07-29T13:00:58.000Z',
        latitude: 37.788447,
        longitude: -122.3871252,
        density: 10.760454757542464,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:59:58.000Z',
        end_time: '2026-07-29T13:00:58.000Z',
        latitude: 37.788447,
        longitude: -122.3871252,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:58:58.000Z',
        end_time: '2026-07-29T12:59:58.000Z',
        latitude: 37.788513,
        longitude: -122.3871007,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:58:58.000Z',
        end_time: '2026-07-29T12:59:58.000Z',
        latitude: 37.788513,
        longitude: -122.3871007,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:58:58.000Z',
        end_time: '2026-07-29T12:59:58.000Z',
        latitude: 37.788513,
        longitude: -122.3871007,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:57:58.000Z',
        end_time: '2026-07-29T12:58:58.000Z',
        latitude: 37.788364,
        longitude: -122.3871375,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T12:53:58.000Z',
        end_time: '2026-07-29T12:58:58.000Z',
        latitude: 37.7885,
        longitude: -122.3870833,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T12:53:58.000Z',
        end_time: '2026-07-29T12:58:58.000Z',
        latitude: 37.7885,
        longitude: -122.3870833,
        density: 7.05781256605429,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:57:58.000Z',
        end_time: '2026-07-29T12:58:58.000Z',
        latitude: 37.788364,
        longitude: -122.3871375,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:57:58.000Z',
        end_time: '2026-07-29T12:58:58.000Z',
        latitude: 37.788364,
        longitude: -122.3871375,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T12:53:58.000Z',
        end_time: '2026-07-29T12:58:58.000Z',
        latitude: 37.7885,
        longitude: -122.3870833,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:56:58.000Z',
        end_time: '2026-07-29T12:57:58.000Z',
        latitude: 37.7883813,
        longitude: -122.3871255,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:56:58.000Z',
        end_time: '2026-07-29T12:57:58.000Z',
        latitude: 37.7883813,
        longitude: -122.3871255,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:56:58.000Z',
        end_time: '2026-07-29T12:57:58.000Z',
        latitude: 37.7883813,
        longitude: -122.3871255,
        density: 28.178126567443115,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:55:58.000Z',
        end_time: '2026-07-29T12:56:58.000Z',
        latitude: 37.7883938,
        longitude: -122.3871577,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:55:58.000Z',
        end_time: '2026-07-29T12:56:58.000Z',
        latitude: 37.7883938,
        longitude: -122.3871577,
        density: 2.0016321845995755,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:55:58.000Z',
        end_time: '2026-07-29T12:56:58.000Z',
        latitude: 37.7883938,
        longitude: -122.3871577,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:54:58.000Z',
        end_time: '2026-07-29T12:55:58.000Z',
        latitude: 37.7818537,
        longitude: -122.389289,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:54:58.000Z',
        end_time: '2026-07-29T12:55:58.000Z',
        latitude: 37.7818537,
        longitude: -122.389289,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:54:58.000Z',
        end_time: '2026-07-29T12:55:58.000Z',
        latitude: 37.7818537,
        longitude: -122.389289,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T12:48:58.000Z',
        end_time: '2026-07-29T12:53:58.000Z',
        latitude: 37.7874,
        longitude: -122.3878333,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:52:58.000Z',
        end_time: '2026-07-29T12:53:58.000Z',
        latitude: 37.7885423,
        longitude: -122.3871197,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:52:58.000Z',
        end_time: '2026-07-29T12:53:58.000Z',
        latitude: 37.7885423,
        longitude: -122.3871197,
        density: 15.935439317863363,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:52:58.000Z',
        end_time: '2026-07-29T12:53:58.000Z',
        latitude: 37.7885423,
        longitude: -122.3871197,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T12:48:58.000Z',
        end_time: '2026-07-29T12:53:58.000Z',
        latitude: 37.7874,
        longitude: -122.3878333,
        density: 2.1052631578947367,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T12:48:58.000Z',
        end_time: '2026-07-29T12:53:58.000Z',
        latitude: 37.7874,
        longitude: -122.3878333,
        density: 5.684231694168204,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:51:58.000Z',
        end_time: '2026-07-29T12:52:58.000Z',
        latitude: 37.7883262,
        longitude: -122.3868998,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:51:58.000Z',
        end_time: '2026-07-29T12:52:58.000Z',
        latitude: 37.7883262,
        longitude: -122.3868998,
        density: 29.065830126171363,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:51:58.000Z',
        end_time: '2026-07-29T12:52:58.000Z',
        latitude: 37.7883262,
        longitude: -122.3868998,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:50:58.000Z',
        end_time: '2026-07-29T12:51:58.000Z',
        latitude: 37.7884645,
        longitude: -122.3871295,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:50:58.000Z',
        end_time: '2026-07-29T12:51:58.000Z',
        latitude: 37.7884645,
        longitude: -122.3871295,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:50:58.000Z',
        end_time: '2026-07-29T12:51:58.000Z',
        latitude: 37.7884645,
        longitude: -122.3871295,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:49:58.000Z',
        end_time: '2026-07-29T12:50:58.000Z',
        latitude: 37.7886982,
        longitude: -122.3871038,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:49:58.000Z',
        end_time: '2026-07-29T12:50:58.000Z',
        latitude: 37.7886982,
        longitude: -122.3871038,
        density: 0.17728425766935008,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:49:58.000Z',
        end_time: '2026-07-29T12:50:58.000Z',
        latitude: 37.7886982,
        longitude: -122.3871038,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T12:43:58.000Z',
        end_time: '2026-07-29T12:48:58.000Z',
        latitude: 37.7886167,
        longitude: -122.3870167,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:47:58.000Z',
        end_time: '2026-07-29T12:48:58.000Z',
        latitude: 37.7885057,
        longitude: -122.3871382,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:47:58.000Z',
        end_time: '2026-07-29T12:48:58.000Z',
        latitude: 37.7885057,
        longitude: -122.3871382,
        density: 1.1988062276497224,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:47:58.000Z',
        end_time: '2026-07-29T12:48:58.000Z',
        latitude: 37.7885057,
        longitude: -122.3871382,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T12:43:58.000Z',
        end_time: '2026-07-29T12:48:58.000Z',
        latitude: 37.7886167,
        longitude: -122.3870167,
        density: 1.0526315789473684,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T12:43:58.000Z',
        end_time: '2026-07-29T12:48:58.000Z',
        latitude: 37.7886167,
        longitude: -122.3870167,
        density: 9.498969508883539,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:46:58.000Z',
        end_time: '2026-07-29T12:47:58.000Z',
        latitude: 37.7887292,
        longitude: -122.3869847,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:46:58.000Z',
        end_time: '2026-07-29T12:47:58.000Z',
        latitude: 37.7887292,
        longitude: -122.3869847,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:46:58.000Z',
        end_time: '2026-07-29T12:47:58.000Z',
        latitude: 37.7887292,
        longitude: -122.3869847,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:45:58.000Z',
        end_time: '2026-07-29T12:46:58.000Z',
        latitude: 37.7888075,
        longitude: -122.3868675,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:45:58.000Z',
        end_time: '2026-07-29T12:46:58.000Z',
        latitude: 37.7888075,
        longitude: -122.3868675,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:45:58.000Z',
        end_time: '2026-07-29T12:46:58.000Z',
        latitude: 37.7888075,
        longitude: -122.3868675,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:44:58.000Z',
        end_time: '2026-07-29T12:45:58.000Z',
        latitude: 37.7885445,
        longitude: -122.3870625,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:44:58.000Z',
        end_time: '2026-07-29T12:45:58.000Z',
        latitude: 37.7885445,
        longitude: -122.3870625,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:44:58.000Z',
        end_time: '2026-07-29T12:45:58.000Z',
        latitude: 37.7885445,
        longitude: -122.3870625,
        density: 27.795502256925126,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T12:38:58.000Z',
        end_time: '2026-07-29T12:43:58.000Z',
        latitude: 37.7918,
        longitude: -122.39085,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T12:38:58.000Z',
        end_time: '2026-07-29T12:43:58.000Z',
        latitude: 37.7918,
        longitude: -122.39085,
        density: 3.1578947368421053,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T12:38:58.000Z',
        end_time: '2026-07-29T12:43:58.000Z',
        latitude: 37.7918,
        longitude: -122.39085,
        density: 14.295201178080308,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:42:58.000Z',
        end_time: '2026-07-29T12:43:58.000Z',
        latitude: 37.7898112,
        longitude: -122.3865748,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:42:58.000Z',
        end_time: '2026-07-29T12:43:58.000Z',
        latitude: 37.7898112,
        longitude: -122.3865748,
        density: 23.60121420654286,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:42:58.000Z',
        end_time: '2026-07-29T12:43:58.000Z',
        latitude: 37.7898112,
        longitude: -122.3865748,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:41:58.000Z',
        end_time: '2026-07-29T12:42:58.000Z',
        latitude: 37.7901743,
        longitude: -122.3863495,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:41:58.000Z',
        end_time: '2026-07-29T12:42:58.000Z',
        latitude: 37.7901743,
        longitude: -122.3863495,
        density: 25.59163535152939,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:41:58.000Z',
        end_time: '2026-07-29T12:42:58.000Z',
        latitude: 37.7901743,
        longitude: -122.3863495,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:40:58.000Z',
        end_time: '2026-07-29T12:41:58.000Z',
        latitude: 37.7902408,
        longitude: -122.3863155,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:40:58.000Z',
        end_time: '2026-07-29T12:41:58.000Z',
        latitude: 37.7902408,
        longitude: -122.3863155,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:40:58.000Z',
        end_time: '2026-07-29T12:41:58.000Z',
        latitude: 37.7902408,
        longitude: -122.3863155,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:39:58.000Z',
        end_time: '2026-07-29T12:40:58.000Z',
        latitude: 37.789998,
        longitude: -122.3863712,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:39:58.000Z',
        end_time: '2026-07-29T12:40:58.000Z',
        latitude: 37.789998,
        longitude: -122.3863712,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:39:58.000Z',
        end_time: '2026-07-29T12:40:58.000Z',
        latitude: 37.789998,
        longitude: -122.3863712,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T12:33:58.000Z',
        end_time: '2026-07-29T12:38:58.000Z',
        latitude: 37.79025,
        longitude: -122.3863333,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:37:58.000Z',
        end_time: '2026-07-29T12:38:58.000Z',
        latitude: 37.7862387,
        longitude: -122.3799347,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:37:58.000Z',
        end_time: '2026-07-29T12:38:58.000Z',
        latitude: 37.7862387,
        longitude: -122.3799347,
        density: 10.304422762519764,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:37:58.000Z',
        end_time: '2026-07-29T12:38:58.000Z',
        latitude: 37.7862387,
        longitude: -122.3799347,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T12:33:58.000Z',
        end_time: '2026-07-29T12:38:58.000Z',
        latitude: 37.79025,
        longitude: -122.3863333,
        density: 3.684210526315789,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T12:33:58.000Z',
        end_time: '2026-07-29T12:38:58.000Z',
        latitude: 37.79025,
        longitude: -122.3863333,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:36:58.000Z',
        end_time: '2026-07-29T12:37:58.000Z',
        latitude: 37.7862387,
        longitude: -122.3799347,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:36:58.000Z',
        end_time: '2026-07-29T12:37:58.000Z',
        latitude: 37.7862387,
        longitude: -122.3799347,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:36:58.000Z',
        end_time: '2026-07-29T12:37:58.000Z',
        latitude: 37.7862387,
        longitude: -122.3799347,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:35:58.000Z',
        end_time: '2026-07-29T12:36:58.000Z',
        latitude: 37.7862387,
        longitude: -122.3799347,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:35:58.000Z',
        end_time: '2026-07-29T12:36:58.000Z',
        latitude: 37.7862387,
        longitude: -122.3799347,
        density: 4.944329273972215,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:35:58.000Z',
        end_time: '2026-07-29T12:36:58.000Z',
        latitude: 37.7862387,
        longitude: -122.3799347,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:34:58.000Z',
        end_time: '2026-07-29T12:35:58.000Z',
        latitude: 37.7862387,
        longitude: -122.3799347,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:34:58.000Z',
        end_time: '2026-07-29T12:35:58.000Z',
        latitude: 37.7862387,
        longitude: -122.3799347,
        density: 6.54942915899683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:34:58.000Z',
        end_time: '2026-07-29T12:35:58.000Z',
        latitude: 37.7862387,
        longitude: -122.3799347,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:33:58.000Z',
        end_time: '2026-07-29T12:34:58.000Z',
        latitude: 37.7886512,
        longitude: -122.3870462,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:33:58.000Z',
        end_time: '2026-07-29T12:34:58.000Z',
        latitude: 37.7886512,
        longitude: -122.3870462,
        density: 6.402472891551547,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:33:58.000Z',
        end_time: '2026-07-29T12:34:58.000Z',
        latitude: 37.7886512,
        longitude: -122.3870462,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T12:28:58.000Z',
        end_time: '2026-07-29T12:33:58.000Z',
        latitude: 37.7887,
        longitude: -122.387,
        density: 6.315789473684211,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T12:28:58.000Z',
        end_time: '2026-07-29T12:33:58.000Z',
        latitude: 37.7887,
        longitude: -122.387,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:32:58.000Z',
        end_time: '2026-07-29T12:33:58.000Z',
        latitude: 37.7888287,
        longitude: -122.3868962,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:32:58.000Z',
        end_time: '2026-07-29T12:33:58.000Z',
        latitude: 37.7888287,
        longitude: -122.3868962,
        density: 15.892066335869458,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:32:58.000Z',
        end_time: '2026-07-29T12:33:58.000Z',
        latitude: 37.7888287,
        longitude: -122.3868962,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T12:28:58.000Z',
        end_time: '2026-07-29T12:33:58.000Z',
        latitude: 37.7887,
        longitude: -122.387,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:31:58.000Z',
        end_time: '2026-07-29T12:32:58.000Z',
        latitude: 37.7886888,
        longitude: -122.387016,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:31:58.000Z',
        end_time: '2026-07-29T12:32:58.000Z',
        latitude: 37.7886888,
        longitude: -122.387016,
        density: 18.421052631578945,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:31:58.000Z',
        end_time: '2026-07-29T12:32:58.000Z',
        latitude: 37.7886888,
        longitude: -122.387016,
        density: 35.24243235965376,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:30:58.000Z',
        end_time: '2026-07-29T12:31:58.000Z',
        latitude: 37.7890883,
        longitude: -122.387019,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:30:58.000Z',
        end_time: '2026-07-29T12:31:58.000Z',
        latitude: 37.7890883,
        longitude: -122.387019,
        density: 30.408426055234077,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:30:58.000Z',
        end_time: '2026-07-29T12:31:58.000Z',
        latitude: 37.7890883,
        longitude: -122.387019,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:29:58.000Z',
        end_time: '2026-07-29T12:30:58.000Z',
        latitude: 37.7890145,
        longitude: -122.386935,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:29:58.000Z',
        end_time: '2026-07-29T12:30:58.000Z',
        latitude: 37.7890145,
        longitude: -122.386935,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:29:58.000Z',
        end_time: '2026-07-29T12:30:58.000Z',
        latitude: 37.7890145,
        longitude: -122.386935,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T12:23:58.000Z',
        end_time: '2026-07-29T12:28:58.000Z',
        latitude: 37.7889,
        longitude: -122.3868,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T12:23:58.000Z',
        end_time: '2026-07-29T12:28:58.000Z',
        latitude: 37.7889,
        longitude: -122.3868,
        density: 5.119800464562331,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:27:58.000Z',
        end_time: '2026-07-29T12:28:58.000Z',
        latitude: 37.7884168,
        longitude: -122.3871142,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:27:58.000Z',
        end_time: '2026-07-29T12:28:58.000Z',
        latitude: 37.7884168,
        longitude: -122.3871142,
        density: 1.6957399624588865,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:27:58.000Z',
        end_time: '2026-07-29T12:28:58.000Z',
        latitude: 37.7884168,
        longitude: -122.3871142,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T12:23:58.000Z',
        end_time: '2026-07-29T12:28:58.000Z',
        latitude: 37.7889,
        longitude: -122.3868,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:26:58.000Z',
        end_time: '2026-07-29T12:27:58.000Z',
        latitude: 37.7884163,
        longitude: -122.387138,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:26:58.000Z',
        end_time: '2026-07-29T12:27:58.000Z',
        latitude: 37.7884163,
        longitude: -122.387138,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:26:58.000Z',
        end_time: '2026-07-29T12:27:58.000Z',
        latitude: 37.7884163,
        longitude: -122.387138,
        density: 6.639035472926644,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:25:58.000Z',
        end_time: '2026-07-29T12:26:58.000Z',
        latitude: 37.7884648,
        longitude: -122.387105,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:25:58.000Z',
        end_time: '2026-07-29T12:26:58.000Z',
        latitude: 37.7884648,
        longitude: -122.387105,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:25:58.000Z',
        end_time: '2026-07-29T12:26:58.000Z',
        latitude: 37.7884648,
        longitude: -122.387105,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:24:58.000Z',
        end_time: '2026-07-29T12:25:58.000Z',
        latitude: 37.7884455,
        longitude: -122.3870807,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:24:58.000Z',
        end_time: '2026-07-29T12:25:58.000Z',
        latitude: 37.7884455,
        longitude: -122.3870807,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:24:58.000Z',
        end_time: '2026-07-29T12:25:58.000Z',
        latitude: 37.7884455,
        longitude: -122.3870807,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:23:58.000Z',
        end_time: '2026-07-29T12:24:58.000Z',
        latitude: 37.7884158,
        longitude: -122.3870332,
        density: 26.31578947368421,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:23:58.000Z',
        end_time: '2026-07-29T12:24:58.000Z',
        latitude: 37.7884158,
        longitude: -122.3870332,
        density: 8.527209468219365,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:23:58.000Z',
        end_time: '2026-07-29T12:24:58.000Z',
        latitude: 37.7884158,
        longitude: -122.3870332,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:22:58.000Z',
        end_time: '2026-07-29T12:23:58.000Z',
        latitude: 37.7884145,
        longitude: -122.3870758,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T12:18:58.000Z',
        end_time: '2026-07-29T12:23:58.000Z',
        latitude: 37.7884167,
        longitude: -122.3870333,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:22:58.000Z',
        end_time: '2026-07-29T12:23:58.000Z',
        latitude: 37.7884145,
        longitude: -122.3870758,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:22:58.000Z',
        end_time: '2026-07-29T12:23:58.000Z',
        latitude: 37.7884145,
        longitude: -122.3870758,
        density: 38.721921448866276,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T12:18:58.000Z',
        end_time: '2026-07-29T12:23:58.000Z',
        latitude: 37.7884167,
        longitude: -122.3870333,
        density: 6.315789473684211,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T12:18:58.000Z',
        end_time: '2026-07-29T12:23:58.000Z',
        latitude: 37.7884167,
        longitude: -122.3870333,
        density: 10.806260046783617,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:21:58.000Z',
        end_time: '2026-07-29T12:22:58.000Z',
        latitude: 37.7884313,
        longitude: -122.38706,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:21:58.000Z',
        end_time: '2026-07-29T12:22:58.000Z',
        latitude: 37.7884313,
        longitude: -122.38706,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:21:58.000Z',
        end_time: '2026-07-29T12:22:58.000Z',
        latitude: 37.7884313,
        longitude: -122.38706,
        density: 39.76254400464187,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:20:58.000Z',
        end_time: '2026-07-29T12:21:58.000Z',
        latitude: 37.7884505,
        longitude: -122.3870615,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:20:58.000Z',
        end_time: '2026-07-29T12:21:58.000Z',
        latitude: 37.7884505,
        longitude: -122.3870615,
        density: 14.79547881178377,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:20:58.000Z',
        end_time: '2026-07-29T12:21:58.000Z',
        latitude: 37.7884505,
        longitude: -122.3870615,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:19:58.000Z',
        end_time: '2026-07-29T12:20:58.000Z',
        latitude: 37.7884862,
        longitude: -122.3870922,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:19:58.000Z',
        end_time: '2026-07-29T12:20:58.000Z',
        latitude: 37.7884862,
        longitude: -122.3870922,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:19:58.000Z',
        end_time: '2026-07-29T12:20:58.000Z',
        latitude: 37.7884862,
        longitude: -122.3870922,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T12:13:58.000Z',
        end_time: '2026-07-29T12:18:58.000Z',
        latitude: 37.78845,
        longitude: -122.3871333,
        density: 5.7894736842105265,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T12:13:58.000Z',
        end_time: '2026-07-29T12:18:58.000Z',
        latitude: 37.78845,
        longitude: -122.3871333,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:17:58.000Z',
        end_time: '2026-07-29T12:18:58.000Z',
        latitude: 37.78849,
        longitude: -122.3871527,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:17:58.000Z',
        end_time: '2026-07-29T12:18:58.000Z',
        latitude: 37.78849,
        longitude: -122.3871527,
        density: 20.785837776157628,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:17:58.000Z',
        end_time: '2026-07-29T12:18:58.000Z',
        latitude: 37.78849,
        longitude: -122.3871527,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T12:13:58.000Z',
        end_time: '2026-07-29T12:18:58.000Z',
        latitude: 37.78845,
        longitude: -122.3871333,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:16:58.000Z',
        end_time: '2026-07-29T12:17:58.000Z',
        latitude: 37.7884857,
        longitude: -122.3871785,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:16:58.000Z',
        end_time: '2026-07-29T12:17:58.000Z',
        latitude: 37.7884857,
        longitude: -122.3871785,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:16:58.000Z',
        end_time: '2026-07-29T12:17:58.000Z',
        latitude: 37.7884857,
        longitude: -122.3871785,
        density: 6.618212082387364,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:15:58.000Z',
        end_time: '2026-07-29T12:16:58.000Z',
        latitude: 37.7884713,
        longitude: -122.3873463,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:15:58.000Z',
        end_time: '2026-07-29T12:16:58.000Z',
        latitude: 37.7884713,
        longitude: -122.3873463,
        density: 0.3714189972366455,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:15:58.000Z',
        end_time: '2026-07-29T12:16:58.000Z',
        latitude: 37.7884713,
        longitude: -122.3873463,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:14:58.000Z',
        end_time: '2026-07-29T12:15:58.000Z',
        latitude: 37.7884765,
        longitude: -122.3871278,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:14:58.000Z',
        end_time: '2026-07-29T12:15:58.000Z',
        latitude: 37.7884765,
        longitude: -122.3871278,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:14:58.000Z',
        end_time: '2026-07-29T12:15:58.000Z',
        latitude: 37.7884765,
        longitude: -122.3871278,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T12:08:59.000Z',
        end_time: '2026-07-29T12:13:59.000Z',
        latitude: 37.7885167,
        longitude: -122.3871,
        density: 25.263157894736842,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T12:08:59.000Z',
        end_time: '2026-07-29T12:13:59.000Z',
        latitude: 37.7885167,
        longitude: -122.3871,
        density: 55.15681587736379,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T12:08:59.000Z',
        end_time: '2026-07-29T12:13:59.000Z',
        latitude: 37.7885167,
        longitude: -122.3871,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:12:58.000Z',
        end_time: '2026-07-29T12:13:58.000Z',
        latitude: 37.7884867,
        longitude: -122.3871195,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:12:58.000Z',
        end_time: '2026-07-29T12:13:58.000Z',
        latitude: 37.7884867,
        longitude: -122.3871195,
        density: 23.684210526315788,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:12:58.000Z',
        end_time: '2026-07-29T12:13:58.000Z',
        latitude: 37.7884867,
        longitude: -122.3871195,
        density: 42.559295341579485,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:11:58.000Z',
        end_time: '2026-07-29T12:12:58.000Z',
        latitude: 37.7885402,
        longitude: -122.3868657,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:11:58.000Z',
        end_time: '2026-07-29T12:12:58.000Z',
        latitude: 37.7885402,
        longitude: -122.3868657,
        density: 21.052631578947366,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:11:58.000Z',
        end_time: '2026-07-29T12:12:58.000Z',
        latitude: 37.7885402,
        longitude: -122.3868657,
        density: 47.52631261064945,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:10:58.000Z',
        end_time: '2026-07-29T12:11:58.000Z',
        latitude: 37.7884565,
        longitude: -122.3871115,
        density: 36.84210526315789,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:10:58.000Z',
        end_time: '2026-07-29T12:11:58.000Z',
        latitude: 37.7884565,
        longitude: -122.3871115,
        density: 51.337775694847316,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:10:58.000Z',
        end_time: '2026-07-29T12:11:58.000Z',
        latitude: 37.7884565,
        longitude: -122.3871115,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:09:59.000Z',
        end_time: '2026-07-29T12:10:59.000Z',
        latitude: 37.7884372,
        longitude: -122.387076,
        density: 21.052631578947366,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:09:59.000Z',
        end_time: '2026-07-29T12:10:59.000Z',
        latitude: 37.7884372,
        longitude: -122.387076,
        density: 37.847305077291544,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:09:59.000Z',
        end_time: '2026-07-29T12:10:59.000Z',
        latitude: 37.7884372,
        longitude: -122.387076,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:08:59.000Z',
        end_time: '2026-07-29T12:09:59.000Z',
        latitude: 37.7884367,
        longitude: -122.3870478,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:08:59.000Z',
        end_time: '2026-07-29T12:09:59.000Z',
        latitude: 37.7884367,
        longitude: -122.3870478,
        density: 23.684210526315788,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:08:59.000Z',
        end_time: '2026-07-29T12:09:59.000Z',
        latitude: 37.7884367,
        longitude: -122.3870478,
        density: 50.0878227275538,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T12:03:59.000Z',
        end_time: '2026-07-29T12:08:59.000Z',
        latitude: 37.7884333,
        longitude: -122.38705,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:07:59.000Z',
        end_time: '2026-07-29T12:08:59.000Z',
        latitude: 37.7884628,
        longitude: -122.3871158,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:07:59.000Z',
        end_time: '2026-07-29T12:08:59.000Z',
        latitude: 37.7884628,
        longitude: -122.3871158,
        density: 20.27568110659588,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:07:59.000Z',
        end_time: '2026-07-29T12:08:59.000Z',
        latitude: 37.7884628,
        longitude: -122.3871158,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T12:03:59.000Z',
        end_time: '2026-07-29T12:08:59.000Z',
        latitude: 37.7884333,
        longitude: -122.38705,
        density: 15.789473684210526,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T12:03:59.000Z',
        end_time: '2026-07-29T12:08:59.000Z',
        latitude: 37.7884333,
        longitude: -122.38705,
        density: 7.529744748620606,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:06:59.000Z',
        end_time: '2026-07-29T12:07:59.000Z',
        latitude: 37.7884688,
        longitude: -122.3871807,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:06:59.000Z',
        end_time: '2026-07-29T12:07:59.000Z',
        latitude: 37.7884688,
        longitude: -122.3871807,
        density: 18.421052631578945,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:06:59.000Z',
        end_time: '2026-07-29T12:07:59.000Z',
        latitude: 37.7884688,
        longitude: -122.3871807,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:05:59.000Z',
        end_time: '2026-07-29T12:06:59.000Z',
        latitude: 37.78846,
        longitude: -122.387159,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:05:59.000Z',
        end_time: '2026-07-29T12:06:59.000Z',
        latitude: 37.78846,
        longitude: -122.387159,
        density: 20.8903526271803,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:05:59.000Z',
        end_time: '2026-07-29T12:06:59.000Z',
        latitude: 37.78846,
        longitude: -122.387159,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:04:59.000Z',
        end_time: '2026-07-29T12:05:59.000Z',
        latitude: 37.788418,
        longitude: -122.3869925,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:04:59.000Z',
        end_time: '2026-07-29T12:05:59.000Z',
        latitude: 37.788418,
        longitude: -122.3869925,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:04:59.000Z',
        end_time: '2026-07-29T12:05:59.000Z',
        latitude: 37.788418,
        longitude: -122.3869925,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T11:58:59.000Z',
        end_time: '2026-07-29T12:03:59.000Z',
        latitude: 37.7884333,
        longitude: -122.3869833,
        density: 8.947368421052632,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T11:58:59.000Z',
        end_time: '2026-07-29T12:03:59.000Z',
        latitude: 37.7884333,
        longitude: -122.3869833,
        density: 32.72299314408107,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:02:59.000Z',
        end_time: '2026-07-29T12:03:59.000Z',
        latitude: 37.7884243,
        longitude: -122.3870287,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:02:59.000Z',
        end_time: '2026-07-29T12:03:59.000Z',
        latitude: 37.7884243,
        longitude: -122.3870287,
        density: 35.70368023427007,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:02:59.000Z',
        end_time: '2026-07-29T12:03:59.000Z',
        latitude: 37.7884243,
        longitude: -122.3870287,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T11:58:59.000Z',
        end_time: '2026-07-29T12:03:59.000Z',
        latitude: 37.7884333,
        longitude: -122.3869833,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:01:59.000Z',
        end_time: '2026-07-29T12:02:59.000Z',
        latitude: 37.7883728,
        longitude: -122.3870093,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:01:59.000Z',
        end_time: '2026-07-29T12:02:59.000Z',
        latitude: 37.7883728,
        longitude: -122.3870093,
        density: 18.421052631578945,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:01:59.000Z',
        end_time: '2026-07-29T12:02:59.000Z',
        latitude: 37.7883728,
        longitude: -122.3870093,
        density: 43.51986977761014,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T12:00:59.000Z',
        end_time: '2026-07-29T12:01:59.000Z',
        latitude: 37.7884147,
        longitude: -122.3869713,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T12:00:59.000Z',
        end_time: '2026-07-29T12:01:59.000Z',
        latitude: 37.7884147,
        longitude: -122.3869713,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T12:00:59.000Z',
        end_time: '2026-07-29T12:01:59.000Z',
        latitude: 37.7884147,
        longitude: -122.3869713,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:59:59.000Z',
        end_time: '2026-07-29T12:00:59.000Z',
        latitude: 37.7884263,
        longitude: -122.3870918,
        density: 10.526315789473683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:59:59.000Z',
        end_time: '2026-07-29T12:00:59.000Z',
        latitude: 37.7884263,
        longitude: -122.3870918,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:59:59.000Z',
        end_time: '2026-07-29T12:00:59.000Z',
        latitude: 37.7884263,
        longitude: -122.3870918,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T11:53:59.000Z',
        end_time: '2026-07-29T11:58:59.000Z',
        latitude: 37.7883833,
        longitude: -122.3870833,
        density: 18.421052631578945,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T11:53:59.000Z',
        end_time: '2026-07-29T11:58:59.000Z',
        latitude: 37.7883833,
        longitude: -122.3870833,
        density: 5.035499438547005,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:57:59.000Z',
        end_time: '2026-07-29T11:58:59.000Z',
        latitude: 37.7884218,
        longitude: -122.3871032,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:57:59.000Z',
        end_time: '2026-07-29T11:58:59.000Z',
        latitude: 37.7884218,
        longitude: -122.3871032,
        density: 12.354939195253444,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:57:59.000Z',
        end_time: '2026-07-29T11:58:59.000Z',
        latitude: 37.7884218,
        longitude: -122.3871032,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T11:53:59.000Z',
        end_time: '2026-07-29T11:58:59.000Z',
        latitude: 37.7883833,
        longitude: -122.3870833,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:56:59.000Z',
        end_time: '2026-07-29T11:57:59.000Z',
        latitude: 37.7884348,
        longitude: -122.3870462,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:56:59.000Z',
        end_time: '2026-07-29T11:57:59.000Z',
        latitude: 37.7884348,
        longitude: -122.3870462,
        density: 15.789473684210526,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:56:59.000Z',
        end_time: '2026-07-29T11:57:59.000Z',
        latitude: 37.7884348,
        longitude: -122.3870462,
        density: 22.206707136909998,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:55:59.000Z',
        end_time: '2026-07-29T11:56:59.000Z',
        latitude: 37.7884168,
        longitude: -122.3870823,
        density: 10.526315789473683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:55:59.000Z',
        end_time: '2026-07-29T11:56:59.000Z',
        latitude: 37.7884168,
        longitude: -122.3870823,
        density: 33.31223133853975,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:55:59.000Z',
        end_time: '2026-07-29T11:56:59.000Z',
        latitude: 37.7884168,
        longitude: -122.3870823,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:54:59.000Z',
        end_time: '2026-07-29T11:55:59.000Z',
        latitude: 37.7883825,
        longitude: -122.3870265,
        density: 36.84210526315789,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:54:59.000Z',
        end_time: '2026-07-29T11:55:59.000Z',
        latitude: 37.7883825,
        longitude: -122.3870265,
        density: 8.607646040425788,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:54:59.000Z',
        end_time: '2026-07-29T11:55:59.000Z',
        latitude: 37.7883825,
        longitude: -122.3870265,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:52:59.000Z',
        end_time: '2026-07-29T11:53:59.000Z',
        latitude: 37.788533,
        longitude: -122.3869317,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:52:59.000Z',
        end_time: '2026-07-29T11:53:59.000Z',
        latitude: 37.788533,
        longitude: -122.3869317,
        density: 34.20843790848573,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:52:59.000Z',
        end_time: '2026-07-29T11:53:59.000Z',
        latitude: 37.788533,
        longitude: -122.3869317,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T11:48:59.000Z',
        end_time: '2026-07-29T11:53:59.000Z',
        latitude: 37.7884333,
        longitude: -122.38695,
        density: 11.052631578947368,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T11:48:59.000Z',
        end_time: '2026-07-29T11:53:59.000Z',
        latitude: 37.7884333,
        longitude: -122.38695,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T11:48:59.000Z',
        end_time: '2026-07-29T11:53:59.000Z',
        latitude: 37.7884333,
        longitude: -122.38695,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:51:59.000Z',
        end_time: '2026-07-29T11:52:59.000Z',
        latitude: 37.7884533,
        longitude: -122.3870465,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:51:59.000Z',
        end_time: '2026-07-29T11:52:59.000Z',
        latitude: 37.7884533,
        longitude: -122.3870465,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:51:59.000Z',
        end_time: '2026-07-29T11:52:59.000Z',
        latitude: 37.7884533,
        longitude: -122.3870465,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:50:59.000Z',
        end_time: '2026-07-29T11:51:59.000Z',
        latitude: 37.7883927,
        longitude: -122.3871198,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:50:59.000Z',
        end_time: '2026-07-29T11:51:59.000Z',
        latitude: 37.7883927,
        longitude: -122.3871198,
        density: 21.052631578947366,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:50:59.000Z',
        end_time: '2026-07-29T11:51:59.000Z',
        latitude: 37.7883927,
        longitude: -122.3871198,
        density: 30.525670096756297,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:49:59.000Z',
        end_time: '2026-07-29T11:50:59.000Z',
        latitude: 37.7883942,
        longitude: -122.3871602,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:49:59.000Z',
        end_time: '2026-07-29T11:50:59.000Z',
        latitude: 37.7883942,
        longitude: -122.3871602,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:49:59.000Z',
        end_time: '2026-07-29T11:50:59.000Z',
        latitude: 37.7883942,
        longitude: -122.3871602,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T11:43:59.000Z',
        end_time: '2026-07-29T11:48:59.000Z',
        latitude: 37.7885167,
        longitude: -122.3868833,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:47:59.000Z',
        end_time: '2026-07-29T11:48:59.000Z',
        latitude: 37.7884848,
        longitude: -122.3870972,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:47:59.000Z',
        end_time: '2026-07-29T11:48:59.000Z',
        latitude: 37.7884848,
        longitude: -122.3870972,
        density: 21.666624492634764,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:47:59.000Z',
        end_time: '2026-07-29T11:48:59.000Z',
        latitude: 37.7884848,
        longitude: -122.3870972,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T11:43:59.000Z',
        end_time: '2026-07-29T11:48:59.000Z',
        latitude: 37.7885167,
        longitude: -122.3868833,
        density: 8.947368421052632,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T11:43:59.000Z',
        end_time: '2026-07-29T11:48:59.000Z',
        latitude: 37.7885167,
        longitude: -122.3868833,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:46:59.000Z',
        end_time: '2026-07-29T11:47:59.000Z',
        latitude: 37.788487,
        longitude: -122.387126,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:46:59.000Z',
        end_time: '2026-07-29T11:47:59.000Z',
        latitude: 37.788487,
        longitude: -122.387126,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:46:59.000Z',
        end_time: '2026-07-29T11:47:59.000Z',
        latitude: 37.788487,
        longitude: -122.387126,
        density: 26.10658901188069,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:45:59.000Z',
        end_time: '2026-07-29T11:46:59.000Z',
        latitude: 37.7884832,
        longitude: -122.387063,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:45:59.000Z',
        end_time: '2026-07-29T11:46:59.000Z',
        latitude: 37.7884832,
        longitude: -122.387063,
        density: 7.5985019363613935,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:45:59.000Z',
        end_time: '2026-07-29T11:46:59.000Z',
        latitude: 37.7884832,
        longitude: -122.387063,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:44:59.000Z',
        end_time: '2026-07-29T11:45:59.000Z',
        latitude: 37.7884627,
        longitude: -122.3871692,
        density: 18.421052631578945,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:44:59.000Z',
        end_time: '2026-07-29T11:45:59.000Z',
        latitude: 37.7884627,
        longitude: -122.3871692,
        density: 29.47948890274901,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:44:59.000Z',
        end_time: '2026-07-29T11:45:59.000Z',
        latitude: 37.7884627,
        longitude: -122.3871692,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T11:38:59.000Z',
        end_time: '2026-07-29T11:43:59.000Z',
        latitude: 37.7884333,
        longitude: -122.38705,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:42:59.000Z',
        end_time: '2026-07-29T11:43:59.000Z',
        latitude: 37.7884635,
        longitude: -122.3870837,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:42:59.000Z',
        end_time: '2026-07-29T11:43:59.000Z',
        latitude: 37.7884635,
        longitude: -122.3870837,
        density: 16.43179424367169,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:42:59.000Z',
        end_time: '2026-07-29T11:43:59.000Z',
        latitude: 37.7884635,
        longitude: -122.3870837,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T11:38:59.000Z',
        end_time: '2026-07-29T11:43:59.000Z',
        latitude: 37.7884333,
        longitude: -122.38705,
        density: 12.105263157894736,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T11:38:59.000Z',
        end_time: '2026-07-29T11:43:59.000Z',
        latitude: 37.7884333,
        longitude: -122.38705,
        density: 40.18854204927307,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:41:59.000Z',
        end_time: '2026-07-29T11:42:59.000Z',
        latitude: 37.7884652,
        longitude: -122.3870872,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:41:59.000Z',
        end_time: '2026-07-29T11:42:59.000Z',
        latitude: 37.7884652,
        longitude: -122.3870872,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:41:59.000Z',
        end_time: '2026-07-29T11:42:59.000Z',
        latitude: 37.7884652,
        longitude: -122.3870872,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:40:59.000Z',
        end_time: '2026-07-29T11:41:59.000Z',
        latitude: 37.7883802,
        longitude: -122.3874448,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:40:59.000Z',
        end_time: '2026-07-29T11:41:59.000Z',
        latitude: 37.7883802,
        longitude: -122.3874448,
        density: 10.526315789473683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:40:59.000Z',
        end_time: '2026-07-29T11:41:59.000Z',
        latitude: 37.7883802,
        longitude: -122.3874448,
        density: 31.7864993172928,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:39:59.000Z',
        end_time: '2026-07-29T11:40:59.000Z',
        latitude: 37.7883815,
        longitude: -122.3873295,
        density: 18.421052631578945,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:39:59.000Z',
        end_time: '2026-07-29T11:40:59.000Z',
        latitude: 37.7883815,
        longitude: -122.3873295,
        density: 18.978768886885916,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:39:59.000Z',
        end_time: '2026-07-29T11:40:59.000Z',
        latitude: 37.7883815,
        longitude: -122.3873295,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:38:59.000Z',
        end_time: '2026-07-29T11:39:59.000Z',
        latitude: 37.7884592,
        longitude: -122.3870952,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:38:59.000Z',
        end_time: '2026-07-29T11:39:59.000Z',
        latitude: 37.7884592,
        longitude: -122.3870952,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:38:59.000Z',
        end_time: '2026-07-29T11:39:59.000Z',
        latitude: 37.7884592,
        longitude: -122.3870952,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T11:33:59.000Z',
        end_time: '2026-07-29T11:38:59.000Z',
        latitude: 37.78845,
        longitude: -122.3870833,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:37:59.000Z',
        end_time: '2026-07-29T11:38:59.000Z',
        latitude: 37.7884557,
        longitude: -122.387092,
        density: 15.789473684210526,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:37:59.000Z',
        end_time: '2026-07-29T11:38:59.000Z',
        latitude: 37.7884557,
        longitude: -122.387092,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:37:59.000Z',
        end_time: '2026-07-29T11:38:59.000Z',
        latitude: 37.7884557,
        longitude: -122.387092,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T11:33:59.000Z',
        end_time: '2026-07-29T11:38:59.000Z',
        latitude: 37.78845,
        longitude: -122.3870833,
        density: 24.210526315789473,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T11:33:59.000Z',
        end_time: '2026-07-29T11:38:59.000Z',
        latitude: 37.78845,
        longitude: -122.3870833,
        density: 40.57498948962891,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:36:59.000Z',
        end_time: '2026-07-29T11:37:59.000Z',
        latitude: 37.7885153,
        longitude: -122.3869745,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:36:59.000Z',
        end_time: '2026-07-29T11:37:59.000Z',
        latitude: 37.7885153,
        longitude: -122.3869745,
        density: 18.421052631578945,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:36:59.000Z',
        end_time: '2026-07-29T11:37:59.000Z',
        latitude: 37.7885153,
        longitude: -122.3869745,
        density: 41.247895935628755,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:35:59.000Z',
        end_time: '2026-07-29T11:36:59.000Z',
        latitude: 37.7884697,
        longitude: -122.3870432,
        density: 34.21052631578947,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:35:59.000Z',
        end_time: '2026-07-29T11:36:59.000Z',
        latitude: 37.7884697,
        longitude: -122.3870432,
        density: 57.464418589456486,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:35:59.000Z',
        end_time: '2026-07-29T11:36:59.000Z',
        latitude: 37.7884697,
        longitude: -122.3870432,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:34:59.000Z',
        end_time: '2026-07-29T11:35:59.000Z',
        latitude: 37.7885003,
        longitude: -122.3869292,
        density: 21.052631578947366,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:34:59.000Z',
        end_time: '2026-07-29T11:35:59.000Z',
        latitude: 37.7885003,
        longitude: -122.3869292,
        density: 28.036836516302323,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:34:59.000Z',
        end_time: '2026-07-29T11:35:59.000Z',
        latitude: 37.7885003,
        longitude: -122.3869292,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T11:28:59.000Z',
        end_time: '2026-07-29T11:33:59.000Z',
        latitude: 37.7886167,
        longitude: -122.3866833,
        density: 31.05263157894737,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T11:28:59.000Z',
        end_time: '2026-07-29T11:33:59.000Z',
        latitude: 37.7886167,
        longitude: -122.3866833,
        density: 56.645673313383064,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:32:59.000Z',
        end_time: '2026-07-29T11:33:59.000Z',
        latitude: 37.7885597,
        longitude: -122.3868318,
        density: 36.84210526315789,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:32:59.000Z',
        end_time: '2026-07-29T11:33:59.000Z',
        latitude: 37.7885597,
        longitude: -122.3868318,
        density: 47.15026262766888,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:32:59.000Z',
        end_time: '2026-07-29T11:33:59.000Z',
        latitude: 37.7885597,
        longitude: -122.3868318,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T11:28:59.000Z',
        end_time: '2026-07-29T11:33:59.000Z',
        latitude: 37.7886167,
        longitude: -122.3866833,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:31:59.000Z',
        end_time: '2026-07-29T11:32:59.000Z',
        latitude: 37.7885252,
        longitude: -122.386955,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:31:59.000Z',
        end_time: '2026-07-29T11:32:59.000Z',
        latitude: 37.7885252,
        longitude: -122.386955,
        density: 60.526315789473685,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:31:59.000Z',
        end_time: '2026-07-29T11:32:59.000Z',
        latitude: 37.7885252,
        longitude: -122.386955,
        density: 82.48399892618957,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:30:59.000Z',
        end_time: '2026-07-29T11:31:59.000Z',
        latitude: 37.7887683,
        longitude: -122.3859553,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:30:59.000Z',
        end_time: '2026-07-29T11:31:59.000Z',
        latitude: 37.7887683,
        longitude: -122.3859553,
        density: 27.177285085326,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:30:59.000Z',
        end_time: '2026-07-29T11:31:59.000Z',
        latitude: 37.7887683,
        longitude: -122.3859553,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:29:59.000Z',
        end_time: '2026-07-29T11:30:59.000Z',
        latitude: 37.7888313,
        longitude: -122.385425,
        density: 21.052631578947366,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:29:59.000Z',
        end_time: '2026-07-29T11:30:59.000Z',
        latitude: 37.7888313,
        longitude: -122.385425,
        density: 41.13774834379625,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:29:59.000Z',
        end_time: '2026-07-29T11:30:59.000Z',
        latitude: 37.7888313,
        longitude: -122.385425,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T11:23:59.000Z',
        end_time: '2026-07-29T11:28:59.000Z',
        latitude: 37.7884,
        longitude: -122.3872,
        density: 18.947368421052634,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T11:23:59.000Z',
        end_time: '2026-07-29T11:28:59.000Z',
        latitude: 37.7884,
        longitude: -122.3872,
        density: 14.115747423782913,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:27:59.000Z',
        end_time: '2026-07-29T11:28:59.000Z',
        latitude: 37.7884522,
        longitude: -122.3871442,
        density: 18.421052631578945,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:27:59.000Z',
        end_time: '2026-07-29T11:28:59.000Z',
        latitude: 37.7884522,
        longitude: -122.3871442,
        density: 43.86255130493743,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:27:59.000Z',
        end_time: '2026-07-29T11:28:59.000Z',
        latitude: 37.7884522,
        longitude: -122.3871442,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T11:23:59.000Z',
        end_time: '2026-07-29T11:28:59.000Z',
        latitude: 37.7884,
        longitude: -122.3872,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:26:59.000Z',
        end_time: '2026-07-29T11:27:59.000Z',
        latitude: 37.788444,
        longitude: -122.3871402,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:26:59.000Z',
        end_time: '2026-07-29T11:27:59.000Z',
        latitude: 37.788444,
        longitude: -122.3871402,
        density: 18.421052631578945,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:26:59.000Z',
        end_time: '2026-07-29T11:27:59.000Z',
        latitude: 37.788444,
        longitude: -122.3871402,
        density: 27.802305305306167,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:25:59.000Z',
        end_time: '2026-07-29T11:26:59.000Z',
        latitude: 37.7884547,
        longitude: -122.3870612,
        density: 26.31578947368421,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:25:59.000Z',
        end_time: '2026-07-29T11:26:59.000Z',
        latitude: 37.7884547,
        longitude: -122.3870612,
        density: 22.032417268963936,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:25:59.000Z',
        end_time: '2026-07-29T11:26:59.000Z',
        latitude: 37.7884547,
        longitude: -122.3870612,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:24:59.000Z',
        end_time: '2026-07-29T11:25:59.000Z',
        latitude: 37.788425,
        longitude: -122.3871277,
        density: 10.526315789473683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:24:59.000Z',
        end_time: '2026-07-29T11:25:59.000Z',
        latitude: 37.788425,
        longitude: -122.3871277,
        density: 23.385000692086116,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:24:59.000Z',
        end_time: '2026-07-29T11:25:59.000Z',
        latitude: 37.788425,
        longitude: -122.3871277,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:23:59.000Z',
        end_time: '2026-07-29T11:24:59.000Z',
        latitude: 37.7884637,
        longitude: -122.3869832,
        density: 21.052631578947366,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:23:59.000Z',
        end_time: '2026-07-29T11:24:59.000Z',
        latitude: 37.7884637,
        longitude: -122.3869832,
        density: 26.511036341058634,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:23:59.000Z',
        end_time: '2026-07-29T11:24:59.000Z',
        latitude: 37.7884637,
        longitude: -122.3869832,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T11:18:59.000Z',
        end_time: '2026-07-29T11:23:59.000Z',
        latitude: 37.7884833,
        longitude: -122.3868167,
        density: 17.894736842105264,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T11:18:59.000Z',
        end_time: '2026-07-29T11:23:59.000Z',
        latitude: 37.7884833,
        longitude: -122.3868167,
        density: 0.7857701690790826,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:22:59.000Z',
        end_time: '2026-07-29T11:23:59.000Z',
        latitude: 37.838575,
        longitude: -121.8885053,
        density: 28.947368421052634,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:22:59.000Z',
        end_time: '2026-07-29T11:23:59.000Z',
        latitude: 37.838575,
        longitude: -121.8885053,
        density: 58.926449862800695,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:22:59.000Z',
        end_time: '2026-07-29T11:23:59.000Z',
        latitude: 37.838575,
        longitude: -121.8885053,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T11:18:59.000Z',
        end_time: '2026-07-29T11:23:59.000Z',
        latitude: 37.7884833,
        longitude: -122.3868167,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:21:59.000Z',
        end_time: '2026-07-29T11:22:59.000Z',
        latitude: 37.838575,
        longitude: -121.8885053,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:21:59.000Z',
        end_time: '2026-07-29T11:22:59.000Z',
        latitude: 37.838575,
        longitude: -121.8885053,
        density: 23.684210526315788,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:21:59.000Z',
        end_time: '2026-07-29T11:22:59.000Z',
        latitude: 37.838575,
        longitude: -121.8885053,
        density: 31.478183586366605,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:20:59.000Z',
        end_time: '2026-07-29T11:21:59.000Z',
        latitude: 37.8277367,
        longitude: -121.9805223,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:20:59.000Z',
        end_time: '2026-07-29T11:21:59.000Z',
        latitude: 37.8277367,
        longitude: -121.9805223,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:20:59.000Z',
        end_time: '2026-07-29T11:21:59.000Z',
        latitude: 37.8277367,
        longitude: -121.9805223,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:19:59.000Z',
        end_time: '2026-07-29T11:20:59.000Z',
        latitude: 37.8199757,
        longitude: -122.049618,
        density: 21.052631578947366,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:19:59.000Z',
        end_time: '2026-07-29T11:20:59.000Z',
        latitude: 37.8199757,
        longitude: -122.049618,
        density: 46.94546887968468,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:19:59.000Z',
        end_time: '2026-07-29T11:20:59.000Z',
        latitude: 37.8199757,
        longitude: -122.049618,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T11:13:59.000Z',
        end_time: '2026-07-29T11:18:59.000Z',
        latitude: 37.76045,
        longitude: -122.3378167,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:17:59.000Z',
        end_time: '2026-07-29T11:18:59.000Z',
        latitude: 37.7691363,
        longitude: -122.3509535,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:17:59.000Z',
        end_time: '2026-07-29T11:18:59.000Z',
        latitude: 37.7691363,
        longitude: -122.3509535,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:17:59.000Z',
        end_time: '2026-07-29T11:18:59.000Z',
        latitude: 37.7691363,
        longitude: -122.3509535,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T11:13:59.000Z',
        end_time: '2026-07-29T11:18:59.000Z',
        latitude: 37.76045,
        longitude: -122.3378167,
        density: 4.2105263157894735,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T11:13:59.000Z',
        end_time: '2026-07-29T11:18:59.000Z',
        latitude: 37.76045,
        longitude: -122.3378167,
        density: 11.801178524894972,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:16:59.000Z',
        end_time: '2026-07-29T11:17:59.000Z',
        latitude: 37.7774878,
        longitude: -122.3655882,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:16:59.000Z',
        end_time: '2026-07-29T11:17:59.000Z',
        latitude: 37.7774878,
        longitude: -122.3655882,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:16:59.000Z',
        end_time: '2026-07-29T11:17:59.000Z',
        latitude: 37.7774878,
        longitude: -122.3655882,
        density: 18.924087161513615,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:15:59.000Z',
        end_time: '2026-07-29T11:16:59.000Z',
        latitude: 37.7877357,
        longitude: -122.3858163,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:15:59.000Z',
        end_time: '2026-07-29T11:16:59.000Z',
        latitude: 37.7877357,
        longitude: -122.3858163,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:15:59.000Z',
        end_time: '2026-07-29T11:16:59.000Z',
        latitude: 37.7877357,
        longitude: -122.3858163,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:14:59.000Z',
        end_time: '2026-07-29T11:15:59.000Z',
        latitude: 37.7885313,
        longitude: -122.3872683,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:14:59.000Z',
        end_time: '2026-07-29T11:15:59.000Z',
        latitude: 37.7885313,
        longitude: -122.3872683,
        density: 10.526315789473683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:14:59.000Z',
        end_time: '2026-07-29T11:15:59.000Z',
        latitude: 37.7885313,
        longitude: -122.3872683,
        density: 22.652999116598615,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:13:59.000Z',
        end_time: '2026-07-29T11:14:59.000Z',
        latitude: 37.7885802,
        longitude: -122.3871815,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:13:59.000Z',
        end_time: '2026-07-29T11:14:59.000Z',
        latitude: 37.7885802,
        longitude: -122.3871815,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:13:59.000Z',
        end_time: '2026-07-29T11:14:59.000Z',
        latitude: 37.7885802,
        longitude: -122.3871815,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:12:59.000Z',
        end_time: '2026-07-29T11:13:59.000Z',
        latitude: 37.7884675,
        longitude: -122.3863402,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T11:08:59.000Z',
        end_time: '2026-07-29T11:13:59.000Z',
        latitude: 37.7885667,
        longitude: -122.3872833,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:12:59.000Z',
        end_time: '2026-07-29T11:13:59.000Z',
        latitude: 37.7884675,
        longitude: -122.3863402,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:12:59.000Z',
        end_time: '2026-07-29T11:13:59.000Z',
        latitude: 37.7884675,
        longitude: -122.3863402,
        density: 5.752145458196144,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T11:08:59.000Z',
        end_time: '2026-07-29T11:13:59.000Z',
        latitude: 37.7885667,
        longitude: -122.3872833,
        density: 22.105263157894736,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T11:08:59.000Z',
        end_time: '2026-07-29T11:13:59.000Z',
        latitude: 37.7885667,
        longitude: -122.3872833,
        density: 47.341353799870376,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:11:59.000Z',
        end_time: '2026-07-29T11:12:59.000Z',
        latitude: 37.7884768,
        longitude: -122.3873703,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:11:59.000Z',
        end_time: '2026-07-29T11:12:59.000Z',
        latitude: 37.7884768,
        longitude: -122.3873703,
        density: 26.31578947368421,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:11:59.000Z',
        end_time: '2026-07-29T11:12:59.000Z',
        latitude: 37.7884768,
        longitude: -122.3873703,
        density: 19.39383088013805,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:10:59.000Z',
        end_time: '2026-07-29T11:11:59.000Z',
        latitude: 37.7885022,
        longitude: -122.3873552,
        density: 15.789473684210526,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:10:59.000Z',
        end_time: '2026-07-29T11:11:59.000Z',
        latitude: 37.7885022,
        longitude: -122.3873552,
        density: 27.01090028569513,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:10:59.000Z',
        end_time: '2026-07-29T11:11:59.000Z',
        latitude: 37.7885022,
        longitude: -122.3873552,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:09:59.000Z',
        end_time: '2026-07-29T11:10:59.000Z',
        latitude: 37.788477,
        longitude: -122.3871138,
        density: 26.31578947368421,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:09:59.000Z',
        end_time: '2026-07-29T11:10:59.000Z',
        latitude: 37.788477,
        longitude: -122.3871138,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:09:59.000Z',
        end_time: '2026-07-29T11:10:59.000Z',
        latitude: 37.788477,
        longitude: -122.3871138,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:08:59.000Z',
        end_time: '2026-07-29T11:09:59.000Z',
        latitude: 37.788447,
        longitude: -122.3871562,
        density: 36.84210526315789,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:08:59.000Z',
        end_time: '2026-07-29T11:09:59.000Z',
        latitude: 37.788447,
        longitude: -122.3871562,
        density: 22.041081367405283,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:08:59.000Z',
        end_time: '2026-07-29T11:09:59.000Z',
        latitude: 37.788447,
        longitude: -122.3871562,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T11:03:59.000Z',
        end_time: '2026-07-29T11:08:59.000Z',
        latitude: 37.7884333,
        longitude: -122.38715,
        density: 23.684210526315788,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T11:03:59.000Z',
        end_time: '2026-07-29T11:08:59.000Z',
        latitude: 37.7884333,
        longitude: -122.38715,
        density: 20.60362007692825,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:07:59.000Z',
        end_time: '2026-07-29T11:08:59.000Z',
        latitude: 37.7884653,
        longitude: -122.3871812,
        density: 23.684210526315788,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:07:59.000Z',
        end_time: '2026-07-29T11:08:59.000Z',
        latitude: 37.7884653,
        longitude: -122.3871812,
        density: 24.80480679654002,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:07:59.000Z',
        end_time: '2026-07-29T11:08:59.000Z',
        latitude: 37.7884653,
        longitude: -122.3871812,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T11:03:59.000Z',
        end_time: '2026-07-29T11:08:59.000Z',
        latitude: 37.7884333,
        longitude: -122.38715,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:06:59.000Z',
        end_time: '2026-07-29T11:07:59.000Z',
        latitude: 37.7884705,
        longitude: -122.3871608,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:06:59.000Z',
        end_time: '2026-07-29T11:07:59.000Z',
        latitude: 37.7884705,
        longitude: -122.3871608,
        density: 28.947368421052634,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:06:59.000Z',
        end_time: '2026-07-29T11:07:59.000Z',
        latitude: 37.7884705,
        longitude: -122.3871608,
        density: 7.629785035862966,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:05:59.000Z',
        end_time: '2026-07-29T11:06:59.000Z',
        latitude: 37.7884625,
        longitude: -122.3872,
        density: 31.57894736842105,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:05:59.000Z',
        end_time: '2026-07-29T11:06:59.000Z',
        latitude: 37.7884625,
        longitude: -122.3872,
        density: 16.000688928526323,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:05:59.000Z',
        end_time: '2026-07-29T11:06:59.000Z',
        latitude: 37.7884625,
        longitude: -122.3872,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:04:59.000Z',
        end_time: '2026-07-29T11:05:59.000Z',
        latitude: 37.788435,
        longitude: -122.3871578,
        density: 15.789473684210526,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:04:59.000Z',
        end_time: '2026-07-29T11:05:59.000Z',
        latitude: 37.788435,
        longitude: -122.3871578,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:04:59.000Z',
        end_time: '2026-07-29T11:05:59.000Z',
        latitude: 37.788435,
        longitude: -122.3871578,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T10:58:59.000Z',
        end_time: '2026-07-29T11:03:59.000Z',
        latitude: 37.7884333,
        longitude: -122.3871333,
        density: 21.578947368421055,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T10:58:59.000Z',
        end_time: '2026-07-29T11:03:59.000Z',
        latitude: 37.7884333,
        longitude: -122.3871333,
        density: 1.8226116650023023,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:02:59.000Z',
        end_time: '2026-07-29T11:03:59.000Z',
        latitude: 37.7884753,
        longitude: -122.3871327,
        density: 15.789473684210526,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:02:59.000Z',
        end_time: '2026-07-29T11:03:59.000Z',
        latitude: 37.7884753,
        longitude: -122.3871327,
        density: 11.804971761560335,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:02:59.000Z',
        end_time: '2026-07-29T11:03:59.000Z',
        latitude: 37.7884753,
        longitude: -122.3871327,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T10:58:59.000Z',
        end_time: '2026-07-29T11:03:59.000Z',
        latitude: 37.7884333,
        longitude: -122.3871333,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:01:59.000Z',
        end_time: '2026-07-29T11:02:59.000Z',
        latitude: 37.7884412,
        longitude: -122.3870587,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:01:59.000Z',
        end_time: '2026-07-29T11:02:59.000Z',
        latitude: 37.7884412,
        longitude: -122.3870587,
        density: 21.052631578947366,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:01:59.000Z',
        end_time: '2026-07-29T11:02:59.000Z',
        latitude: 37.7884412,
        longitude: -122.3870587,
        density: 39.37590674834708,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T11:00:59.000Z',
        end_time: '2026-07-29T11:01:59.000Z',
        latitude: 37.788381,
        longitude: -122.3823993,
        density: 34.21052631578947,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T11:00:59.000Z',
        end_time: '2026-07-29T11:01:59.000Z',
        latitude: 37.788381,
        longitude: -122.3823993,
        density: 51.75686116152838,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T11:00:59.000Z',
        end_time: '2026-07-29T11:01:59.000Z',
        latitude: 37.788381,
        longitude: -122.3823993,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:59:59.000Z',
        end_time: '2026-07-29T11:00:59.000Z',
        latitude: 37.7886495,
        longitude: -122.387511,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:59:59.000Z',
        end_time: '2026-07-29T11:00:59.000Z',
        latitude: 37.7886495,
        longitude: -122.387511,
        density: 31.57894736842105,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:59:59.000Z',
        end_time: '2026-07-29T11:00:59.000Z',
        latitude: 37.7886495,
        longitude: -122.387511,
        density: 39.41682449780926,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:57:59.000Z',
        end_time: '2026-07-29T10:58:59.000Z',
        latitude: 37.788446,
        longitude: -122.3871035,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T10:53:59.000Z',
        end_time: '2026-07-29T10:58:59.000Z',
        latitude: 37.78845,
        longitude: -122.3871333,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:57:59.000Z',
        end_time: '2026-07-29T10:58:59.000Z',
        latitude: 37.788446,
        longitude: -122.3871035,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:57:59.000Z',
        end_time: '2026-07-29T10:58:59.000Z',
        latitude: 37.788446,
        longitude: -122.3871035,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T10:53:59.000Z',
        end_time: '2026-07-29T10:58:59.000Z',
        latitude: 37.78845,
        longitude: -122.3871333,
        density: 4.2105263157894735,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T10:53:59.000Z',
        end_time: '2026-07-29T10:58:59.000Z',
        latitude: 37.78845,
        longitude: -122.3871333,
        density: 25.04403915090473,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:56:59.000Z',
        end_time: '2026-07-29T10:57:59.000Z',
        latitude: 37.7884248,
        longitude: -122.3871882,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:56:59.000Z',
        end_time: '2026-07-29T10:57:59.000Z',
        latitude: 37.7884248,
        longitude: -122.3871882,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:56:59.000Z',
        end_time: '2026-07-29T10:57:59.000Z',
        latitude: 37.7884248,
        longitude: -122.3871882,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:55:59.000Z',
        end_time: '2026-07-29T10:56:59.000Z',
        latitude: 37.7884393,
        longitude: -122.3871483,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:55:59.000Z',
        end_time: '2026-07-29T10:56:59.000Z',
        latitude: 37.7884393,
        longitude: -122.3871483,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:55:59.000Z',
        end_time: '2026-07-29T10:56:59.000Z',
        latitude: 37.7884393,
        longitude: -122.3871483,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:54:59.000Z',
        end_time: '2026-07-29T10:55:59.000Z',
        latitude: 37.7884355,
        longitude: -122.3871277,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:54:59.000Z',
        end_time: '2026-07-29T10:55:59.000Z',
        latitude: 37.7884355,
        longitude: -122.3871277,
        density: 28.08806017293804,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:54:59.000Z',
        end_time: '2026-07-29T10:55:59.000Z',
        latitude: 37.7884355,
        longitude: -122.3871277,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:53:59.000Z',
        end_time: '2026-07-29T10:54:59.000Z',
        latitude: 37.788443,
        longitude: -122.3871583,
        density: 10.526315789473683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:53:59.000Z',
        end_time: '2026-07-29T10:54:59.000Z',
        latitude: 37.788443,
        longitude: -122.3871583,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:53:59.000Z',
        end_time: '2026-07-29T10:54:59.000Z',
        latitude: 37.788443,
        longitude: -122.3871583,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T10:48:59.000Z',
        end_time: '2026-07-29T10:53:59.000Z',
        latitude: 37.78845,
        longitude: -122.3871833,
        density: 28.421052631578945,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T10:48:59.000Z',
        end_time: '2026-07-29T10:53:59.000Z',
        latitude: 37.78845,
        longitude: -122.3871833,
        density: 47.23776631687108,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:52:59.000Z',
        end_time: '2026-07-29T10:53:59.000Z',
        latitude: 37.7884653,
        longitude: -122.3871,
        density: 23.684210526315788,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:52:59.000Z',
        end_time: '2026-07-29T10:53:59.000Z',
        latitude: 37.7884653,
        longitude: -122.3871,
        density: 20.900246846654845,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:52:59.000Z',
        end_time: '2026-07-29T10:53:59.000Z',
        latitude: 37.7884653,
        longitude: -122.3871,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T10:48:59.000Z',
        end_time: '2026-07-29T10:53:59.000Z',
        latitude: 37.78845,
        longitude: -122.3871833,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:51:59.000Z',
        end_time: '2026-07-29T10:52:59.000Z',
        latitude: 37.7884598,
        longitude: -122.387033,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:51:59.000Z',
        end_time: '2026-07-29T10:52:59.000Z',
        latitude: 37.7884598,
        longitude: -122.387033,
        density: 26.31578947368421,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:51:59.000Z',
        end_time: '2026-07-29T10:52:59.000Z',
        latitude: 37.7884598,
        longitude: -122.387033,
        density: 11.425737808516653,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:50:59.000Z',
        end_time: '2026-07-29T10:51:59.000Z',
        latitude: 37.7884953,
        longitude: -122.387204,
        density: 39.473684210526315,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:50:59.000Z',
        end_time: '2026-07-29T10:51:59.000Z',
        latitude: 37.7884953,
        longitude: -122.387204,
        density: 20.325437699583475,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:50:59.000Z',
        end_time: '2026-07-29T10:51:59.000Z',
        latitude: 37.7884953,
        longitude: -122.387204,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:49:59.000Z',
        end_time: '2026-07-29T10:50:59.000Z',
        latitude: 37.7885195,
        longitude: -122.3872833,
        density: 28.947368421052634,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:49:59.000Z',
        end_time: '2026-07-29T10:50:59.000Z',
        latitude: 37.7885195,
        longitude: -122.3872833,
        density: 41.51245806204347,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:49:59.000Z',
        end_time: '2026-07-29T10:50:59.000Z',
        latitude: 37.7885195,
        longitude: -122.3872833,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:48:59.000Z',
        end_time: '2026-07-29T10:49:59.000Z',
        latitude: 37.7884997,
        longitude: -122.3872243,
        density: 23.684210526315788,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:48:59.000Z',
        end_time: '2026-07-29T10:49:59.000Z',
        latitude: 37.7884997,
        longitude: -122.3872243,
        density: 13.751960545519179,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:48:59.000Z',
        end_time: '2026-07-29T10:49:59.000Z',
        latitude: 37.7884997,
        longitude: -122.3872243,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:47:59.000Z',
        end_time: '2026-07-29T10:48:59.000Z',
        latitude: 37.7884977,
        longitude: -122.3871872,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:47:59.000Z',
        end_time: '2026-07-29T10:48:59.000Z',
        latitude: 37.7884977,
        longitude: -122.3871872,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:47:59.000Z',
        end_time: '2026-07-29T10:48:59.000Z',
        latitude: 37.7884977,
        longitude: -122.3871872,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T10:43:59.000Z',
        end_time: '2026-07-29T10:48:59.000Z',
        latitude: 37.7885,
        longitude: -122.3872167,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T10:43:59.000Z',
        end_time: '2026-07-29T10:48:59.000Z',
        latitude: 37.7885,
        longitude: -122.3872167,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T10:43:59.000Z',
        end_time: '2026-07-29T10:48:59.000Z',
        latitude: 37.7885,
        longitude: -122.3872167,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:46:59.000Z',
        end_time: '2026-07-29T10:47:59.000Z',
        latitude: 37.788499,
        longitude: -122.3871628,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:46:59.000Z',
        end_time: '2026-07-29T10:47:59.000Z',
        latitude: 37.788499,
        longitude: -122.3871628,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:46:59.000Z',
        end_time: '2026-07-29T10:47:59.000Z',
        latitude: 37.788499,
        longitude: -122.3871628,
        density: 29.979605669904466,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:45:59.000Z',
        end_time: '2026-07-29T10:46:59.000Z',
        latitude: 37.7884975,
        longitude: -122.3870908,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:45:59.000Z',
        end_time: '2026-07-29T10:46:59.000Z',
        latitude: 37.7884975,
        longitude: -122.3870908,
        density: 21.33640587729139,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:45:59.000Z',
        end_time: '2026-07-29T10:46:59.000Z',
        latitude: 37.7884975,
        longitude: -122.3870908,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:44:59.000Z',
        end_time: '2026-07-29T10:45:59.000Z',
        latitude: 37.7884322,
        longitude: -122.3870212,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:44:59.000Z',
        end_time: '2026-07-29T10:45:59.000Z',
        latitude: 37.7884322,
        longitude: -122.3870212,
        density: 16.92857958698888,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:44:59.000Z',
        end_time: '2026-07-29T10:45:59.000Z',
        latitude: 37.7884322,
        longitude: -122.3870212,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T10:39:00.000Z',
        end_time: '2026-07-29T10:44:00.000Z',
        latitude: 37.7884,
        longitude: -122.387,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:43:00.000Z',
        end_time: '2026-07-29T10:44:00.000Z',
        latitude: 37.7884243,
        longitude: -122.3871032,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:43:00.000Z',
        end_time: '2026-07-29T10:44:00.000Z',
        latitude: 37.7884243,
        longitude: -122.3871032,
        density: 35.873886969368854,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:43:00.000Z',
        end_time: '2026-07-29T10:44:00.000Z',
        latitude: 37.7884243,
        longitude: -122.3871032,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T10:39:00.000Z',
        end_time: '2026-07-29T10:44:00.000Z',
        latitude: 37.7884,
        longitude: -122.387,
        density: 12.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T10:39:00.000Z',
        end_time: '2026-07-29T10:44:00.000Z',
        latitude: 37.7884,
        longitude: -122.387,
        density: 30.04681793752247,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:42:00.000Z',
        end_time: '2026-07-29T10:43:00.000Z',
        latitude: 37.7884018,
        longitude: -122.3871183,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:42:00.000Z',
        end_time: '2026-07-29T10:43:00.000Z',
        latitude: 37.7884018,
        longitude: -122.3871183,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:42:00.000Z',
        end_time: '2026-07-29T10:43:00.000Z',
        latitude: 37.7884018,
        longitude: -122.3871183,
        density: 28.901833246827668,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:41:00.000Z',
        end_time: '2026-07-29T10:42:00.000Z',
        latitude: 37.788418,
        longitude: -122.3871628,
        density: 18.421052631578945,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:41:00.000Z',
        end_time: '2026-07-29T10:42:00.000Z',
        latitude: 37.788418,
        longitude: -122.3871628,
        density: 29.725109084985515,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:41:00.000Z',
        end_time: '2026-07-29T10:42:00.000Z',
        latitude: 37.788418,
        longitude: -122.3871628,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:40:00.000Z',
        end_time: '2026-07-29T10:41:00.000Z',
        latitude: 37.7884482,
        longitude: -122.3872112,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:40:00.000Z',
        end_time: '2026-07-29T10:41:00.000Z',
        latitude: 37.7884482,
        longitude: -122.3872112,
        density: 33.90123641846956,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:40:00.000Z',
        end_time: '2026-07-29T10:41:00.000Z',
        latitude: 37.7884482,
        longitude: -122.3872112,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:39:00.000Z',
        end_time: '2026-07-29T10:40:00.000Z',
        latitude: 37.78846,
        longitude: -122.3872148,
        density: 18.421052631578945,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:39:00.000Z',
        end_time: '2026-07-29T10:40:00.000Z',
        latitude: 37.78846,
        longitude: -122.3872148,
        density: 36.84866196480119,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:39:00.000Z',
        end_time: '2026-07-29T10:40:00.000Z',
        latitude: 37.78846,
        longitude: -122.3872148,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T10:34:00.000Z',
        end_time: '2026-07-29T10:39:00.000Z',
        latitude: 37.78845,
        longitude: -122.3871833,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:38:00.000Z',
        end_time: '2026-07-29T10:39:00.000Z',
        latitude: 37.7883848,
        longitude: -122.3870307,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:38:00.000Z',
        end_time: '2026-07-29T10:39:00.000Z',
        latitude: 37.7883848,
        longitude: -122.3870307,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:38:00.000Z',
        end_time: '2026-07-29T10:39:00.000Z',
        latitude: 37.7883848,
        longitude: -122.3870307,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T10:34:00.000Z',
        end_time: '2026-07-29T10:39:00.000Z',
        latitude: 37.78845,
        longitude: -122.3871833,
        density: 30.526315789473685,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T10:34:00.000Z',
        end_time: '2026-07-29T10:39:00.000Z',
        latitude: 37.78845,
        longitude: -122.3871833,
        density: 1.557863446753597,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:37:00.000Z',
        end_time: '2026-07-29T10:38:00.000Z',
        latitude: 37.7883912,
        longitude: -122.3870058,
        density: 39.473684210526315,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:37:00.000Z',
        end_time: '2026-07-29T10:38:00.000Z',
        latitude: 37.7883912,
        longitude: -122.3870058,
        density: 52.1813443450649,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:37:00.000Z',
        end_time: '2026-07-29T10:38:00.000Z',
        latitude: 37.7883912,
        longitude: -122.3870058,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:36:00.000Z',
        end_time: '2026-07-29T10:37:00.000Z',
        latitude: 37.7884573,
        longitude: -122.3870303,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:36:00.000Z',
        end_time: '2026-07-29T10:37:00.000Z',
        latitude: 37.7884573,
        longitude: -122.3870303,
        density: 42.10526315789473,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:36:00.000Z',
        end_time: '2026-07-29T10:37:00.000Z',
        latitude: 37.7884573,
        longitude: -122.3870303,
        density: 63.58616974413236,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:35:00.000Z',
        end_time: '2026-07-29T10:36:00.000Z',
        latitude: 37.7884418,
        longitude: -122.3871552,
        density: 28.947368421052634,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:35:00.000Z',
        end_time: '2026-07-29T10:36:00.000Z',
        latitude: 37.7884418,
        longitude: -122.3871552,
        density: 49.86793144998961,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:35:00.000Z',
        end_time: '2026-07-29T10:36:00.000Z',
        latitude: 37.7884418,
        longitude: -122.3871552,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T10:29:00.000Z',
        end_time: '2026-07-29T10:34:00.000Z',
        latitude: 37.7883167,
        longitude: -122.3870167,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:33:00.000Z',
        end_time: '2026-07-29T10:34:00.000Z',
        latitude: 37.7883718,
        longitude: -122.3870705,
        density: 10.526315789473683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:33:00.000Z',
        end_time: '2026-07-29T10:34:00.000Z',
        latitude: 37.7883718,
        longitude: -122.3870705,
        density: 7.3639229757066245,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:33:00.000Z',
        end_time: '2026-07-29T10:34:00.000Z',
        latitude: 37.7883718,
        longitude: -122.3870705,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T10:29:00.000Z',
        end_time: '2026-07-29T10:34:00.000Z',
        latitude: 37.7883167,
        longitude: -122.3870167,
        density: 22.63157894736842,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T10:29:00.000Z',
        end_time: '2026-07-29T10:34:00.000Z',
        latitude: 37.7883167,
        longitude: -122.3870167,
        density: 5.347077981013701,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:32:00.000Z',
        end_time: '2026-07-29T10:33:00.000Z',
        latitude: 37.7883565,
        longitude: -122.3870693,
        density: 47.368421052631575,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:32:00.000Z',
        end_time: '2026-07-29T10:33:00.000Z',
        latitude: 37.7883565,
        longitude: -122.3870693,
        density: 53.735912832129685,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:32:00.000Z',
        end_time: '2026-07-29T10:33:00.000Z',
        latitude: 37.7883565,
        longitude: -122.3870693,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:31:00.000Z',
        end_time: '2026-07-29T10:32:00.000Z',
        latitude: 37.7883187,
        longitude: -122.3874038,
        density: 23.684210526315788,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:31:00.000Z',
        end_time: '2026-07-29T10:32:00.000Z',
        latitude: 37.7883187,
        longitude: -122.3874038,
        density: 0.3848170769855912,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:31:00.000Z',
        end_time: '2026-07-29T10:32:00.000Z',
        latitude: 37.7883187,
        longitude: -122.3874038,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:30:00.000Z',
        end_time: '2026-07-29T10:31:00.000Z',
        latitude: 37.7884347,
        longitude: -122.3871715,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:30:00.000Z',
        end_time: '2026-07-29T10:31:00.000Z',
        latitude: 37.7884347,
        longitude: -122.3871715,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:30:00.000Z',
        end_time: '2026-07-29T10:31:00.000Z',
        latitude: 37.7884347,
        longitude: -122.3871715,
        density: 15.681317354381385,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T10:24:00.000Z',
        end_time: '2026-07-29T10:29:00.000Z',
        latitude: 37.7884333,
        longitude: -122.38715,
        density: 15.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T10:24:00.000Z',
        end_time: '2026-07-29T10:29:00.000Z',
        latitude: 37.7884333,
        longitude: -122.38715,
        density: 30.550764668914706,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T10:24:00.000Z',
        end_time: '2026-07-29T10:29:00.000Z',
        latitude: 37.7884333,
        longitude: -122.38715,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:28:00.000Z',
        end_time: '2026-07-29T10:29:00.000Z',
        latitude: 37.7884407,
        longitude: -122.3871072,
        density: 42.10526315789473,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:28:00.000Z',
        end_time: '2026-07-29T10:29:00.000Z',
        latitude: 37.7884407,
        longitude: -122.3871072,
        density: 24.44111075622289,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:28:00.000Z',
        end_time: '2026-07-29T10:29:00.000Z',
        latitude: 37.7884407,
        longitude: -122.3871072,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:27:00.000Z',
        end_time: '2026-07-29T10:28:00.000Z',
        latitude: 37.788404,
        longitude: -122.3870945,
        density: 23.684210526315788,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:27:00.000Z',
        end_time: '2026-07-29T10:28:00.000Z',
        latitude: 37.788404,
        longitude: -122.3870945,
        density: 35.7357996135044,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:27:00.000Z',
        end_time: '2026-07-29T10:28:00.000Z',
        latitude: 37.788404,
        longitude: -122.3870945,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:26:00.000Z',
        end_time: '2026-07-29T10:27:00.000Z',
        latitude: 37.7884622,
        longitude: -122.3871843,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:26:00.000Z',
        end_time: '2026-07-29T10:27:00.000Z',
        latitude: 37.7884622,
        longitude: -122.3871843,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:26:00.000Z',
        end_time: '2026-07-29T10:27:00.000Z',
        latitude: 37.7884622,
        longitude: -122.3871843,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:25:00.000Z',
        end_time: '2026-07-29T10:26:00.000Z',
        latitude: 37.7884578,
        longitude: -122.3871432,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:25:00.000Z',
        end_time: '2026-07-29T10:26:00.000Z',
        latitude: 37.7884578,
        longitude: -122.3871432,
        density: 14.494111085439188,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:25:00.000Z',
        end_time: '2026-07-29T10:26:00.000Z',
        latitude: 37.7884578,
        longitude: -122.3871432,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T10:19:00.000Z',
        end_time: '2026-07-29T10:24:00.000Z',
        latitude: 37.7884833,
        longitude: -122.38715,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:23:00.000Z',
        end_time: '2026-07-29T10:24:00.000Z',
        latitude: 37.7907513,
        longitude: -122.3866327,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:23:00.000Z',
        end_time: '2026-07-29T10:24:00.000Z',
        latitude: 37.7907513,
        longitude: -122.3866327,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:23:00.000Z',
        end_time: '2026-07-29T10:24:00.000Z',
        latitude: 37.7907513,
        longitude: -122.3866327,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T10:19:00.000Z',
        end_time: '2026-07-29T10:24:00.000Z',
        latitude: 37.7884833,
        longitude: -122.38715,
        density: 12.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T10:19:00.000Z',
        end_time: '2026-07-29T10:24:00.000Z',
        latitude: 37.7884833,
        longitude: -122.38715,
        density: 8.30119712949622,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:22:00.000Z',
        end_time: '2026-07-29T10:23:00.000Z',
        latitude: 37.7887717,
        longitude: -122.387089,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:22:00.000Z',
        end_time: '2026-07-29T10:23:00.000Z',
        latitude: 37.7887717,
        longitude: -122.387089,
        density: 15.789473684210526,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:22:00.000Z',
        end_time: '2026-07-29T10:23:00.000Z',
        latitude: 37.7887717,
        longitude: -122.387089,
        density: 8.188360232306499,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:21:00.000Z',
        end_time: '2026-07-29T10:22:00.000Z',
        latitude: 37.7887717,
        longitude: -122.387089,
        density: 23.684210526315788,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:21:00.000Z',
        end_time: '2026-07-29T10:22:00.000Z',
        latitude: 37.7887717,
        longitude: -122.387089,
        density: 44.37368307274489,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:21:00.000Z',
        end_time: '2026-07-29T10:22:00.000Z',
        latitude: 37.7887717,
        longitude: -122.387089,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:20:00.000Z',
        end_time: '2026-07-29T10:21:00.000Z',
        latitude: 37.7884905,
        longitude: -122.3871322,
        density: 18.421052631578945,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:20:00.000Z',
        end_time: '2026-07-29T10:21:00.000Z',
        latitude: 37.7884905,
        longitude: -122.3871322,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:20:00.000Z',
        end_time: '2026-07-29T10:21:00.000Z',
        latitude: 37.7884905,
        longitude: -122.3871322,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:19:00.000Z',
        end_time: '2026-07-29T10:20:00.000Z',
        latitude: 37.7883478,
        longitude: -122.3871722,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:19:00.000Z',
        end_time: '2026-07-29T10:20:00.000Z',
        latitude: 37.7883478,
        longitude: -122.3871722,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:19:00.000Z',
        end_time: '2026-07-29T10:20:00.000Z',
        latitude: 37.7883478,
        longitude: -122.3871722,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T10:14:00.000Z',
        end_time: '2026-07-29T10:19:00.000Z',
        latitude: 37.7883,
        longitude: -122.38715,
        density: 4.2105263157894735,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T10:14:00.000Z',
        end_time: '2026-07-29T10:19:00.000Z',
        latitude: 37.7883,
        longitude: -122.38715,
        density: 32.655437547761096,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:18:00.000Z',
        end_time: '2026-07-29T10:19:00.000Z',
        latitude: 37.7885707,
        longitude: -122.3870408,
        density: 18.421052631578945,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:18:00.000Z',
        end_time: '2026-07-29T10:19:00.000Z',
        latitude: 37.7885707,
        longitude: -122.3870408,
        density: 40.0698278243036,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:18:00.000Z',
        end_time: '2026-07-29T10:19:00.000Z',
        latitude: 37.7885707,
        longitude: -122.3870408,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T10:14:00.000Z',
        end_time: '2026-07-29T10:19:00.000Z',
        latitude: 37.7883,
        longitude: -122.38715,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:17:00.000Z',
        end_time: '2026-07-29T10:18:00.000Z',
        latitude: 37.7884432,
        longitude: -122.3870978,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:17:00.000Z',
        end_time: '2026-07-29T10:18:00.000Z',
        latitude: 37.7884432,
        longitude: -122.3870978,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:17:00.000Z',
        end_time: '2026-07-29T10:18:00.000Z',
        latitude: 37.7884432,
        longitude: -122.3870978,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:16:00.000Z',
        end_time: '2026-07-29T10:17:00.000Z',
        latitude: 37.7883733,
        longitude: -122.3871452,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:16:00.000Z',
        end_time: '2026-07-29T10:17:00.000Z',
        latitude: 37.7883733,
        longitude: -122.3871452,
        density: 5.331995704407384,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:16:00.000Z',
        end_time: '2026-07-29T10:17:00.000Z',
        latitude: 37.7883733,
        longitude: -122.3871452,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:15:00.000Z',
        end_time: '2026-07-29T10:16:00.000Z',
        latitude: 37.788369,
        longitude: -122.3871387,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:15:00.000Z',
        end_time: '2026-07-29T10:16:00.000Z',
        latitude: 37.788369,
        longitude: -122.3871387,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:15:00.000Z',
        end_time: '2026-07-29T10:16:00.000Z',
        latitude: 37.788369,
        longitude: -122.3871387,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:14:00.000Z',
        end_time: '2026-07-29T10:15:00.000Z',
        latitude: 37.7883407,
        longitude: -122.387163,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:14:00.000Z',
        end_time: '2026-07-29T10:15:00.000Z',
        latitude: 37.7883407,
        longitude: -122.387163,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:14:00.000Z',
        end_time: '2026-07-29T10:15:00.000Z',
        latitude: 37.7883407,
        longitude: -122.387163,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T10:09:00.000Z',
        end_time: '2026-07-29T10:14:00.000Z',
        latitude: 37.7883167,
        longitude: -122.3871667,
        density: 8.947368421052632,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T10:09:00.000Z',
        end_time: '2026-07-29T10:14:00.000Z',
        latitude: 37.7883167,
        longitude: -122.3871667,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:13:00.000Z',
        end_time: '2026-07-29T10:14:00.000Z',
        latitude: 37.7883582,
        longitude: -122.387203,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:13:00.000Z',
        end_time: '2026-07-29T10:14:00.000Z',
        latitude: 37.7883582,
        longitude: -122.387203,
        density: 7.856866422779165,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:13:00.000Z',
        end_time: '2026-07-29T10:14:00.000Z',
        latitude: 37.7883582,
        longitude: -122.387203,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T10:09:00.000Z',
        end_time: '2026-07-29T10:14:00.000Z',
        latitude: 37.7883167,
        longitude: -122.3871667,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:12:00.000Z',
        end_time: '2026-07-29T10:13:00.000Z',
        latitude: 37.7884802,
        longitude: -122.3871618,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:12:00.000Z',
        end_time: '2026-07-29T10:13:00.000Z',
        latitude: 37.7884802,
        longitude: -122.3871618,
        density: 10.526315789473683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:12:00.000Z',
        end_time: '2026-07-29T10:13:00.000Z',
        latitude: 37.7884802,
        longitude: -122.3871618,
        density: 13.26701118705791,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:11:00.000Z',
        end_time: '2026-07-29T10:12:00.000Z',
        latitude: 37.7883595,
        longitude: -122.3872087,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:11:00.000Z',
        end_time: '2026-07-29T10:12:00.000Z',
        latitude: 37.7883595,
        longitude: -122.3872087,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:11:00.000Z',
        end_time: '2026-07-29T10:12:00.000Z',
        latitude: 37.7883595,
        longitude: -122.3872087,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:10:00.000Z',
        end_time: '2026-07-29T10:11:00.000Z',
        latitude: 37.7883722,
        longitude: -122.3865102,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:10:00.000Z',
        end_time: '2026-07-29T10:11:00.000Z',
        latitude: 37.7883722,
        longitude: -122.3865102,
        density: 5.861815181157938,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:10:00.000Z',
        end_time: '2026-07-29T10:11:00.000Z',
        latitude: 37.7883722,
        longitude: -122.3865102,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:08:00.000Z',
        end_time: '2026-07-29T10:09:00.000Z',
        latitude: 37.788417,
        longitude: -122.3872195,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T10:04:00.000Z',
        end_time: '2026-07-29T10:09:00.000Z',
        latitude: 37.7884,
        longitude: -122.38715,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:08:00.000Z',
        end_time: '2026-07-29T10:09:00.000Z',
        latitude: 37.788417,
        longitude: -122.3872195,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:08:00.000Z',
        end_time: '2026-07-29T10:09:00.000Z',
        latitude: 37.788417,
        longitude: -122.3872195,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T10:04:00.000Z',
        end_time: '2026-07-29T10:09:00.000Z',
        latitude: 37.7884,
        longitude: -122.38715,
        density: 13.684210526315791,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T10:04:00.000Z',
        end_time: '2026-07-29T10:09:00.000Z',
        latitude: 37.7884,
        longitude: -122.38715,
        density: 9.21016508113344,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:07:00.000Z',
        end_time: '2026-07-29T10:08:00.000Z',
        latitude: 37.7883313,
        longitude: -122.387235,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:07:00.000Z',
        end_time: '2026-07-29T10:08:00.000Z',
        latitude: 37.7883313,
        longitude: -122.387235,
        density: 10.526315789473683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:07:00.000Z',
        end_time: '2026-07-29T10:08:00.000Z',
        latitude: 37.7883313,
        longitude: -122.387235,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:06:00.000Z',
        end_time: '2026-07-29T10:07:00.000Z',
        latitude: 37.7884138,
        longitude: -122.3871122,
        density: 18.421052631578945,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:06:00.000Z',
        end_time: '2026-07-29T10:07:00.000Z',
        latitude: 37.7884138,
        longitude: -122.3871122,
        density: 14.744340003553534,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:06:00.000Z',
        end_time: '2026-07-29T10:07:00.000Z',
        latitude: 37.7884138,
        longitude: -122.3871122,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:05:00.000Z',
        end_time: '2026-07-29T10:06:00.000Z',
        latitude: 37.8216087,
        longitude: -121.9659162,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:05:00.000Z',
        end_time: '2026-07-29T10:06:00.000Z',
        latitude: 37.8216087,
        longitude: -121.9659162,
        density: 29.70481395082247,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:05:00.000Z',
        end_time: '2026-07-29T10:06:00.000Z',
        latitude: 37.8216087,
        longitude: -121.9659162,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:04:00.000Z',
        end_time: '2026-07-29T10:05:00.000Z',
        latitude: 37.8208848,
        longitude: -121.9893808,
        density: 21.052631578947366,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:04:00.000Z',
        end_time: '2026-07-29T10:05:00.000Z',
        latitude: 37.8208848,
        longitude: -121.9893808,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:04:00.000Z',
        end_time: '2026-07-29T10:05:00.000Z',
        latitude: 37.8208848,
        longitude: -121.9893808,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:03:00.000Z',
        end_time: '2026-07-29T10:04:00.000Z',
        latitude: 37.8149705,
        longitude: -122.0851165,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:03:00.000Z',
        end_time: '2026-07-29T10:04:00.000Z',
        latitude: 37.8149705,
        longitude: -122.0851165,
        density: 15.789473684210526,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:03:00.000Z',
        end_time: '2026-07-29T10:04:00.000Z',
        latitude: 37.8149705,
        longitude: -122.0851165,
        density: 14.769316415782997,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T09:59:00.000Z',
        end_time: '2026-07-29T10:04:00.000Z',
        latitude: 37.82035,
        longitude: -121.9995667,
        density: 19.473684210526315,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T09:59:00.000Z',
        end_time: '2026-07-29T10:04:00.000Z',
        latitude: 37.82035,
        longitude: -121.9995667,
        density: 32.106823358131365,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T09:59:00.000Z',
        end_time: '2026-07-29T10:04:00.000Z',
        latitude: 37.82035,
        longitude: -121.9995667,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:02:00.000Z',
        end_time: '2026-07-29T10:03:00.000Z',
        latitude: 37.809051,
        longitude: -122.1721755,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:02:00.000Z',
        end_time: '2026-07-29T10:03:00.000Z',
        latitude: 37.809051,
        longitude: -122.1721755,
        density: 21.052631578947366,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:02:00.000Z',
        end_time: '2026-07-29T10:03:00.000Z',
        latitude: 37.809051,
        longitude: -122.1721755,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:01:00.000Z',
        end_time: '2026-07-29T10:02:00.000Z',
        latitude: 37.8002928,
        longitude: -122.2734247,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:01:00.000Z',
        end_time: '2026-07-29T10:02:00.000Z',
        latitude: 37.8002928,
        longitude: -122.2734247,
        density: 21.052631578947366,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:01:00.000Z',
        end_time: '2026-07-29T10:02:00.000Z',
        latitude: 37.8002928,
        longitude: -122.2734247,
        density: 7.656742471001568,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T10:00:00.000Z',
        end_time: '2026-07-29T10:01:00.000Z',
        latitude: 37.7906767,
        longitude: -122.3659022,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T10:00:00.000Z',
        end_time: '2026-07-29T10:01:00.000Z',
        latitude: 37.7906767,
        longitude: -122.3659022,
        density: 18.421052631578945,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T10:00:00.000Z',
        end_time: '2026-07-29T10:01:00.000Z',
        latitude: 37.7906767,
        longitude: -122.3659022,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T09:54:00.000Z',
        end_time: '2026-07-29T09:59:00.000Z',
        latitude: 37.7884333,
        longitude: -122.3869667,
        density: 12.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T09:54:00.000Z',
        end_time: '2026-07-29T09:59:00.000Z',
        latitude: 37.7884333,
        longitude: -122.3869667,
        density: 39.30268361488882,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T09:54:00.000Z',
        end_time: '2026-07-29T09:59:00.000Z',
        latitude: 37.7884333,
        longitude: -122.3869667,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:58:00.000Z',
        end_time: '2026-07-29T09:59:00.000Z',
        latitude: 37.7884177,
        longitude: -122.3870067,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:58:00.000Z',
        end_time: '2026-07-29T09:59:00.000Z',
        latitude: 37.7884177,
        longitude: -122.3870067,
        density: 15.789473684210526,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:58:00.000Z',
        end_time: '2026-07-29T09:59:00.000Z',
        latitude: 37.7884177,
        longitude: -122.3870067,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:57:00.000Z',
        end_time: '2026-07-29T09:58:00.000Z',
        latitude: 37.7884155,
        longitude: -122.3871478,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:57:00.000Z',
        end_time: '2026-07-29T09:58:00.000Z',
        latitude: 37.7884155,
        longitude: -122.3871478,
        density: 15.789473684210526,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:57:00.000Z',
        end_time: '2026-07-29T09:58:00.000Z',
        latitude: 37.7884155,
        longitude: -122.3871478,
        density: 31.301260790429758,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:56:00.000Z',
        end_time: '2026-07-29T09:57:00.000Z',
        latitude: 37.7884545,
        longitude: -122.3871595,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:56:00.000Z',
        end_time: '2026-07-29T09:57:00.000Z',
        latitude: 37.7884545,
        longitude: -122.3871595,
        density: 14.017413656025813,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:56:00.000Z',
        end_time: '2026-07-29T09:57:00.000Z',
        latitude: 37.7884545,
        longitude: -122.3871595,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:55:00.000Z',
        end_time: '2026-07-29T09:56:00.000Z',
        latitude: 37.7884458,
        longitude: -122.387122,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:55:00.000Z',
        end_time: '2026-07-29T09:56:00.000Z',
        latitude: 37.7884458,
        longitude: -122.387122,
        density: 15.789473684210526,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:55:00.000Z',
        end_time: '2026-07-29T09:56:00.000Z',
        latitude: 37.7884458,
        longitude: -122.387122,
        density: 21.17697188436094,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:54:00.000Z',
        end_time: '2026-07-29T09:55:00.000Z',
        latitude: 37.7884255,
        longitude: -122.3871152,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:54:00.000Z',
        end_time: '2026-07-29T09:55:00.000Z',
        latitude: 37.7884255,
        longitude: -122.3871152,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:54:00.000Z',
        end_time: '2026-07-29T09:55:00.000Z',
        latitude: 37.7884255,
        longitude: -122.3871152,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:53:00.000Z',
        end_time: '2026-07-29T09:54:00.000Z',
        latitude: 37.7884118,
        longitude: -122.3871405,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:53:00.000Z',
        end_time: '2026-07-29T09:54:00.000Z',
        latitude: 37.7884118,
        longitude: -122.3871405,
        density: 7.239339791560566,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:53:00.000Z',
        end_time: '2026-07-29T09:54:00.000Z',
        latitude: 37.7884118,
        longitude: -122.3871405,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T09:49:00.000Z',
        end_time: '2026-07-29T09:54:00.000Z',
        latitude: 37.7884167,
        longitude: -122.3871167,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T09:49:00.000Z',
        end_time: '2026-07-29T09:54:00.000Z',
        latitude: 37.7884167,
        longitude: -122.3871167,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T09:49:00.000Z',
        end_time: '2026-07-29T09:54:00.000Z',
        latitude: 37.7884167,
        longitude: -122.3871167,
        density: 15.756777354754858,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:52:00.000Z',
        end_time: '2026-07-29T09:53:00.000Z',
        latitude: 37.7883925,
        longitude: -122.3871385,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:52:00.000Z',
        end_time: '2026-07-29T09:53:00.000Z',
        latitude: 37.7883925,
        longitude: -122.3871385,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:52:00.000Z',
        end_time: '2026-07-29T09:53:00.000Z',
        latitude: 37.7883925,
        longitude: -122.3871385,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:51:00.000Z',
        end_time: '2026-07-29T09:52:00.000Z',
        latitude: 37.7884105,
        longitude: -122.3871095,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:51:00.000Z',
        end_time: '2026-07-29T09:52:00.000Z',
        latitude: 37.7884105,
        longitude: -122.3871095,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:51:00.000Z',
        end_time: '2026-07-29T09:52:00.000Z',
        latitude: 37.7884105,
        longitude: -122.3871095,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:50:00.000Z',
        end_time: '2026-07-29T09:51:00.000Z',
        latitude: 37.7884668,
        longitude: -122.3871357,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:50:00.000Z',
        end_time: '2026-07-29T09:51:00.000Z',
        latitude: 37.7884668,
        longitude: -122.3871357,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:50:00.000Z',
        end_time: '2026-07-29T09:51:00.000Z',
        latitude: 37.7884668,
        longitude: -122.3871357,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T09:44:00.000Z',
        end_time: '2026-07-29T09:49:00.000Z',
        latitude: 37.7884667,
        longitude: -122.3871,
        density: 3.684210526315789,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T09:44:00.000Z',
        end_time: '2026-07-29T09:49:00.000Z',
        latitude: 37.7884667,
        longitude: -122.3871,
        density: 7.01387357462502,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:48:00.000Z',
        end_time: '2026-07-29T09:49:00.000Z',
        latitude: 37.7896142,
        longitude: -122.3810668,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:48:00.000Z',
        end_time: '2026-07-29T09:49:00.000Z',
        latitude: 37.7896142,
        longitude: -122.3810668,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:48:00.000Z',
        end_time: '2026-07-29T09:49:00.000Z',
        latitude: 37.7896142,
        longitude: -122.3810668,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T09:44:00.000Z',
        end_time: '2026-07-29T09:49:00.000Z',
        latitude: 37.7884667,
        longitude: -122.3871,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:47:00.000Z',
        end_time: '2026-07-29T09:48:00.000Z',
        latitude: 37.7882595,
        longitude: -122.3875488,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:47:00.000Z',
        end_time: '2026-07-29T09:48:00.000Z',
        latitude: 37.7882595,
        longitude: -122.3875488,
        density: 24.17539032562353,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:47:00.000Z',
        end_time: '2026-07-29T09:48:00.000Z',
        latitude: 37.7882595,
        longitude: -122.3875488,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:46:00.000Z',
        end_time: '2026-07-29T09:47:00.000Z',
        latitude: 37.7883267,
        longitude: -122.3871013,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:46:00.000Z',
        end_time: '2026-07-29T09:47:00.000Z',
        latitude: 37.7883267,
        longitude: -122.3871013,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:46:00.000Z',
        end_time: '2026-07-29T09:47:00.000Z',
        latitude: 37.7883267,
        longitude: -122.3871013,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:45:00.000Z',
        end_time: '2026-07-29T09:46:00.000Z',
        latitude: 37.7883855,
        longitude: -122.3871165,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:45:00.000Z',
        end_time: '2026-07-29T09:46:00.000Z',
        latitude: 37.7883855,
        longitude: -122.3871165,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:45:00.000Z',
        end_time: '2026-07-29T09:46:00.000Z',
        latitude: 37.7883855,
        longitude: -122.3871165,
        density: 18.314918054252306,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T09:39:00.000Z',
        end_time: '2026-07-29T09:44:00.000Z',
        latitude: 37.7884333,
        longitude: -122.3871,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:43:00.000Z',
        end_time: '2026-07-29T09:44:00.000Z',
        latitude: 37.7884355,
        longitude: -122.387094,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:43:00.000Z',
        end_time: '2026-07-29T09:44:00.000Z',
        latitude: 37.7884355,
        longitude: -122.387094,
        density: 15.621476540708517,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:43:00.000Z',
        end_time: '2026-07-29T09:44:00.000Z',
        latitude: 37.7884355,
        longitude: -122.387094,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T09:39:00.000Z',
        end_time: '2026-07-29T09:44:00.000Z',
        latitude: 37.7884333,
        longitude: -122.3871,
        density: 15.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T09:39:00.000Z',
        end_time: '2026-07-29T09:44:00.000Z',
        latitude: 37.7884333,
        longitude: -122.3871,
        density: 36.92176426918682,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:42:00.000Z',
        end_time: '2026-07-29T09:43:00.000Z',
        latitude: 37.7883722,
        longitude: -122.3871187,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:42:00.000Z',
        end_time: '2026-07-29T09:43:00.000Z',
        latitude: 37.7883722,
        longitude: -122.3871187,
        density: 27.884268893862554,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:42:00.000Z',
        end_time: '2026-07-29T09:43:00.000Z',
        latitude: 37.7883722,
        longitude: -122.3871187,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:41:00.000Z',
        end_time: '2026-07-29T09:42:00.000Z',
        latitude: 37.7884222,
        longitude: -122.3871128,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:41:00.000Z',
        end_time: '2026-07-29T09:42:00.000Z',
        latitude: 37.7884222,
        longitude: -122.3871128,
        density: 23.684210526315788,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:41:00.000Z',
        end_time: '2026-07-29T09:42:00.000Z',
        latitude: 37.7884222,
        longitude: -122.3871128,
        density: 51.23920024863249,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:40:00.000Z',
        end_time: '2026-07-29T09:41:00.000Z',
        latitude: 37.7883857,
        longitude: -122.387122,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:40:00.000Z',
        end_time: '2026-07-29T09:41:00.000Z',
        latitude: 37.7883857,
        longitude: -122.387122,
        density: 23.684210526315788,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:40:00.000Z',
        end_time: '2026-07-29T09:41:00.000Z',
        latitude: 37.7883857,
        longitude: -122.387122,
        density: 20.165519926594605,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T09:34:00.000Z',
        end_time: '2026-07-29T09:39:00.000Z',
        latitude: 37.7884167,
        longitude: -122.3871333,
        density: 4.736842105263158,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T09:34:00.000Z',
        end_time: '2026-07-29T09:39:00.000Z',
        latitude: 37.7884167,
        longitude: -122.3871333,
        density: 25.093258762328645,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:38:00.000Z',
        end_time: '2026-07-29T09:39:00.000Z',
        latitude: 37.7884127,
        longitude: -122.387154,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:38:00.000Z',
        end_time: '2026-07-29T09:39:00.000Z',
        latitude: 37.7884127,
        longitude: -122.387154,
        density: 19.320573260721865,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:38:00.000Z',
        end_time: '2026-07-29T09:39:00.000Z',
        latitude: 37.7884127,
        longitude: -122.387154,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T09:34:00.000Z',
        end_time: '2026-07-29T09:39:00.000Z',
        latitude: 37.7884167,
        longitude: -122.3871333,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:37:00.000Z',
        end_time: '2026-07-29T09:38:00.000Z',
        latitude: 37.7883897,
        longitude: -122.3871573,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:37:00.000Z',
        end_time: '2026-07-29T09:38:00.000Z',
        latitude: 37.7883897,
        longitude: -122.3871573,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:37:00.000Z',
        end_time: '2026-07-29T09:38:00.000Z',
        latitude: 37.7883897,
        longitude: -122.3871573,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:36:00.000Z',
        end_time: '2026-07-29T09:37:00.000Z',
        latitude: 37.7884243,
        longitude: -122.3871138,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:36:00.000Z',
        end_time: '2026-07-29T09:37:00.000Z',
        latitude: 37.7884243,
        longitude: -122.3871138,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:36:00.000Z',
        end_time: '2026-07-29T09:37:00.000Z',
        latitude: 37.7884243,
        longitude: -122.3871138,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:35:00.000Z',
        end_time: '2026-07-29T09:36:00.000Z',
        latitude: 37.7884183,
        longitude: -122.3870653,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:35:00.000Z',
        end_time: '2026-07-29T09:36:00.000Z',
        latitude: 37.7884183,
        longitude: -122.3870653,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:35:00.000Z',
        end_time: '2026-07-29T09:36:00.000Z',
        latitude: 37.7884183,
        longitude: -122.3870653,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T09:29:00.000Z',
        end_time: '2026-07-29T09:34:00.000Z',
        latitude: 37.78845,
        longitude: -122.3871,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:33:00.000Z',
        end_time: '2026-07-29T09:34:00.000Z',
        latitude: 37.7884475,
        longitude: -122.3871127,
        density: 21.052631578947366,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:33:00.000Z',
        end_time: '2026-07-29T09:34:00.000Z',
        latitude: 37.7884475,
        longitude: -122.3871127,
        density: 42.18609757656847,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:33:00.000Z',
        end_time: '2026-07-29T09:34:00.000Z',
        latitude: 37.7884475,
        longitude: -122.3871127,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T09:29:00.000Z',
        end_time: '2026-07-29T09:34:00.000Z',
        latitude: 37.78845,
        longitude: -122.3871,
        density: 20.526315789473685,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T09:29:00.000Z',
        end_time: '2026-07-29T09:34:00.000Z',
        latitude: 37.78845,
        longitude: -122.3871,
        density: 3.2150872197288436,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:32:00.000Z',
        end_time: '2026-07-29T09:33:00.000Z',
        latitude: 37.788361,
        longitude: -122.3871643,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:32:00.000Z',
        end_time: '2026-07-29T09:33:00.000Z',
        latitude: 37.788361,
        longitude: -122.3871643,
        density: 21.052631578947366,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:32:00.000Z',
        end_time: '2026-07-29T09:33:00.000Z',
        latitude: 37.788361,
        longitude: -122.3871643,
        density: 39.0937496906499,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:31:00.000Z',
        end_time: '2026-07-29T09:32:00.000Z',
        latitude: 37.7885507,
        longitude: -122.3870368,
        density: 18.421052631578945,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:31:00.000Z',
        end_time: '2026-07-29T09:32:00.000Z',
        latitude: 37.7885507,
        longitude: -122.3870368,
        density: 41.88879450976654,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:31:00.000Z',
        end_time: '2026-07-29T09:32:00.000Z',
        latitude: 37.7885507,
        longitude: -122.3870368,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:30:00.000Z',
        end_time: '2026-07-29T09:31:00.000Z',
        latitude: 37.7883912,
        longitude: -122.3871565,
        density: 18.421052631578945,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:30:00.000Z',
        end_time: '2026-07-29T09:31:00.000Z',
        latitude: 37.7883912,
        longitude: -122.3871565,
        density: 22.503286957297963,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:30:00.000Z',
        end_time: '2026-07-29T09:31:00.000Z',
        latitude: 37.7883912,
        longitude: -122.3871565,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:28:00.000Z',
        end_time: '2026-07-29T09:29:00.000Z',
        latitude: 37.7884443,
        longitude: -122.3871575,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:28:00.000Z',
        end_time: '2026-07-29T09:29:00.000Z',
        latitude: 37.7884443,
        longitude: -122.3871575,
        density: 21.052631578947366,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:28:00.000Z',
        end_time: '2026-07-29T09:29:00.000Z',
        latitude: 37.7884443,
        longitude: -122.3871575,
        density: 31.98603692413786,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T09:24:00.000Z',
        end_time: '2026-07-29T09:29:00.000Z',
        latitude: 37.7884167,
        longitude: -122.3871333,
        density: 16.315789473684212,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T09:24:00.000Z',
        end_time: '2026-07-29T09:29:00.000Z',
        latitude: 37.7884167,
        longitude: -122.3871333,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T09:24:00.000Z',
        end_time: '2026-07-29T09:29:00.000Z',
        latitude: 37.7884167,
        longitude: -122.3871333,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:27:00.000Z',
        end_time: '2026-07-29T09:28:00.000Z',
        latitude: 37.7884205,
        longitude: -122.3871228,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:27:00.000Z',
        end_time: '2026-07-29T09:28:00.000Z',
        latitude: 37.7884205,
        longitude: -122.3871228,
        density: 23.684210526315788,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:27:00.000Z',
        end_time: '2026-07-29T09:28:00.000Z',
        latitude: 37.7884205,
        longitude: -122.3871228,
        density: 23.46991138176788,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:26:00.000Z',
        end_time: '2026-07-29T09:27:00.000Z',
        latitude: 37.7884397,
        longitude: -122.3872897,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:26:00.000Z',
        end_time: '2026-07-29T09:27:00.000Z',
        latitude: 37.7884397,
        longitude: -122.3872897,
        density: 10.526315789473683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:26:00.000Z',
        end_time: '2026-07-29T09:27:00.000Z',
        latitude: 37.7884397,
        longitude: -122.3872897,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:25:00.000Z',
        end_time: '2026-07-29T09:26:00.000Z',
        latitude: 37.7884072,
        longitude: -122.3872333,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:25:00.000Z',
        end_time: '2026-07-29T09:26:00.000Z',
        latitude: 37.7884072,
        longitude: -122.3872333,
        density: 10.526315789473683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:25:00.000Z',
        end_time: '2026-07-29T09:26:00.000Z',
        latitude: 37.7884072,
        longitude: -122.3872333,
        density: 7.384691074407945,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T09:19:01.000Z',
        end_time: '2026-07-29T09:24:01.000Z',
        latitude: 37.7886167,
        longitude: -122.3862667,
        density: 12.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T09:19:01.000Z',
        end_time: '2026-07-29T09:24:01.000Z',
        latitude: 37.7886167,
        longitude: -122.3862667,
        density: 9.35267528106453,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T09:19:01.000Z',
        end_time: '2026-07-29T09:24:01.000Z',
        latitude: 37.7886167,
        longitude: -122.3862667,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:23:00.000Z',
        end_time: '2026-07-29T09:24:00.000Z',
        latitude: 37.788943,
        longitude: -122.3847302,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:23:00.000Z',
        end_time: '2026-07-29T09:24:00.000Z',
        latitude: 37.788943,
        longitude: -122.3847302,
        density: 10.526315789473683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:23:00.000Z',
        end_time: '2026-07-29T09:24:00.000Z',
        latitude: 37.788943,
        longitude: -122.3847302,
        density: 38.86592806221089,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:22:00.000Z',
        end_time: '2026-07-29T09:23:00.000Z',
        latitude: 37.7884487,
        longitude: -122.3871442,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:22:00.000Z',
        end_time: '2026-07-29T09:23:00.000Z',
        latitude: 37.7884487,
        longitude: -122.3871442,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:22:00.000Z',
        end_time: '2026-07-29T09:23:00.000Z',
        latitude: 37.7884487,
        longitude: -122.3871442,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:21:00.000Z',
        end_time: '2026-07-29T09:22:00.000Z',
        latitude: 37.7884308,
        longitude: -122.387126,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:21:00.000Z',
        end_time: '2026-07-29T09:22:00.000Z',
        latitude: 37.7884308,
        longitude: -122.387126,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:21:00.000Z',
        end_time: '2026-07-29T09:22:00.000Z',
        latitude: 37.7884308,
        longitude: -122.387126,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:20:00.000Z',
        end_time: '2026-07-29T09:21:00.000Z',
        latitude: 37.788393,
        longitude: -122.387171,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:20:00.000Z',
        end_time: '2026-07-29T09:21:00.000Z',
        latitude: 37.788393,
        longitude: -122.387171,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:20:00.000Z',
        end_time: '2026-07-29T09:21:00.000Z',
        latitude: 37.788393,
        longitude: -122.387171,
        density: 40.199457971346376,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T09:14:01.000Z',
        end_time: '2026-07-29T09:19:01.000Z',
        latitude: 37.7883833,
        longitude: -122.3870667,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T09:14:01.000Z',
        end_time: '2026-07-29T09:19:01.000Z',
        latitude: 37.7883833,
        longitude: -122.3870667,
        density: 3.684210526315789,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T09:14:01.000Z',
        end_time: '2026-07-29T09:19:01.000Z',
        latitude: 37.7883833,
        longitude: -122.3870667,
        density: 31.11218208144512,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:18:00.000Z',
        end_time: '2026-07-29T09:19:00.000Z',
        latitude: 37.7884142,
        longitude: -122.387137,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:18:00.000Z',
        end_time: '2026-07-29T09:19:00.000Z',
        latitude: 37.7884142,
        longitude: -122.387137,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:18:00.000Z',
        end_time: '2026-07-29T09:19:00.000Z',
        latitude: 37.7884142,
        longitude: -122.387137,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:17:01.000Z',
        end_time: '2026-07-29T09:18:01.000Z',
        latitude: 37.788429,
        longitude: -122.3871735,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:17:01.000Z',
        end_time: '2026-07-29T09:18:01.000Z',
        latitude: 37.788429,
        longitude: -122.3871735,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:17:01.000Z',
        end_time: '2026-07-29T09:18:01.000Z',
        latitude: 37.788429,
        longitude: -122.3871735,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:16:01.000Z',
        end_time: '2026-07-29T09:17:01.000Z',
        latitude: 37.7884418,
        longitude: -122.3871423,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:16:01.000Z',
        end_time: '2026-07-29T09:17:01.000Z',
        latitude: 37.7884418,
        longitude: -122.3871423,
        density: 27.99280197532313,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:16:01.000Z',
        end_time: '2026-07-29T09:17:01.000Z',
        latitude: 37.7884418,
        longitude: -122.3871423,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:15:01.000Z',
        end_time: '2026-07-29T09:16:01.000Z',
        latitude: 37.788426,
        longitude: -122.3872315,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:15:01.000Z',
        end_time: '2026-07-29T09:16:01.000Z',
        latitude: 37.788426,
        longitude: -122.3872315,
        density: 3.7963549109007615,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:15:01.000Z',
        end_time: '2026-07-29T09:16:01.000Z',
        latitude: 37.788426,
        longitude: -122.3872315,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T09:09:01.000Z',
        end_time: '2026-07-29T09:14:01.000Z',
        latitude: 37.7883833,
        longitude: -122.3871167,
        density: 6.842105263157896,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T09:09:01.000Z',
        end_time: '2026-07-29T09:14:01.000Z',
        latitude: 37.7883833,
        longitude: -122.3871167,
        density: 4.814141211877267,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T09:09:01.000Z',
        end_time: '2026-07-29T09:14:01.000Z',
        latitude: 37.7883833,
        longitude: -122.3871167,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:12:01.000Z',
        end_time: '2026-07-29T09:13:01.000Z',
        latitude: 37.788412,
        longitude: -122.3871373,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:12:01.000Z',
        end_time: '2026-07-29T09:13:01.000Z',
        latitude: 37.788412,
        longitude: -122.3871373,
        density: 10.526315789473683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:12:01.000Z',
        end_time: '2026-07-29T09:13:01.000Z',
        latitude: 37.788412,
        longitude: -122.3871373,
        density: 9.68997842634762,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:11:01.000Z',
        end_time: '2026-07-29T09:12:01.000Z',
        latitude: 37.788459,
        longitude: -122.3872272,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:11:01.000Z',
        end_time: '2026-07-29T09:12:01.000Z',
        latitude: 37.788459,
        longitude: -122.3872272,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:11:01.000Z',
        end_time: '2026-07-29T09:12:01.000Z',
        latitude: 37.788459,
        longitude: -122.3872272,
        density: 36.53093523485148,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:10:01.000Z',
        end_time: '2026-07-29T09:11:01.000Z',
        latitude: 37.7884512,
        longitude: -122.3872925,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:10:01.000Z',
        end_time: '2026-07-29T09:11:01.000Z',
        latitude: 37.7884512,
        longitude: -122.3872925,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:10:01.000Z',
        end_time: '2026-07-29T09:11:01.000Z',
        latitude: 37.7884512,
        longitude: -122.3872925,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:09:01.000Z',
        end_time: '2026-07-29T09:10:01.000Z',
        latitude: 37.7884385,
        longitude: -122.3872267,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:09:01.000Z',
        end_time: '2026-07-29T09:10:01.000Z',
        latitude: 37.7884385,
        longitude: -122.3872267,
        density: 34.18753416116995,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:09:01.000Z',
        end_time: '2026-07-29T09:10:01.000Z',
        latitude: 37.7884385,
        longitude: -122.3872267,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:08:01.000Z',
        end_time: '2026-07-29T09:09:01.000Z',
        latitude: 37.7884402,
        longitude: -122.3871792,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T09:04:01.000Z',
        end_time: '2026-07-29T09:09:01.000Z',
        latitude: 37.7884333,
        longitude: -122.3872167,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:08:01.000Z',
        end_time: '2026-07-29T09:09:01.000Z',
        latitude: 37.7884402,
        longitude: -122.3871792,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:08:01.000Z',
        end_time: '2026-07-29T09:09:01.000Z',
        latitude: 37.7884402,
        longitude: -122.3871792,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T09:04:01.000Z',
        end_time: '2026-07-29T09:09:01.000Z',
        latitude: 37.7884333,
        longitude: -122.3872167,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T09:04:01.000Z',
        end_time: '2026-07-29T09:09:01.000Z',
        latitude: 37.7884333,
        longitude: -122.3872167,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:07:01.000Z',
        end_time: '2026-07-29T09:08:01.000Z',
        latitude: 37.7884848,
        longitude: -122.387342,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:07:01.000Z',
        end_time: '2026-07-29T09:08:01.000Z',
        latitude: 37.7884848,
        longitude: -122.387342,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:07:01.000Z',
        end_time: '2026-07-29T09:08:01.000Z',
        latitude: 37.7884848,
        longitude: -122.387342,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:06:01.000Z',
        end_time: '2026-07-29T09:07:01.000Z',
        latitude: 37.7884765,
        longitude: -122.3871998,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:06:01.000Z',
        end_time: '2026-07-29T09:07:01.000Z',
        latitude: 37.7884765,
        longitude: -122.3871998,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:06:01.000Z',
        end_time: '2026-07-29T09:07:01.000Z',
        latitude: 37.7884765,
        longitude: -122.3871998,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:05:01.000Z',
        end_time: '2026-07-29T09:06:01.000Z',
        latitude: 37.7884537,
        longitude: -122.387094,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:05:01.000Z',
        end_time: '2026-07-29T09:06:01.000Z',
        latitude: 37.7884537,
        longitude: -122.387094,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:05:01.000Z',
        end_time: '2026-07-29T09:06:01.000Z',
        latitude: 37.7884537,
        longitude: -122.387094,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T08:59:01.000Z',
        end_time: '2026-07-29T09:04:01.000Z',
        latitude: 37.7884,
        longitude: -122.3875,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:03:01.000Z',
        end_time: '2026-07-29T09:04:01.000Z',
        latitude: 37.7883885,
        longitude: -122.3874328,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:03:01.000Z',
        end_time: '2026-07-29T09:04:01.000Z',
        latitude: 37.7883885,
        longitude: -122.3874328,
        density: 1.4985990630640051,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:03:01.000Z',
        end_time: '2026-07-29T09:04:01.000Z',
        latitude: 37.7883885,
        longitude: -122.3874328,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T08:59:01.000Z',
        end_time: '2026-07-29T09:04:01.000Z',
        latitude: 37.7884,
        longitude: -122.3875,
        density: 12.105263157894736,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T08:59:01.000Z',
        end_time: '2026-07-29T09:04:01.000Z',
        latitude: 37.7884,
        longitude: -122.3875,
        density: 4.089371347097723,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:02:01.000Z',
        end_time: '2026-07-29T09:03:01.000Z',
        latitude: 37.7884345,
        longitude: -122.3871588,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:02:01.000Z',
        end_time: '2026-07-29T09:03:01.000Z',
        latitude: 37.7884345,
        longitude: -122.3871588,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:02:01.000Z',
        end_time: '2026-07-29T09:03:01.000Z',
        latitude: 37.7884345,
        longitude: -122.3871588,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:01:01.000Z',
        end_time: '2026-07-29T09:02:01.000Z',
        latitude: 37.788381,
        longitude: -122.3872737,
        density: 10.526315789473683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:01:01.000Z',
        end_time: '2026-07-29T09:02:01.000Z',
        latitude: 37.788381,
        longitude: -122.3872737,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:01:01.000Z',
        end_time: '2026-07-29T09:02:01.000Z',
        latitude: 37.788381,
        longitude: -122.3872737,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T09:00:01.000Z',
        end_time: '2026-07-29T09:01:01.000Z',
        latitude: 37.788377,
        longitude: -122.3872273,
        density: 21.052631578947366,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T09:00:01.000Z',
        end_time: '2026-07-29T09:01:01.000Z',
        latitude: 37.788377,
        longitude: -122.3872273,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T09:00:01.000Z',
        end_time: '2026-07-29T09:01:01.000Z',
        latitude: 37.788377,
        longitude: -122.3872273,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:59:01.000Z',
        end_time: '2026-07-29T09:00:01.000Z',
        latitude: 37.7884843,
        longitude: -122.3864935,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:59:01.000Z',
        end_time: '2026-07-29T09:00:01.000Z',
        latitude: 37.7884843,
        longitude: -122.3864935,
        density: 15.789473684210526,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:59:01.000Z',
        end_time: '2026-07-29T09:00:01.000Z',
        latitude: 37.7884843,
        longitude: -122.3864935,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T08:54:01.000Z',
        end_time: '2026-07-29T08:59:01.000Z',
        latitude: 37.7884167,
        longitude: -122.387,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:58:01.000Z',
        end_time: '2026-07-29T08:59:01.000Z',
        latitude: 37.7883958,
        longitude: -122.3870767,
        density: 31.57894736842105,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:58:01.000Z',
        end_time: '2026-07-29T08:59:01.000Z',
        latitude: 37.7883958,
        longitude: -122.3870767,
        density: 6.117624877034604,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:58:01.000Z',
        end_time: '2026-07-29T08:59:01.000Z',
        latitude: 37.7883958,
        longitude: -122.3870767,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T08:54:01.000Z',
        end_time: '2026-07-29T08:59:01.000Z',
        latitude: 37.7884167,
        longitude: -122.387,
        density: 15.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T08:54:01.000Z',
        end_time: '2026-07-29T08:59:01.000Z',
        latitude: 37.7884167,
        longitude: -122.387,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:57:01.000Z',
        end_time: '2026-07-29T08:58:01.000Z',
        latitude: 37.7884418,
        longitude: -122.3870687,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:57:01.000Z',
        end_time: '2026-07-29T08:58:01.000Z',
        latitude: 37.7884418,
        longitude: -122.3870687,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:57:01.000Z',
        end_time: '2026-07-29T08:58:01.000Z',
        latitude: 37.7884418,
        longitude: -122.3870687,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:56:01.000Z',
        end_time: '2026-07-29T08:57:01.000Z',
        latitude: 37.7884347,
        longitude: -122.3872095,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:56:01.000Z',
        end_time: '2026-07-29T08:57:01.000Z',
        latitude: 37.7884347,
        longitude: -122.3872095,
        density: 18.421052631578945,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:56:01.000Z',
        end_time: '2026-07-29T08:57:01.000Z',
        latitude: 37.7884347,
        longitude: -122.3872095,
        density: 9.310085109461832,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:55:01.000Z',
        end_time: '2026-07-29T08:56:01.000Z',
        latitude: 37.7884542,
        longitude: -122.3873052,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:55:01.000Z',
        end_time: '2026-07-29T08:56:01.000Z',
        latitude: 37.7884542,
        longitude: -122.3873052,
        density: 10.526315789473683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:55:01.000Z',
        end_time: '2026-07-29T08:56:01.000Z',
        latitude: 37.7884542,
        longitude: -122.3873052,
        density: 35.86226579921222,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T08:49:01.000Z',
        end_time: '2026-07-29T08:54:01.000Z',
        latitude: 37.7884833,
        longitude: -122.3872167,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:53:01.000Z',
        end_time: '2026-07-29T08:54:01.000Z',
        latitude: 37.7884487,
        longitude: -122.387196,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:53:01.000Z',
        end_time: '2026-07-29T08:54:01.000Z',
        latitude: 37.7884487,
        longitude: -122.387196,
        density: 23.450019244198664,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:53:01.000Z',
        end_time: '2026-07-29T08:54:01.000Z',
        latitude: 37.7884487,
        longitude: -122.387196,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T08:49:01.000Z',
        end_time: '2026-07-29T08:54:01.000Z',
        latitude: 37.7884833,
        longitude: -122.3872167,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T08:49:01.000Z',
        end_time: '2026-07-29T08:54:01.000Z',
        latitude: 37.7884833,
        longitude: -122.3872167,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:52:01.000Z',
        end_time: '2026-07-29T08:53:01.000Z',
        latitude: 37.7884428,
        longitude: -122.3871395,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:52:01.000Z',
        end_time: '2026-07-29T08:53:01.000Z',
        latitude: 37.7884428,
        longitude: -122.3871395,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:52:01.000Z',
        end_time: '2026-07-29T08:53:01.000Z',
        latitude: 37.7884428,
        longitude: -122.3871395,
        density: 33.513330952109,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:51:01.000Z',
        end_time: '2026-07-29T08:52:01.000Z',
        latitude: 37.7884292,
        longitude: -122.3870318,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:51:01.000Z',
        end_time: '2026-07-29T08:52:01.000Z',
        latitude: 37.7884292,
        longitude: -122.3870318,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:51:01.000Z',
        end_time: '2026-07-29T08:52:01.000Z',
        latitude: 37.7884292,
        longitude: -122.3870318,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:50:01.000Z',
        end_time: '2026-07-29T08:51:01.000Z',
        latitude: 37.7884778,
        longitude: -122.3870083,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:50:01.000Z',
        end_time: '2026-07-29T08:51:01.000Z',
        latitude: 37.7884778,
        longitude: -122.3870083,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:50:01.000Z',
        end_time: '2026-07-29T08:51:01.000Z',
        latitude: 37.7884778,
        longitude: -122.3870083,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T08:44:01.000Z',
        end_time: '2026-07-29T08:49:01.000Z',
        latitude: 37.7885,
        longitude: -122.38705,
        density: 8.947368421052632,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T08:44:01.000Z',
        end_time: '2026-07-29T08:49:01.000Z',
        latitude: 37.7885,
        longitude: -122.38705,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:48:01.000Z',
        end_time: '2026-07-29T08:49:01.000Z',
        latitude: 37.7884733,
        longitude: -122.3871685,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:48:01.000Z',
        end_time: '2026-07-29T08:49:01.000Z',
        latitude: 37.7884733,
        longitude: -122.3871685,
        density: 22.866216044675177,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T08:44:01.000Z',
        end_time: '2026-07-29T08:49:01.000Z',
        latitude: 37.7885,
        longitude: -122.38705,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:48:01.000Z',
        end_time: '2026-07-29T08:49:01.000Z',
        latitude: 37.7884733,
        longitude: -122.3871685,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:47:01.000Z',
        end_time: '2026-07-29T08:48:01.000Z',
        latitude: 37.7884117,
        longitude: -122.3872763,
        density: 21.052631578947366,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:47:01.000Z',
        end_time: '2026-07-29T08:48:01.000Z',
        latitude: 37.7884117,
        longitude: -122.3872763,
        density: 5.445299789378673,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:47:01.000Z',
        end_time: '2026-07-29T08:48:01.000Z',
        latitude: 37.7884117,
        longitude: -122.3872763,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:46:01.000Z',
        end_time: '2026-07-29T08:47:01.000Z',
        latitude: 37.7884002,
        longitude: -122.3871537,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:46:01.000Z',
        end_time: '2026-07-29T08:47:01.000Z',
        latitude: 37.7884002,
        longitude: -122.3871537,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:46:01.000Z',
        end_time: '2026-07-29T08:47:01.000Z',
        latitude: 37.7884002,
        longitude: -122.3871537,
        density: 33.14829238872891,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:45:01.000Z',
        end_time: '2026-07-29T08:46:01.000Z',
        latitude: 37.7884208,
        longitude: -122.387173,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:45:01.000Z',
        end_time: '2026-07-29T08:46:01.000Z',
        latitude: 37.7884208,
        longitude: -122.387173,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:45:01.000Z',
        end_time: '2026-07-29T08:46:01.000Z',
        latitude: 37.7884208,
        longitude: -122.387173,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:43:01.000Z',
        end_time: '2026-07-29T08:44:01.000Z',
        latitude: 37.7884388,
        longitude: -122.3870393,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T08:39:01.000Z',
        end_time: '2026-07-29T08:44:01.000Z',
        latitude: 37.7883833,
        longitude: -122.38725,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:43:01.000Z',
        end_time: '2026-07-29T08:44:01.000Z',
        latitude: 37.7884388,
        longitude: -122.3870393,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:43:01.000Z',
        end_time: '2026-07-29T08:44:01.000Z',
        latitude: 37.7884388,
        longitude: -122.3870393,
        density: 15.051585106777416,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T08:39:01.000Z',
        end_time: '2026-07-29T08:44:01.000Z',
        latitude: 37.7883833,
        longitude: -122.38725,
        density: 8.947368421052632,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T08:39:01.000Z',
        end_time: '2026-07-29T08:44:01.000Z',
        latitude: 37.7883833,
        longitude: -122.38725,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:42:01.000Z',
        end_time: '2026-07-29T08:43:01.000Z',
        latitude: 37.7885365,
        longitude: -122.386495,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:42:01.000Z',
        end_time: '2026-07-29T08:43:01.000Z',
        latitude: 37.7885365,
        longitude: -122.386495,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:42:01.000Z',
        end_time: '2026-07-29T08:43:01.000Z',
        latitude: 37.7885365,
        longitude: -122.386495,
        density: 16.167820859721857,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:41:01.000Z',
        end_time: '2026-07-29T08:42:01.000Z',
        latitude: 37.7883937,
        longitude: -122.3870235,
        density: 18.421052631578945,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:41:01.000Z',
        end_time: '2026-07-29T08:42:01.000Z',
        latitude: 37.7883937,
        longitude: -122.3870235,
        density: 30.476023378570115,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:41:01.000Z',
        end_time: '2026-07-29T08:42:01.000Z',
        latitude: 37.7883937,
        longitude: -122.3870235,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:40:01.000Z',
        end_time: '2026-07-29T08:41:01.000Z',
        latitude: 37.7884707,
        longitude: -122.3873465,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:40:01.000Z',
        end_time: '2026-07-29T08:41:01.000Z',
        latitude: 37.7884707,
        longitude: -122.3873465,
        density: 6.582451356990481,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:40:01.000Z',
        end_time: '2026-07-29T08:41:01.000Z',
        latitude: 37.7884707,
        longitude: -122.3873465,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T08:34:01.000Z',
        end_time: '2026-07-29T08:39:01.000Z',
        latitude: 37.7884833,
        longitude: -122.3873,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T08:34:01.000Z',
        end_time: '2026-07-29T08:39:01.000Z',
        latitude: 37.7884833,
        longitude: -122.3873,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:38:01.000Z',
        end_time: '2026-07-29T08:39:01.000Z',
        latitude: 37.7884762,
        longitude: -122.3870668,
        density: 15.789473684210526,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:38:01.000Z',
        end_time: '2026-07-29T08:39:01.000Z',
        latitude: 37.7884762,
        longitude: -122.3870668,
        density: 45.48121395387061,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:38:01.000Z',
        end_time: '2026-07-29T08:39:01.000Z',
        latitude: 37.7884762,
        longitude: -122.3870668,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T08:34:01.000Z',
        end_time: '2026-07-29T08:39:01.000Z',
        latitude: 37.7884833,
        longitude: -122.3873,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:37:01.000Z',
        end_time: '2026-07-29T08:38:01.000Z',
        latitude: 37.7885003,
        longitude: -122.3864933,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:37:01.000Z',
        end_time: '2026-07-29T08:38:01.000Z',
        latitude: 37.7885003,
        longitude: -122.3864933,
        density: 10.526315789473683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:37:01.000Z',
        end_time: '2026-07-29T08:38:01.000Z',
        latitude: 37.7885003,
        longitude: -122.3864933,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:36:01.000Z',
        end_time: '2026-07-29T08:37:01.000Z',
        latitude: 37.7884985,
        longitude: -122.3868633,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:36:01.000Z',
        end_time: '2026-07-29T08:37:01.000Z',
        latitude: 37.7884985,
        longitude: -122.3868633,
        density: 19.56222389826798,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:36:01.000Z',
        end_time: '2026-07-29T08:37:01.000Z',
        latitude: 37.7884985,
        longitude: -122.3868633,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:35:01.000Z',
        end_time: '2026-07-29T08:36:01.000Z',
        latitude: 37.7884623,
        longitude: -122.3867832,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:35:01.000Z',
        end_time: '2026-07-29T08:36:01.000Z',
        latitude: 37.7884623,
        longitude: -122.3867832,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:35:01.000Z',
        end_time: '2026-07-29T08:36:01.000Z',
        latitude: 37.7884623,
        longitude: -122.3867832,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:34:01.000Z',
        end_time: '2026-07-29T08:35:01.000Z',
        latitude: 37.7884778,
        longitude: -122.3871193,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:34:01.000Z',
        end_time: '2026-07-29T08:35:01.000Z',
        latitude: 37.7884778,
        longitude: -122.3871193,
        density: 30.324952567387097,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:34:01.000Z',
        end_time: '2026-07-29T08:35:01.000Z',
        latitude: 37.7884778,
        longitude: -122.3871193,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T08:29:01.000Z',
        end_time: '2026-07-29T08:34:01.000Z',
        latitude: 37.7884667,
        longitude: -122.38715,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T08:29:01.000Z',
        end_time: '2026-07-29T08:34:01.000Z',
        latitude: 37.7884667,
        longitude: -122.38715,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:33:01.000Z',
        end_time: '2026-07-29T08:34:01.000Z',
        latitude: 37.7884502,
        longitude: -122.3870092,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:33:01.000Z',
        end_time: '2026-07-29T08:34:01.000Z',
        latitude: 37.7884502,
        longitude: -122.3870092,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:33:01.000Z',
        end_time: '2026-07-29T08:34:01.000Z',
        latitude: 37.7884502,
        longitude: -122.3870092,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T08:29:01.000Z',
        end_time: '2026-07-29T08:34:01.000Z',
        latitude: 37.7884667,
        longitude: -122.38715,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:32:01.000Z',
        end_time: '2026-07-29T08:33:01.000Z',
        latitude: 37.7884447,
        longitude: -122.3870283,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:32:01.000Z',
        end_time: '2026-07-29T08:33:01.000Z',
        latitude: 37.7884447,
        longitude: -122.3870283,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:32:01.000Z',
        end_time: '2026-07-29T08:33:01.000Z',
        latitude: 37.7884447,
        longitude: -122.3870283,
        density: 1.676506835897933,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:31:01.000Z',
        end_time: '2026-07-29T08:32:01.000Z',
        latitude: 37.7884872,
        longitude: -122.3871385,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:31:01.000Z',
        end_time: '2026-07-29T08:32:01.000Z',
        latitude: 37.7884872,
        longitude: -122.3871385,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:31:01.000Z',
        end_time: '2026-07-29T08:32:01.000Z',
        latitude: 37.7884872,
        longitude: -122.3871385,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:30:01.000Z',
        end_time: '2026-07-29T08:31:01.000Z',
        latitude: 37.7884845,
        longitude: -122.3872627,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:30:01.000Z',
        end_time: '2026-07-29T08:31:01.000Z',
        latitude: 37.7884845,
        longitude: -122.3872627,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:30:01.000Z',
        end_time: '2026-07-29T08:31:01.000Z',
        latitude: 37.7884845,
        longitude: -122.3872627,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T08:24:01.000Z',
        end_time: '2026-07-29T08:29:01.000Z',
        latitude: 37.78845,
        longitude: -122.3873,
        density: 6.842105263157896,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T08:24:01.000Z',
        end_time: '2026-07-29T08:29:01.000Z',
        latitude: 37.78845,
        longitude: -122.3873,
        density: 10.836643136184534,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:28:01.000Z',
        end_time: '2026-07-29T08:29:01.000Z',
        latitude: 37.7884663,
        longitude: -122.3872878,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:28:01.000Z',
        end_time: '2026-07-29T08:29:01.000Z',
        latitude: 37.7884663,
        longitude: -122.3872878,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:28:01.000Z',
        end_time: '2026-07-29T08:29:01.000Z',
        latitude: 37.7884663,
        longitude: -122.3872878,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T08:24:01.000Z',
        end_time: '2026-07-29T08:29:01.000Z',
        latitude: 37.78845,
        longitude: -122.3873,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:27:01.000Z',
        end_time: '2026-07-29T08:28:01.000Z',
        latitude: 37.7884715,
        longitude: -122.387153,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:27:01.000Z',
        end_time: '2026-07-29T08:28:01.000Z',
        latitude: 37.7884715,
        longitude: -122.387153,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:27:01.000Z',
        end_time: '2026-07-29T08:28:01.000Z',
        latitude: 37.7884715,
        longitude: -122.387153,
        density: 37.6935076107726,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:26:01.000Z',
        end_time: '2026-07-29T08:27:01.000Z',
        latitude: 37.7884617,
        longitude: -122.3871748,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:26:01.000Z',
        end_time: '2026-07-29T08:27:01.000Z',
        latitude: 37.7884617,
        longitude: -122.3871748,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:26:01.000Z',
        end_time: '2026-07-29T08:27:01.000Z',
        latitude: 37.7884617,
        longitude: -122.3871748,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:25:01.000Z',
        end_time: '2026-07-29T08:26:01.000Z',
        latitude: 37.7884697,
        longitude: -122.3871823,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:25:01.000Z',
        end_time: '2026-07-29T08:26:01.000Z',
        latitude: 37.7884697,
        longitude: -122.3871823,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:25:01.000Z',
        end_time: '2026-07-29T08:26:01.000Z',
        latitude: 37.7884697,
        longitude: -122.3871823,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T08:19:01.000Z',
        end_time: '2026-07-29T08:24:01.000Z',
        latitude: 37.7884333,
        longitude: -122.3871667,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:23:01.000Z',
        end_time: '2026-07-29T08:24:01.000Z',
        latitude: 37.788366,
        longitude: -122.3870662,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:23:01.000Z',
        end_time: '2026-07-29T08:24:01.000Z',
        latitude: 37.788366,
        longitude: -122.3870662,
        density: 14.973876058617616,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:23:01.000Z',
        end_time: '2026-07-29T08:24:01.000Z',
        latitude: 37.788366,
        longitude: -122.3870662,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T08:19:01.000Z',
        end_time: '2026-07-29T08:24:01.000Z',
        latitude: 37.7884333,
        longitude: -122.3871667,
        density: 3.684210526315789,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T08:19:01.000Z',
        end_time: '2026-07-29T08:24:01.000Z',
        latitude: 37.7884333,
        longitude: -122.3871667,
        density: 28.072894167434267,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:22:01.000Z',
        end_time: '2026-07-29T08:23:01.000Z',
        latitude: 37.7883847,
        longitude: -122.387068,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:22:01.000Z',
        end_time: '2026-07-29T08:23:01.000Z',
        latitude: 37.7883847,
        longitude: -122.387068,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:22:01.000Z',
        end_time: '2026-07-29T08:23:01.000Z',
        latitude: 37.7883847,
        longitude: -122.387068,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:21:01.000Z',
        end_time: '2026-07-29T08:22:01.000Z',
        latitude: 37.7883808,
        longitude: -122.3870185,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:21:01.000Z',
        end_time: '2026-07-29T08:22:01.000Z',
        latitude: 37.7883808,
        longitude: -122.3870185,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:21:01.000Z',
        end_time: '2026-07-29T08:22:01.000Z',
        latitude: 37.7883808,
        longitude: -122.3870185,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:20:01.000Z',
        end_time: '2026-07-29T08:21:01.000Z',
        latitude: 37.7883167,
        longitude: -122.3869487,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:20:01.000Z',
        end_time: '2026-07-29T08:21:01.000Z',
        latitude: 37.7883167,
        longitude: -122.3869487,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:20:01.000Z',
        end_time: '2026-07-29T08:21:01.000Z',
        latitude: 37.7883167,
        longitude: -122.3869487,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:19:01.000Z',
        end_time: '2026-07-29T08:20:01.000Z',
        latitude: 37.7884248,
        longitude: -122.3869768,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:19:01.000Z',
        end_time: '2026-07-29T08:20:01.000Z',
        latitude: 37.7884248,
        longitude: -122.3869768,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:19:01.000Z',
        end_time: '2026-07-29T08:20:01.000Z',
        latitude: 37.7884248,
        longitude: -122.3869768,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T08:14:01.000Z',
        end_time: '2026-07-29T08:19:01.000Z',
        latitude: 37.7884167,
        longitude: -122.3869833,
        density: 1.0526315789473684,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T08:14:01.000Z',
        end_time: '2026-07-29T08:19:01.000Z',
        latitude: 37.7884167,
        longitude: -122.3869833,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:18:01.000Z',
        end_time: '2026-07-29T08:19:01.000Z',
        latitude: 37.7884028,
        longitude: -122.3870313,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:18:01.000Z',
        end_time: '2026-07-29T08:19:01.000Z',
        latitude: 37.7884028,
        longitude: -122.3870313,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:18:01.000Z',
        end_time: '2026-07-29T08:19:01.000Z',
        latitude: 37.7884028,
        longitude: -122.3870313,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T08:14:01.000Z',
        end_time: '2026-07-29T08:19:01.000Z',
        latitude: 37.7884167,
        longitude: -122.3869833,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:17:01.000Z',
        end_time: '2026-07-29T08:18:01.000Z',
        latitude: 37.7883663,
        longitude: -122.387057,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:17:01.000Z',
        end_time: '2026-07-29T08:18:01.000Z',
        latitude: 37.7883663,
        longitude: -122.387057,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:17:01.000Z',
        end_time: '2026-07-29T08:18:01.000Z',
        latitude: 37.7883663,
        longitude: -122.387057,
        density: 23.493217390923107,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:16:01.000Z',
        end_time: '2026-07-29T08:17:01.000Z',
        latitude: 37.7883717,
        longitude: -122.3870692,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:16:01.000Z',
        end_time: '2026-07-29T08:17:01.000Z',
        latitude: 37.7883717,
        longitude: -122.3870692,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:16:01.000Z',
        end_time: '2026-07-29T08:17:01.000Z',
        latitude: 37.7883717,
        longitude: -122.3870692,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:15:01.000Z',
        end_time: '2026-07-29T08:16:01.000Z',
        latitude: 37.7883728,
        longitude: -122.3870178,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:15:01.000Z',
        end_time: '2026-07-29T08:16:01.000Z',
        latitude: 37.7883728,
        longitude: -122.3870178,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:15:01.000Z',
        end_time: '2026-07-29T08:16:01.000Z',
        latitude: 37.7883728,
        longitude: -122.3870178,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T08:09:01.000Z',
        end_time: '2026-07-29T08:14:01.000Z',
        latitude: 37.78835,
        longitude: -122.387,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:13:01.000Z',
        end_time: '2026-07-29T08:14:01.000Z',
        latitude: 37.7883935,
        longitude: -122.3870643,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:13:01.000Z',
        end_time: '2026-07-29T08:14:01.000Z',
        latitude: 37.7883935,
        longitude: -122.3870643,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:13:01.000Z',
        end_time: '2026-07-29T08:14:01.000Z',
        latitude: 37.7883935,
        longitude: -122.3870643,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T08:09:01.000Z',
        end_time: '2026-07-29T08:14:01.000Z',
        latitude: 37.78835,
        longitude: -122.387,
        density: 1.5789473684210527,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T08:09:01.000Z',
        end_time: '2026-07-29T08:14:01.000Z',
        latitude: 37.78835,
        longitude: -122.387,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:12:01.000Z',
        end_time: '2026-07-29T08:13:01.000Z',
        latitude: 37.788347,
        longitude: -122.3870978,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:12:01.000Z',
        end_time: '2026-07-29T08:13:01.000Z',
        latitude: 37.788347,
        longitude: -122.3870978,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:12:01.000Z',
        end_time: '2026-07-29T08:13:01.000Z',
        latitude: 37.788347,
        longitude: -122.3870978,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:11:01.000Z',
        end_time: '2026-07-29T08:12:01.000Z',
        latitude: 37.7884047,
        longitude: -122.3871178,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:11:01.000Z',
        end_time: '2026-07-29T08:12:01.000Z',
        latitude: 37.7884047,
        longitude: -122.3871178,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:11:01.000Z',
        end_time: '2026-07-29T08:12:01.000Z',
        latitude: 37.7884047,
        longitude: -122.3871178,
        density: 6.210141833631289,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:10:01.000Z',
        end_time: '2026-07-29T08:11:01.000Z',
        latitude: 37.7883223,
        longitude: -122.3871003,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:10:01.000Z',
        end_time: '2026-07-29T08:11:01.000Z',
        latitude: 37.7883223,
        longitude: -122.3871003,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:10:01.000Z',
        end_time: '2026-07-29T08:11:01.000Z',
        latitude: 37.7883223,
        longitude: -122.3871003,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T08:04:01.000Z',
        end_time: '2026-07-29T08:09:01.000Z',
        latitude: 37.7883167,
        longitude: -122.3871,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:08:01.000Z',
        end_time: '2026-07-29T08:09:01.000Z',
        latitude: 37.7883642,
        longitude: -122.3871098,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:08:01.000Z',
        end_time: '2026-07-29T08:09:01.000Z',
        latitude: 37.7883642,
        longitude: -122.3871098,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:08:01.000Z',
        end_time: '2026-07-29T08:09:01.000Z',
        latitude: 37.7883642,
        longitude: -122.3871098,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T08:04:01.000Z',
        end_time: '2026-07-29T08:09:01.000Z',
        latitude: 37.7883167,
        longitude: -122.3871,
        density: 3.684210526315789,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T08:04:01.000Z',
        end_time: '2026-07-29T08:09:01.000Z',
        latitude: 37.7883167,
        longitude: -122.3871,
        density: 32.55867694349836,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:07:01.000Z',
        end_time: '2026-07-29T08:08:01.000Z',
        latitude: 37.7883243,
        longitude: -122.3871127,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:07:01.000Z',
        end_time: '2026-07-29T08:08:01.000Z',
        latitude: 37.7883243,
        longitude: -122.3871127,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:07:01.000Z',
        end_time: '2026-07-29T08:08:01.000Z',
        latitude: 37.7883243,
        longitude: -122.3871127,
        density: 15.088718963171393,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:06:01.000Z',
        end_time: '2026-07-29T08:07:01.000Z',
        latitude: 37.7884015,
        longitude: -122.3870872,
        density: 10.526315789473683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:06:01.000Z',
        end_time: '2026-07-29T08:07:01.000Z',
        latitude: 37.7884015,
        longitude: -122.3870872,
        density: 29.066491972226203,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:06:01.000Z',
        end_time: '2026-07-29T08:07:01.000Z',
        latitude: 37.7884015,
        longitude: -122.3870872,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:05:01.000Z',
        end_time: '2026-07-29T08:06:01.000Z',
        latitude: 37.788433,
        longitude: -122.3871247,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:05:01.000Z',
        end_time: '2026-07-29T08:06:01.000Z',
        latitude: 37.788433,
        longitude: -122.3871247,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:05:01.000Z',
        end_time: '2026-07-29T08:06:01.000Z',
        latitude: 37.788433,
        longitude: -122.3871247,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T07:59:01.000Z',
        end_time: '2026-07-29T08:04:01.000Z',
        latitude: 37.78845,
        longitude: -122.3871167,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T07:59:01.000Z',
        end_time: '2026-07-29T08:04:01.000Z',
        latitude: 37.78845,
        longitude: -122.3871167,
        density: 28.033125690364248,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:03:01.000Z',
        end_time: '2026-07-29T08:04:01.000Z',
        latitude: 37.7884642,
        longitude: -122.3871302,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:03:01.000Z',
        end_time: '2026-07-29T08:04:01.000Z',
        latitude: 37.7884642,
        longitude: -122.3871302,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:03:01.000Z',
        end_time: '2026-07-29T08:04:01.000Z',
        latitude: 37.7884642,
        longitude: -122.3871302,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T07:59:01.000Z',
        end_time: '2026-07-29T08:04:01.000Z',
        latitude: 37.78845,
        longitude: -122.3871167,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:02:01.000Z',
        end_time: '2026-07-29T08:03:01.000Z',
        latitude: 37.7884767,
        longitude: -122.387175,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:02:01.000Z',
        end_time: '2026-07-29T08:03:01.000Z',
        latitude: 37.7884767,
        longitude: -122.387175,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:02:01.000Z',
        end_time: '2026-07-29T08:03:01.000Z',
        latitude: 37.7884767,
        longitude: -122.387175,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:01:01.000Z',
        end_time: '2026-07-29T08:02:01.000Z',
        latitude: 37.78849,
        longitude: -122.3871375,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:01:01.000Z',
        end_time: '2026-07-29T08:02:01.000Z',
        latitude: 37.78849,
        longitude: -122.3871375,
        density: 3.378843890680323,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:01:01.000Z',
        end_time: '2026-07-29T08:02:01.000Z',
        latitude: 37.78849,
        longitude: -122.3871375,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T08:00:01.000Z',
        end_time: '2026-07-29T08:01:01.000Z',
        latitude: 37.7884528,
        longitude: -122.3872407,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T08:00:01.000Z',
        end_time: '2026-07-29T08:01:01.000Z',
        latitude: 37.7884528,
        longitude: -122.3872407,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T08:00:01.000Z',
        end_time: '2026-07-29T08:01:01.000Z',
        latitude: 37.7884528,
        longitude: -122.3872407,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:58:01.000Z',
        end_time: '2026-07-29T07:59:01.000Z',
        latitude: 37.7884547,
        longitude: -122.3871005,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:58:01.000Z',
        end_time: '2026-07-29T07:59:01.000Z',
        latitude: 37.7884547,
        longitude: -122.3871005,
        density: 21.052631578947366,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:58:01.000Z',
        end_time: '2026-07-29T07:59:01.000Z',
        latitude: 37.7884547,
        longitude: -122.3871005,
        density: 30.68019689095573,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T07:54:01.000Z',
        end_time: '2026-07-29T07:59:01.000Z',
        latitude: 37.78845,
        longitude: -122.3870833,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T07:54:01.000Z',
        end_time: '2026-07-29T07:59:01.000Z',
        latitude: 37.78845,
        longitude: -122.3870833,
        density: 21.827496763765048,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T07:54:01.000Z',
        end_time: '2026-07-29T07:59:01.000Z',
        latitude: 37.78845,
        longitude: -122.3870833,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:57:01.000Z',
        end_time: '2026-07-29T07:58:01.000Z',
        latitude: 37.7884705,
        longitude: -122.3870342,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:57:01.000Z',
        end_time: '2026-07-29T07:58:01.000Z',
        latitude: 37.7884705,
        longitude: -122.3870342,
        density: 10.526315789473683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:57:01.000Z',
        end_time: '2026-07-29T07:58:01.000Z',
        latitude: 37.7884705,
        longitude: -122.3870342,
        density: 32.54157847031658,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:56:01.000Z',
        end_time: '2026-07-29T07:57:01.000Z',
        latitude: 37.788464,
        longitude: -122.3871205,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:56:01.000Z',
        end_time: '2026-07-29T07:57:01.000Z',
        latitude: 37.788464,
        longitude: -122.3871205,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:56:01.000Z',
        end_time: '2026-07-29T07:57:01.000Z',
        latitude: 37.788464,
        longitude: -122.3871205,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:55:02.000Z',
        end_time: '2026-07-29T07:56:02.000Z',
        latitude: 37.788437,
        longitude: -122.3870683,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:55:02.000Z',
        end_time: '2026-07-29T07:56:02.000Z',
        latitude: 37.788437,
        longitude: -122.3870683,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:55:02.000Z',
        end_time: '2026-07-29T07:56:02.000Z',
        latitude: 37.788437,
        longitude: -122.3870683,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:54:01.000Z',
        end_time: '2026-07-29T07:55:01.000Z',
        latitude: 37.7883832,
        longitude: -122.3870258,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:54:01.000Z',
        end_time: '2026-07-29T07:55:01.000Z',
        latitude: 37.7883832,
        longitude: -122.3870258,
        density: 25.430616687977086,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:54:01.000Z',
        end_time: '2026-07-29T07:55:01.000Z',
        latitude: 37.7883832,
        longitude: -122.3870258,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:53:02.000Z',
        end_time: '2026-07-29T07:54:02.000Z',
        latitude: 37.7882857,
        longitude: -122.3869565,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T07:49:02.000Z',
        end_time: '2026-07-29T07:54:02.000Z',
        latitude: 37.7883833,
        longitude: -122.387,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:53:02.000Z',
        end_time: '2026-07-29T07:54:02.000Z',
        latitude: 37.7882857,
        longitude: -122.3869565,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:53:02.000Z',
        end_time: '2026-07-29T07:54:02.000Z',
        latitude: 37.7882857,
        longitude: -122.3869565,
        density: 14.524677475440026,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T07:49:02.000Z',
        end_time: '2026-07-29T07:54:02.000Z',
        latitude: 37.7883833,
        longitude: -122.387,
        density: 4.2105263157894735,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T07:49:02.000Z',
        end_time: '2026-07-29T07:54:02.000Z',
        latitude: 37.7883833,
        longitude: -122.387,
        density: 16.850110223620455,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:52:02.000Z',
        end_time: '2026-07-29T07:53:02.000Z',
        latitude: 37.7884112,
        longitude: -122.3870582,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:52:02.000Z',
        end_time: '2026-07-29T07:53:02.000Z',
        latitude: 37.7884112,
        longitude: -122.3870582,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:52:02.000Z',
        end_time: '2026-07-29T07:53:02.000Z',
        latitude: 37.7884112,
        longitude: -122.3870582,
        density: 32.33539430945363,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:51:02.000Z',
        end_time: '2026-07-29T07:52:02.000Z',
        latitude: 37.788436,
        longitude: -122.387151,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:51:02.000Z',
        end_time: '2026-07-29T07:52:02.000Z',
        latitude: 37.788436,
        longitude: -122.387151,
        density: 26.077264003787246,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:51:02.000Z',
        end_time: '2026-07-29T07:52:02.000Z',
        latitude: 37.788436,
        longitude: -122.387151,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:50:02.000Z',
        end_time: '2026-07-29T07:51:02.000Z',
        latitude: 37.7877815,
        longitude: -122.3876175,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:50:02.000Z',
        end_time: '2026-07-29T07:51:02.000Z',
        latitude: 37.7877815,
        longitude: -122.3876175,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:50:02.000Z',
        end_time: '2026-07-29T07:51:02.000Z',
        latitude: 37.7877815,
        longitude: -122.3876175,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T07:44:02.000Z',
        end_time: '2026-07-29T07:49:02.000Z',
        latitude: 37.7884167,
        longitude: -122.3869333,
        density: 2.1052631578947367,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T07:44:02.000Z',
        end_time: '2026-07-29T07:49:02.000Z',
        latitude: 37.7884167,
        longitude: -122.3869333,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:48:02.000Z',
        end_time: '2026-07-29T07:49:02.000Z',
        latitude: 37.788465,
        longitude: -122.3870307,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:48:02.000Z',
        end_time: '2026-07-29T07:49:02.000Z',
        latitude: 37.788465,
        longitude: -122.3870307,
        density: 20.12686259168889,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:48:02.000Z',
        end_time: '2026-07-29T07:49:02.000Z',
        latitude: 37.788465,
        longitude: -122.3870307,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T07:44:02.000Z',
        end_time: '2026-07-29T07:49:02.000Z',
        latitude: 37.7884167,
        longitude: -122.3869333,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:47:02.000Z',
        end_time: '2026-07-29T07:48:02.000Z',
        latitude: 37.7885103,
        longitude: -122.3875198,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:47:02.000Z',
        end_time: '2026-07-29T07:48:02.000Z',
        latitude: 37.7885103,
        longitude: -122.3875198,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:47:02.000Z',
        end_time: '2026-07-29T07:48:02.000Z',
        latitude: 37.7885103,
        longitude: -122.3875198,
        density: 27.535940151507404,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:46:02.000Z',
        end_time: '2026-07-29T07:47:02.000Z',
        latitude: 37.7885287,
        longitude: -122.390348,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:46:02.000Z',
        end_time: '2026-07-29T07:47:02.000Z',
        latitude: 37.7885287,
        longitude: -122.390348,
        density: 26.172106569562196,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:46:02.000Z',
        end_time: '2026-07-29T07:47:02.000Z',
        latitude: 37.7885287,
        longitude: -122.390348,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:45:02.000Z',
        end_time: '2026-07-29T07:46:02.000Z',
        latitude: 37.7885057,
        longitude: -122.3892748,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:45:02.000Z',
        end_time: '2026-07-29T07:46:02.000Z',
        latitude: 37.7885057,
        longitude: -122.3892748,
        density: 17.69213351974644,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:45:02.000Z',
        end_time: '2026-07-29T07:46:02.000Z',
        latitude: 37.7885057,
        longitude: -122.3892748,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:44:02.000Z',
        end_time: '2026-07-29T07:45:02.000Z',
        latitude: 37.7883462,
        longitude: -122.388952,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:44:02.000Z',
        end_time: '2026-07-29T07:45:02.000Z',
        latitude: 37.7883462,
        longitude: -122.388952,
        density: 23.16901955358409,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:44:02.000Z',
        end_time: '2026-07-29T07:45:02.000Z',
        latitude: 37.7883462,
        longitude: -122.388952,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T07:39:02.000Z',
        end_time: '2026-07-29T07:44:02.000Z',
        latitude: 37.7883,
        longitude: -122.3896,
        density: 1.0526315789473684,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T07:39:02.000Z',
        end_time: '2026-07-29T07:44:02.000Z',
        latitude: 37.7883,
        longitude: -122.3896,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:43:02.000Z',
        end_time: '2026-07-29T07:44:02.000Z',
        latitude: 37.788341,
        longitude: -122.3874097,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:43:02.000Z',
        end_time: '2026-07-29T07:44:02.000Z',
        latitude: 37.788341,
        longitude: -122.3874097,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:43:02.000Z',
        end_time: '2026-07-29T07:44:02.000Z',
        latitude: 37.788341,
        longitude: -122.3874097,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T07:39:02.000Z',
        end_time: '2026-07-29T07:44:02.000Z',
        latitude: 37.7883,
        longitude: -122.3896,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:42:02.000Z',
        end_time: '2026-07-29T07:43:02.000Z',
        latitude: 37.7884107,
        longitude: -122.387154,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:42:02.000Z',
        end_time: '2026-07-29T07:43:02.000Z',
        latitude: 37.7884107,
        longitude: -122.387154,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:42:02.000Z',
        end_time: '2026-07-29T07:43:02.000Z',
        latitude: 37.7884107,
        longitude: -122.387154,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:41:02.000Z',
        end_time: '2026-07-29T07:42:02.000Z',
        latitude: 37.7884277,
        longitude: -122.3871218,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:41:02.000Z',
        end_time: '2026-07-29T07:42:02.000Z',
        latitude: 37.7884277,
        longitude: -122.3871218,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:41:02.000Z',
        end_time: '2026-07-29T07:42:02.000Z',
        latitude: 37.7884277,
        longitude: -122.3871218,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:40:02.000Z',
        end_time: '2026-07-29T07:41:02.000Z',
        latitude: 37.7884088,
        longitude: -122.3870452,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:40:02.000Z',
        end_time: '2026-07-29T07:41:02.000Z',
        latitude: 37.7884088,
        longitude: -122.3870452,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:40:02.000Z',
        end_time: '2026-07-29T07:41:02.000Z',
        latitude: 37.7884088,
        longitude: -122.3870452,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:39:02.000Z',
        end_time: '2026-07-29T07:40:02.000Z',
        latitude: 37.7884277,
        longitude: -122.3866652,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:39:02.000Z',
        end_time: '2026-07-29T07:40:02.000Z',
        latitude: 37.7884277,
        longitude: -122.3866652,
        density: 1.6263968285835073,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:39:02.000Z',
        end_time: '2026-07-29T07:40:02.000Z',
        latitude: 37.7884277,
        longitude: -122.3866652,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:38:02.000Z',
        end_time: '2026-07-29T07:39:02.000Z',
        latitude: 37.7884758,
        longitude: -122.3863647,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:38:02.000Z',
        end_time: '2026-07-29T07:39:02.000Z',
        latitude: 37.7884758,
        longitude: -122.3863647,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:38:02.000Z',
        end_time: '2026-07-29T07:39:02.000Z',
        latitude: 37.7884758,
        longitude: -122.3863647,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T07:34:02.000Z',
        end_time: '2026-07-29T07:39:02.000Z',
        latitude: 37.7884167,
        longitude: -122.3865667,
        density: 2.1052631578947367,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T07:34:02.000Z',
        end_time: '2026-07-29T07:39:02.000Z',
        latitude: 37.7884167,
        longitude: -122.3865667,
        density: 18.11784586350186,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T07:34:02.000Z',
        end_time: '2026-07-29T07:39:02.000Z',
        latitude: 37.7884167,
        longitude: -122.3865667,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:37:02.000Z',
        end_time: '2026-07-29T07:38:02.000Z',
        latitude: 37.7884287,
        longitude: -122.3869378,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:37:02.000Z',
        end_time: '2026-07-29T07:38:02.000Z',
        latitude: 37.7884287,
        longitude: -122.3869378,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:37:02.000Z',
        end_time: '2026-07-29T07:38:02.000Z',
        latitude: 37.7884287,
        longitude: -122.3869378,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:36:02.000Z',
        end_time: '2026-07-29T07:37:02.000Z',
        latitude: 37.7884082,
        longitude: -122.3870088,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:36:02.000Z',
        end_time: '2026-07-29T07:37:02.000Z',
        latitude: 37.7884082,
        longitude: -122.3870088,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:36:02.000Z',
        end_time: '2026-07-29T07:37:02.000Z',
        latitude: 37.7884082,
        longitude: -122.3870088,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:35:02.000Z',
        end_time: '2026-07-29T07:36:02.000Z',
        latitude: 37.788429,
        longitude: -122.386866,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:35:02.000Z',
        end_time: '2026-07-29T07:36:02.000Z',
        latitude: 37.788429,
        longitude: -122.386866,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:35:02.000Z',
        end_time: '2026-07-29T07:36:02.000Z',
        latitude: 37.788429,
        longitude: -122.386866,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T07:29:02.000Z',
        end_time: '2026-07-29T07:34:02.000Z',
        latitude: 37.7884167,
        longitude: -122.387,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T07:29:02.000Z',
        end_time: '2026-07-29T07:34:02.000Z',
        latitude: 37.7884167,
        longitude: -122.387,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T07:29:02.000Z',
        end_time: '2026-07-29T07:34:02.000Z',
        latitude: 37.7884167,
        longitude: -122.387,
        density: 29.811608561932754,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:33:02.000Z',
        end_time: '2026-07-29T07:34:02.000Z',
        latitude: 37.7884255,
        longitude: -122.3869457,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:33:02.000Z',
        end_time: '2026-07-29T07:34:02.000Z',
        latitude: 37.7884255,
        longitude: -122.3869457,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:33:02.000Z',
        end_time: '2026-07-29T07:34:02.000Z',
        latitude: 37.7884255,
        longitude: -122.3869457,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:32:02.000Z',
        end_time: '2026-07-29T07:33:02.000Z',
        latitude: 37.788435,
        longitude: -122.386807,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:32:02.000Z',
        end_time: '2026-07-29T07:33:02.000Z',
        latitude: 37.788435,
        longitude: -122.386807,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:32:02.000Z',
        end_time: '2026-07-29T07:33:02.000Z',
        latitude: 37.788435,
        longitude: -122.386807,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:31:02.000Z',
        end_time: '2026-07-29T07:32:02.000Z',
        latitude: 37.7884395,
        longitude: -122.3868548,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:31:02.000Z',
        end_time: '2026-07-29T07:32:02.000Z',
        latitude: 37.7884395,
        longitude: -122.3868548,
        density: 20.759128997303623,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:31:02.000Z',
        end_time: '2026-07-29T07:32:02.000Z',
        latitude: 37.7884395,
        longitude: -122.3868548,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:30:02.000Z',
        end_time: '2026-07-29T07:31:02.000Z',
        latitude: 37.7883908,
        longitude: -122.3869843,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:30:02.000Z',
        end_time: '2026-07-29T07:31:02.000Z',
        latitude: 37.7883908,
        longitude: -122.3869843,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:30:02.000Z',
        end_time: '2026-07-29T07:31:02.000Z',
        latitude: 37.7883908,
        longitude: -122.3869843,
        density: 11.165594554599888,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T07:24:02.000Z',
        end_time: '2026-07-29T07:29:02.000Z',
        latitude: 37.7884167,
        longitude: -122.38715,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:28:02.000Z',
        end_time: '2026-07-29T07:29:02.000Z',
        latitude: 37.7885875,
        longitude: -122.3875467,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:28:02.000Z',
        end_time: '2026-07-29T07:29:02.000Z',
        latitude: 37.7885875,
        longitude: -122.3875467,
        density: 27.07021606080889,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:28:02.000Z',
        end_time: '2026-07-29T07:29:02.000Z',
        latitude: 37.7885875,
        longitude: -122.3875467,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T07:24:02.000Z',
        end_time: '2026-07-29T07:29:02.000Z',
        latitude: 37.7884167,
        longitude: -122.38715,
        density: 1.5789473684210527,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T07:24:02.000Z',
        end_time: '2026-07-29T07:29:02.000Z',
        latitude: 37.7884167,
        longitude: -122.38715,
        density: 13.873413211806819,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:27:02.000Z',
        end_time: '2026-07-29T07:28:02.000Z',
        latitude: 37.7884672,
        longitude: -122.3871965,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:27:02.000Z',
        end_time: '2026-07-29T07:28:02.000Z',
        latitude: 37.7884672,
        longitude: -122.3871965,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:27:02.000Z',
        end_time: '2026-07-29T07:28:02.000Z',
        latitude: 37.7884672,
        longitude: -122.3871965,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:26:02.000Z',
        end_time: '2026-07-29T07:27:02.000Z',
        latitude: 37.7884312,
        longitude: -122.3870597,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:26:02.000Z',
        end_time: '2026-07-29T07:27:02.000Z',
        latitude: 37.7884312,
        longitude: -122.3870597,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:26:02.000Z',
        end_time: '2026-07-29T07:27:02.000Z',
        latitude: 37.7884312,
        longitude: -122.3870597,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:25:02.000Z',
        end_time: '2026-07-29T07:26:02.000Z',
        latitude: 37.7884267,
        longitude: -122.3870023,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:25:02.000Z',
        end_time: '2026-07-29T07:26:02.000Z',
        latitude: 37.7884267,
        longitude: -122.3870023,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:25:02.000Z',
        end_time: '2026-07-29T07:26:02.000Z',
        latitude: 37.7884267,
        longitude: -122.3870023,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:24:02.000Z',
        end_time: '2026-07-29T07:25:02.000Z',
        latitude: 37.7884308,
        longitude: -122.3870078,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:24:02.000Z',
        end_time: '2026-07-29T07:25:02.000Z',
        latitude: 37.7884308,
        longitude: -122.3870078,
        density: 28.843894874096037,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:24:02.000Z',
        end_time: '2026-07-29T07:25:02.000Z',
        latitude: 37.7884308,
        longitude: -122.3870078,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T07:19:02.000Z',
        end_time: '2026-07-29T07:24:02.000Z',
        latitude: 37.7884333,
        longitude: -122.3870333,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:23:02.000Z',
        end_time: '2026-07-29T07:24:02.000Z',
        latitude: 37.7884487,
        longitude: -122.3870153,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:23:02.000Z',
        end_time: '2026-07-29T07:24:02.000Z',
        latitude: 37.7884487,
        longitude: -122.3870153,
        density: 7.87933177252611,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:23:02.000Z',
        end_time: '2026-07-29T07:24:02.000Z',
        latitude: 37.7884487,
        longitude: -122.3870153,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T07:19:02.000Z',
        end_time: '2026-07-29T07:24:02.000Z',
        latitude: 37.7884333,
        longitude: -122.3870333,
        density: 1.5789473684210527,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T07:19:02.000Z',
        end_time: '2026-07-29T07:24:02.000Z',
        latitude: 37.7884333,
        longitude: -122.3870333,
        density: 8.484275030505536,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:22:02.000Z',
        end_time: '2026-07-29T07:23:02.000Z',
        latitude: 37.7884267,
        longitude: -122.3870712,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:22:02.000Z',
        end_time: '2026-07-29T07:23:02.000Z',
        latitude: 37.7884267,
        longitude: -122.3870712,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:22:02.000Z',
        end_time: '2026-07-29T07:23:02.000Z',
        latitude: 37.7884267,
        longitude: -122.3870712,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:21:02.000Z',
        end_time: '2026-07-29T07:22:02.000Z',
        latitude: 37.7883928,
        longitude: -122.3869622,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:21:02.000Z',
        end_time: '2026-07-29T07:22:02.000Z',
        latitude: 37.7883928,
        longitude: -122.3869622,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:21:02.000Z',
        end_time: '2026-07-29T07:22:02.000Z',
        latitude: 37.7883928,
        longitude: -122.3869622,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:20:02.000Z',
        end_time: '2026-07-29T07:21:02.000Z',
        latitude: 37.78841,
        longitude: -122.3870892,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:20:02.000Z',
        end_time: '2026-07-29T07:21:02.000Z',
        latitude: 37.78841,
        longitude: -122.3870892,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:20:02.000Z',
        end_time: '2026-07-29T07:21:02.000Z',
        latitude: 37.78841,
        longitude: -122.3870892,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:19:02.000Z',
        end_time: '2026-07-29T07:20:02.000Z',
        latitude: 37.7884218,
        longitude: -122.3871122,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:19:02.000Z',
        end_time: '2026-07-29T07:20:02.000Z',
        latitude: 37.7884218,
        longitude: -122.3871122,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:19:02.000Z',
        end_time: '2026-07-29T07:20:02.000Z',
        latitude: 37.7884218,
        longitude: -122.3871122,
        density: 3.7943259210395803,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T07:14:02.000Z',
        end_time: '2026-07-29T07:19:02.000Z',
        latitude: 37.7884,
        longitude: -122.3871333,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:18:02.000Z',
        end_time: '2026-07-29T07:19:02.000Z',
        latitude: 37.788413,
        longitude: -122.3872057,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:18:02.000Z',
        end_time: '2026-07-29T07:19:02.000Z',
        latitude: 37.788413,
        longitude: -122.3872057,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:18:02.000Z',
        end_time: '2026-07-29T07:19:02.000Z',
        latitude: 37.788413,
        longitude: -122.3872057,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T07:14:02.000Z',
        end_time: '2026-07-29T07:19:02.000Z',
        latitude: 37.7884,
        longitude: -122.3871333,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T07:14:02.000Z',
        end_time: '2026-07-29T07:19:02.000Z',
        latitude: 37.7884,
        longitude: -122.3871333,
        density: 13.833519429463568,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:17:02.000Z',
        end_time: '2026-07-29T07:18:02.000Z',
        latitude: 37.7884252,
        longitude: -122.387156,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:17:02.000Z',
        end_time: '2026-07-29T07:18:02.000Z',
        latitude: 37.7884252,
        longitude: -122.387156,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:17:02.000Z',
        end_time: '2026-07-29T07:18:02.000Z',
        latitude: 37.7884252,
        longitude: -122.387156,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:16:02.000Z',
        end_time: '2026-07-29T07:17:02.000Z',
        latitude: 37.7884012,
        longitude: -122.3871288,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:16:02.000Z',
        end_time: '2026-07-29T07:17:02.000Z',
        latitude: 37.7884012,
        longitude: -122.3871288,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:16:02.000Z',
        end_time: '2026-07-29T07:17:02.000Z',
        latitude: 37.7884012,
        longitude: -122.3871288,
        density: 16.26007984205733,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:15:02.000Z',
        end_time: '2026-07-29T07:16:02.000Z',
        latitude: 37.7883893,
        longitude: -122.3870793,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:15:02.000Z',
        end_time: '2026-07-29T07:16:02.000Z',
        latitude: 37.7883893,
        longitude: -122.3870793,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:15:02.000Z',
        end_time: '2026-07-29T07:16:02.000Z',
        latitude: 37.7883893,
        longitude: -122.3870793,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:14:02.000Z',
        end_time: '2026-07-29T07:15:02.000Z',
        latitude: 37.7884193,
        longitude: -122.3871058,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:14:02.000Z',
        end_time: '2026-07-29T07:15:02.000Z',
        latitude: 37.7884193,
        longitude: -122.3871058,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:14:02.000Z',
        end_time: '2026-07-29T07:15:02.000Z',
        latitude: 37.7884193,
        longitude: -122.3871058,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:13:02.000Z',
        end_time: '2026-07-29T07:14:02.000Z',
        latitude: 37.7884208,
        longitude: -122.3871335,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T07:09:02.000Z',
        end_time: '2026-07-29T07:14:02.000Z',
        latitude: 37.7884167,
        longitude: -122.3871333,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:13:02.000Z',
        end_time: '2026-07-29T07:14:02.000Z',
        latitude: 37.7884208,
        longitude: -122.3871335,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:13:02.000Z',
        end_time: '2026-07-29T07:14:02.000Z',
        latitude: 37.7884208,
        longitude: -122.3871335,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T07:09:02.000Z',
        end_time: '2026-07-29T07:14:02.000Z',
        latitude: 37.7884167,
        longitude: -122.3871333,
        density: 1.5789473684210527,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T07:09:02.000Z',
        end_time: '2026-07-29T07:14:02.000Z',
        latitude: 37.7884167,
        longitude: -122.3871333,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:12:02.000Z',
        end_time: '2026-07-29T07:13:02.000Z',
        latitude: 37.7884438,
        longitude: -122.3870927,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:12:02.000Z',
        end_time: '2026-07-29T07:13:02.000Z',
        latitude: 37.7884438,
        longitude: -122.3870927,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:12:02.000Z',
        end_time: '2026-07-29T07:13:02.000Z',
        latitude: 37.7884438,
        longitude: -122.3870927,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:11:02.000Z',
        end_time: '2026-07-29T07:12:02.000Z',
        latitude: 37.788394,
        longitude: -122.3871158,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:11:02.000Z',
        end_time: '2026-07-29T07:12:02.000Z',
        latitude: 37.788394,
        longitude: -122.3871158,
        density: 29.544851253231926,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:11:02.000Z',
        end_time: '2026-07-29T07:12:02.000Z',
        latitude: 37.788394,
        longitude: -122.3871158,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:10:02.000Z',
        end_time: '2026-07-29T07:11:02.000Z',
        latitude: 37.78846,
        longitude: -122.3871123,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:10:02.000Z',
        end_time: '2026-07-29T07:11:02.000Z',
        latitude: 37.78846,
        longitude: -122.3871123,
        density: 22.592514178840815,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:10:02.000Z',
        end_time: '2026-07-29T07:11:02.000Z',
        latitude: 37.78846,
        longitude: -122.3871123,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T07:04:02.000Z',
        end_time: '2026-07-29T07:09:02.000Z',
        latitude: 37.7885,
        longitude: -122.38705,
        density: 1.0526315789473684,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T07:04:02.000Z',
        end_time: '2026-07-29T07:09:02.000Z',
        latitude: 37.7885,
        longitude: -122.38705,
        density: 18.315556293326136,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:08:02.000Z',
        end_time: '2026-07-29T07:09:02.000Z',
        latitude: 37.788479,
        longitude: -122.3870752,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:08:02.000Z',
        end_time: '2026-07-29T07:09:02.000Z',
        latitude: 37.788479,
        longitude: -122.3870752,
        density: 0.9326128003080396,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:08:02.000Z',
        end_time: '2026-07-29T07:09:02.000Z',
        latitude: 37.788479,
        longitude: -122.3870752,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T07:04:02.000Z',
        end_time: '2026-07-29T07:09:02.000Z',
        latitude: 37.7885,
        longitude: -122.38705,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:07:02.000Z',
        end_time: '2026-07-29T07:08:02.000Z',
        latitude: 37.7885773,
        longitude: -122.3868998,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:07:02.000Z',
        end_time: '2026-07-29T07:08:02.000Z',
        latitude: 37.7885773,
        longitude: -122.3868998,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:07:02.000Z',
        end_time: '2026-07-29T07:08:02.000Z',
        latitude: 37.7885773,
        longitude: -122.3868998,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:06:02.000Z',
        end_time: '2026-07-29T07:07:02.000Z',
        latitude: 37.7885185,
        longitude: -122.3870298,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:06:02.000Z',
        end_time: '2026-07-29T07:07:02.000Z',
        latitude: 37.7885185,
        longitude: -122.3870298,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:06:02.000Z',
        end_time: '2026-07-29T07:07:02.000Z',
        latitude: 37.7885185,
        longitude: -122.3870298,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:05:02.000Z',
        end_time: '2026-07-29T07:06:02.000Z',
        latitude: 37.788518,
        longitude: -122.3870373,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:05:02.000Z',
        end_time: '2026-07-29T07:06:02.000Z',
        latitude: 37.788518,
        longitude: -122.3870373,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:05:02.000Z',
        end_time: '2026-07-29T07:06:02.000Z',
        latitude: 37.788518,
        longitude: -122.3870373,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T06:59:02.000Z',
        end_time: '2026-07-29T07:04:02.000Z',
        latitude: 37.7883,
        longitude: -122.3875667,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:03:02.000Z',
        end_time: '2026-07-29T07:04:02.000Z',
        latitude: 37.7883593,
        longitude: -122.3870347,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:03:02.000Z',
        end_time: '2026-07-29T07:04:02.000Z',
        latitude: 37.7883593,
        longitude: -122.3870347,
        density: 28.612039951252786,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:03:02.000Z',
        end_time: '2026-07-29T07:04:02.000Z',
        latitude: 37.7883593,
        longitude: -122.3870347,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T06:59:02.000Z',
        end_time: '2026-07-29T07:04:02.000Z',
        latitude: 37.7883,
        longitude: -122.3875667,
        density: 0.5263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T06:59:02.000Z',
        end_time: '2026-07-29T07:04:02.000Z',
        latitude: 37.7883,
        longitude: -122.3875667,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:02:02.000Z',
        end_time: '2026-07-29T07:03:02.000Z',
        latitude: 37.7883912,
        longitude: -122.3871017,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:02:02.000Z',
        end_time: '2026-07-29T07:03:02.000Z',
        latitude: 37.7883912,
        longitude: -122.3871017,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:02:02.000Z',
        end_time: '2026-07-29T07:03:02.000Z',
        latitude: 37.7883912,
        longitude: -122.3871017,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:01:02.000Z',
        end_time: '2026-07-29T07:02:02.000Z',
        latitude: 37.7879278,
        longitude: -122.3859618,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:01:02.000Z',
        end_time: '2026-07-29T07:02:02.000Z',
        latitude: 37.7879278,
        longitude: -122.3859618,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:01:02.000Z',
        end_time: '2026-07-29T07:02:02.000Z',
        latitude: 37.7879278,
        longitude: -122.3859618,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T07:00:02.000Z',
        end_time: '2026-07-29T07:01:02.000Z',
        latitude: 37.7884133,
        longitude: -122.3867702,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T07:00:02.000Z',
        end_time: '2026-07-29T07:01:02.000Z',
        latitude: 37.7884133,
        longitude: -122.3867702,
        density: 23.13177729027889,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T07:00:02.000Z',
        end_time: '2026-07-29T07:01:02.000Z',
        latitude: 37.7884133,
        longitude: -122.3867702,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T06:54:02.000Z',
        end_time: '2026-07-29T06:59:02.000Z',
        latitude: 37.7884333,
        longitude: -122.3872,
        density: 0.5263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T06:54:02.000Z',
        end_time: '2026-07-29T06:59:02.000Z',
        latitude: 37.7884333,
        longitude: -122.3872,
        density: 19.590878638975123,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:58:02.000Z',
        end_time: '2026-07-29T06:59:02.000Z',
        latitude: 37.7884377,
        longitude: -122.3871067,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:58:02.000Z',
        end_time: '2026-07-29T06:59:02.000Z',
        latitude: 37.7884377,
        longitude: -122.3871067,
        density: 14.5096174828819,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:58:02.000Z',
        end_time: '2026-07-29T06:59:02.000Z',
        latitude: 37.7884377,
        longitude: -122.3871067,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T06:54:02.000Z',
        end_time: '2026-07-29T06:59:02.000Z',
        latitude: 37.7884333,
        longitude: -122.3872,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:57:02.000Z',
        end_time: '2026-07-29T06:58:02.000Z',
        latitude: 37.788482,
        longitude: -122.3871127,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:57:02.000Z',
        end_time: '2026-07-29T06:58:02.000Z',
        latitude: 37.788482,
        longitude: -122.3871127,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:57:02.000Z',
        end_time: '2026-07-29T06:58:02.000Z',
        latitude: 37.788482,
        longitude: -122.3871127,
        density: 8.066695746931378,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:56:02.000Z',
        end_time: '2026-07-29T06:57:02.000Z',
        latitude: 37.7884827,
        longitude: -122.3870658,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:56:02.000Z',
        end_time: '2026-07-29T06:57:02.000Z',
        latitude: 37.7884827,
        longitude: -122.3870658,
        density: 22.888463919036948,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:56:02.000Z',
        end_time: '2026-07-29T06:57:02.000Z',
        latitude: 37.7884827,
        longitude: -122.3870658,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:55:02.000Z',
        end_time: '2026-07-29T06:56:02.000Z',
        latitude: 37.7884567,
        longitude: -122.3871527,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:55:02.000Z',
        end_time: '2026-07-29T06:56:02.000Z',
        latitude: 37.7884567,
        longitude: -122.3871527,
        density: 17.34133774354259,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:55:02.000Z',
        end_time: '2026-07-29T06:56:02.000Z',
        latitude: 37.7884567,
        longitude: -122.3871527,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:54:02.000Z',
        end_time: '2026-07-29T06:55:02.000Z',
        latitude: 37.7884775,
        longitude: -122.3870758,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:54:02.000Z',
        end_time: '2026-07-29T06:55:02.000Z',
        latitude: 37.7884775,
        longitude: -122.3870758,
        density: 21.571775179465035,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:54:02.000Z',
        end_time: '2026-07-29T06:55:02.000Z',
        latitude: 37.7884775,
        longitude: -122.3870758,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T06:49:02.000Z',
        end_time: '2026-07-29T06:54:02.000Z',
        latitude: 37.7884667,
        longitude: -122.3870667,
        density: 0.5263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T06:49:02.000Z',
        end_time: '2026-07-29T06:54:02.000Z',
        latitude: 37.7884667,
        longitude: -122.3870667,
        density: 27.22361449108317,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:53:02.000Z',
        end_time: '2026-07-29T06:54:02.000Z',
        latitude: 37.7884368,
        longitude: -122.3870652,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:53:02.000Z',
        end_time: '2026-07-29T06:54:02.000Z',
        latitude: 37.7884368,
        longitude: -122.3870652,
        density: 0.6430841804253662,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:53:02.000Z',
        end_time: '2026-07-29T06:54:02.000Z',
        latitude: 37.7884368,
        longitude: -122.3870652,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T06:49:02.000Z',
        end_time: '2026-07-29T06:54:02.000Z',
        latitude: 37.7884667,
        longitude: -122.3870667,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:52:02.000Z',
        end_time: '2026-07-29T06:53:02.000Z',
        latitude: 37.788371,
        longitude: -122.3872388,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:52:02.000Z',
        end_time: '2026-07-29T06:53:02.000Z',
        latitude: 37.788371,
        longitude: -122.3872388,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:52:02.000Z',
        end_time: '2026-07-29T06:53:02.000Z',
        latitude: 37.788371,
        longitude: -122.3872388,
        density: 27.069979910597834,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:51:02.000Z',
        end_time: '2026-07-29T06:52:02.000Z',
        latitude: 37.7882283,
        longitude: -122.387646,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:51:02.000Z',
        end_time: '2026-07-29T06:52:02.000Z',
        latitude: 37.7882283,
        longitude: -122.387646,
        density: 13.590579859170928,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:51:02.000Z',
        end_time: '2026-07-29T06:52:02.000Z',
        latitude: 37.7882283,
        longitude: -122.387646,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:50:02.000Z',
        end_time: '2026-07-29T06:51:02.000Z',
        latitude: 37.7883648,
        longitude: -122.387017,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:50:02.000Z',
        end_time: '2026-07-29T06:51:02.000Z',
        latitude: 37.7883648,
        longitude: -122.387017,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:50:02.000Z',
        end_time: '2026-07-29T06:51:02.000Z',
        latitude: 37.7883648,
        longitude: -122.387017,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T06:44:02.000Z',
        end_time: '2026-07-29T06:49:02.000Z',
        latitude: 37.7884333,
        longitude: -122.3870833,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:48:02.000Z',
        end_time: '2026-07-29T06:49:02.000Z',
        latitude: 37.7884243,
        longitude: -122.3871357,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:48:02.000Z',
        end_time: '2026-07-29T06:49:02.000Z',
        latitude: 37.7884243,
        longitude: -122.3871357,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:48:02.000Z',
        end_time: '2026-07-29T06:49:02.000Z',
        latitude: 37.7884243,
        longitude: -122.3871357,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T06:44:02.000Z',
        end_time: '2026-07-29T06:49:02.000Z',
        latitude: 37.7884333,
        longitude: -122.3870833,
        density: 1.0526315789473684,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T06:44:02.000Z',
        end_time: '2026-07-29T06:49:02.000Z',
        latitude: 37.7884333,
        longitude: -122.3870833,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:47:02.000Z',
        end_time: '2026-07-29T06:48:02.000Z',
        latitude: 37.7884373,
        longitude: -122.387124,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:47:02.000Z',
        end_time: '2026-07-29T06:48:02.000Z',
        latitude: 37.7884373,
        longitude: -122.387124,
        density: 9.265644650571456,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:47:02.000Z',
        end_time: '2026-07-29T06:48:02.000Z',
        latitude: 37.7884373,
        longitude: -122.387124,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:46:02.000Z',
        end_time: '2026-07-29T06:47:02.000Z',
        latitude: 37.7884168,
        longitude: -122.387232,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:46:02.000Z',
        end_time: '2026-07-29T06:47:02.000Z',
        latitude: 37.7884168,
        longitude: -122.387232,
        density: 33.89597437910719,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:46:02.000Z',
        end_time: '2026-07-29T06:47:02.000Z',
        latitude: 37.7884168,
        longitude: -122.387232,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:45:02.000Z',
        end_time: '2026-07-29T06:46:02.000Z',
        latitude: 37.7884078,
        longitude: -122.3872018,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:45:02.000Z',
        end_time: '2026-07-29T06:46:02.000Z',
        latitude: 37.7884078,
        longitude: -122.3872018,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:45:02.000Z',
        end_time: '2026-07-29T06:46:02.000Z',
        latitude: 37.7884078,
        longitude: -122.3872018,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:44:02.000Z',
        end_time: '2026-07-29T06:45:02.000Z',
        latitude: 37.7884285,
        longitude: -122.3870875,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:44:02.000Z',
        end_time: '2026-07-29T06:45:02.000Z',
        latitude: 37.7884285,
        longitude: -122.3870875,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:44:02.000Z',
        end_time: '2026-07-29T06:45:02.000Z',
        latitude: 37.7884285,
        longitude: -122.3870875,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T06:39:02.000Z',
        end_time: '2026-07-29T06:44:02.000Z',
        latitude: 37.7884167,
        longitude: -122.38705,
        density: 0.5263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T06:39:02.000Z',
        end_time: '2026-07-29T06:44:02.000Z',
        latitude: 37.7884167,
        longitude: -122.38705,
        density: 28.90989877821225,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:43:02.000Z',
        end_time: '2026-07-29T06:44:02.000Z',
        latitude: 37.7884407,
        longitude: -122.3869758,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:43:02.000Z',
        end_time: '2026-07-29T06:44:02.000Z',
        latitude: 37.7884407,
        longitude: -122.3869758,
        density: 24.40071249122684,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:43:02.000Z',
        end_time: '2026-07-29T06:44:02.000Z',
        latitude: 37.7884407,
        longitude: -122.3869758,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T06:39:02.000Z',
        end_time: '2026-07-29T06:44:02.000Z',
        latitude: 37.7884167,
        longitude: -122.38705,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:42:02.000Z',
        end_time: '2026-07-29T06:43:02.000Z',
        latitude: 37.7884232,
        longitude: -122.3871053,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:42:02.000Z',
        end_time: '2026-07-29T06:43:02.000Z',
        latitude: 37.7884232,
        longitude: -122.3871053,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:42:02.000Z',
        end_time: '2026-07-29T06:43:02.000Z',
        latitude: 37.7884232,
        longitude: -122.3871053,
        density: 9.43351903277951,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:41:02.000Z',
        end_time: '2026-07-29T06:42:02.000Z',
        latitude: 37.7884867,
        longitude: -122.3873273,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:41:02.000Z',
        end_time: '2026-07-29T06:42:02.000Z',
        latitude: 37.7884867,
        longitude: -122.3873273,
        density: 0.7200977895534821,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:41:02.000Z',
        end_time: '2026-07-29T06:42:02.000Z',
        latitude: 37.7884867,
        longitude: -122.3873273,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:40:02.000Z',
        end_time: '2026-07-29T06:41:02.000Z',
        latitude: 37.7884693,
        longitude: -122.3871475,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:40:02.000Z',
        end_time: '2026-07-29T06:41:02.000Z',
        latitude: 37.7884693,
        longitude: -122.3871475,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:40:02.000Z',
        end_time: '2026-07-29T06:41:02.000Z',
        latitude: 37.7884693,
        longitude: -122.3871475,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T06:34:02.000Z',
        end_time: '2026-07-29T06:39:02.000Z',
        latitude: 37.7890667,
        longitude: -122.3810167,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:38:02.000Z',
        end_time: '2026-07-29T06:39:02.000Z',
        latitude: 37.7894273,
        longitude: -122.3784538,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:38:02.000Z',
        end_time: '2026-07-29T06:39:02.000Z',
        latitude: 37.7894273,
        longitude: -122.3784538,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:38:02.000Z',
        end_time: '2026-07-29T06:39:02.000Z',
        latitude: 37.7894273,
        longitude: -122.3784538,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T06:34:02.000Z',
        end_time: '2026-07-29T06:39:02.000Z',
        latitude: 37.7890667,
        longitude: -122.3810167,
        density: 1.0526315789473684,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T06:34:02.000Z',
        end_time: '2026-07-29T06:39:02.000Z',
        latitude: 37.7890667,
        longitude: -122.3810167,
        density: 5.6548218327394615,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:37:02.000Z',
        end_time: '2026-07-29T06:38:02.000Z',
        latitude: 37.7891182,
        longitude: -122.3804843,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:37:02.000Z',
        end_time: '2026-07-29T06:38:02.000Z',
        latitude: 37.7891182,
        longitude: -122.3804843,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:37:02.000Z',
        end_time: '2026-07-29T06:38:02.000Z',
        latitude: 37.7891182,
        longitude: -122.3804843,
        density: 2.504040092301221,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:36:02.000Z',
        end_time: '2026-07-29T06:37:02.000Z',
        latitude: 37.7886302,
        longitude: -122.3857678,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:36:02.000Z',
        end_time: '2026-07-29T06:37:02.000Z',
        latitude: 37.7886302,
        longitude: -122.3857678,
        density: 26.245532763752554,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:36:02.000Z',
        end_time: '2026-07-29T06:37:02.000Z',
        latitude: 37.7886302,
        longitude: -122.3857678,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:35:02.000Z',
        end_time: '2026-07-29T06:36:02.000Z',
        latitude: 37.7884597,
        longitude: -122.3870825,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:35:02.000Z',
        end_time: '2026-07-29T06:36:02.000Z',
        latitude: 37.7884597,
        longitude: -122.3870825,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:35:02.000Z',
        end_time: '2026-07-29T06:36:02.000Z',
        latitude: 37.7884597,
        longitude: -122.3870825,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:33:02.000Z',
        end_time: '2026-07-29T06:34:02.000Z',
        latitude: 37.7884738,
        longitude: -122.3871185,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:33:02.000Z',
        end_time: '2026-07-29T06:34:02.000Z',
        latitude: 37.7884738,
        longitude: -122.3871185,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:33:02.000Z',
        end_time: '2026-07-29T06:34:02.000Z',
        latitude: 37.7884738,
        longitude: -122.3871185,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T06:29:02.000Z',
        end_time: '2026-07-29T06:34:02.000Z',
        latitude: 37.7886167,
        longitude: -122.38735,
        density: 2.1052631578947367,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T06:29:02.000Z',
        end_time: '2026-07-29T06:34:02.000Z',
        latitude: 37.7886167,
        longitude: -122.38735,
        density: 21.720985502092,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T06:29:02.000Z',
        end_time: '2026-07-29T06:34:02.000Z',
        latitude: 37.7886167,
        longitude: -122.38735,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:32:02.000Z',
        end_time: '2026-07-29T06:33:02.000Z',
        latitude: 37.78847,
        longitude: -122.3870787,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:32:02.000Z',
        end_time: '2026-07-29T06:33:02.000Z',
        latitude: 37.78847,
        longitude: -122.3870787,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:32:02.000Z',
        end_time: '2026-07-29T06:33:02.000Z',
        latitude: 37.78847,
        longitude: -122.3870787,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:31:02.000Z',
        end_time: '2026-07-29T06:32:02.000Z',
        latitude: 37.7885355,
        longitude: -122.386837,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:31:02.000Z',
        end_time: '2026-07-29T06:32:02.000Z',
        latitude: 37.7885355,
        longitude: -122.386837,
        density: 20.835272891561527,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:31:02.000Z',
        end_time: '2026-07-29T06:32:02.000Z',
        latitude: 37.7885355,
        longitude: -122.386837,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:30:03.000Z',
        end_time: '2026-07-29T06:31:03.000Z',
        latitude: 37.7884943,
        longitude: -122.3869253,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:30:03.000Z',
        end_time: '2026-07-29T06:31:03.000Z',
        latitude: 37.7884943,
        longitude: -122.3869253,
        density: 30.62475169335419,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:30:03.000Z',
        end_time: '2026-07-29T06:31:03.000Z',
        latitude: 37.7884943,
        longitude: -122.3869253,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:29:02.000Z',
        end_time: '2026-07-29T06:30:02.000Z',
        latitude: 37.7885462,
        longitude: -122.3865125,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:29:02.000Z',
        end_time: '2026-07-29T06:30:02.000Z',
        latitude: 37.7885462,
        longitude: -122.3865125,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:29:02.000Z',
        end_time: '2026-07-29T06:30:02.000Z',
        latitude: 37.7885462,
        longitude: -122.3865125,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T06:24:03.000Z',
        end_time: '2026-07-29T06:29:03.000Z',
        latitude: 37.7884667,
        longitude: -122.38695,
        density: 0.5263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T06:24:03.000Z',
        end_time: '2026-07-29T06:29:03.000Z',
        latitude: 37.7884667,
        longitude: -122.38695,
        density: 5.080234798973236,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:28:03.000Z',
        end_time: '2026-07-29T06:29:03.000Z',
        latitude: 37.7884718,
        longitude: -122.3869495,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:28:03.000Z',
        end_time: '2026-07-29T06:29:03.000Z',
        latitude: 37.7884718,
        longitude: -122.3869495,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:28:03.000Z',
        end_time: '2026-07-29T06:29:03.000Z',
        latitude: 37.7884718,
        longitude: -122.3869495,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T06:24:03.000Z',
        end_time: '2026-07-29T06:29:03.000Z',
        latitude: 37.7884667,
        longitude: -122.38695,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:27:02.000Z',
        end_time: '2026-07-29T06:28:02.000Z',
        latitude: 37.7884583,
        longitude: -122.3870827,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:27:02.000Z',
        end_time: '2026-07-29T06:28:02.000Z',
        latitude: 37.7884583,
        longitude: -122.3870827,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:27:02.000Z',
        end_time: '2026-07-29T06:28:02.000Z',
        latitude: 37.7884583,
        longitude: -122.3870827,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:26:03.000Z',
        end_time: '2026-07-29T06:27:03.000Z',
        latitude: 37.7884547,
        longitude: -122.3869778,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:26:03.000Z',
        end_time: '2026-07-29T06:27:03.000Z',
        latitude: 37.7884547,
        longitude: -122.3869778,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:26:03.000Z',
        end_time: '2026-07-29T06:27:03.000Z',
        latitude: 37.7884547,
        longitude: -122.3869778,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:25:03.000Z',
        end_time: '2026-07-29T06:26:03.000Z',
        latitude: 37.7884707,
        longitude: -122.387117,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:25:03.000Z',
        end_time: '2026-07-29T06:26:03.000Z',
        latitude: 37.7884707,
        longitude: -122.387117,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:25:03.000Z',
        end_time: '2026-07-29T06:26:03.000Z',
        latitude: 37.7884707,
        longitude: -122.387117,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T06:19:03.000Z',
        end_time: '2026-07-29T06:24:03.000Z',
        latitude: 37.7884667,
        longitude: -122.387,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:23:03.000Z',
        end_time: '2026-07-29T06:24:03.000Z',
        latitude: 37.7884758,
        longitude: -122.3870758,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:23:03.000Z',
        end_time: '2026-07-29T06:24:03.000Z',
        latitude: 37.7884758,
        longitude: -122.3870758,
        density: 10.619287824477786,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:23:03.000Z',
        end_time: '2026-07-29T06:24:03.000Z',
        latitude: 37.7884758,
        longitude: -122.3870758,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T06:19:03.000Z',
        end_time: '2026-07-29T06:24:03.000Z',
        latitude: 37.7884667,
        longitude: -122.387,
        density: 3.1578947368421053,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T06:19:03.000Z',
        end_time: '2026-07-29T06:24:03.000Z',
        latitude: 37.7884667,
        longitude: -122.387,
        density: 26.19322384057821,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:22:03.000Z',
        end_time: '2026-07-29T06:23:03.000Z',
        latitude: 37.788502,
        longitude: -122.3870507,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:22:03.000Z',
        end_time: '2026-07-29T06:23:03.000Z',
        latitude: 37.788502,
        longitude: -122.3870507,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:22:03.000Z',
        end_time: '2026-07-29T06:23:03.000Z',
        latitude: 37.788502,
        longitude: -122.3870507,
        density: 26.062088318371895,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:21:03.000Z',
        end_time: '2026-07-29T06:22:03.000Z',
        latitude: 37.7884932,
        longitude: -122.3870478,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:21:03.000Z',
        end_time: '2026-07-29T06:22:03.000Z',
        latitude: 37.7884932,
        longitude: -122.3870478,
        density: 31.994381612259236,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:21:03.000Z',
        end_time: '2026-07-29T06:22:03.000Z',
        latitude: 37.7884932,
        longitude: -122.3870478,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:20:03.000Z',
        end_time: '2026-07-29T06:21:03.000Z',
        latitude: 37.788491,
        longitude: -122.387069,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:20:03.000Z',
        end_time: '2026-07-29T06:21:03.000Z',
        latitude: 37.788491,
        longitude: -122.387069,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:20:03.000Z',
        end_time: '2026-07-29T06:21:03.000Z',
        latitude: 37.788491,
        longitude: -122.387069,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T06:14:03.000Z',
        end_time: '2026-07-29T06:19:03.000Z',
        latitude: 37.7884667,
        longitude: -122.38705,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:18:03.000Z',
        end_time: '2026-07-29T06:19:03.000Z',
        latitude: 37.7884753,
        longitude: -122.3870805,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:18:03.000Z',
        end_time: '2026-07-29T06:19:03.000Z',
        latitude: 37.7884753,
        longitude: -122.3870805,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:18:03.000Z',
        end_time: '2026-07-29T06:19:03.000Z',
        latitude: 37.7884753,
        longitude: -122.3870805,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T06:14:03.000Z',
        end_time: '2026-07-29T06:19:03.000Z',
        latitude: 37.7884667,
        longitude: -122.38705,
        density: 3.684210526315789,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T06:14:03.000Z',
        end_time: '2026-07-29T06:19:03.000Z',
        latitude: 37.7884667,
        longitude: -122.38705,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:17:03.000Z',
        end_time: '2026-07-29T06:18:03.000Z',
        latitude: 37.788458,
        longitude: -122.3871827,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:17:03.000Z',
        end_time: '2026-07-29T06:18:03.000Z',
        latitude: 37.788458,
        longitude: -122.3871827,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:17:03.000Z',
        end_time: '2026-07-29T06:18:03.000Z',
        latitude: 37.788458,
        longitude: -122.3871827,
        density: 21.598460908862947,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:16:03.000Z',
        end_time: '2026-07-29T06:17:03.000Z',
        latitude: 37.7884628,
        longitude: -122.387185,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:16:03.000Z',
        end_time: '2026-07-29T06:17:03.000Z',
        latitude: 37.7884628,
        longitude: -122.387185,
        density: 11.36092546619315,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:16:03.000Z',
        end_time: '2026-07-29T06:17:03.000Z',
        latitude: 37.7884628,
        longitude: -122.387185,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:15:03.000Z',
        end_time: '2026-07-29T06:16:03.000Z',
        latitude: 37.7884228,
        longitude: -122.3875627,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:15:03.000Z',
        end_time: '2026-07-29T06:16:03.000Z',
        latitude: 37.7884228,
        longitude: -122.3875627,
        density: 13.762843210724807,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:15:03.000Z',
        end_time: '2026-07-29T06:16:03.000Z',
        latitude: 37.7884228,
        longitude: -122.3875627,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T06:09:03.000Z',
        end_time: '2026-07-29T06:14:03.000Z',
        latitude: 37.7885833,
        longitude: -122.3887333,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:13:03.000Z',
        end_time: '2026-07-29T06:14:03.000Z',
        latitude: 37.7884015,
        longitude: -122.3869248,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:13:03.000Z',
        end_time: '2026-07-29T06:14:03.000Z',
        latitude: 37.7884015,
        longitude: -122.3869248,
        density: 11.782261083742696,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:13:03.000Z',
        end_time: '2026-07-29T06:14:03.000Z',
        latitude: 37.7884015,
        longitude: -122.3869248,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T06:09:03.000Z',
        end_time: '2026-07-29T06:14:03.000Z',
        latitude: 37.7885833,
        longitude: -122.3887333,
        density: 3.684210526315789,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T06:09:03.000Z',
        end_time: '2026-07-29T06:14:03.000Z',
        latitude: 37.7885833,
        longitude: -122.3887333,
        density: 28.496173016536716,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:12:03.000Z',
        end_time: '2026-07-29T06:13:03.000Z',
        latitude: 37.7881867,
        longitude: -122.3867802,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:12:03.000Z',
        end_time: '2026-07-29T06:13:03.000Z',
        latitude: 37.7881867,
        longitude: -122.3867802,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:12:03.000Z',
        end_time: '2026-07-29T06:13:03.000Z',
        latitude: 37.7881867,
        longitude: -122.3867802,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:11:03.000Z',
        end_time: '2026-07-29T06:12:03.000Z',
        latitude: 37.7884397,
        longitude: -122.3868913,
        density: 10.526315789473683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:11:03.000Z',
        end_time: '2026-07-29T06:12:03.000Z',
        latitude: 37.7884397,
        longitude: -122.3868913,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:11:03.000Z',
        end_time: '2026-07-29T06:12:03.000Z',
        latitude: 37.7884397,
        longitude: -122.3868913,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:10:03.000Z',
        end_time: '2026-07-29T06:11:03.000Z',
        latitude: 37.788547,
        longitude: -122.3858098,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:10:03.000Z',
        end_time: '2026-07-29T06:11:03.000Z',
        latitude: 37.788547,
        longitude: -122.3858098,
        density: 22.28794591320799,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:10:03.000Z',
        end_time: '2026-07-29T06:11:03.000Z',
        latitude: 37.788547,
        longitude: -122.3858098,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T06:04:03.000Z',
        end_time: '2026-07-29T06:09:03.000Z',
        latitude: 37.7884833,
        longitude: -122.3867333,
        density: 4.2105263157894735,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T06:04:03.000Z',
        end_time: '2026-07-29T06:09:03.000Z',
        latitude: 37.7884833,
        longitude: -122.3867333,
        density: 3.130094467515492,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:08:03.000Z',
        end_time: '2026-07-29T06:09:03.000Z',
        latitude: 37.7884588,
        longitude: -122.3871065,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:08:03.000Z',
        end_time: '2026-07-29T06:09:03.000Z',
        latitude: 37.7884588,
        longitude: -122.3871065,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:08:03.000Z',
        end_time: '2026-07-29T06:09:03.000Z',
        latitude: 37.7884588,
        longitude: -122.3871065,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T06:04:03.000Z',
        end_time: '2026-07-29T06:09:03.000Z',
        latitude: 37.7884833,
        longitude: -122.3867333,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:07:03.000Z',
        end_time: '2026-07-29T06:08:03.000Z',
        latitude: 37.7884515,
        longitude: -122.3870825,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:07:03.000Z',
        end_time: '2026-07-29T06:08:03.000Z',
        latitude: 37.7884515,
        longitude: -122.3870825,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:07:03.000Z',
        end_time: '2026-07-29T06:08:03.000Z',
        latitude: 37.7884515,
        longitude: -122.3870825,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:06:03.000Z',
        end_time: '2026-07-29T06:07:03.000Z',
        latitude: 37.7884395,
        longitude: -122.3871032,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:06:03.000Z',
        end_time: '2026-07-29T06:07:03.000Z',
        latitude: 37.7884395,
        longitude: -122.3871032,
        density: 20.232405645339615,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:06:03.000Z',
        end_time: '2026-07-29T06:07:03.000Z',
        latitude: 37.7884395,
        longitude: -122.3871032,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:05:03.000Z',
        end_time: '2026-07-29T06:06:03.000Z',
        latitude: 37.7884812,
        longitude: -122.387088,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:05:03.000Z',
        end_time: '2026-07-29T06:06:03.000Z',
        latitude: 37.7884812,
        longitude: -122.387088,
        density: 31.24522592940589,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:05:03.000Z',
        end_time: '2026-07-29T06:06:03.000Z',
        latitude: 37.7884812,
        longitude: -122.387088,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T05:59:03.000Z',
        end_time: '2026-07-29T06:04:03.000Z',
        latitude: 37.7884167,
        longitude: -122.3869833,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T05:59:03.000Z',
        end_time: '2026-07-29T06:04:03.000Z',
        latitude: 37.7884167,
        longitude: -122.3869833,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T05:59:03.000Z',
        end_time: '2026-07-29T06:04:03.000Z',
        latitude: 37.7884167,
        longitude: -122.3869833,
        density: 18.756067390359245,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:03:03.000Z',
        end_time: '2026-07-29T06:04:03.000Z',
        latitude: 37.7883497,
        longitude: -122.3870263,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:03:03.000Z',
        end_time: '2026-07-29T06:04:03.000Z',
        latitude: 37.7883497,
        longitude: -122.3870263,
        density: 5.9782252376881315,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:03:03.000Z',
        end_time: '2026-07-29T06:04:03.000Z',
        latitude: 37.7883497,
        longitude: -122.3870263,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:02:03.000Z',
        end_time: '2026-07-29T06:03:03.000Z',
        latitude: 37.7883002,
        longitude: -122.3871858,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:02:03.000Z',
        end_time: '2026-07-29T06:03:03.000Z',
        latitude: 37.7883002,
        longitude: -122.3871858,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:02:03.000Z',
        end_time: '2026-07-29T06:03:03.000Z',
        latitude: 37.7883002,
        longitude: -122.3871858,
        density: 30.995692178966962,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:01:03.000Z',
        end_time: '2026-07-29T06:02:03.000Z',
        latitude: 37.7871815,
        longitude: -122.3875395,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:01:03.000Z',
        end_time: '2026-07-29T06:02:03.000Z',
        latitude: 37.7871815,
        longitude: -122.3875395,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:01:03.000Z',
        end_time: '2026-07-29T06:02:03.000Z',
        latitude: 37.7871815,
        longitude: -122.3875395,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T06:00:03.000Z',
        end_time: '2026-07-29T06:01:03.000Z',
        latitude: 37.7884512,
        longitude: -122.3871413,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T06:00:03.000Z',
        end_time: '2026-07-29T06:01:03.000Z',
        latitude: 37.7884512,
        longitude: -122.3871413,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T06:00:03.000Z',
        end_time: '2026-07-29T06:01:03.000Z',
        latitude: 37.7884512,
        longitude: -122.3871413,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:59:03.000Z',
        end_time: '2026-07-29T06:00:03.000Z',
        latitude: 37.78839,
        longitude: -122.387181,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:59:03.000Z',
        end_time: '2026-07-29T06:00:03.000Z',
        latitude: 37.78839,
        longitude: -122.387181,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:59:03.000Z',
        end_time: '2026-07-29T06:00:03.000Z',
        latitude: 37.78839,
        longitude: -122.387181,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:58:03.000Z',
        end_time: '2026-07-29T05:59:03.000Z',
        latitude: 37.7884273,
        longitude: -122.3870553,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T05:54:03.000Z',
        end_time: '2026-07-29T05:59:03.000Z',
        latitude: 37.7883833,
        longitude: -122.38715,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:58:03.000Z',
        end_time: '2026-07-29T05:59:03.000Z',
        latitude: 37.7884273,
        longitude: -122.3870553,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:58:03.000Z',
        end_time: '2026-07-29T05:59:03.000Z',
        latitude: 37.7884273,
        longitude: -122.3870553,
        density: 29.47876438137508,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T05:54:03.000Z',
        end_time: '2026-07-29T05:59:03.000Z',
        latitude: 37.7883833,
        longitude: -122.38715,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T05:54:03.000Z',
        end_time: '2026-07-29T05:59:03.000Z',
        latitude: 37.7883833,
        longitude: -122.38715,
        density: 10.598967514805437,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:57:03.000Z',
        end_time: '2026-07-29T05:58:03.000Z',
        latitude: 37.7884433,
        longitude: -122.387076,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:57:03.000Z',
        end_time: '2026-07-29T05:58:03.000Z',
        latitude: 37.7884433,
        longitude: -122.387076,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:57:03.000Z',
        end_time: '2026-07-29T05:58:03.000Z',
        latitude: 37.7884433,
        longitude: -122.387076,
        density: 27.145225792742863,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:56:03.000Z',
        end_time: '2026-07-29T05:57:03.000Z',
        latitude: 37.7884502,
        longitude: -122.3870833,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:56:03.000Z',
        end_time: '2026-07-29T05:57:03.000Z',
        latitude: 37.7884502,
        longitude: -122.3870833,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:56:03.000Z',
        end_time: '2026-07-29T05:57:03.000Z',
        latitude: 37.7884502,
        longitude: -122.3870833,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:55:03.000Z',
        end_time: '2026-07-29T05:56:03.000Z',
        latitude: 37.7883772,
        longitude: -122.3870717,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:55:03.000Z',
        end_time: '2026-07-29T05:56:03.000Z',
        latitude: 37.7883772,
        longitude: -122.3870717,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:55:03.000Z',
        end_time: '2026-07-29T05:56:03.000Z',
        latitude: 37.7883772,
        longitude: -122.3870717,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:54:03.000Z',
        end_time: '2026-07-29T05:55:03.000Z',
        latitude: 37.7882658,
        longitude: -122.3871703,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:54:03.000Z',
        end_time: '2026-07-29T05:55:03.000Z',
        latitude: 37.7882658,
        longitude: -122.3871703,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:54:03.000Z',
        end_time: '2026-07-29T05:55:03.000Z',
        latitude: 37.7882658,
        longitude: -122.3871703,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:53:03.000Z',
        end_time: '2026-07-29T05:54:03.000Z',
        latitude: 37.787995,
        longitude: -122.387555,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:53:03.000Z',
        end_time: '2026-07-29T05:54:03.000Z',
        latitude: 37.787995,
        longitude: -122.387555,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:53:03.000Z',
        end_time: '2026-07-29T05:54:03.000Z',
        latitude: 37.787995,
        longitude: -122.387555,
        density: 8.744177465377883,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T05:49:03.000Z',
        end_time: '2026-07-29T05:54:03.000Z',
        latitude: 37.7882,
        longitude: -122.3872333,
        density: 1.5789473684210527,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T05:49:03.000Z',
        end_time: '2026-07-29T05:54:03.000Z',
        latitude: 37.7882,
        longitude: -122.3872333,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T05:49:03.000Z',
        end_time: '2026-07-29T05:54:03.000Z',
        latitude: 37.7882,
        longitude: -122.3872333,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:52:03.000Z',
        end_time: '2026-07-29T05:53:03.000Z',
        latitude: 37.7882955,
        longitude: -122.3871418,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:52:03.000Z',
        end_time: '2026-07-29T05:53:03.000Z',
        latitude: 37.7882955,
        longitude: -122.3871418,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:52:03.000Z',
        end_time: '2026-07-29T05:53:03.000Z',
        latitude: 37.7882955,
        longitude: -122.3871418,
        density: 13.034300020599634,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:51:03.000Z',
        end_time: '2026-07-29T05:52:03.000Z',
        latitude: 37.7883892,
        longitude: -122.3870358,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:51:03.000Z',
        end_time: '2026-07-29T05:52:03.000Z',
        latitude: 37.7883892,
        longitude: -122.3870358,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:51:03.000Z',
        end_time: '2026-07-29T05:52:03.000Z',
        latitude: 37.7883892,
        longitude: -122.3870358,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:50:03.000Z',
        end_time: '2026-07-29T05:51:03.000Z',
        latitude: 37.7884362,
        longitude: -122.3869125,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:50:03.000Z',
        end_time: '2026-07-29T05:51:03.000Z',
        latitude: 37.7884362,
        longitude: -122.3869125,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:50:03.000Z',
        end_time: '2026-07-29T05:51:03.000Z',
        latitude: 37.7884362,
        longitude: -122.3869125,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:49:03.000Z',
        end_time: '2026-07-29T05:50:03.000Z',
        latitude: 37.7887892,
        longitude: -122.3859465,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:49:03.000Z',
        end_time: '2026-07-29T05:50:03.000Z',
        latitude: 37.7887892,
        longitude: -122.3859465,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:49:03.000Z',
        end_time: '2026-07-29T05:50:03.000Z',
        latitude: 37.7887892,
        longitude: -122.3859465,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:48:03.000Z',
        end_time: '2026-07-29T05:49:03.000Z',
        latitude: 37.7884702,
        longitude: -122.3871785,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T05:44:03.000Z',
        end_time: '2026-07-29T05:49:03.000Z',
        latitude: 37.7888833,
        longitude: -122.3856333,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:48:03.000Z',
        end_time: '2026-07-29T05:49:03.000Z',
        latitude: 37.7884702,
        longitude: -122.3871785,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:48:03.000Z',
        end_time: '2026-07-29T05:49:03.000Z',
        latitude: 37.7884702,
        longitude: -122.3871785,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T05:44:03.000Z',
        end_time: '2026-07-29T05:49:03.000Z',
        latitude: 37.7888833,
        longitude: -122.3856333,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T05:44:03.000Z',
        end_time: '2026-07-29T05:49:03.000Z',
        latitude: 37.7888833,
        longitude: -122.3856333,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:47:03.000Z',
        end_time: '2026-07-29T05:48:03.000Z',
        latitude: 37.7884515,
        longitude: -122.3872478,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:47:03.000Z',
        end_time: '2026-07-29T05:48:03.000Z',
        latitude: 37.7884515,
        longitude: -122.3872478,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:47:03.000Z',
        end_time: '2026-07-29T05:48:03.000Z',
        latitude: 37.7884515,
        longitude: -122.3872478,
        density: 23.25952010050962,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:46:03.000Z',
        end_time: '2026-07-29T05:47:03.000Z',
        latitude: 37.7884057,
        longitude: -122.3869582,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:46:03.000Z',
        end_time: '2026-07-29T05:47:03.000Z',
        latitude: 37.7884057,
        longitude: -122.3869582,
        density: 14.714749523080979,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:46:03.000Z',
        end_time: '2026-07-29T05:47:03.000Z',
        latitude: 37.7884057,
        longitude: -122.3869582,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:45:03.000Z',
        end_time: '2026-07-29T05:46:03.000Z',
        latitude: 37.7883332,
        longitude: -122.3869765,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:45:03.000Z',
        end_time: '2026-07-29T05:46:03.000Z',
        latitude: 37.7883332,
        longitude: -122.3869765,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:45:03.000Z',
        end_time: '2026-07-29T05:46:03.000Z',
        latitude: 37.7883332,
        longitude: -122.3869765,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:44:03.000Z',
        end_time: '2026-07-29T05:45:03.000Z',
        latitude: 37.7882995,
        longitude: -122.3868498,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:44:03.000Z',
        end_time: '2026-07-29T05:45:03.000Z',
        latitude: 37.7882995,
        longitude: -122.3868498,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:44:03.000Z',
        end_time: '2026-07-29T05:45:03.000Z',
        latitude: 37.7882995,
        longitude: -122.3868498,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T05:39:03.000Z',
        end_time: '2026-07-29T05:44:03.000Z',
        latitude: 37.7883,
        longitude: -122.3868333,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:43:03.000Z',
        end_time: '2026-07-29T05:44:03.000Z',
        latitude: 37.7882197,
        longitude: -122.3869782,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:43:03.000Z',
        end_time: '2026-07-29T05:44:03.000Z',
        latitude: 37.7882197,
        longitude: -122.3869782,
        density: 3.5689332478773754,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:43:03.000Z',
        end_time: '2026-07-29T05:44:03.000Z',
        latitude: 37.7882197,
        longitude: -122.3869782,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T05:39:03.000Z',
        end_time: '2026-07-29T05:44:03.000Z',
        latitude: 37.7883,
        longitude: -122.3868333,
        density: 1.5789473684210527,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T05:39:03.000Z',
        end_time: '2026-07-29T05:44:03.000Z',
        latitude: 37.7883,
        longitude: -122.3868333,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:42:03.000Z',
        end_time: '2026-07-29T05:43:03.000Z',
        latitude: 37.7882235,
        longitude: -122.3871827,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:42:03.000Z',
        end_time: '2026-07-29T05:43:03.000Z',
        latitude: 37.7882235,
        longitude: -122.3871827,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:42:03.000Z',
        end_time: '2026-07-29T05:43:03.000Z',
        latitude: 37.7882235,
        longitude: -122.3871827,
        density: 8.480329574077398,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:41:03.000Z',
        end_time: '2026-07-29T05:42:03.000Z',
        latitude: 37.788182,
        longitude: -122.3871353,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:41:03.000Z',
        end_time: '2026-07-29T05:42:03.000Z',
        latitude: 37.788182,
        longitude: -122.3871353,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:41:03.000Z',
        end_time: '2026-07-29T05:42:03.000Z',
        latitude: 37.788182,
        longitude: -122.3871353,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:40:03.000Z',
        end_time: '2026-07-29T05:41:03.000Z',
        latitude: 37.7882125,
        longitude: -122.387092,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:40:03.000Z',
        end_time: '2026-07-29T05:41:03.000Z',
        latitude: 37.7882125,
        longitude: -122.387092,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:40:03.000Z',
        end_time: '2026-07-29T05:41:03.000Z',
        latitude: 37.7882125,
        longitude: -122.387092,
        density: 9.47725328665312,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:39:03.000Z',
        end_time: '2026-07-29T05:40:03.000Z',
        latitude: 37.788293,
        longitude: -122.3870868,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:39:03.000Z',
        end_time: '2026-07-29T05:40:03.000Z',
        latitude: 37.788293,
        longitude: -122.3870868,
        density: 9.21195123383496,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:39:03.000Z',
        end_time: '2026-07-29T05:40:03.000Z',
        latitude: 37.788293,
        longitude: -122.3870868,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:38:03.000Z',
        end_time: '2026-07-29T05:39:03.000Z',
        latitude: 37.7881983,
        longitude: -122.3872217,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T05:34:03.000Z',
        end_time: '2026-07-29T05:39:03.000Z',
        latitude: 37.7882833,
        longitude: -122.3870833,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:38:03.000Z',
        end_time: '2026-07-29T05:39:03.000Z',
        latitude: 37.7881983,
        longitude: -122.3872217,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:38:03.000Z',
        end_time: '2026-07-29T05:39:03.000Z',
        latitude: 37.7881983,
        longitude: -122.3872217,
        density: 12.135558546916819,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T05:34:03.000Z',
        end_time: '2026-07-29T05:39:03.000Z',
        latitude: 37.7882833,
        longitude: -122.3870833,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T05:34:03.000Z',
        end_time: '2026-07-29T05:39:03.000Z',
        latitude: 37.7882833,
        longitude: -122.3870833,
        density: 26.076152261564783,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:37:03.000Z',
        end_time: '2026-07-29T05:38:03.000Z',
        latitude: 37.788342,
        longitude: -122.3871595,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:37:03.000Z',
        end_time: '2026-07-29T05:38:03.000Z',
        latitude: 37.788342,
        longitude: -122.3871595,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:37:03.000Z',
        end_time: '2026-07-29T05:38:03.000Z',
        latitude: 37.788342,
        longitude: -122.3871595,
        density: 30.59633830066164,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:36:03.000Z',
        end_time: '2026-07-29T05:37:03.000Z',
        latitude: 37.7885722,
        longitude: -122.3870618,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:36:03.000Z',
        end_time: '2026-07-29T05:37:03.000Z',
        latitude: 37.7885722,
        longitude: -122.3870618,
        density: 8.227207097186824,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:36:03.000Z',
        end_time: '2026-07-29T05:37:03.000Z',
        latitude: 37.7885722,
        longitude: -122.3870618,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:35:03.000Z',
        end_time: '2026-07-29T05:36:03.000Z',
        latitude: 37.7884723,
        longitude: -122.3870623,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:35:03.000Z',
        end_time: '2026-07-29T05:36:03.000Z',
        latitude: 37.7884723,
        longitude: -122.3870623,
        density: 9.050458052696918,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:35:03.000Z',
        end_time: '2026-07-29T05:36:03.000Z',
        latitude: 37.7884723,
        longitude: -122.3870623,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:34:03.000Z',
        end_time: '2026-07-29T05:35:03.000Z',
        latitude: 37.7885447,
        longitude: -122.3870432,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:34:03.000Z',
        end_time: '2026-07-29T05:35:03.000Z',
        latitude: 37.7885447,
        longitude: -122.3870432,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:34:03.000Z',
        end_time: '2026-07-29T05:35:03.000Z',
        latitude: 37.7885447,
        longitude: -122.3870432,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T05:29:03.000Z',
        end_time: '2026-07-29T05:34:03.000Z',
        latitude: 37.7882833,
        longitude: -122.3871667,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:33:03.000Z',
        end_time: '2026-07-29T05:34:03.000Z',
        latitude: 37.7877395,
        longitude: -122.387523,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:33:03.000Z',
        end_time: '2026-07-29T05:34:03.000Z',
        latitude: 37.7877395,
        longitude: -122.387523,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:33:03.000Z',
        end_time: '2026-07-29T05:34:03.000Z',
        latitude: 37.7877395,
        longitude: -122.387523,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T05:29:03.000Z',
        end_time: '2026-07-29T05:34:03.000Z',
        latitude: 37.7882833,
        longitude: -122.3871667,
        density: 2.1052631578947367,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T05:29:03.000Z',
        end_time: '2026-07-29T05:34:03.000Z',
        latitude: 37.7882833,
        longitude: -122.3871667,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:32:03.000Z',
        end_time: '2026-07-29T05:33:03.000Z',
        latitude: 37.7885702,
        longitude: -122.3871148,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:32:03.000Z',
        end_time: '2026-07-29T05:33:03.000Z',
        latitude: 37.7885702,
        longitude: -122.3871148,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:32:03.000Z',
        end_time: '2026-07-29T05:33:03.000Z',
        latitude: 37.7885702,
        longitude: -122.3871148,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:31:03.000Z',
        end_time: '2026-07-29T05:32:03.000Z',
        latitude: 37.7884293,
        longitude: -122.3871052,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:31:03.000Z',
        end_time: '2026-07-29T05:32:03.000Z',
        latitude: 37.7884293,
        longitude: -122.3871052,
        density: 4.459647309135328,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:31:03.000Z',
        end_time: '2026-07-29T05:32:03.000Z',
        latitude: 37.7884293,
        longitude: -122.3871052,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:30:03.000Z',
        end_time: '2026-07-29T05:31:03.000Z',
        latitude: 37.78821,
        longitude: -122.3879997,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:30:03.000Z',
        end_time: '2026-07-29T05:31:03.000Z',
        latitude: 37.78821,
        longitude: -122.3879997,
        density: 15.051073207834282,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:30:03.000Z',
        end_time: '2026-07-29T05:31:03.000Z',
        latitude: 37.78821,
        longitude: -122.3879997,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:29:03.000Z',
        end_time: '2026-07-29T05:30:03.000Z',
        latitude: 37.7883892,
        longitude: -122.3868935,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:29:03.000Z',
        end_time: '2026-07-29T05:30:03.000Z',
        latitude: 37.7883892,
        longitude: -122.3868935,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:29:03.000Z',
        end_time: '2026-07-29T05:30:03.000Z',
        latitude: 37.7883892,
        longitude: -122.3868935,
        density: 15.03396733750007,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T05:24:03.000Z',
        end_time: '2026-07-29T05:29:03.000Z',
        latitude: 37.7883333,
        longitude: -122.387,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:28:03.000Z',
        end_time: '2026-07-29T05:29:03.000Z',
        latitude: 37.7884103,
        longitude: -122.3869963,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:28:03.000Z',
        end_time: '2026-07-29T05:29:03.000Z',
        latitude: 37.7884103,
        longitude: -122.3869963,
        density: 19.17513956631051,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:28:03.000Z',
        end_time: '2026-07-29T05:29:03.000Z',
        latitude: 37.7884103,
        longitude: -122.3869963,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T05:24:03.000Z',
        end_time: '2026-07-29T05:29:03.000Z',
        latitude: 37.7883333,
        longitude: -122.387,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T05:24:03.000Z',
        end_time: '2026-07-29T05:29:03.000Z',
        latitude: 37.7883333,
        longitude: -122.387,
        density: 28.05156163635546,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:27:03.000Z',
        end_time: '2026-07-29T05:28:03.000Z',
        latitude: 37.7884768,
        longitude: -122.387078,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:27:03.000Z',
        end_time: '2026-07-29T05:28:03.000Z',
        latitude: 37.7884768,
        longitude: -122.387078,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:27:03.000Z',
        end_time: '2026-07-29T05:28:03.000Z',
        latitude: 37.7884768,
        longitude: -122.387078,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:26:03.000Z',
        end_time: '2026-07-29T05:27:03.000Z',
        latitude: 37.7884935,
        longitude: -122.3871,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:26:03.000Z',
        end_time: '2026-07-29T05:27:03.000Z',
        latitude: 37.7884935,
        longitude: -122.3871,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:26:03.000Z',
        end_time: '2026-07-29T05:27:03.000Z',
        latitude: 37.7884935,
        longitude: -122.3871,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:25:03.000Z',
        end_time: '2026-07-29T05:26:03.000Z',
        latitude: 37.7884743,
        longitude: -122.3871428,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:25:03.000Z',
        end_time: '2026-07-29T05:26:03.000Z',
        latitude: 37.7884743,
        longitude: -122.3871428,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:25:03.000Z',
        end_time: '2026-07-29T05:26:03.000Z',
        latitude: 37.7884743,
        longitude: -122.3871428,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:24:03.000Z',
        end_time: '2026-07-29T05:25:03.000Z',
        latitude: 37.7884535,
        longitude: -122.3871298,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:24:03.000Z',
        end_time: '2026-07-29T05:25:03.000Z',
        latitude: 37.7884535,
        longitude: -122.3871298,
        density: 18.70486516882176,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:24:03.000Z',
        end_time: '2026-07-29T05:25:03.000Z',
        latitude: 37.7884535,
        longitude: -122.3871298,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:23:03.000Z',
        end_time: '2026-07-29T05:24:03.000Z',
        latitude: 37.7884462,
        longitude: -122.3870848,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:23:03.000Z',
        end_time: '2026-07-29T05:24:03.000Z',
        latitude: 37.7884462,
        longitude: -122.3870848,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:23:03.000Z',
        end_time: '2026-07-29T05:24:03.000Z',
        latitude: 37.7884462,
        longitude: -122.3870848,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T05:19:03.000Z',
        end_time: '2026-07-29T05:24:03.000Z',
        latitude: 37.7884667,
        longitude: -122.3870833,
        density: 1.0526315789473684,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T05:19:03.000Z',
        end_time: '2026-07-29T05:24:03.000Z',
        latitude: 37.7884667,
        longitude: -122.3870833,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T05:19:03.000Z',
        end_time: '2026-07-29T05:24:03.000Z',
        latitude: 37.7884667,
        longitude: -122.3870833,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:22:03.000Z',
        end_time: '2026-07-29T05:23:03.000Z',
        latitude: 37.7884152,
        longitude: -122.3871622,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:22:03.000Z',
        end_time: '2026-07-29T05:23:03.000Z',
        latitude: 37.7884152,
        longitude: -122.3871622,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:22:03.000Z',
        end_time: '2026-07-29T05:23:03.000Z',
        latitude: 37.7884152,
        longitude: -122.3871622,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:21:03.000Z',
        end_time: '2026-07-29T05:22:03.000Z',
        latitude: 37.788458,
        longitude: -122.3871227,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:21:03.000Z',
        end_time: '2026-07-29T05:22:03.000Z',
        latitude: 37.788458,
        longitude: -122.3871227,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:21:03.000Z',
        end_time: '2026-07-29T05:22:03.000Z',
        latitude: 37.788458,
        longitude: -122.3871227,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:20:03.000Z',
        end_time: '2026-07-29T05:21:03.000Z',
        latitude: 37.7884308,
        longitude: -122.3871462,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:20:03.000Z',
        end_time: '2026-07-29T05:21:03.000Z',
        latitude: 37.7884308,
        longitude: -122.3871462,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:20:03.000Z',
        end_time: '2026-07-29T05:21:03.000Z',
        latitude: 37.7884308,
        longitude: -122.3871462,
        density: 26.22650348256193,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:19:03.000Z',
        end_time: '2026-07-29T05:20:03.000Z',
        latitude: 37.7884625,
        longitude: -122.3871333,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:19:03.000Z',
        end_time: '2026-07-29T05:20:03.000Z',
        latitude: 37.7884625,
        longitude: -122.3871333,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:19:03.000Z',
        end_time: '2026-07-29T05:20:03.000Z',
        latitude: 37.7884625,
        longitude: -122.3871333,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:18:03.000Z',
        end_time: '2026-07-29T05:19:03.000Z',
        latitude: 37.7884522,
        longitude: -122.3871498,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T05:14:03.000Z',
        end_time: '2026-07-29T05:19:03.000Z',
        latitude: 37.78845,
        longitude: -122.3871333,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T05:14:03.000Z',
        end_time: '2026-07-29T05:19:03.000Z',
        latitude: 37.78845,
        longitude: -122.3871333,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T05:14:03.000Z',
        end_time: '2026-07-29T05:19:03.000Z',
        latitude: 37.78845,
        longitude: -122.3871333,
        density: 4.62286125927899,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:18:03.000Z',
        end_time: '2026-07-29T05:19:03.000Z',
        latitude: 37.7884522,
        longitude: -122.3871498,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:18:03.000Z',
        end_time: '2026-07-29T05:19:03.000Z',
        latitude: 37.7884522,
        longitude: -122.3871498,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:17:03.000Z',
        end_time: '2026-07-29T05:18:03.000Z',
        latitude: 37.7885035,
        longitude: -122.3870948,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:17:03.000Z',
        end_time: '2026-07-29T05:18:03.000Z',
        latitude: 37.7885035,
        longitude: -122.3870948,
        density: 11.995531327203423,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:17:03.000Z',
        end_time: '2026-07-29T05:18:03.000Z',
        latitude: 37.7885035,
        longitude: -122.3870948,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:16:03.000Z',
        end_time: '2026-07-29T05:17:03.000Z',
        latitude: 37.7884663,
        longitude: -122.3870615,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:16:03.000Z',
        end_time: '2026-07-29T05:17:03.000Z',
        latitude: 37.7884663,
        longitude: -122.3870615,
        density: 8.280068577891244,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:16:03.000Z',
        end_time: '2026-07-29T05:17:03.000Z',
        latitude: 37.7884663,
        longitude: -122.3870615,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:15:03.000Z',
        end_time: '2026-07-29T05:16:03.000Z',
        latitude: 37.7884557,
        longitude: -122.3870468,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:15:03.000Z',
        end_time: '2026-07-29T05:16:03.000Z',
        latitude: 37.7884557,
        longitude: -122.3870468,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:15:03.000Z',
        end_time: '2026-07-29T05:16:03.000Z',
        latitude: 37.7884557,
        longitude: -122.3870468,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T05:09:03.000Z',
        end_time: '2026-07-29T05:14:03.000Z',
        latitude: 37.7884667,
        longitude: -122.3870667,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:13:03.000Z',
        end_time: '2026-07-29T05:14:03.000Z',
        latitude: 37.7884553,
        longitude: -122.3871277,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:13:03.000Z',
        end_time: '2026-07-29T05:14:03.000Z',
        latitude: 37.7884553,
        longitude: -122.3871277,
        density: 12.643914734964472,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:13:03.000Z',
        end_time: '2026-07-29T05:14:03.000Z',
        latitude: 37.7884553,
        longitude: -122.3871277,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T05:09:03.000Z',
        end_time: '2026-07-29T05:14:03.000Z',
        latitude: 37.7884667,
        longitude: -122.3870667,
        density: 5.7894736842105265,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T05:09:03.000Z',
        end_time: '2026-07-29T05:14:03.000Z',
        latitude: 37.7884667,
        longitude: -122.3870667,
        density: 21.219244749162453,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:12:03.000Z',
        end_time: '2026-07-29T05:13:03.000Z',
        latitude: 37.7884337,
        longitude: -122.3872712,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:12:03.000Z',
        end_time: '2026-07-29T05:13:03.000Z',
        latitude: 37.7884337,
        longitude: -122.3872712,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:12:03.000Z',
        end_time: '2026-07-29T05:13:03.000Z',
        latitude: 37.7884337,
        longitude: -122.3872712,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:11:03.000Z',
        end_time: '2026-07-29T05:12:03.000Z',
        latitude: 37.7882348,
        longitude: -122.388013,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:11:03.000Z',
        end_time: '2026-07-29T05:12:03.000Z',
        latitude: 37.7882348,
        longitude: -122.388013,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:11:03.000Z',
        end_time: '2026-07-29T05:12:03.000Z',
        latitude: 37.7882348,
        longitude: -122.388013,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:10:03.000Z',
        end_time: '2026-07-29T05:11:03.000Z',
        latitude: 37.7883217,
        longitude: -122.3876235,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:10:03.000Z',
        end_time: '2026-07-29T05:11:03.000Z',
        latitude: 37.7883217,
        longitude: -122.3876235,
        density: 4.705711843699399,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:10:03.000Z',
        end_time: '2026-07-29T05:11:03.000Z',
        latitude: 37.7883217,
        longitude: -122.3876235,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:09:03.000Z',
        end_time: '2026-07-29T05:10:03.000Z',
        latitude: 37.7885062,
        longitude: -122.3869847,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:09:03.000Z',
        end_time: '2026-07-29T05:10:03.000Z',
        latitude: 37.7885062,
        longitude: -122.3869847,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:09:03.000Z',
        end_time: '2026-07-29T05:10:03.000Z',
        latitude: 37.7885062,
        longitude: -122.3869847,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T05:04:03.000Z',
        end_time: '2026-07-29T05:09:03.000Z',
        latitude: 37.7884833,
        longitude: -122.3869833,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T05:04:03.000Z',
        end_time: '2026-07-29T05:09:03.000Z',
        latitude: 37.7884833,
        longitude: -122.3869833,
        density: 15.854301295302783,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:08:03.000Z',
        end_time: '2026-07-29T05:09:03.000Z',
        latitude: 37.7884842,
        longitude: -122.3870172,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:08:03.000Z',
        end_time: '2026-07-29T05:09:03.000Z',
        latitude: 37.7884842,
        longitude: -122.3870172,
        density: 5.232428740270635,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:08:03.000Z',
        end_time: '2026-07-29T05:09:03.000Z',
        latitude: 37.7884842,
        longitude: -122.3870172,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T05:04:03.000Z',
        end_time: '2026-07-29T05:09:03.000Z',
        latitude: 37.7884833,
        longitude: -122.3869833,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:07:03.000Z',
        end_time: '2026-07-29T05:08:03.000Z',
        latitude: 37.7827057,
        longitude: -122.408941,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:07:03.000Z',
        end_time: '2026-07-29T05:08:03.000Z',
        latitude: 37.7827057,
        longitude: -122.408941,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:07:03.000Z',
        end_time: '2026-07-29T05:08:03.000Z',
        latitude: 37.7827057,
        longitude: -122.408941,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:06:03.000Z',
        end_time: '2026-07-29T05:07:03.000Z',
        latitude: 37.7827057,
        longitude: -122.408941,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:06:03.000Z',
        end_time: '2026-07-29T05:07:03.000Z',
        latitude: 37.7827057,
        longitude: -122.408941,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:06:03.000Z',
        end_time: '2026-07-29T05:07:03.000Z',
        latitude: 37.7827057,
        longitude: -122.408941,
        density: 8.04586256391977,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:05:03.000Z',
        end_time: '2026-07-29T05:06:03.000Z',
        latitude: 37.7827057,
        longitude: -122.408941,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:05:03.000Z',
        end_time: '2026-07-29T05:06:03.000Z',
        latitude: 37.7827057,
        longitude: -122.408941,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:05:03.000Z',
        end_time: '2026-07-29T05:06:03.000Z',
        latitude: 37.7827057,
        longitude: -122.408941,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:04:03.000Z',
        end_time: '2026-07-29T05:05:03.000Z',
        latitude: 37.7827057,
        longitude: -122.408941,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:04:03.000Z',
        end_time: '2026-07-29T05:05:03.000Z',
        latitude: 37.7827057,
        longitude: -122.408941,
        density: 10.526315789473683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:04:03.000Z',
        end_time: '2026-07-29T05:05:03.000Z',
        latitude: 37.7827057,
        longitude: -122.408941,
        density: 30.26888535875586,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T04:59:04.000Z',
        end_time: '2026-07-29T05:04:04.000Z',
        latitude: 37.7842667,
        longitude: -122.4029833,
        density: 4.736842105263158,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T04:59:04.000Z',
        end_time: '2026-07-29T05:04:04.000Z',
        latitude: 37.7842667,
        longitude: -122.4029833,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T04:59:04.000Z',
        end_time: '2026-07-29T05:04:04.000Z',
        latitude: 37.7842667,
        longitude: -122.4029833,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:03:03.000Z',
        end_time: '2026-07-29T05:04:03.000Z',
        latitude: 37.7886403,
        longitude: -122.3863848,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:03:03.000Z',
        end_time: '2026-07-29T05:04:03.000Z',
        latitude: 37.7886403,
        longitude: -122.3863848,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:03:03.000Z',
        end_time: '2026-07-29T05:04:03.000Z',
        latitude: 37.7886403,
        longitude: -122.3863848,
        density: 26.8307433922088,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:02:04.000Z',
        end_time: '2026-07-29T05:03:04.000Z',
        latitude: 37.7885305,
        longitude: -122.386752,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:02:04.000Z',
        end_time: '2026-07-29T05:03:04.000Z',
        latitude: 37.7885305,
        longitude: -122.386752,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:02:04.000Z',
        end_time: '2026-07-29T05:03:04.000Z',
        latitude: 37.7885305,
        longitude: -122.386752,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:01:04.000Z',
        end_time: '2026-07-29T05:02:04.000Z',
        latitude: 37.7884218,
        longitude: -122.3873582,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:01:04.000Z',
        end_time: '2026-07-29T05:02:04.000Z',
        latitude: 37.7884218,
        longitude: -122.3873582,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:01:04.000Z',
        end_time: '2026-07-29T05:02:04.000Z',
        latitude: 37.7884218,
        longitude: -122.3873582,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T05:00:04.000Z',
        end_time: '2026-07-29T05:01:04.000Z',
        latitude: 37.7885688,
        longitude: -122.3867305,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T05:00:04.000Z',
        end_time: '2026-07-29T05:01:04.000Z',
        latitude: 37.7885688,
        longitude: -122.3867305,
        density: 25.292285153198137,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T05:00:04.000Z',
        end_time: '2026-07-29T05:01:04.000Z',
        latitude: 37.7885688,
        longitude: -122.3867305,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:59:04.000Z',
        end_time: '2026-07-29T05:00:04.000Z',
        latitude: 37.7886555,
        longitude: -122.3867228,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:59:04.000Z',
        end_time: '2026-07-29T05:00:04.000Z',
        latitude: 37.7886555,
        longitude: -122.3867228,
        density: 22.153379018207016,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:59:04.000Z',
        end_time: '2026-07-29T05:00:04.000Z',
        latitude: 37.7886555,
        longitude: -122.3867228,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:58:04.000Z',
        end_time: '2026-07-29T04:59:04.000Z',
        latitude: 37.7884733,
        longitude: -122.3870873,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T04:54:04.000Z',
        end_time: '2026-07-29T04:59:04.000Z',
        latitude: 37.7886,
        longitude: -122.38695,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:58:04.000Z',
        end_time: '2026-07-29T04:59:04.000Z',
        latitude: 37.7884733,
        longitude: -122.3870873,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:58:04.000Z',
        end_time: '2026-07-29T04:59:04.000Z',
        latitude: 37.7884733,
        longitude: -122.3870873,
        density: 9.458682718686475,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T04:54:04.000Z',
        end_time: '2026-07-29T04:59:04.000Z',
        latitude: 37.7886,
        longitude: -122.38695,
        density: 2.1052631578947367,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T04:54:04.000Z',
        end_time: '2026-07-29T04:59:04.000Z',
        latitude: 37.7886,
        longitude: -122.38695,
        density: 3.3458956460022082,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:57:04.000Z',
        end_time: '2026-07-29T04:58:04.000Z',
        latitude: 37.7884607,
        longitude: -122.3870917,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:57:04.000Z',
        end_time: '2026-07-29T04:58:04.000Z',
        latitude: 37.7884607,
        longitude: -122.3870917,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:57:04.000Z',
        end_time: '2026-07-29T04:58:04.000Z',
        latitude: 37.7884607,
        longitude: -122.3870917,
        density: 14.160165083023797,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:56:04.000Z',
        end_time: '2026-07-29T04:57:04.000Z',
        latitude: 37.788461,
        longitude: -122.387061,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:56:04.000Z',
        end_time: '2026-07-29T04:57:04.000Z',
        latitude: 37.788461,
        longitude: -122.387061,
        density: 6.70752205777578,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:56:04.000Z',
        end_time: '2026-07-29T04:57:04.000Z',
        latitude: 37.788461,
        longitude: -122.387061,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:55:04.000Z',
        end_time: '2026-07-29T04:56:04.000Z',
        latitude: 37.7884545,
        longitude: -122.3870272,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:55:04.000Z',
        end_time: '2026-07-29T04:56:04.000Z',
        latitude: 37.7884545,
        longitude: -122.3870272,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:55:04.000Z',
        end_time: '2026-07-29T04:56:04.000Z',
        latitude: 37.7884545,
        longitude: -122.3870272,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T04:49:04.000Z',
        end_time: '2026-07-29T04:54:04.000Z',
        latitude: 37.7883167,
        longitude: -122.3872,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T04:49:04.000Z',
        end_time: '2026-07-29T04:54:04.000Z',
        latitude: 37.7883167,
        longitude: -122.3872,
        density: 14.606932165595744,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:53:04.000Z',
        end_time: '2026-07-29T04:54:04.000Z',
        latitude: 37.7888673,
        longitude: -122.3865958,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:53:04.000Z',
        end_time: '2026-07-29T04:54:04.000Z',
        latitude: 37.7888673,
        longitude: -122.3865958,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:53:04.000Z',
        end_time: '2026-07-29T04:54:04.000Z',
        latitude: 37.7888673,
        longitude: -122.3865958,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T04:49:04.000Z',
        end_time: '2026-07-29T04:54:04.000Z',
        latitude: 37.7883167,
        longitude: -122.3872,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:52:04.000Z',
        end_time: '2026-07-29T04:53:04.000Z',
        latitude: 37.788522,
        longitude: -122.3870518,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:52:04.000Z',
        end_time: '2026-07-29T04:53:04.000Z',
        latitude: 37.788522,
        longitude: -122.3870518,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:52:04.000Z',
        end_time: '2026-07-29T04:53:04.000Z',
        latitude: 37.788522,
        longitude: -122.3870518,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:51:04.000Z',
        end_time: '2026-07-29T04:52:04.000Z',
        latitude: 37.788497,
        longitude: -122.3871275,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:51:04.000Z',
        end_time: '2026-07-29T04:52:04.000Z',
        latitude: 37.788497,
        longitude: -122.3871275,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:51:04.000Z',
        end_time: '2026-07-29T04:52:04.000Z',
        latitude: 37.788497,
        longitude: -122.3871275,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:50:04.000Z',
        end_time: '2026-07-29T04:51:04.000Z',
        latitude: 37.7883527,
        longitude: -122.3870548,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:50:04.000Z',
        end_time: '2026-07-29T04:51:04.000Z',
        latitude: 37.7883527,
        longitude: -122.3870548,
        density: 6.363055542232119,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:50:04.000Z',
        end_time: '2026-07-29T04:51:04.000Z',
        latitude: 37.7883527,
        longitude: -122.3870548,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:49:04.000Z',
        end_time: '2026-07-29T04:50:04.000Z',
        latitude: 37.7883988,
        longitude: -122.3870733,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:49:04.000Z',
        end_time: '2026-07-29T04:50:04.000Z',
        latitude: 37.7883988,
        longitude: -122.3870733,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:49:04.000Z',
        end_time: '2026-07-29T04:50:04.000Z',
        latitude: 37.7883988,
        longitude: -122.3870733,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T04:44:04.000Z',
        end_time: '2026-07-29T04:49:04.000Z',
        latitude: 37.7884167,
        longitude: -122.3870833,
        density: 2.1052631578947367,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T04:44:04.000Z',
        end_time: '2026-07-29T04:49:04.000Z',
        latitude: 37.7884167,
        longitude: -122.3870833,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:48:04.000Z',
        end_time: '2026-07-29T04:49:04.000Z',
        latitude: 37.7884503,
        longitude: -122.3871165,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:48:04.000Z',
        end_time: '2026-07-29T04:49:04.000Z',
        latitude: 37.7884503,
        longitude: -122.3871165,
        density: 6.109784344774276,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:48:04.000Z',
        end_time: '2026-07-29T04:49:04.000Z',
        latitude: 37.7884503,
        longitude: -122.3871165,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T04:44:04.000Z',
        end_time: '2026-07-29T04:49:04.000Z',
        latitude: 37.7884167,
        longitude: -122.3870833,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:47:04.000Z',
        end_time: '2026-07-29T04:48:04.000Z',
        latitude: 37.7885225,
        longitude: -122.3870942,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:47:04.000Z',
        end_time: '2026-07-29T04:48:04.000Z',
        latitude: 37.7885225,
        longitude: -122.3870942,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:47:04.000Z',
        end_time: '2026-07-29T04:48:04.000Z',
        latitude: 37.7885225,
        longitude: -122.3870942,
        density: 7.219873024933042,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:46:04.000Z',
        end_time: '2026-07-29T04:47:04.000Z',
        latitude: 37.7885163,
        longitude: -122.3870953,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:46:04.000Z',
        end_time: '2026-07-29T04:47:04.000Z',
        latitude: 37.7885163,
        longitude: -122.3870953,
        density: 29.204702680488477,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:46:04.000Z',
        end_time: '2026-07-29T04:47:04.000Z',
        latitude: 37.7885163,
        longitude: -122.3870953,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:45:04.000Z',
        end_time: '2026-07-29T04:46:04.000Z',
        latitude: 37.7885285,
        longitude: -122.3871865,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:45:04.000Z',
        end_time: '2026-07-29T04:46:04.000Z',
        latitude: 37.7885285,
        longitude: -122.3871865,
        density: 34.63656256604332,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:45:04.000Z',
        end_time: '2026-07-29T04:46:04.000Z',
        latitude: 37.7885285,
        longitude: -122.3871865,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:44:04.000Z',
        end_time: '2026-07-29T04:45:04.000Z',
        latitude: 37.7884923,
        longitude: -122.3871487,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:44:04.000Z',
        end_time: '2026-07-29T04:45:04.000Z',
        latitude: 37.7884923,
        longitude: -122.3871487,
        density: 2.3873199740315876,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:44:04.000Z',
        end_time: '2026-07-29T04:45:04.000Z',
        latitude: 37.7884923,
        longitude: -122.3871487,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T04:39:04.000Z',
        end_time: '2026-07-29T04:44:04.000Z',
        latitude: 37.7885,
        longitude: -122.38715,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:43:04.000Z',
        end_time: '2026-07-29T04:44:04.000Z',
        latitude: 37.7885012,
        longitude: -122.3871442,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:43:04.000Z',
        end_time: '2026-07-29T04:44:04.000Z',
        latitude: 37.7885012,
        longitude: -122.3871442,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:43:04.000Z',
        end_time: '2026-07-29T04:44:04.000Z',
        latitude: 37.7885012,
        longitude: -122.3871442,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T04:39:04.000Z',
        end_time: '2026-07-29T04:44:04.000Z',
        latitude: 37.7885,
        longitude: -122.38715,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T04:39:04.000Z',
        end_time: '2026-07-29T04:44:04.000Z',
        latitude: 37.7885,
        longitude: -122.38715,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:42:04.000Z',
        end_time: '2026-07-29T04:43:04.000Z',
        latitude: 37.7884703,
        longitude: -122.3871092,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:42:04.000Z',
        end_time: '2026-07-29T04:43:04.000Z',
        latitude: 37.7884703,
        longitude: -122.3871092,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:42:04.000Z',
        end_time: '2026-07-29T04:43:04.000Z',
        latitude: 37.7884703,
        longitude: -122.3871092,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:41:04.000Z',
        end_time: '2026-07-29T04:42:04.000Z',
        latitude: 37.7884947,
        longitude: -122.3870943,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:41:04.000Z',
        end_time: '2026-07-29T04:42:04.000Z',
        latitude: 37.7884947,
        longitude: -122.3870943,
        density: 24.510647947285126,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:41:04.000Z',
        end_time: '2026-07-29T04:42:04.000Z',
        latitude: 37.7884947,
        longitude: -122.3870943,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:40:04.000Z',
        end_time: '2026-07-29T04:41:04.000Z',
        latitude: 37.7884218,
        longitude: -122.3870628,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:40:04.000Z',
        end_time: '2026-07-29T04:41:04.000Z',
        latitude: 37.7884218,
        longitude: -122.3870628,
        density: 13.246455768637428,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:40:04.000Z',
        end_time: '2026-07-29T04:41:04.000Z',
        latitude: 37.7884218,
        longitude: -122.3870628,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:39:04.000Z',
        end_time: '2026-07-29T04:40:04.000Z',
        latitude: 37.7883888,
        longitude: -122.3871063,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:39:04.000Z',
        end_time: '2026-07-29T04:40:04.000Z',
        latitude: 37.7883888,
        longitude: -122.3871063,
        density: 32.13826411185784,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:39:04.000Z',
        end_time: '2026-07-29T04:40:04.000Z',
        latitude: 37.7883888,
        longitude: -122.3871063,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T04:34:04.000Z',
        end_time: '2026-07-29T04:39:04.000Z',
        latitude: 37.7884,
        longitude: -122.3870833,
        density: 5.7894736842105265,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T04:34:04.000Z',
        end_time: '2026-07-29T04:39:04.000Z',
        latitude: 37.7884,
        longitude: -122.3870833,
        density: 27.903475614649217,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:38:04.000Z',
        end_time: '2026-07-29T04:39:04.000Z',
        latitude: 37.8165397,
        longitude: -122.4091075,
        density: 10.526315789473683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:38:04.000Z',
        end_time: '2026-07-29T04:39:04.000Z',
        latitude: 37.8165397,
        longitude: -122.4091075,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:38:04.000Z',
        end_time: '2026-07-29T04:39:04.000Z',
        latitude: 37.8165397,
        longitude: -122.4091075,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T04:34:04.000Z',
        end_time: '2026-07-29T04:39:04.000Z',
        latitude: 37.7884,
        longitude: -122.3870833,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:37:04.000Z',
        end_time: '2026-07-29T04:38:04.000Z',
        latitude: 37.8165397,
        longitude: -122.4091075,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:37:04.000Z',
        end_time: '2026-07-29T04:38:04.000Z',
        latitude: 37.8165397,
        longitude: -122.4091075,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:37:04.000Z',
        end_time: '2026-07-29T04:38:04.000Z',
        latitude: 37.8165397,
        longitude: -122.4091075,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:36:04.000Z',
        end_time: '2026-07-29T04:37:04.000Z',
        latitude: 37.7911693,
        longitude: -122.3931772,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:36:04.000Z',
        end_time: '2026-07-29T04:37:04.000Z',
        latitude: 37.7911693,
        longitude: -122.3931772,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:36:04.000Z',
        end_time: '2026-07-29T04:37:04.000Z',
        latitude: 37.7911693,
        longitude: -122.3931772,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:35:04.000Z',
        end_time: '2026-07-29T04:36:04.000Z',
        latitude: 37.7903297,
        longitude: -122.3898605,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:35:04.000Z',
        end_time: '2026-07-29T04:36:04.000Z',
        latitude: 37.7903297,
        longitude: -122.3898605,
        density: 36.60869758445862,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:35:04.000Z',
        end_time: '2026-07-29T04:36:04.000Z',
        latitude: 37.7903297,
        longitude: -122.3898605,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T04:29:04.000Z',
        end_time: '2026-07-29T04:34:04.000Z',
        latitude: 37.788,
        longitude: -122.38685,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:33:04.000Z',
        end_time: '2026-07-29T04:34:04.000Z',
        latitude: 37.7876278,
        longitude: -122.3866513,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:33:04.000Z',
        end_time: '2026-07-29T04:34:04.000Z',
        latitude: 37.7876278,
        longitude: -122.3866513,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:33:04.000Z',
        end_time: '2026-07-29T04:34:04.000Z',
        latitude: 37.7876278,
        longitude: -122.3866513,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T04:29:04.000Z',
        end_time: '2026-07-29T04:34:04.000Z',
        latitude: 37.788,
        longitude: -122.38685,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T04:29:04.000Z',
        end_time: '2026-07-29T04:34:04.000Z',
        latitude: 37.788,
        longitude: -122.38685,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:32:04.000Z',
        end_time: '2026-07-29T04:33:04.000Z',
        latitude: 37.7866847,
        longitude: -122.3858103,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:32:04.000Z',
        end_time: '2026-07-29T04:33:04.000Z',
        latitude: 37.7866847,
        longitude: -122.3858103,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:32:04.000Z',
        end_time: '2026-07-29T04:33:04.000Z',
        latitude: 37.7866847,
        longitude: -122.3858103,
        density: 3.659975904978312,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:31:04.000Z',
        end_time: '2026-07-29T04:32:04.000Z',
        latitude: 37.7812582,
        longitude: -122.381538,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:31:04.000Z',
        end_time: '2026-07-29T04:32:04.000Z',
        latitude: 37.7812582,
        longitude: -122.381538,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:31:04.000Z',
        end_time: '2026-07-29T04:32:04.000Z',
        latitude: 37.7812582,
        longitude: -122.381538,
        density: 7.15139796339416,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:30:04.000Z',
        end_time: '2026-07-29T04:31:04.000Z',
        latitude: 37.7884292,
        longitude: -122.3870655,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:30:04.000Z',
        end_time: '2026-07-29T04:31:04.000Z',
        latitude: 37.7884292,
        longitude: -122.3870655,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:30:04.000Z',
        end_time: '2026-07-29T04:31:04.000Z',
        latitude: 37.7884292,
        longitude: -122.3870655,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:29:04.000Z',
        end_time: '2026-07-29T04:30:04.000Z',
        latitude: 37.7885478,
        longitude: -122.3870802,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:29:04.000Z',
        end_time: '2026-07-29T04:30:04.000Z',
        latitude: 37.7885478,
        longitude: -122.3870802,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:29:04.000Z',
        end_time: '2026-07-29T04:30:04.000Z',
        latitude: 37.7885478,
        longitude: -122.3870802,
        density: 18.15778454828786,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T04:24:04.000Z',
        end_time: '2026-07-29T04:29:04.000Z',
        latitude: 37.7885167,
        longitude: -122.3871,
        density: 8.421052631578947,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T04:24:04.000Z',
        end_time: '2026-07-29T04:29:04.000Z',
        latitude: 37.7885167,
        longitude: -122.3871,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:28:04.000Z',
        end_time: '2026-07-29T04:29:04.000Z',
        latitude: 37.7886152,
        longitude: -122.3868945,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:28:04.000Z',
        end_time: '2026-07-29T04:29:04.000Z',
        latitude: 37.7886152,
        longitude: -122.3868945,
        density: 27.072822505196086,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:28:04.000Z',
        end_time: '2026-07-29T04:29:04.000Z',
        latitude: 37.7886152,
        longitude: -122.3868945,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T04:24:04.000Z',
        end_time: '2026-07-29T04:29:04.000Z',
        latitude: 37.7885167,
        longitude: -122.3871,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:27:04.000Z',
        end_time: '2026-07-29T04:28:04.000Z',
        latitude: 37.7885958,
        longitude: -122.3871728,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:27:04.000Z',
        end_time: '2026-07-29T04:28:04.000Z',
        latitude: 37.7885958,
        longitude: -122.3871728,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:27:04.000Z',
        end_time: '2026-07-29T04:28:04.000Z',
        latitude: 37.7885958,
        longitude: -122.3871728,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:26:04.000Z',
        end_time: '2026-07-29T04:27:04.000Z',
        latitude: 37.7886218,
        longitude: -122.3871348,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:26:04.000Z',
        end_time: '2026-07-29T04:27:04.000Z',
        latitude: 37.7886218,
        longitude: -122.3871348,
        density: 28.707562623754903,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:26:04.000Z',
        end_time: '2026-07-29T04:27:04.000Z',
        latitude: 37.7886218,
        longitude: -122.3871348,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:25:04.000Z',
        end_time: '2026-07-29T04:26:04.000Z',
        latitude: 37.7883915,
        longitude: -122.3871352,
        density: 15.789473684210526,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:25:04.000Z',
        end_time: '2026-07-29T04:26:04.000Z',
        latitude: 37.7883915,
        longitude: -122.3871352,
        density: 17.59257241340282,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:25:04.000Z',
        end_time: '2026-07-29T04:26:04.000Z',
        latitude: 37.7883915,
        longitude: -122.3871352,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:24:04.000Z',
        end_time: '2026-07-29T04:25:04.000Z',
        latitude: 37.7885445,
        longitude: -122.3871165,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:24:04.000Z',
        end_time: '2026-07-29T04:25:04.000Z',
        latitude: 37.7885445,
        longitude: -122.3871165,
        density: 20.326231609590042,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:24:04.000Z',
        end_time: '2026-07-29T04:25:04.000Z',
        latitude: 37.7885445,
        longitude: -122.3871165,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T04:19:04.000Z',
        end_time: '2026-07-29T04:24:04.000Z',
        latitude: 37.7885,
        longitude: -122.3871167,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:23:04.000Z',
        end_time: '2026-07-29T04:24:04.000Z',
        latitude: 37.7884737,
        longitude: -122.3871137,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:23:04.000Z',
        end_time: '2026-07-29T04:24:04.000Z',
        latitude: 37.7884737,
        longitude: -122.3871137,
        density: 14.206537617735023,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:23:04.000Z',
        end_time: '2026-07-29T04:24:04.000Z',
        latitude: 37.7884737,
        longitude: -122.3871137,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T04:19:04.000Z',
        end_time: '2026-07-29T04:24:04.000Z',
        latitude: 37.7885,
        longitude: -122.3871167,
        density: 1.0526315789473684,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T04:19:04.000Z',
        end_time: '2026-07-29T04:24:04.000Z',
        latitude: 37.7885,
        longitude: -122.3871167,
        density: 22.447345969659345,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:22:04.000Z',
        end_time: '2026-07-29T04:23:04.000Z',
        latitude: 37.7886228,
        longitude: -122.3871253,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:22:04.000Z',
        end_time: '2026-07-29T04:23:04.000Z',
        latitude: 37.7886228,
        longitude: -122.3871253,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:22:04.000Z',
        end_time: '2026-07-29T04:23:04.000Z',
        latitude: 37.7886228,
        longitude: -122.3871253,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:21:04.000Z',
        end_time: '2026-07-29T04:22:04.000Z',
        latitude: 37.7885947,
        longitude: -122.387164,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:21:04.000Z',
        end_time: '2026-07-29T04:22:04.000Z',
        latitude: 37.7885947,
        longitude: -122.387164,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:21:04.000Z',
        end_time: '2026-07-29T04:22:04.000Z',
        latitude: 37.7885947,
        longitude: -122.387164,
        density: 2.631784308673404,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:20:04.000Z',
        end_time: '2026-07-29T04:21:04.000Z',
        latitude: 37.7885352,
        longitude: -122.3872088,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:20:04.000Z',
        end_time: '2026-07-29T04:21:04.000Z',
        latitude: 37.7885352,
        longitude: -122.3872088,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:20:04.000Z',
        end_time: '2026-07-29T04:21:04.000Z',
        latitude: 37.7885352,
        longitude: -122.3872088,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:19:04.000Z',
        end_time: '2026-07-29T04:20:04.000Z',
        latitude: 37.7884988,
        longitude: -122.3872187,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:19:04.000Z',
        end_time: '2026-07-29T04:20:04.000Z',
        latitude: 37.7884988,
        longitude: -122.3872187,
        density: 14.368087398558899,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:19:04.000Z',
        end_time: '2026-07-29T04:20:04.000Z',
        latitude: 37.7884988,
        longitude: -122.3872187,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:18:04.000Z',
        end_time: '2026-07-29T04:19:04.000Z',
        latitude: 37.7883958,
        longitude: -122.3870678,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T04:14:04.000Z',
        end_time: '2026-07-29T04:19:04.000Z',
        latitude: 37.7884667,
        longitude: -122.3872,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:18:04.000Z',
        end_time: '2026-07-29T04:19:04.000Z',
        latitude: 37.7883958,
        longitude: -122.3870678,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:18:04.000Z',
        end_time: '2026-07-29T04:19:04.000Z',
        latitude: 37.7883958,
        longitude: -122.3870678,
        density: 29.086162452020112,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T04:14:04.000Z',
        end_time: '2026-07-29T04:19:04.000Z',
        latitude: 37.7884667,
        longitude: -122.3872,
        density: 2.1052631578947367,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T04:14:04.000Z',
        end_time: '2026-07-29T04:19:04.000Z',
        latitude: 37.7884667,
        longitude: -122.3872,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:17:04.000Z',
        end_time: '2026-07-29T04:18:04.000Z',
        latitude: 37.7883932,
        longitude: -122.38715,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:17:04.000Z',
        end_time: '2026-07-29T04:18:04.000Z',
        latitude: 37.7883932,
        longitude: -122.38715,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:17:04.000Z',
        end_time: '2026-07-29T04:18:04.000Z',
        latitude: 37.7883932,
        longitude: -122.38715,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:16:04.000Z',
        end_time: '2026-07-29T04:17:04.000Z',
        latitude: 37.7884048,
        longitude: -122.3872437,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:16:04.000Z',
        end_time: '2026-07-29T04:17:04.000Z',
        latitude: 37.7884048,
        longitude: -122.3872437,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:16:04.000Z',
        end_time: '2026-07-29T04:17:04.000Z',
        latitude: 37.7884048,
        longitude: -122.3872437,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:15:04.000Z',
        end_time: '2026-07-29T04:16:04.000Z',
        latitude: 37.7884177,
        longitude: -122.3871682,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:15:04.000Z',
        end_time: '2026-07-29T04:16:04.000Z',
        latitude: 37.7884177,
        longitude: -122.3871682,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:15:04.000Z',
        end_time: '2026-07-29T04:16:04.000Z',
        latitude: 37.7884177,
        longitude: -122.3871682,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:14:04.000Z',
        end_time: '2026-07-29T04:15:04.000Z',
        latitude: 37.7884435,
        longitude: -122.3870663,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:14:04.000Z',
        end_time: '2026-07-29T04:15:04.000Z',
        latitude: 37.7884435,
        longitude: -122.3870663,
        density: 7.434778523905631,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:14:04.000Z',
        end_time: '2026-07-29T04:15:04.000Z',
        latitude: 37.7884435,
        longitude: -122.3870663,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T04:09:04.000Z',
        end_time: '2026-07-29T04:14:04.000Z',
        latitude: 37.7884167,
        longitude: -122.3870333,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:13:04.000Z',
        end_time: '2026-07-29T04:14:04.000Z',
        latitude: 37.788405,
        longitude: -122.3870477,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:13:04.000Z',
        end_time: '2026-07-29T04:14:04.000Z',
        latitude: 37.788405,
        longitude: -122.3870477,
        density: 27.381345594401004,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:13:04.000Z',
        end_time: '2026-07-29T04:14:04.000Z',
        latitude: 37.788405,
        longitude: -122.3870477,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T04:09:04.000Z',
        end_time: '2026-07-29T04:14:04.000Z',
        latitude: 37.7884167,
        longitude: -122.3870333,
        density: 0.5263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T04:09:04.000Z',
        end_time: '2026-07-29T04:14:04.000Z',
        latitude: 37.7884167,
        longitude: -122.3870333,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:12:04.000Z',
        end_time: '2026-07-29T04:13:04.000Z',
        latitude: 37.7884383,
        longitude: -122.3871278,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:12:04.000Z',
        end_time: '2026-07-29T04:13:04.000Z',
        latitude: 37.7884383,
        longitude: -122.3871278,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:12:04.000Z',
        end_time: '2026-07-29T04:13:04.000Z',
        latitude: 37.7884383,
        longitude: -122.3871278,
        density: 24.967268080163496,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:11:04.000Z',
        end_time: '2026-07-29T04:12:04.000Z',
        latitude: 37.7884662,
        longitude: -122.38712,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:11:04.000Z',
        end_time: '2026-07-29T04:12:04.000Z',
        latitude: 37.7884662,
        longitude: -122.38712,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:11:04.000Z',
        end_time: '2026-07-29T04:12:04.000Z',
        latitude: 37.7884662,
        longitude: -122.38712,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:10:04.000Z',
        end_time: '2026-07-29T04:11:04.000Z',
        latitude: 37.7884915,
        longitude: -122.3871102,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:10:04.000Z',
        end_time: '2026-07-29T04:11:04.000Z',
        latitude: 37.7884915,
        longitude: -122.3871102,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:10:04.000Z',
        end_time: '2026-07-29T04:11:04.000Z',
        latitude: 37.7884915,
        longitude: -122.3871102,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:09:04.000Z',
        end_time: '2026-07-29T04:10:04.000Z',
        latitude: 37.7885108,
        longitude: -122.3872202,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:09:04.000Z',
        end_time: '2026-07-29T04:10:04.000Z',
        latitude: 37.7885108,
        longitude: -122.3872202,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:09:04.000Z',
        end_time: '2026-07-29T04:10:04.000Z',
        latitude: 37.7885108,
        longitude: -122.3872202,
        density: 11.847607150351521,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T04:04:04.000Z',
        end_time: '2026-07-29T04:09:04.000Z',
        latitude: 37.7884833,
        longitude: -122.38725,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T04:04:04.000Z',
        end_time: '2026-07-29T04:09:04.000Z',
        latitude: 37.7884833,
        longitude: -122.38725,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:08:04.000Z',
        end_time: '2026-07-29T04:09:04.000Z',
        latitude: 37.788469,
        longitude: -122.3870608,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:08:04.000Z',
        end_time: '2026-07-29T04:09:04.000Z',
        latitude: 37.788469,
        longitude: -122.3870608,
        density: 38.783471239326346,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:08:04.000Z',
        end_time: '2026-07-29T04:09:04.000Z',
        latitude: 37.788469,
        longitude: -122.3870608,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T04:04:04.000Z',
        end_time: '2026-07-29T04:09:04.000Z',
        latitude: 37.7884833,
        longitude: -122.38725,
        density: 1.0526315789473684,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:07:04.000Z',
        end_time: '2026-07-29T04:08:04.000Z',
        latitude: 37.788465,
        longitude: -122.3871025,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:07:04.000Z',
        end_time: '2026-07-29T04:08:04.000Z',
        latitude: 37.788465,
        longitude: -122.3871025,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:07:04.000Z',
        end_time: '2026-07-29T04:08:04.000Z',
        latitude: 37.788465,
        longitude: -122.3871025,
        density: 13.427669845169511,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:06:04.000Z',
        end_time: '2026-07-29T04:07:04.000Z',
        latitude: 37.7884107,
        longitude: -122.3869265,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:06:04.000Z',
        end_time: '2026-07-29T04:07:04.000Z',
        latitude: 37.7884107,
        longitude: -122.3869265,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:06:04.000Z',
        end_time: '2026-07-29T04:07:04.000Z',
        latitude: 37.7884107,
        longitude: -122.3869265,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:05:04.000Z',
        end_time: '2026-07-29T04:06:04.000Z',
        latitude: 37.7884138,
        longitude: -122.3871558,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:05:04.000Z',
        end_time: '2026-07-29T04:06:04.000Z',
        latitude: 37.7884138,
        longitude: -122.3871558,
        density: 29.989760270346007,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:05:04.000Z',
        end_time: '2026-07-29T04:06:04.000Z',
        latitude: 37.7884138,
        longitude: -122.3871558,
        density: 2.631578947368421,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:04:04.000Z',
        end_time: '2026-07-29T04:05:04.000Z',
        latitude: 37.7884195,
        longitude: -122.3871205,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:04:04.000Z',
        end_time: '2026-07-29T04:05:04.000Z',
        latitude: 37.7884195,
        longitude: -122.3871205,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:04:04.000Z',
        end_time: '2026-07-29T04:05:04.000Z',
        latitude: 37.7884195,
        longitude: -122.3871205,
        density: 2.631578947368421,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T03:59:04.000Z',
        end_time: '2026-07-29T04:04:04.000Z',
        latitude: 37.7884333,
        longitude: -122.3870833,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:03:04.000Z',
        end_time: '2026-07-29T04:04:04.000Z',
        latitude: 37.7884505,
        longitude: -122.3870277,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:03:04.000Z',
        end_time: '2026-07-29T04:04:04.000Z',
        latitude: 37.7884505,
        longitude: -122.3870277,
        density: 3.37487718203465,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:03:04.000Z',
        end_time: '2026-07-29T04:04:04.000Z',
        latitude: 37.7884505,
        longitude: -122.3870277,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T03:59:04.000Z',
        end_time: '2026-07-29T04:04:04.000Z',
        latitude: 37.7884333,
        longitude: -122.3870833,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T03:59:04.000Z',
        end_time: '2026-07-29T04:04:04.000Z',
        latitude: 37.7884333,
        longitude: -122.3870833,
        density: 8.249497588767367,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:02:04.000Z',
        end_time: '2026-07-29T04:03:04.000Z',
        latitude: 37.7884213,
        longitude: -122.387044,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:02:04.000Z',
        end_time: '2026-07-29T04:03:04.000Z',
        latitude: 37.7884213,
        longitude: -122.387044,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:02:04.000Z',
        end_time: '2026-07-29T04:03:04.000Z',
        latitude: 37.7884213,
        longitude: -122.387044,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:01:04.000Z',
        end_time: '2026-07-29T04:02:04.000Z',
        latitude: 37.7884765,
        longitude: -122.3871157,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:01:04.000Z',
        end_time: '2026-07-29T04:02:04.000Z',
        latitude: 37.7884765,
        longitude: -122.3871157,
        density: 8.873122818519864,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:01:04.000Z',
        end_time: '2026-07-29T04:02:04.000Z',
        latitude: 37.7884765,
        longitude: -122.3871157,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T04:00:04.000Z',
        end_time: '2026-07-29T04:01:04.000Z',
        latitude: 37.7884792,
        longitude: -122.3869652,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T04:00:04.000Z',
        end_time: '2026-07-29T04:01:04.000Z',
        latitude: 37.7884792,
        longitude: -122.3869652,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T04:00:04.000Z',
        end_time: '2026-07-29T04:01:04.000Z',
        latitude: 37.7884792,
        longitude: -122.3869652,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:59:04.000Z',
        end_time: '2026-07-29T04:00:04.000Z',
        latitude: 37.7883908,
        longitude: -122.3870938,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:59:04.000Z',
        end_time: '2026-07-29T04:00:04.000Z',
        latitude: 37.7883908,
        longitude: -122.3870938,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:59:04.000Z',
        end_time: '2026-07-29T04:00:04.000Z',
        latitude: 37.7883908,
        longitude: -122.3870938,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T03:54:04.000Z',
        end_time: '2026-07-29T03:59:04.000Z',
        latitude: 37.78835,
        longitude: -122.38715,
        density: 0.5263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T03:54:04.000Z',
        end_time: '2026-07-29T03:59:04.000Z',
        latitude: 37.78835,
        longitude: -122.38715,
        density: 0.2955920839972831,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:58:04.000Z',
        end_time: '2026-07-29T03:59:04.000Z',
        latitude: 37.7883287,
        longitude: -122.3872108,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:58:04.000Z',
        end_time: '2026-07-29T03:59:04.000Z',
        latitude: 37.7883287,
        longitude: -122.3872108,
        density: 22.04976279169997,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:58:04.000Z',
        end_time: '2026-07-29T03:59:04.000Z',
        latitude: 37.7883287,
        longitude: -122.3872108,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T03:54:04.000Z',
        end_time: '2026-07-29T03:59:04.000Z',
        latitude: 37.78835,
        longitude: -122.38715,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:57:04.000Z',
        end_time: '2026-07-29T03:58:04.000Z',
        latitude: 37.7883837,
        longitude: -122.3871312,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:57:04.000Z',
        end_time: '2026-07-29T03:58:04.000Z',
        latitude: 37.7883837,
        longitude: -122.3871312,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:57:04.000Z',
        end_time: '2026-07-29T03:58:04.000Z',
        latitude: 37.7883837,
        longitude: -122.3871312,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:56:04.000Z',
        end_time: '2026-07-29T03:57:04.000Z',
        latitude: 37.7884803,
        longitude: -122.3870988,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:56:04.000Z',
        end_time: '2026-07-29T03:57:04.000Z',
        latitude: 37.7884803,
        longitude: -122.3870988,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:56:04.000Z',
        end_time: '2026-07-29T03:57:04.000Z',
        latitude: 37.7884803,
        longitude: -122.3870988,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:55:04.000Z',
        end_time: '2026-07-29T03:56:04.000Z',
        latitude: 37.7884822,
        longitude: -122.3871123,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:55:04.000Z',
        end_time: '2026-07-29T03:56:04.000Z',
        latitude: 37.7884822,
        longitude: -122.3871123,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:55:04.000Z',
        end_time: '2026-07-29T03:56:04.000Z',
        latitude: 37.7884822,
        longitude: -122.3871123,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:54:04.000Z',
        end_time: '2026-07-29T03:55:04.000Z',
        latitude: 37.7884,
        longitude: -122.3871665,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:54:04.000Z',
        end_time: '2026-07-29T03:55:04.000Z',
        latitude: 37.7884,
        longitude: -122.3871665,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:54:04.000Z',
        end_time: '2026-07-29T03:55:04.000Z',
        latitude: 37.7884,
        longitude: -122.3871665,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:53:04.000Z',
        end_time: '2026-07-29T03:54:04.000Z',
        latitude: 37.7863865,
        longitude: -122.3897928,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T03:49:04.000Z',
        end_time: '2026-07-29T03:54:04.000Z',
        latitude: 37.7884333,
        longitude: -122.3870833,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:53:04.000Z',
        end_time: '2026-07-29T03:54:04.000Z',
        latitude: 37.7863865,
        longitude: -122.3897928,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:53:04.000Z',
        end_time: '2026-07-29T03:54:04.000Z',
        latitude: 37.7863865,
        longitude: -122.3897928,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T03:49:04.000Z',
        end_time: '2026-07-29T03:54:04.000Z',
        latitude: 37.7884333,
        longitude: -122.3870833,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T03:49:04.000Z',
        end_time: '2026-07-29T03:54:04.000Z',
        latitude: 37.7884333,
        longitude: -122.3870833,
        density: 6.132014130987571,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:52:04.000Z',
        end_time: '2026-07-29T03:53:04.000Z',
        latitude: 37.7884623,
        longitude: -122.3870982,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:52:04.000Z',
        end_time: '2026-07-29T03:53:04.000Z',
        latitude: 37.7884623,
        longitude: -122.3870982,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:52:04.000Z',
        end_time: '2026-07-29T03:53:04.000Z',
        latitude: 37.7884623,
        longitude: -122.3870982,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:51:04.000Z',
        end_time: '2026-07-29T03:52:04.000Z',
        latitude: 37.7866533,
        longitude: -122.38991,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:51:04.000Z',
        end_time: '2026-07-29T03:52:04.000Z',
        latitude: 37.7866533,
        longitude: -122.38991,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:51:04.000Z',
        end_time: '2026-07-29T03:52:04.000Z',
        latitude: 37.7866533,
        longitude: -122.38991,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:50:04.000Z',
        end_time: '2026-07-29T03:51:04.000Z',
        latitude: 37.7885347,
        longitude: -122.3873087,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:50:04.000Z',
        end_time: '2026-07-29T03:51:04.000Z',
        latitude: 37.7885347,
        longitude: -122.3873087,
        density: 3.511180878925564,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:50:04.000Z',
        end_time: '2026-07-29T03:51:04.000Z',
        latitude: 37.7885347,
        longitude: -122.3873087,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:49:04.000Z',
        end_time: '2026-07-29T03:50:04.000Z',
        latitude: 37.7884638,
        longitude: -122.3871743,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:49:04.000Z',
        end_time: '2026-07-29T03:50:04.000Z',
        latitude: 37.7884638,
        longitude: -122.3871743,
        density: 8.540056293148574,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:49:04.000Z',
        end_time: '2026-07-29T03:50:04.000Z',
        latitude: 37.7884638,
        longitude: -122.3871743,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T03:44:04.000Z',
        end_time: '2026-07-29T03:49:04.000Z',
        latitude: 37.7886167,
        longitude: -122.3870167,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T03:44:04.000Z',
        end_time: '2026-07-29T03:49:04.000Z',
        latitude: 37.7886167,
        longitude: -122.3870167,
        density: 31.225063058175426,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:48:04.000Z',
        end_time: '2026-07-29T03:49:04.000Z',
        latitude: 37.7885805,
        longitude: -122.3869287,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:48:04.000Z',
        end_time: '2026-07-29T03:49:04.000Z',
        latitude: 37.7885805,
        longitude: -122.3869287,
        density: 29.37077256492477,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:48:04.000Z',
        end_time: '2026-07-29T03:49:04.000Z',
        latitude: 37.7885805,
        longitude: -122.3869287,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T03:44:04.000Z',
        end_time: '2026-07-29T03:49:04.000Z',
        latitude: 37.7886167,
        longitude: -122.3870167,
        density: 0.5263157894736842,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:47:04.000Z',
        end_time: '2026-07-29T03:48:04.000Z',
        latitude: 37.7888205,
        longitude: -122.386606,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:47:04.000Z',
        end_time: '2026-07-29T03:48:04.000Z',
        latitude: 37.7888205,
        longitude: -122.386606,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:47:04.000Z',
        end_time: '2026-07-29T03:48:04.000Z',
        latitude: 37.7888205,
        longitude: -122.386606,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:46:04.000Z',
        end_time: '2026-07-29T03:47:04.000Z',
        latitude: 37.7883888,
        longitude: -122.3875088,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:46:04.000Z',
        end_time: '2026-07-29T03:47:04.000Z',
        latitude: 37.7883888,
        longitude: -122.3875088,
        density: 21.353259440975886,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:46:04.000Z',
        end_time: '2026-07-29T03:47:04.000Z',
        latitude: 37.7883888,
        longitude: -122.3875088,
        density: 2.631578947368421,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:45:04.000Z',
        end_time: '2026-07-29T03:46:04.000Z',
        latitude: 37.7884593,
        longitude: -122.3871065,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:45:04.000Z',
        end_time: '2026-07-29T03:46:04.000Z',
        latitude: 37.7884593,
        longitude: -122.3871065,
        density: 14.867108952926342,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:45:04.000Z',
        end_time: '2026-07-29T03:46:04.000Z',
        latitude: 37.7884593,
        longitude: -122.3871065,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T03:39:04.000Z',
        end_time: '2026-07-29T03:44:04.000Z',
        latitude: 37.7884167,
        longitude: -122.38715,
        density: 1.0526315789473684,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T03:39:04.000Z',
        end_time: '2026-07-29T03:44:04.000Z',
        latitude: 37.7884167,
        longitude: -122.38715,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:43:04.000Z',
        end_time: '2026-07-29T03:44:04.000Z',
        latitude: 37.7884547,
        longitude: -122.3871687,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:43:04.000Z',
        end_time: '2026-07-29T03:44:04.000Z',
        latitude: 37.7884547,
        longitude: -122.3871687,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:43:04.000Z',
        end_time: '2026-07-29T03:44:04.000Z',
        latitude: 37.7884547,
        longitude: -122.3871687,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T03:39:04.000Z',
        end_time: '2026-07-29T03:44:04.000Z',
        latitude: 37.7884167,
        longitude: -122.38715,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:42:04.000Z',
        end_time: '2026-07-29T03:43:04.000Z',
        latitude: 37.7884813,
        longitude: -122.3872737,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:42:04.000Z',
        end_time: '2026-07-29T03:43:04.000Z',
        latitude: 37.7884813,
        longitude: -122.3872737,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:42:04.000Z',
        end_time: '2026-07-29T03:43:04.000Z',
        latitude: 37.7884813,
        longitude: -122.3872737,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:41:04.000Z',
        end_time: '2026-07-29T03:42:04.000Z',
        latitude: 37.788423,
        longitude: -122.3872082,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:41:04.000Z',
        end_time: '2026-07-29T03:42:04.000Z',
        latitude: 37.788423,
        longitude: -122.3872082,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:41:04.000Z',
        end_time: '2026-07-29T03:42:04.000Z',
        latitude: 37.788423,
        longitude: -122.3872082,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:40:04.000Z',
        end_time: '2026-07-29T03:41:04.000Z',
        latitude: 37.788414,
        longitude: -122.3871012,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:40:04.000Z',
        end_time: '2026-07-29T03:41:04.000Z',
        latitude: 37.788414,
        longitude: -122.3871012,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:40:04.000Z',
        end_time: '2026-07-29T03:41:04.000Z',
        latitude: 37.788414,
        longitude: -122.3871012,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T03:34:05.000Z',
        end_time: '2026-07-29T03:39:05.000Z',
        latitude: 37.7884333,
        longitude: -122.3870167,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T03:34:05.000Z',
        end_time: '2026-07-29T03:39:05.000Z',
        latitude: 37.7884333,
        longitude: -122.3870167,
        density: 0.5263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T03:34:05.000Z',
        end_time: '2026-07-29T03:39:05.000Z',
        latitude: 37.7884333,
        longitude: -122.3870167,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:38:04.000Z',
        end_time: '2026-07-29T03:39:04.000Z',
        latitude: 37.7884347,
        longitude: -122.3870465,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:38:04.000Z',
        end_time: '2026-07-29T03:39:04.000Z',
        latitude: 37.7884347,
        longitude: -122.3870465,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:38:04.000Z',
        end_time: '2026-07-29T03:39:04.000Z',
        latitude: 37.7884347,
        longitude: -122.3870465,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:37:05.000Z',
        end_time: '2026-07-29T03:38:05.000Z',
        latitude: 37.7883955,
        longitude: -122.3870923,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:37:05.000Z',
        end_time: '2026-07-29T03:38:05.000Z',
        latitude: 37.7883955,
        longitude: -122.3870923,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:37:05.000Z',
        end_time: '2026-07-29T03:38:05.000Z',
        latitude: 37.7883955,
        longitude: -122.3870923,
        density: 10.244528558226364,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:36:05.000Z',
        end_time: '2026-07-29T03:37:05.000Z',
        latitude: 37.7883693,
        longitude: -122.3871207,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:36:05.000Z',
        end_time: '2026-07-29T03:37:05.000Z',
        latitude: 37.7883693,
        longitude: -122.3871207,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:36:05.000Z',
        end_time: '2026-07-29T03:37:05.000Z',
        latitude: 37.7883693,
        longitude: -122.3871207,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:35:05.000Z',
        end_time: '2026-07-29T03:36:05.000Z',
        latitude: 37.788395,
        longitude: -122.3871965,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:35:05.000Z',
        end_time: '2026-07-29T03:36:05.000Z',
        latitude: 37.788395,
        longitude: -122.3871965,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:35:05.000Z',
        end_time: '2026-07-29T03:36:05.000Z',
        latitude: 37.788395,
        longitude: -122.3871965,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T03:29:05.000Z',
        end_time: '2026-07-29T03:34:05.000Z',
        latitude: 37.7884333,
        longitude: -122.38775,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T03:29:05.000Z',
        end_time: '2026-07-29T03:34:05.000Z',
        latitude: 37.7884333,
        longitude: -122.38775,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:33:05.000Z',
        end_time: '2026-07-29T03:34:05.000Z',
        latitude: 37.7884442,
        longitude: -122.3873938,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:33:05.000Z',
        end_time: '2026-07-29T03:34:05.000Z',
        latitude: 37.7884442,
        longitude: -122.3873938,
        density: 6.873103735496269,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:33:05.000Z',
        end_time: '2026-07-29T03:34:05.000Z',
        latitude: 37.7884442,
        longitude: -122.3873938,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T03:29:05.000Z',
        end_time: '2026-07-29T03:34:05.000Z',
        latitude: 37.7884333,
        longitude: -122.38775,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:32:05.000Z',
        end_time: '2026-07-29T03:33:05.000Z',
        latitude: 37.7884333,
        longitude: -122.3869747,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:32:05.000Z',
        end_time: '2026-07-29T03:33:05.000Z',
        latitude: 37.7884333,
        longitude: -122.3869747,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:32:05.000Z',
        end_time: '2026-07-29T03:33:05.000Z',
        latitude: 37.7884333,
        longitude: -122.3869747,
        density: 14.058490191771277,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:31:05.000Z',
        end_time: '2026-07-29T03:32:05.000Z',
        latitude: 37.7885018,
        longitude: -122.3872735,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:31:05.000Z',
        end_time: '2026-07-29T03:32:05.000Z',
        latitude: 37.7885018,
        longitude: -122.3872735,
        density: 29.945939893540185,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:31:05.000Z',
        end_time: '2026-07-29T03:32:05.000Z',
        latitude: 37.7885018,
        longitude: -122.3872735,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:30:05.000Z',
        end_time: '2026-07-29T03:31:05.000Z',
        latitude: 37.7883597,
        longitude: -122.3873768,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:30:05.000Z',
        end_time: '2026-07-29T03:31:05.000Z',
        latitude: 37.7883597,
        longitude: -122.3873768,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:30:05.000Z',
        end_time: '2026-07-29T03:31:05.000Z',
        latitude: 37.7883597,
        longitude: -122.3873768,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T03:24:05.000Z',
        end_time: '2026-07-29T03:29:05.000Z',
        latitude: 37.7885,
        longitude: -122.38705,
        density: 2.1052631578947367,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T03:24:05.000Z',
        end_time: '2026-07-29T03:29:05.000Z',
        latitude: 37.7885,
        longitude: -122.38705,
        density: 16.194816107507396,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T03:24:05.000Z',
        end_time: '2026-07-29T03:29:05.000Z',
        latitude: 37.7885,
        longitude: -122.38705,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:28:05.000Z',
        end_time: '2026-07-29T03:29:05.000Z',
        latitude: 37.7884648,
        longitude: -122.3870852,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:28:05.000Z',
        end_time: '2026-07-29T03:29:05.000Z',
        latitude: 37.7884648,
        longitude: -122.3870852,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:28:05.000Z',
        end_time: '2026-07-29T03:29:05.000Z',
        latitude: 37.7884648,
        longitude: -122.3870852,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:27:05.000Z',
        end_time: '2026-07-29T03:28:05.000Z',
        latitude: 37.7884933,
        longitude: -122.3870197,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:27:05.000Z',
        end_time: '2026-07-29T03:28:05.000Z',
        latitude: 37.7884933,
        longitude: -122.3870197,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:27:05.000Z',
        end_time: '2026-07-29T03:28:05.000Z',
        latitude: 37.7884933,
        longitude: -122.3870197,
        density: 16.071396248110506,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:26:05.000Z',
        end_time: '2026-07-29T03:27:05.000Z',
        latitude: 37.7884878,
        longitude: -122.3869155,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:26:05.000Z',
        end_time: '2026-07-29T03:27:05.000Z',
        latitude: 37.7884878,
        longitude: -122.3869155,
        density: 33.97815301755766,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:26:05.000Z',
        end_time: '2026-07-29T03:27:05.000Z',
        latitude: 37.7884878,
        longitude: -122.3869155,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:25:05.000Z',
        end_time: '2026-07-29T03:26:05.000Z',
        latitude: 37.7884518,
        longitude: -122.3870975,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:25:05.000Z',
        end_time: '2026-07-29T03:26:05.000Z',
        latitude: 37.7884518,
        longitude: -122.3870975,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:25:05.000Z',
        end_time: '2026-07-29T03:26:05.000Z',
        latitude: 37.7884518,
        longitude: -122.3870975,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:24:05.000Z',
        end_time: '2026-07-29T03:25:05.000Z',
        latitude: 37.788495,
        longitude: -122.3870698,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:24:05.000Z',
        end_time: '2026-07-29T03:25:05.000Z',
        latitude: 37.788495,
        longitude: -122.3870698,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:24:05.000Z',
        end_time: '2026-07-29T03:25:05.000Z',
        latitude: 37.788495,
        longitude: -122.3870698,
        density: 28.694300947558617,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T03:19:05.000Z',
        end_time: '2026-07-29T03:24:05.000Z',
        latitude: 37.7884833,
        longitude: -122.3870667,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:23:05.000Z',
        end_time: '2026-07-29T03:24:05.000Z',
        latitude: 37.7884873,
        longitude: -122.3871133,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:23:05.000Z',
        end_time: '2026-07-29T03:24:05.000Z',
        latitude: 37.7884873,
        longitude: -122.3871133,
        density: 4.086959214320589,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:23:05.000Z',
        end_time: '2026-07-29T03:24:05.000Z',
        latitude: 37.7884873,
        longitude: -122.3871133,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T03:19:05.000Z',
        end_time: '2026-07-29T03:24:05.000Z',
        latitude: 37.7884833,
        longitude: -122.3870667,
        density: 1.0526315789473684,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T03:19:05.000Z',
        end_time: '2026-07-29T03:24:05.000Z',
        latitude: 37.7884833,
        longitude: -122.3870667,
        density: 22.3164168719797,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:22:05.000Z',
        end_time: '2026-07-29T03:23:05.000Z',
        latitude: 37.7884097,
        longitude: -122.3871182,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:22:05.000Z',
        end_time: '2026-07-29T03:23:05.000Z',
        latitude: 37.7884097,
        longitude: -122.3871182,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:22:05.000Z',
        end_time: '2026-07-29T03:23:05.000Z',
        latitude: 37.7884097,
        longitude: -122.3871182,
        density: 17.71020055797541,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:21:05.000Z',
        end_time: '2026-07-29T03:22:05.000Z',
        latitude: 37.7884322,
        longitude: -122.3870522,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:21:05.000Z',
        end_time: '2026-07-29T03:22:05.000Z',
        latitude: 37.7884322,
        longitude: -122.3870522,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:21:05.000Z',
        end_time: '2026-07-29T03:22:05.000Z',
        latitude: 37.7884322,
        longitude: -122.3870522,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:20:05.000Z',
        end_time: '2026-07-29T03:21:05.000Z',
        latitude: 37.7884422,
        longitude: -122.3870343,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:20:05.000Z',
        end_time: '2026-07-29T03:21:05.000Z',
        latitude: 37.7884422,
        longitude: -122.3870343,
        density: 4.707194826803503,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:20:05.000Z',
        end_time: '2026-07-29T03:21:05.000Z',
        latitude: 37.7884422,
        longitude: -122.3870343,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T03:14:05.000Z',
        end_time: '2026-07-29T03:19:05.000Z',
        latitude: 37.7884167,
        longitude: -122.3870833,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T03:14:05.000Z',
        end_time: '2026-07-29T03:19:05.000Z',
        latitude: 37.7884167,
        longitude: -122.3870833,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:18:05.000Z',
        end_time: '2026-07-29T03:19:05.000Z',
        latitude: 37.7884457,
        longitude: -122.387101,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:18:05.000Z',
        end_time: '2026-07-29T03:19:05.000Z',
        latitude: 37.7884457,
        longitude: -122.387101,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:18:05.000Z',
        end_time: '2026-07-29T03:19:05.000Z',
        latitude: 37.7884457,
        longitude: -122.387101,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T03:14:05.000Z',
        end_time: '2026-07-29T03:19:05.000Z',
        latitude: 37.7884167,
        longitude: -122.3870833,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:17:05.000Z',
        end_time: '2026-07-29T03:18:05.000Z',
        latitude: 37.7884373,
        longitude: -122.3871122,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:17:05.000Z',
        end_time: '2026-07-29T03:18:05.000Z',
        latitude: 37.7884373,
        longitude: -122.3871122,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:17:05.000Z',
        end_time: '2026-07-29T03:18:05.000Z',
        latitude: 37.7884373,
        longitude: -122.3871122,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:16:05.000Z',
        end_time: '2026-07-29T03:17:05.000Z',
        latitude: 37.7884845,
        longitude: -122.3870692,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:16:05.000Z',
        end_time: '2026-07-29T03:17:05.000Z',
        latitude: 37.7884845,
        longitude: -122.3870692,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:16:05.000Z',
        end_time: '2026-07-29T03:17:05.000Z',
        latitude: 37.7884845,
        longitude: -122.3870692,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:15:05.000Z',
        end_time: '2026-07-29T03:16:05.000Z',
        latitude: 37.7885558,
        longitude: -122.3868707,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:15:05.000Z',
        end_time: '2026-07-29T03:16:05.000Z',
        latitude: 37.7885558,
        longitude: -122.3868707,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:15:05.000Z',
        end_time: '2026-07-29T03:16:05.000Z',
        latitude: 37.7885558,
        longitude: -122.3868707,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:14:05.000Z',
        end_time: '2026-07-29T03:15:05.000Z',
        latitude: 37.7885307,
        longitude: -122.3869622,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:14:05.000Z',
        end_time: '2026-07-29T03:15:05.000Z',
        latitude: 37.7885307,
        longitude: -122.3869622,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:14:05.000Z',
        end_time: '2026-07-29T03:15:05.000Z',
        latitude: 37.7885307,
        longitude: -122.3869622,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T03:09:05.000Z',
        end_time: '2026-07-29T03:14:05.000Z',
        latitude: 37.7885167,
        longitude: -122.38695,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T03:09:05.000Z',
        end_time: '2026-07-29T03:14:05.000Z',
        latitude: 37.7885167,
        longitude: -122.38695,
        density: 20.23931232548894,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:13:05.000Z',
        end_time: '2026-07-29T03:14:05.000Z',
        latitude: 37.7884845,
        longitude: -122.3870813,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:13:05.000Z',
        end_time: '2026-07-29T03:14:05.000Z',
        latitude: 37.7884845,
        longitude: -122.3870813,
        density: 3.0513694192034446,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:13:05.000Z',
        end_time: '2026-07-29T03:14:05.000Z',
        latitude: 37.7884845,
        longitude: -122.3870813,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T03:09:05.000Z',
        end_time: '2026-07-29T03:14:05.000Z',
        latitude: 37.7885167,
        longitude: -122.38695,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:12:05.000Z',
        end_time: '2026-07-29T03:13:05.000Z',
        latitude: 37.788312,
        longitude: -122.3871802,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:12:05.000Z',
        end_time: '2026-07-29T03:13:05.000Z',
        latitude: 37.788312,
        longitude: -122.3871802,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:12:05.000Z',
        end_time: '2026-07-29T03:13:05.000Z',
        latitude: 37.788312,
        longitude: -122.3871802,
        density: 5.628452991119848,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:11:05.000Z',
        end_time: '2026-07-29T03:12:05.000Z',
        latitude: 37.7884015,
        longitude: -122.3870028,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:11:05.000Z',
        end_time: '2026-07-29T03:12:05.000Z',
        latitude: 37.7884015,
        longitude: -122.3870028,
        density: 15.709718484440112,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:11:05.000Z',
        end_time: '2026-07-29T03:12:05.000Z',
        latitude: 37.7884015,
        longitude: -122.3870028,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:10:05.000Z',
        end_time: '2026-07-29T03:11:05.000Z',
        latitude: 37.7884628,
        longitude: -122.3870308,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:10:05.000Z',
        end_time: '2026-07-29T03:11:05.000Z',
        latitude: 37.7884628,
        longitude: -122.3870308,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:10:05.000Z',
        end_time: '2026-07-29T03:11:05.000Z',
        latitude: 37.7884628,
        longitude: -122.3870308,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:09:05.000Z',
        end_time: '2026-07-29T03:10:05.000Z',
        latitude: 37.7885097,
        longitude: -122.3870567,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:09:05.000Z',
        end_time: '2026-07-29T03:10:05.000Z',
        latitude: 37.7885097,
        longitude: -122.3870567,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:09:05.000Z',
        end_time: '2026-07-29T03:10:05.000Z',
        latitude: 37.7885097,
        longitude: -122.3870567,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:08:05.000Z',
        end_time: '2026-07-29T03:09:05.000Z',
        latitude: 37.7864067,
        longitude: -122.3916043,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:08:05.000Z',
        end_time: '2026-07-29T03:09:05.000Z',
        latitude: 37.7864067,
        longitude: -122.3916043,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:08:05.000Z',
        end_time: '2026-07-29T03:09:05.000Z',
        latitude: 37.7864067,
        longitude: -122.3916043,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T03:04:05.000Z',
        end_time: '2026-07-29T03:09:05.000Z',
        latitude: 37.7885,
        longitude: -122.3870167,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T03:04:05.000Z',
        end_time: '2026-07-29T03:09:05.000Z',
        latitude: 37.7885,
        longitude: -122.3870167,
        density: 19.535493146956952,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T03:04:05.000Z',
        end_time: '2026-07-29T03:09:05.000Z',
        latitude: 37.7885,
        longitude: -122.3870167,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:07:05.000Z',
        end_time: '2026-07-29T03:08:05.000Z',
        latitude: 37.7864067,
        longitude: -122.3916043,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:07:05.000Z',
        end_time: '2026-07-29T03:08:05.000Z',
        latitude: 37.7864067,
        longitude: -122.3916043,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:07:05.000Z',
        end_time: '2026-07-29T03:08:05.000Z',
        latitude: 37.7864067,
        longitude: -122.3916043,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:06:05.000Z',
        end_time: '2026-07-29T03:07:05.000Z',
        latitude: 37.7864067,
        longitude: -122.3916043,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:06:05.000Z',
        end_time: '2026-07-29T03:07:05.000Z',
        latitude: 37.7864067,
        longitude: -122.3916043,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:06:05.000Z',
        end_time: '2026-07-29T03:07:05.000Z',
        latitude: 37.7864067,
        longitude: -122.3916043,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:05:05.000Z',
        end_time: '2026-07-29T03:06:05.000Z',
        latitude: 37.7864067,
        longitude: -122.3916043,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:05:05.000Z',
        end_time: '2026-07-29T03:06:05.000Z',
        latitude: 37.7864067,
        longitude: -122.3916043,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:05:05.000Z',
        end_time: '2026-07-29T03:06:05.000Z',
        latitude: 37.7864067,
        longitude: -122.3916043,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:04:05.000Z',
        end_time: '2026-07-29T03:05:05.000Z',
        latitude: 37.7924092,
        longitude: -122.3748287,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:04:05.000Z',
        end_time: '2026-07-29T03:05:05.000Z',
        latitude: 37.7924092,
        longitude: -122.3748287,
        density: 20.28019423796637,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:04:05.000Z',
        end_time: '2026-07-29T03:05:05.000Z',
        latitude: 37.7924092,
        longitude: -122.3748287,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:03:05.000Z',
        end_time: '2026-07-29T03:04:05.000Z',
        latitude: 37.789945,
        longitude: -122.3863927,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T02:59:05.000Z',
        end_time: '2026-07-29T03:04:05.000Z',
        latitude: 37.7924,
        longitude: -122.3748167,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:03:05.000Z',
        end_time: '2026-07-29T03:04:05.000Z',
        latitude: 37.789945,
        longitude: -122.3863927,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:03:05.000Z',
        end_time: '2026-07-29T03:04:05.000Z',
        latitude: 37.789945,
        longitude: -122.3863927,
        density: 6.148369333912176,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T02:59:05.000Z',
        end_time: '2026-07-29T03:04:05.000Z',
        latitude: 37.7924,
        longitude: -122.3748167,
        density: 4.2105263157894735,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T02:59:05.000Z',
        end_time: '2026-07-29T03:04:05.000Z',
        latitude: 37.7924,
        longitude: -122.3748167,
        density: 31.203095870209843,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:02:05.000Z',
        end_time: '2026-07-29T03:03:05.000Z',
        latitude: 37.7885037,
        longitude: -122.3871107,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:02:05.000Z',
        end_time: '2026-07-29T03:03:05.000Z',
        latitude: 37.7885037,
        longitude: -122.3871107,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:02:05.000Z',
        end_time: '2026-07-29T03:03:05.000Z',
        latitude: 37.7885037,
        longitude: -122.3871107,
        density: 13.558811066504603,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:01:05.000Z',
        end_time: '2026-07-29T03:02:05.000Z',
        latitude: 37.7884433,
        longitude: -122.3871918,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:01:05.000Z',
        end_time: '2026-07-29T03:02:05.000Z',
        latitude: 37.7884433,
        longitude: -122.3871918,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:01:05.000Z',
        end_time: '2026-07-29T03:02:05.000Z',
        latitude: 37.7884433,
        longitude: -122.3871918,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T03:00:05.000Z',
        end_time: '2026-07-29T03:01:05.000Z',
        latitude: 37.7883597,
        longitude: -122.3872432,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T03:00:05.000Z',
        end_time: '2026-07-29T03:01:05.000Z',
        latitude: 37.7883597,
        longitude: -122.3872432,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T03:00:05.000Z',
        end_time: '2026-07-29T03:01:05.000Z',
        latitude: 37.7883597,
        longitude: -122.3872432,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:59:05.000Z',
        end_time: '2026-07-29T03:00:05.000Z',
        latitude: 37.7882197,
        longitude: -122.3876403,
        density: 10.526315789473683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:59:05.000Z',
        end_time: '2026-07-29T03:00:05.000Z',
        latitude: 37.7882197,
        longitude: -122.3876403,
        density: 13.233006393009783,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:59:05.000Z',
        end_time: '2026-07-29T03:00:05.000Z',
        latitude: 37.7882197,
        longitude: -122.3876403,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T02:54:05.000Z',
        end_time: '2026-07-29T02:59:05.000Z',
        latitude: 37.7884833,
        longitude: -122.3869167,
        density: 3.1578947368421053,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T02:54:05.000Z',
        end_time: '2026-07-29T02:59:05.000Z',
        latitude: 37.7884833,
        longitude: -122.3869167,
        density: 15.96739808544703,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:58:05.000Z',
        end_time: '2026-07-29T02:59:05.000Z',
        latitude: 37.7884132,
        longitude: -122.3871477,
        density: 10.526315789473683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:58:05.000Z',
        end_time: '2026-07-29T02:59:05.000Z',
        latitude: 37.7884132,
        longitude: -122.3871477,
        density: 11.573669944590222,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:58:05.000Z',
        end_time: '2026-07-29T02:59:05.000Z',
        latitude: 37.7884132,
        longitude: -122.3871477,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T02:54:05.000Z',
        end_time: '2026-07-29T02:59:05.000Z',
        latitude: 37.7884833,
        longitude: -122.3869167,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:57:05.000Z',
        end_time: '2026-07-29T02:58:05.000Z',
        latitude: 37.7883815,
        longitude: -122.3872507,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:57:05.000Z',
        end_time: '2026-07-29T02:58:05.000Z',
        latitude: 37.7883815,
        longitude: -122.3872507,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:57:05.000Z',
        end_time: '2026-07-29T02:58:05.000Z',
        latitude: 37.7883815,
        longitude: -122.3872507,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:56:05.000Z',
        end_time: '2026-07-29T02:57:05.000Z',
        latitude: 37.7884368,
        longitude: -122.3871363,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:56:05.000Z',
        end_time: '2026-07-29T02:57:05.000Z',
        latitude: 37.7884368,
        longitude: -122.3871363,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:56:05.000Z',
        end_time: '2026-07-29T02:57:05.000Z',
        latitude: 37.7884368,
        longitude: -122.3871363,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:55:05.000Z',
        end_time: '2026-07-29T02:56:05.000Z',
        latitude: 37.7884183,
        longitude: -122.3871222,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:55:05.000Z',
        end_time: '2026-07-29T02:56:05.000Z',
        latitude: 37.7884183,
        longitude: -122.3871222,
        density: 19.66765289320781,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:55:05.000Z',
        end_time: '2026-07-29T02:56:05.000Z',
        latitude: 37.7884183,
        longitude: -122.3871222,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:53:05.000Z',
        end_time: '2026-07-29T02:54:05.000Z',
        latitude: 37.788365,
        longitude: -122.38719,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:53:05.000Z',
        end_time: '2026-07-29T02:54:05.000Z',
        latitude: 37.788365,
        longitude: -122.38719,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:53:05.000Z',
        end_time: '2026-07-29T02:54:05.000Z',
        latitude: 37.788365,
        longitude: -122.38719,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T02:49:05.000Z',
        end_time: '2026-07-29T02:54:05.000Z',
        latitude: 37.7884,
        longitude: -122.3871167,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T02:49:05.000Z',
        end_time: '2026-07-29T02:54:05.000Z',
        latitude: 37.7884,
        longitude: -122.3871167,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T02:49:05.000Z',
        end_time: '2026-07-29T02:54:05.000Z',
        latitude: 37.7884,
        longitude: -122.3871167,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:52:05.000Z',
        end_time: '2026-07-29T02:53:05.000Z',
        latitude: 37.788362,
        longitude: -122.3871792,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:52:05.000Z',
        end_time: '2026-07-29T02:53:05.000Z',
        latitude: 37.788362,
        longitude: -122.3871792,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:52:05.000Z',
        end_time: '2026-07-29T02:53:05.000Z',
        latitude: 37.788362,
        longitude: -122.3871792,
        density: 2.112378105679187,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:51:05.000Z',
        end_time: '2026-07-29T02:52:05.000Z',
        latitude: 37.7884085,
        longitude: -122.3870882,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:51:05.000Z',
        end_time: '2026-07-29T02:52:05.000Z',
        latitude: 37.7884085,
        longitude: -122.3870882,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:51:05.000Z',
        end_time: '2026-07-29T02:52:05.000Z',
        latitude: 37.7884085,
        longitude: -122.3870882,
        density: 6.616132597076549,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:50:05.000Z',
        end_time: '2026-07-29T02:51:05.000Z',
        latitude: 37.7884117,
        longitude: -122.3871453,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:50:05.000Z',
        end_time: '2026-07-29T02:51:05.000Z',
        latitude: 37.7884117,
        longitude: -122.3871453,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:50:05.000Z',
        end_time: '2026-07-29T02:51:05.000Z',
        latitude: 37.7884117,
        longitude: -122.3871453,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T02:44:05.000Z',
        end_time: '2026-07-29T02:49:05.000Z',
        latitude: 37.7883833,
        longitude: -122.3871667,
        density: 1.5789473684210527,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:48:05.000Z',
        end_time: '2026-07-29T02:49:05.000Z',
        latitude: 37.7884815,
        longitude: -122.3870252,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:48:05.000Z',
        end_time: '2026-07-29T02:49:05.000Z',
        latitude: 37.7884815,
        longitude: -122.3870252,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:48:05.000Z',
        end_time: '2026-07-29T02:49:05.000Z',
        latitude: 37.7884815,
        longitude: -122.3870252,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T02:44:05.000Z',
        end_time: '2026-07-29T02:49:05.000Z',
        latitude: 37.7883833,
        longitude: -122.3871667,
        density: 2.1052631578947367,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T02:44:05.000Z',
        end_time: '2026-07-29T02:49:05.000Z',
        latitude: 37.7883833,
        longitude: -122.3871667,
        density: 13.102245999056901,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:47:05.000Z',
        end_time: '2026-07-29T02:48:05.000Z',
        latitude: 37.7884373,
        longitude: -122.3871415,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:47:05.000Z',
        end_time: '2026-07-29T02:48:05.000Z',
        latitude: 37.7884373,
        longitude: -122.3871415,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:47:05.000Z',
        end_time: '2026-07-29T02:48:05.000Z',
        latitude: 37.7884373,
        longitude: -122.3871415,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:46:05.000Z',
        end_time: '2026-07-29T02:47:05.000Z',
        latitude: 37.7884157,
        longitude: -122.3872167,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:46:05.000Z',
        end_time: '2026-07-29T02:47:05.000Z',
        latitude: 37.7884157,
        longitude: -122.3872167,
        density: 2.8952282078805736,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:46:05.000Z',
        end_time: '2026-07-29T02:47:05.000Z',
        latitude: 37.7884157,
        longitude: -122.3872167,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:45:05.000Z',
        end_time: '2026-07-29T02:46:05.000Z',
        latitude: 37.7884608,
        longitude: -122.387036,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:45:05.000Z',
        end_time: '2026-07-29T02:46:05.000Z',
        latitude: 37.7884608,
        longitude: -122.387036,
        density: 14.800454607024905,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:45:05.000Z',
        end_time: '2026-07-29T02:46:05.000Z',
        latitude: 37.7884608,
        longitude: -122.387036,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T02:39:05.000Z',
        end_time: '2026-07-29T02:44:05.000Z',
        latitude: 37.7884833,
        longitude: -122.3869,
        density: 2.1052631578947367,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T02:39:05.000Z',
        end_time: '2026-07-29T02:44:05.000Z',
        latitude: 37.7884833,
        longitude: -122.3869,
        density: 9.742789825265616,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:43:05.000Z',
        end_time: '2026-07-29T02:44:05.000Z',
        latitude: 37.7885715,
        longitude: -122.3864997,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:43:05.000Z',
        end_time: '2026-07-29T02:44:05.000Z',
        latitude: 37.7885715,
        longitude: -122.3864997,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:43:05.000Z',
        end_time: '2026-07-29T02:44:05.000Z',
        latitude: 37.7885715,
        longitude: -122.3864997,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T02:39:05.000Z',
        end_time: '2026-07-29T02:44:05.000Z',
        latitude: 37.7884833,
        longitude: -122.3869,
        density: 0.5263157894736842,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:42:05.000Z',
        end_time: '2026-07-29T02:43:05.000Z',
        latitude: 37.7884978,
        longitude: -122.3869435,
        density: 2.631578947368421,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:42:05.000Z',
        end_time: '2026-07-29T02:43:05.000Z',
        latitude: 37.7884978,
        longitude: -122.3869435,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:42:05.000Z',
        end_time: '2026-07-29T02:43:05.000Z',
        latitude: 37.7884978,
        longitude: -122.3869435,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:41:05.000Z',
        end_time: '2026-07-29T02:42:05.000Z',
        latitude: 37.7884522,
        longitude: -122.3869775,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:41:05.000Z',
        end_time: '2026-07-29T02:42:05.000Z',
        latitude: 37.7884522,
        longitude: -122.3869775,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:41:05.000Z',
        end_time: '2026-07-29T02:42:05.000Z',
        latitude: 37.7884522,
        longitude: -122.3869775,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:40:05.000Z',
        end_time: '2026-07-29T02:41:05.000Z',
        latitude: 37.7884592,
        longitude: -122.3870605,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:40:05.000Z',
        end_time: '2026-07-29T02:41:05.000Z',
        latitude: 37.7884592,
        longitude: -122.3870605,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:40:05.000Z',
        end_time: '2026-07-29T02:41:05.000Z',
        latitude: 37.7884592,
        longitude: -122.3870605,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:39:05.000Z',
        end_time: '2026-07-29T02:40:05.000Z',
        latitude: 37.7884973,
        longitude: -122.3870287,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:39:05.000Z',
        end_time: '2026-07-29T02:40:05.000Z',
        latitude: 37.7884973,
        longitude: -122.3870287,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:39:05.000Z',
        end_time: '2026-07-29T02:40:05.000Z',
        latitude: 37.7884973,
        longitude: -122.3870287,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:38:05.000Z',
        end_time: '2026-07-29T02:39:05.000Z',
        latitude: 37.7884733,
        longitude: -122.38706,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:38:05.000Z',
        end_time: '2026-07-29T02:39:05.000Z',
        latitude: 37.7884733,
        longitude: -122.38706,
        density: 13.380946277312953,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:38:05.000Z',
        end_time: '2026-07-29T02:39:05.000Z',
        latitude: 37.7884733,
        longitude: -122.38706,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T02:34:05.000Z',
        end_time: '2026-07-29T02:39:05.000Z',
        latitude: 37.7884833,
        longitude: -122.3870333,
        density: 4.2105263157894735,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T02:34:05.000Z',
        end_time: '2026-07-29T02:39:05.000Z',
        latitude: 37.7884833,
        longitude: -122.3870333,
        density: 31.982707184750474,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T02:34:05.000Z',
        end_time: '2026-07-29T02:39:05.000Z',
        latitude: 37.7884833,
        longitude: -122.3870333,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:37:05.000Z',
        end_time: '2026-07-29T02:38:05.000Z',
        latitude: 37.7884483,
        longitude: -122.3871278,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:37:05.000Z',
        end_time: '2026-07-29T02:38:05.000Z',
        latitude: 37.7884483,
        longitude: -122.3871278,
        density: 10.526315789473683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:37:05.000Z',
        end_time: '2026-07-29T02:38:05.000Z',
        latitude: 37.7884483,
        longitude: -122.3871278,
        density: 13.899946461825127,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:36:05.000Z',
        end_time: '2026-07-29T02:37:05.000Z',
        latitude: 37.7884662,
        longitude: -122.3870828,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:36:05.000Z',
        end_time: '2026-07-29T02:37:05.000Z',
        latitude: 37.7884662,
        longitude: -122.3870828,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:36:05.000Z',
        end_time: '2026-07-29T02:37:05.000Z',
        latitude: 37.7884662,
        longitude: -122.3870828,
        density: 33.425304707009715,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:35:05.000Z',
        end_time: '2026-07-29T02:36:05.000Z',
        latitude: 37.7884835,
        longitude: -122.387018,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:35:05.000Z',
        end_time: '2026-07-29T02:36:05.000Z',
        latitude: 37.7884835,
        longitude: -122.387018,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:35:05.000Z',
        end_time: '2026-07-29T02:36:05.000Z',
        latitude: 37.7884835,
        longitude: -122.387018,
        density: 1.7227995373908742,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T02:29:05.000Z',
        end_time: '2026-07-29T02:34:05.000Z',
        latitude: 37.7885,
        longitude: -122.3869,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:33:05.000Z',
        end_time: '2026-07-29T02:34:05.000Z',
        latitude: 37.788537,
        longitude: -122.3868372,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:33:05.000Z',
        end_time: '2026-07-29T02:34:05.000Z',
        latitude: 37.788537,
        longitude: -122.3868372,
        density: 15.486325925350801,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:33:05.000Z',
        end_time: '2026-07-29T02:34:05.000Z',
        latitude: 37.788537,
        longitude: -122.3868372,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T02:29:05.000Z',
        end_time: '2026-07-29T02:34:05.000Z',
        latitude: 37.7885,
        longitude: -122.3869,
        density: 1.0526315789473684,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T02:29:05.000Z',
        end_time: '2026-07-29T02:34:05.000Z',
        latitude: 37.7885,
        longitude: -122.3869,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:32:05.000Z',
        end_time: '2026-07-29T02:33:05.000Z',
        latitude: 37.78855,
        longitude: -122.3867508,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:32:05.000Z',
        end_time: '2026-07-29T02:33:05.000Z',
        latitude: 37.78855,
        longitude: -122.3867508,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:32:05.000Z',
        end_time: '2026-07-29T02:33:05.000Z',
        latitude: 37.78855,
        longitude: -122.3867508,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:31:05.000Z',
        end_time: '2026-07-29T02:32:05.000Z',
        latitude: 37.788488,
        longitude: -122.3869102,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:31:05.000Z',
        end_time: '2026-07-29T02:32:05.000Z',
        latitude: 37.788488,
        longitude: -122.3869102,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:31:05.000Z',
        end_time: '2026-07-29T02:32:05.000Z',
        latitude: 37.788488,
        longitude: -122.3869102,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:30:05.000Z',
        end_time: '2026-07-29T02:31:05.000Z',
        latitude: 37.7885142,
        longitude: -122.3867182,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:30:05.000Z',
        end_time: '2026-07-29T02:31:05.000Z',
        latitude: 37.7885142,
        longitude: -122.3867182,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:30:05.000Z',
        end_time: '2026-07-29T02:31:05.000Z',
        latitude: 37.7885142,
        longitude: -122.3867182,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:29:05.000Z',
        end_time: '2026-07-29T02:30:05.000Z',
        latitude: 37.7884698,
        longitude: -122.3868878,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:29:05.000Z',
        end_time: '2026-07-29T02:30:05.000Z',
        latitude: 37.7884698,
        longitude: -122.3868878,
        density: 15.934047915685621,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:29:05.000Z',
        end_time: '2026-07-29T02:30:05.000Z',
        latitude: 37.7884698,
        longitude: -122.3868878,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T02:24:05.000Z',
        end_time: '2026-07-29T02:29:05.000Z',
        latitude: 37.7884667,
        longitude: -122.3868833,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T02:24:05.000Z',
        end_time: '2026-07-29T02:29:05.000Z',
        latitude: 37.7884667,
        longitude: -122.3868833,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:28:05.000Z',
        end_time: '2026-07-29T02:29:05.000Z',
        latitude: 37.7884672,
        longitude: -122.3869413,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:28:05.000Z',
        end_time: '2026-07-29T02:29:05.000Z',
        latitude: 37.7884672,
        longitude: -122.3869413,
        density: 24.187361012753378,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:28:05.000Z',
        end_time: '2026-07-29T02:29:05.000Z',
        latitude: 37.7884672,
        longitude: -122.3869413,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T02:24:05.000Z',
        end_time: '2026-07-29T02:29:05.000Z',
        latitude: 37.7884667,
        longitude: -122.3868833,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:27:05.000Z',
        end_time: '2026-07-29T02:28:05.000Z',
        latitude: 37.7884785,
        longitude: -122.3868607,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:27:05.000Z',
        end_time: '2026-07-29T02:28:05.000Z',
        latitude: 37.7884785,
        longitude: -122.3868607,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:27:05.000Z',
        end_time: '2026-07-29T02:28:05.000Z',
        latitude: 37.7884785,
        longitude: -122.3868607,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:26:05.000Z',
        end_time: '2026-07-29T02:27:05.000Z',
        latitude: 37.7885243,
        longitude: -122.3868108,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:26:05.000Z',
        end_time: '2026-07-29T02:27:05.000Z',
        latitude: 37.7885243,
        longitude: -122.3868108,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:26:05.000Z',
        end_time: '2026-07-29T02:27:05.000Z',
        latitude: 37.7885243,
        longitude: -122.3868108,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:25:05.000Z',
        end_time: '2026-07-29T02:26:05.000Z',
        latitude: 37.7885118,
        longitude: -122.3868585,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:25:05.000Z',
        end_time: '2026-07-29T02:26:05.000Z',
        latitude: 37.7885118,
        longitude: -122.3868585,
        density: 5.06801571658456,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:25:05.000Z',
        end_time: '2026-07-29T02:26:05.000Z',
        latitude: 37.7885118,
        longitude: -122.3868585,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:24:05.000Z',
        end_time: '2026-07-29T02:25:05.000Z',
        latitude: 37.7884987,
        longitude: -122.3869572,
        density: 10.526315789473683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:24:05.000Z',
        end_time: '2026-07-29T02:25:05.000Z',
        latitude: 37.7884987,
        longitude: -122.3869572,
        density: 8.3371877883121,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:24:05.000Z',
        end_time: '2026-07-29T02:25:05.000Z',
        latitude: 37.7884987,
        longitude: -122.3869572,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T02:19:05.000Z',
        end_time: '2026-07-29T02:24:05.000Z',
        latitude: 37.7885,
        longitude: -122.3869667,
        density: 6.842105263157896,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T02:19:05.000Z',
        end_time: '2026-07-29T02:24:05.000Z',
        latitude: 37.7885,
        longitude: -122.3869667,
        density: 35.74378022344247,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:23:05.000Z',
        end_time: '2026-07-29T02:24:05.000Z',
        latitude: 37.7885023,
        longitude: -122.3869963,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:23:05.000Z',
        end_time: '2026-07-29T02:24:05.000Z',
        latitude: 37.7885023,
        longitude: -122.3869963,
        density: 35.96602994433589,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:23:05.000Z',
        end_time: '2026-07-29T02:24:05.000Z',
        latitude: 37.7885023,
        longitude: -122.3869963,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T02:19:05.000Z',
        end_time: '2026-07-29T02:24:05.000Z',
        latitude: 37.7885,
        longitude: -122.3869667,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:22:05.000Z',
        end_time: '2026-07-29T02:23:05.000Z',
        latitude: 37.7884998,
        longitude: -122.3868763,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:22:05.000Z',
        end_time: '2026-07-29T02:23:05.000Z',
        latitude: 37.7884998,
        longitude: -122.3868763,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:22:05.000Z',
        end_time: '2026-07-29T02:23:05.000Z',
        latitude: 37.7884998,
        longitude: -122.3868763,
        density: 13.303869449814446,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:21:05.000Z',
        end_time: '2026-07-29T02:22:05.000Z',
        latitude: 37.7884395,
        longitude: -122.3870568,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:21:05.000Z',
        end_time: '2026-07-29T02:22:05.000Z',
        latitude: 37.7884395,
        longitude: -122.3870568,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:21:05.000Z',
        end_time: '2026-07-29T02:22:05.000Z',
        latitude: 37.7884395,
        longitude: -122.3870568,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:20:05.000Z',
        end_time: '2026-07-29T02:21:05.000Z',
        latitude: 37.7884795,
        longitude: -122.3870278,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:20:05.000Z',
        end_time: '2026-07-29T02:21:05.000Z',
        latitude: 37.7884795,
        longitude: -122.3870278,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:20:05.000Z',
        end_time: '2026-07-29T02:21:05.000Z',
        latitude: 37.7884795,
        longitude: -122.3870278,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:18:05.000Z',
        end_time: '2026-07-29T02:19:05.000Z',
        latitude: 37.788574,
        longitude: -122.387001,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:18:05.000Z',
        end_time: '2026-07-29T02:19:05.000Z',
        latitude: 37.788574,
        longitude: -122.387001,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:18:05.000Z',
        end_time: '2026-07-29T02:19:05.000Z',
        latitude: 37.788574,
        longitude: -122.387001,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T02:14:05.000Z',
        end_time: '2026-07-29T02:19:05.000Z',
        latitude: 37.7885667,
        longitude: -122.3869833,
        density: 4.736842105263158,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T02:14:05.000Z',
        end_time: '2026-07-29T02:19:05.000Z',
        latitude: 37.7885667,
        longitude: -122.3869833,
        density: 19.7233499203033,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T02:14:05.000Z',
        end_time: '2026-07-29T02:19:05.000Z',
        latitude: 37.7885667,
        longitude: -122.3869833,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:17:05.000Z',
        end_time: '2026-07-29T02:18:05.000Z',
        latitude: 37.788517,
        longitude: -122.3869835,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:17:05.000Z',
        end_time: '2026-07-29T02:18:05.000Z',
        latitude: 37.788517,
        longitude: -122.3869835,
        density: 10.526315789473683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:17:05.000Z',
        end_time: '2026-07-29T02:18:05.000Z',
        latitude: 37.788517,
        longitude: -122.3869835,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:16:05.000Z',
        end_time: '2026-07-29T02:17:05.000Z',
        latitude: 37.7885525,
        longitude: -122.3869908,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:16:05.000Z',
        end_time: '2026-07-29T02:17:05.000Z',
        latitude: 37.7885525,
        longitude: -122.3869908,
        density: 9.17492243480385,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:16:05.000Z',
        end_time: '2026-07-29T02:17:05.000Z',
        latitude: 37.7885525,
        longitude: -122.3869908,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:15:05.000Z',
        end_time: '2026-07-29T02:16:05.000Z',
        latitude: 37.7885252,
        longitude: -122.3868107,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:15:05.000Z',
        end_time: '2026-07-29T02:16:05.000Z',
        latitude: 37.7885252,
        longitude: -122.3868107,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:15:05.000Z',
        end_time: '2026-07-29T02:16:05.000Z',
        latitude: 37.7885252,
        longitude: -122.3868107,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T02:09:06.000Z',
        end_time: '2026-07-29T02:14:06.000Z',
        latitude: 37.78845,
        longitude: -122.3869667,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T02:09:06.000Z',
        end_time: '2026-07-29T02:14:06.000Z',
        latitude: 37.78845,
        longitude: -122.3869667,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T02:09:06.000Z',
        end_time: '2026-07-29T02:14:06.000Z',
        latitude: 37.78845,
        longitude: -122.3869667,
        density: 12.390566328867987,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:13:05.000Z',
        end_time: '2026-07-29T02:14:05.000Z',
        latitude: 37.78846,
        longitude: -122.3869993,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:13:05.000Z',
        end_time: '2026-07-29T02:14:05.000Z',
        latitude: 37.78846,
        longitude: -122.3869993,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:13:05.000Z',
        end_time: '2026-07-29T02:14:05.000Z',
        latitude: 37.78846,
        longitude: -122.3869993,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:12:06.000Z',
        end_time: '2026-07-29T02:13:06.000Z',
        latitude: 37.788465,
        longitude: -122.3870043,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:12:06.000Z',
        end_time: '2026-07-29T02:13:06.000Z',
        latitude: 37.788465,
        longitude: -122.3870043,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:12:06.000Z',
        end_time: '2026-07-29T02:13:06.000Z',
        latitude: 37.788465,
        longitude: -122.3870043,
        density: 10.55648348450716,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:11:06.000Z',
        end_time: '2026-07-29T02:12:06.000Z',
        latitude: 37.7884525,
        longitude: -122.3870145,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:11:06.000Z',
        end_time: '2026-07-29T02:12:06.000Z',
        latitude: 37.7884525,
        longitude: -122.3870145,
        density: 23.346479548495754,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:11:06.000Z',
        end_time: '2026-07-29T02:12:06.000Z',
        latitude: 37.7884525,
        longitude: -122.3870145,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:10:06.000Z',
        end_time: '2026-07-29T02:11:06.000Z',
        latitude: 37.7884348,
        longitude: -122.3870408,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:10:06.000Z',
        end_time: '2026-07-29T02:11:06.000Z',
        latitude: 37.7884348,
        longitude: -122.3870408,
        density: 24.999891078704092,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:10:06.000Z',
        end_time: '2026-07-29T02:11:06.000Z',
        latitude: 37.7884348,
        longitude: -122.3870408,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:09:06.000Z',
        end_time: '2026-07-29T02:10:06.000Z',
        latitude: 37.7884443,
        longitude: -122.3870295,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:09:06.000Z',
        end_time: '2026-07-29T02:10:06.000Z',
        latitude: 37.7884443,
        longitude: -122.3870295,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:09:06.000Z',
        end_time: '2026-07-29T02:10:06.000Z',
        latitude: 37.7884443,
        longitude: -122.3870295,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T02:04:06.000Z',
        end_time: '2026-07-29T02:09:06.000Z',
        latitude: 37.7884167,
        longitude: -122.3870167,
        density: 12.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T02:04:06.000Z',
        end_time: '2026-07-29T02:09:06.000Z',
        latitude: 37.7884167,
        longitude: -122.3870167,
        density: 2.258894787351645,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:08:06.000Z',
        end_time: '2026-07-29T02:09:06.000Z',
        latitude: 37.7884308,
        longitude: -122.3870725,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:08:06.000Z',
        end_time: '2026-07-29T02:09:06.000Z',
        latitude: 37.7884308,
        longitude: -122.3870725,
        density: 28.406441716381124,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:08:06.000Z',
        end_time: '2026-07-29T02:09:06.000Z',
        latitude: 37.7884308,
        longitude: -122.3870725,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T02:04:06.000Z',
        end_time: '2026-07-29T02:09:06.000Z',
        latitude: 37.7884167,
        longitude: -122.3870167,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:07:06.000Z',
        end_time: '2026-07-29T02:08:06.000Z',
        latitude: 37.788429,
        longitude: -122.38714,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:07:06.000Z',
        end_time: '2026-07-29T02:08:06.000Z',
        latitude: 37.788429,
        longitude: -122.38714,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:07:06.000Z',
        end_time: '2026-07-29T02:08:06.000Z',
        latitude: 37.788429,
        longitude: -122.38714,
        density: 11.351930859694424,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:06:06.000Z',
        end_time: '2026-07-29T02:07:06.000Z',
        latitude: 37.7884443,
        longitude: -122.3870988,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:06:06.000Z',
        end_time: '2026-07-29T02:07:06.000Z',
        latitude: 37.7884443,
        longitude: -122.3870988,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:06:06.000Z',
        end_time: '2026-07-29T02:07:06.000Z',
        latitude: 37.7884443,
        longitude: -122.3870988,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:05:06.000Z',
        end_time: '2026-07-29T02:06:06.000Z',
        latitude: 37.7884332,
        longitude: -122.3870067,
        density: 10.526315789473683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:05:06.000Z',
        end_time: '2026-07-29T02:06:06.000Z',
        latitude: 37.7884332,
        longitude: -122.3870067,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:05:06.000Z',
        end_time: '2026-07-29T02:06:06.000Z',
        latitude: 37.7884332,
        longitude: -122.3870067,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:03:06.000Z',
        end_time: '2026-07-29T02:04:06.000Z',
        latitude: 37.7884467,
        longitude: -122.387139,
        density: 21.052631578947366,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:03:06.000Z',
        end_time: '2026-07-29T02:04:06.000Z',
        latitude: 37.7884467,
        longitude: -122.387139,
        density: 44.57834769539018,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:03:06.000Z',
        end_time: '2026-07-29T02:04:06.000Z',
        latitude: 37.7884467,
        longitude: -122.387139,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T01:59:06.000Z',
        end_time: '2026-07-29T02:04:06.000Z',
        latitude: 37.78845,
        longitude: -122.3865333,
        density: 11.578947368421053,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T01:59:06.000Z',
        end_time: '2026-07-29T02:04:06.000Z',
        latitude: 37.78845,
        longitude: -122.3865333,
        density: 35.84433615008843,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T01:59:06.000Z',
        end_time: '2026-07-29T02:04:06.000Z',
        latitude: 37.78845,
        longitude: -122.3865333,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:02:06.000Z',
        end_time: '2026-07-29T02:03:06.000Z',
        latitude: 37.7884217,
        longitude: -122.3870268,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:02:06.000Z',
        end_time: '2026-07-29T02:03:06.000Z',
        latitude: 37.7884217,
        longitude: -122.3870268,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:02:06.000Z',
        end_time: '2026-07-29T02:03:06.000Z',
        latitude: 37.7884217,
        longitude: -122.3870268,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:01:06.000Z',
        end_time: '2026-07-29T02:02:06.000Z',
        latitude: 37.7884638,
        longitude: -122.3870038,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:01:06.000Z',
        end_time: '2026-07-29T02:02:06.000Z',
        latitude: 37.7884638,
        longitude: -122.3870038,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:01:06.000Z',
        end_time: '2026-07-29T02:02:06.000Z',
        latitude: 37.7884638,
        longitude: -122.3870038,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T02:00:06.000Z',
        end_time: '2026-07-29T02:01:06.000Z',
        latitude: 37.7884345,
        longitude: -122.3877655,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T02:00:06.000Z',
        end_time: '2026-07-29T02:01:06.000Z',
        latitude: 37.7884345,
        longitude: -122.3877655,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T02:00:06.000Z',
        end_time: '2026-07-29T02:01:06.000Z',
        latitude: 37.7884345,
        longitude: -122.3877655,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T01:54:06.000Z',
        end_time: '2026-07-29T01:59:06.000Z',
        latitude: 37.78845,
        longitude: -122.3879833,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:58:06.000Z',
        end_time: '2026-07-29T01:59:06.000Z',
        latitude: 37.788425,
        longitude: -122.3879673,
        density: 15.789473684210526,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:58:06.000Z',
        end_time: '2026-07-29T01:59:06.000Z',
        latitude: 37.788425,
        longitude: -122.3879673,
        density: 8.10687039691797,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:58:06.000Z',
        end_time: '2026-07-29T01:59:06.000Z',
        latitude: 37.788425,
        longitude: -122.3879673,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T01:54:06.000Z',
        end_time: '2026-07-29T01:59:06.000Z',
        latitude: 37.78845,
        longitude: -122.3879833,
        density: 10.526315789473683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T01:54:06.000Z',
        end_time: '2026-07-29T01:59:06.000Z',
        latitude: 37.78845,
        longitude: -122.3879833,
        density: 14.578980185992185,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:57:06.000Z',
        end_time: '2026-07-29T01:58:06.000Z',
        latitude: 37.7883478,
        longitude: -122.3868068,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:57:06.000Z',
        end_time: '2026-07-29T01:58:06.000Z',
        latitude: 37.7883478,
        longitude: -122.3868068,
        density: 15.789473684210526,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:57:06.000Z',
        end_time: '2026-07-29T01:58:06.000Z',
        latitude: 37.7883478,
        longitude: -122.3868068,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:56:06.000Z',
        end_time: '2026-07-29T01:57:06.000Z',
        latitude: 37.788339,
        longitude: -122.3870098,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:56:06.000Z',
        end_time: '2026-07-29T01:57:06.000Z',
        latitude: 37.788339,
        longitude: -122.3870098,
        density: 4.366347907738254,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:56:06.000Z',
        end_time: '2026-07-29T01:57:06.000Z',
        latitude: 37.788339,
        longitude: -122.3870098,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:55:06.000Z',
        end_time: '2026-07-29T01:56:06.000Z',
        latitude: 37.788365,
        longitude: -122.3870325,
        density: 15.789473684210526,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:55:06.000Z',
        end_time: '2026-07-29T01:56:06.000Z',
        latitude: 37.788365,
        longitude: -122.3870325,
        density: 9.805945249084921,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:55:06.000Z',
        end_time: '2026-07-29T01:56:06.000Z',
        latitude: 37.788365,
        longitude: -122.3870325,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T01:49:06.000Z',
        end_time: '2026-07-29T01:54:06.000Z',
        latitude: 37.7884167,
        longitude: -122.3869333,
        density: 10.526315789473683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T01:49:06.000Z',
        end_time: '2026-07-29T01:54:06.000Z',
        latitude: 37.7884167,
        longitude: -122.3869333,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:53:06.000Z',
        end_time: '2026-07-29T01:54:06.000Z',
        latitude: 37.7884242,
        longitude: -122.3869583,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:53:06.000Z',
        end_time: '2026-07-29T01:54:06.000Z',
        latitude: 37.7884242,
        longitude: -122.3869583,
        density: 0.2071268471937966,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:53:06.000Z',
        end_time: '2026-07-29T01:54:06.000Z',
        latitude: 37.7884242,
        longitude: -122.3869583,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T01:49:06.000Z',
        end_time: '2026-07-29T01:54:06.000Z',
        latitude: 37.7884167,
        longitude: -122.3869333,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:52:06.000Z',
        end_time: '2026-07-29T01:53:06.000Z',
        latitude: 37.7884705,
        longitude: -122.3870362,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:52:06.000Z',
        end_time: '2026-07-29T01:53:06.000Z',
        latitude: 37.7884705,
        longitude: -122.3870362,
        density: 26.31578947368421,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:52:06.000Z',
        end_time: '2026-07-29T01:53:06.000Z',
        latitude: 37.7884705,
        longitude: -122.3870362,
        density: 29.529351301089925,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:51:06.000Z',
        end_time: '2026-07-29T01:52:06.000Z',
        latitude: 37.788475,
        longitude: -122.3870513,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:51:06.000Z',
        end_time: '2026-07-29T01:52:06.000Z',
        latitude: 37.788475,
        longitude: -122.3870513,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:51:06.000Z',
        end_time: '2026-07-29T01:52:06.000Z',
        latitude: 37.788475,
        longitude: -122.3870513,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:50:06.000Z',
        end_time: '2026-07-29T01:51:06.000Z',
        latitude: 37.7884817,
        longitude: -122.386993,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:50:06.000Z',
        end_time: '2026-07-29T01:51:06.000Z',
        latitude: 37.7884817,
        longitude: -122.386993,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:50:06.000Z',
        end_time: '2026-07-29T01:51:06.000Z',
        latitude: 37.7884817,
        longitude: -122.386993,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T01:44:06.000Z',
        end_time: '2026-07-29T01:49:06.000Z',
        latitude: 37.7884833,
        longitude: -122.3870333,
        density: 3.684210526315789,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T01:44:06.000Z',
        end_time: '2026-07-29T01:49:06.000Z',
        latitude: 37.7884833,
        longitude: -122.3870333,
        density: 29.14000845863093,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:48:06.000Z',
        end_time: '2026-07-29T01:49:06.000Z',
        latitude: 37.7884418,
        longitude: -122.3871445,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:48:06.000Z',
        end_time: '2026-07-29T01:49:06.000Z',
        latitude: 37.7884418,
        longitude: -122.3871445,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:48:06.000Z',
        end_time: '2026-07-29T01:49:06.000Z',
        latitude: 37.7884418,
        longitude: -122.3871445,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T01:44:06.000Z',
        end_time: '2026-07-29T01:49:06.000Z',
        latitude: 37.7884833,
        longitude: -122.3870333,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:47:06.000Z',
        end_time: '2026-07-29T01:48:06.000Z',
        latitude: 37.7884367,
        longitude: -122.3870985,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:47:06.000Z',
        end_time: '2026-07-29T01:48:06.000Z',
        latitude: 37.7884367,
        longitude: -122.3870985,
        density: 7.894736842105263,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:47:06.000Z',
        end_time: '2026-07-29T01:48:06.000Z',
        latitude: 37.7884367,
        longitude: -122.3870985,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:46:06.000Z',
        end_time: '2026-07-29T01:47:06.000Z',
        latitude: 37.7884587,
        longitude: -122.3870892,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:46:06.000Z',
        end_time: '2026-07-29T01:47:06.000Z',
        latitude: 37.7884587,
        longitude: -122.3870892,
        density: 11.649882225616244,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:46:06.000Z',
        end_time: '2026-07-29T01:47:06.000Z',
        latitude: 37.7884587,
        longitude: -122.3870892,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:45:06.000Z',
        end_time: '2026-07-29T01:46:06.000Z',
        latitude: 37.7884577,
        longitude: -122.3870995,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:45:06.000Z',
        end_time: '2026-07-29T01:46:06.000Z',
        latitude: 37.7884577,
        longitude: -122.3870995,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:45:06.000Z',
        end_time: '2026-07-29T01:46:06.000Z',
        latitude: 37.7884577,
        longitude: -122.3870995,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T01:39:06.000Z',
        end_time: '2026-07-29T01:44:06.000Z',
        latitude: 37.7883833,
        longitude: -122.3871833,
        density: 0.5263157894736842,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:43:06.000Z',
        end_time: '2026-07-29T01:44:06.000Z',
        latitude: 37.7884337,
        longitude: -122.3871212,
        density: 44.73684210526316,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:43:06.000Z',
        end_time: '2026-07-29T01:44:06.000Z',
        latitude: 37.7884337,
        longitude: -122.3871212,
        density: 71.00400247411191,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:43:06.000Z',
        end_time: '2026-07-29T01:44:06.000Z',
        latitude: 37.7884337,
        longitude: -122.3871212,
        density: 2.631578947368421,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T01:39:06.000Z',
        end_time: '2026-07-29T01:44:06.000Z',
        latitude: 37.7883833,
        longitude: -122.3871833,
        density: 10,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T01:39:06.000Z',
        end_time: '2026-07-29T01:44:06.000Z',
        latitude: 37.7883833,
        longitude: -122.3871833,
        density: 38.13415148013316,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:42:06.000Z',
        end_time: '2026-07-29T01:43:06.000Z',
        latitude: 37.7885113,
        longitude: -122.3871277,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:42:06.000Z',
        end_time: '2026-07-29T01:43:06.000Z',
        latitude: 37.7885113,
        longitude: -122.3871277,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:42:06.000Z',
        end_time: '2026-07-29T01:43:06.000Z',
        latitude: 37.7885113,
        longitude: -122.3871277,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:41:06.000Z',
        end_time: '2026-07-29T01:42:06.000Z',
        latitude: 37.788478,
        longitude: -122.3871718,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:41:06.000Z',
        end_time: '2026-07-29T01:42:06.000Z',
        latitude: 37.788478,
        longitude: -122.3871718,
        density: 13.86408428476821,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:41:06.000Z',
        end_time: '2026-07-29T01:42:06.000Z',
        latitude: 37.788478,
        longitude: -122.3871718,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:40:06.000Z',
        end_time: '2026-07-29T01:41:06.000Z',
        latitude: 37.7884652,
        longitude: -122.3871337,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:40:06.000Z',
        end_time: '2026-07-29T01:41:06.000Z',
        latitude: 37.7884652,
        longitude: -122.3871337,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:40:06.000Z',
        end_time: '2026-07-29T01:41:06.000Z',
        latitude: 37.7884652,
        longitude: -122.3871337,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T01:34:06.000Z',
        end_time: '2026-07-29T01:39:06.000Z',
        latitude: 37.7884833,
        longitude: -122.3871167,
        density: 3.1578947368421053,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T01:34:06.000Z',
        end_time: '2026-07-29T01:39:06.000Z',
        latitude: 37.7884833,
        longitude: -122.3871167,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:38:06.000Z',
        end_time: '2026-07-29T01:39:06.000Z',
        latitude: 37.7884715,
        longitude: -122.3871278,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:38:06.000Z',
        end_time: '2026-07-29T01:39:06.000Z',
        latitude: 37.7884715,
        longitude: -122.3871278,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:38:06.000Z',
        end_time: '2026-07-29T01:39:06.000Z',
        latitude: 37.7884715,
        longitude: -122.3871278,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T01:34:06.000Z',
        end_time: '2026-07-29T01:39:06.000Z',
        latitude: 37.7884833,
        longitude: -122.3871167,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:37:06.000Z',
        end_time: '2026-07-29T01:38:06.000Z',
        latitude: 37.7884307,
        longitude: -122.3871265,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:37:06.000Z',
        end_time: '2026-07-29T01:38:06.000Z',
        latitude: 37.7884307,
        longitude: -122.3871265,
        density: 10.526315789473683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:37:06.000Z',
        end_time: '2026-07-29T01:38:06.000Z',
        latitude: 37.7884307,
        longitude: -122.3871265,
        density: 12.324416123824339,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:36:06.000Z',
        end_time: '2026-07-29T01:37:06.000Z',
        latitude: 37.7884483,
        longitude: -122.3870543,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:36:06.000Z',
        end_time: '2026-07-29T01:37:06.000Z',
        latitude: 37.7884483,
        longitude: -122.3870543,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:36:06.000Z',
        end_time: '2026-07-29T01:37:06.000Z',
        latitude: 37.7884483,
        longitude: -122.3870543,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:35:06.000Z',
        end_time: '2026-07-29T01:36:06.000Z',
        latitude: 37.7884075,
        longitude: -122.3870228,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:35:06.000Z',
        end_time: '2026-07-29T01:36:06.000Z',
        latitude: 37.7884075,
        longitude: -122.3870228,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:35:06.000Z',
        end_time: '2026-07-29T01:36:06.000Z',
        latitude: 37.7884075,
        longitude: -122.3870228,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:34:06.000Z',
        end_time: '2026-07-29T01:35:06.000Z',
        latitude: 37.7884175,
        longitude: -122.3871158,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:34:06.000Z',
        end_time: '2026-07-29T01:35:06.000Z',
        latitude: 37.7884175,
        longitude: -122.3871158,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:34:06.000Z',
        end_time: '2026-07-29T01:35:06.000Z',
        latitude: 37.7884175,
        longitude: -122.3871158,
        density: 19.13703585248642,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T01:29:06.000Z',
        end_time: '2026-07-29T01:34:06.000Z',
        latitude: 37.7884167,
        longitude: -122.3871,
        density: 1.0526315789473684,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T01:29:06.000Z',
        end_time: '2026-07-29T01:34:06.000Z',
        latitude: 37.7884167,
        longitude: -122.3871,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T01:29:06.000Z',
        end_time: '2026-07-29T01:34:06.000Z',
        latitude: 37.7884167,
        longitude: -122.3871,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:33:06.000Z',
        end_time: '2026-07-29T01:34:06.000Z',
        latitude: 37.7884365,
        longitude: -122.3870988,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:33:06.000Z',
        end_time: '2026-07-29T01:34:06.000Z',
        latitude: 37.7884365,
        longitude: -122.3870988,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:33:06.000Z',
        end_time: '2026-07-29T01:34:06.000Z',
        latitude: 37.7884365,
        longitude: -122.3870988,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:32:06.000Z',
        end_time: '2026-07-29T01:33:06.000Z',
        latitude: 37.7884757,
        longitude: -122.3870487,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:32:06.000Z',
        end_time: '2026-07-29T01:33:06.000Z',
        latitude: 37.7884757,
        longitude: -122.3870487,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:32:06.000Z',
        end_time: '2026-07-29T01:33:06.000Z',
        latitude: 37.7884757,
        longitude: -122.3870487,
        density: 27.003660530119195,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:31:06.000Z',
        end_time: '2026-07-29T01:32:06.000Z',
        latitude: 37.7884823,
        longitude: -122.3869463,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:31:06.000Z',
        end_time: '2026-07-29T01:32:06.000Z',
        latitude: 37.7884823,
        longitude: -122.3869463,
        density: 5.211393768053721,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:31:06.000Z',
        end_time: '2026-07-29T01:32:06.000Z',
        latitude: 37.7884823,
        longitude: -122.3869463,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:30:06.000Z',
        end_time: '2026-07-29T01:31:06.000Z',
        latitude: 37.788478,
        longitude: -122.3870432,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:30:06.000Z',
        end_time: '2026-07-29T01:31:06.000Z',
        latitude: 37.788478,
        longitude: -122.3870432,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:30:06.000Z',
        end_time: '2026-07-29T01:31:06.000Z',
        latitude: 37.788478,
        longitude: -122.3870432,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T01:24:06.000Z',
        end_time: '2026-07-29T01:29:06.000Z',
        latitude: 37.7884833,
        longitude: -122.38705,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:28:06.000Z',
        end_time: '2026-07-29T01:29:06.000Z',
        latitude: 37.7885298,
        longitude: -122.3870433,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:28:06.000Z',
        end_time: '2026-07-29T01:29:06.000Z',
        latitude: 37.7885298,
        longitude: -122.3870433,
        density: 12.056153394352439,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:28:06.000Z',
        end_time: '2026-07-29T01:29:06.000Z',
        latitude: 37.7885298,
        longitude: -122.3870433,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T01:24:06.000Z',
        end_time: '2026-07-29T01:29:06.000Z',
        latitude: 37.7884833,
        longitude: -122.38705,
        density: 3.1578947368421053,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T01:24:06.000Z',
        end_time: '2026-07-29T01:29:06.000Z',
        latitude: 37.7884833,
        longitude: -122.38705,
        density: 20.4251421971609,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:27:06.000Z',
        end_time: '2026-07-29T01:28:06.000Z',
        latitude: 37.7884997,
        longitude: -122.3870033,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:27:06.000Z',
        end_time: '2026-07-29T01:28:06.000Z',
        latitude: 37.7884997,
        longitude: -122.3870033,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:27:06.000Z',
        end_time: '2026-07-29T01:28:06.000Z',
        latitude: 37.7884997,
        longitude: -122.3870033,
        density: 19.506945588587655,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:26:06.000Z',
        end_time: '2026-07-29T01:27:06.000Z',
        latitude: 37.7884733,
        longitude: -122.3870112,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:26:06.000Z',
        end_time: '2026-07-29T01:27:06.000Z',
        latitude: 37.7884733,
        longitude: -122.3870112,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:26:06.000Z',
        end_time: '2026-07-29T01:27:06.000Z',
        latitude: 37.7884733,
        longitude: -122.3870112,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:25:06.000Z',
        end_time: '2026-07-29T01:26:06.000Z',
        latitude: 37.7884615,
        longitude: -122.3871118,
        density: 15.789473684210526,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:25:06.000Z',
        end_time: '2026-07-29T01:26:06.000Z',
        latitude: 37.7884615,
        longitude: -122.3871118,
        density: 41.43781666366002,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:25:06.000Z',
        end_time: '2026-07-29T01:26:06.000Z',
        latitude: 37.7884615,
        longitude: -122.3871118,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T01:19:06.000Z',
        end_time: '2026-07-29T01:24:06.000Z',
        latitude: 37.7884667,
        longitude: -122.3871167,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T01:19:06.000Z',
        end_time: '2026-07-29T01:24:06.000Z',
        latitude: 37.7884667,
        longitude: -122.3871167,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:23:06.000Z',
        end_time: '2026-07-29T01:24:06.000Z',
        latitude: 37.7884733,
        longitude: -122.3871423,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:23:06.000Z',
        end_time: '2026-07-29T01:24:06.000Z',
        latitude: 37.7884733,
        longitude: -122.3871423,
        density: 28.015089231335427,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:23:06.000Z',
        end_time: '2026-07-29T01:24:06.000Z',
        latitude: 37.7884733,
        longitude: -122.3871423,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T01:19:06.000Z',
        end_time: '2026-07-29T01:24:06.000Z',
        latitude: 37.7884667,
        longitude: -122.3871167,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:22:06.000Z',
        end_time: '2026-07-29T01:23:06.000Z',
        latitude: 37.7884902,
        longitude: -122.3871228,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:22:06.000Z',
        end_time: '2026-07-29T01:23:06.000Z',
        latitude: 37.7884902,
        longitude: -122.3871228,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:22:06.000Z',
        end_time: '2026-07-29T01:23:06.000Z',
        latitude: 37.7884902,
        longitude: -122.3871228,
        density: 18.43996166052873,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:21:06.000Z',
        end_time: '2026-07-29T01:22:06.000Z',
        latitude: 37.7884833,
        longitude: -122.3871592,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:21:06.000Z',
        end_time: '2026-07-29T01:22:06.000Z',
        latitude: 37.7884833,
        longitude: -122.3871592,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:21:06.000Z',
        end_time: '2026-07-29T01:22:06.000Z',
        latitude: 37.7884833,
        longitude: -122.3871592,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:20:06.000Z',
        end_time: '2026-07-29T01:21:06.000Z',
        latitude: 37.7885363,
        longitude: -122.3871445,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:20:06.000Z',
        end_time: '2026-07-29T01:21:06.000Z',
        latitude: 37.7885363,
        longitude: -122.3871445,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:20:06.000Z',
        end_time: '2026-07-29T01:21:06.000Z',
        latitude: 37.7885363,
        longitude: -122.3871445,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:19:06.000Z',
        end_time: '2026-07-29T01:20:06.000Z',
        latitude: 37.7885302,
        longitude: -122.3871283,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:19:06.000Z',
        end_time: '2026-07-29T01:20:06.000Z',
        latitude: 37.7885302,
        longitude: -122.3871283,
        density: 28.00513693964513,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:19:06.000Z',
        end_time: '2026-07-29T01:20:06.000Z',
        latitude: 37.7885302,
        longitude: -122.3871283,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T01:14:06.000Z',
        end_time: '2026-07-29T01:19:06.000Z',
        latitude: 37.7885167,
        longitude: -122.3871,
        density: 3.1578947368421053,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T01:14:06.000Z',
        end_time: '2026-07-29T01:19:06.000Z',
        latitude: 37.7885167,
        longitude: -122.3871,
        density: 24.346326175771832,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:18:06.000Z',
        end_time: '2026-07-29T01:19:06.000Z',
        latitude: 37.788522,
        longitude: -122.3870708,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:18:06.000Z',
        end_time: '2026-07-29T01:19:06.000Z',
        latitude: 37.788522,
        longitude: -122.3870708,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:18:06.000Z',
        end_time: '2026-07-29T01:19:06.000Z',
        latitude: 37.788522,
        longitude: -122.3870708,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T01:14:06.000Z',
        end_time: '2026-07-29T01:19:06.000Z',
        latitude: 37.7885167,
        longitude: -122.3871,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:17:06.000Z',
        end_time: '2026-07-29T01:18:06.000Z',
        latitude: 37.7885465,
        longitude: -122.3871557,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:17:06.000Z',
        end_time: '2026-07-29T01:18:06.000Z',
        latitude: 37.7885465,
        longitude: -122.3871557,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:17:06.000Z',
        end_time: '2026-07-29T01:18:06.000Z',
        latitude: 37.7885465,
        longitude: -122.3871557,
        density: 6.630493580883874,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:16:06.000Z',
        end_time: '2026-07-29T01:17:06.000Z',
        latitude: 37.7886317,
        longitude: -122.3871198,
        density: 15.789473684210526,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:16:06.000Z',
        end_time: '2026-07-29T01:17:06.000Z',
        latitude: 37.7886317,
        longitude: -122.3871198,
        density: 7.994256959245164,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:16:06.000Z',
        end_time: '2026-07-29T01:17:06.000Z',
        latitude: 37.7886317,
        longitude: -122.3871198,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:15:06.000Z',
        end_time: '2026-07-29T01:16:06.000Z',
        latitude: 37.7885037,
        longitude: -122.3871538,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:15:06.000Z',
        end_time: '2026-07-29T01:16:06.000Z',
        latitude: 37.7885037,
        longitude: -122.3871538,
        density: 11.33241497012925,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:15:06.000Z',
        end_time: '2026-07-29T01:16:06.000Z',
        latitude: 37.7885037,
        longitude: -122.3871538,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:14:06.000Z',
        end_time: '2026-07-29T01:15:06.000Z',
        latitude: 37.7885963,
        longitude: -122.3871165,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:14:06.000Z',
        end_time: '2026-07-29T01:15:06.000Z',
        latitude: 37.7885963,
        longitude: -122.3871165,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:14:06.000Z',
        end_time: '2026-07-29T01:15:06.000Z',
        latitude: 37.7885963,
        longitude: -122.3871165,
        density: 14.131081030034425,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T01:09:06.000Z',
        end_time: '2026-07-29T01:14:06.000Z',
        latitude: 37.7885333,
        longitude: -122.3871167,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:13:06.000Z',
        end_time: '2026-07-29T01:14:06.000Z',
        latitude: 37.7883925,
        longitude: -122.38713,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:13:06.000Z',
        end_time: '2026-07-29T01:14:06.000Z',
        latitude: 37.7883925,
        longitude: -122.38713,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:13:06.000Z',
        end_time: '2026-07-29T01:14:06.000Z',
        latitude: 37.7883925,
        longitude: -122.38713,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T01:09:06.000Z',
        end_time: '2026-07-29T01:14:06.000Z',
        latitude: 37.7885333,
        longitude: -122.3871167,
        density: 1.5789473684210527,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T01:09:06.000Z',
        end_time: '2026-07-29T01:14:06.000Z',
        latitude: 37.7885333,
        longitude: -122.3871167,
        density: 1.8870875406909033,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:12:06.000Z',
        end_time: '2026-07-29T01:13:06.000Z',
        latitude: 37.7884567,
        longitude: -122.3871327,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:12:06.000Z',
        end_time: '2026-07-29T01:13:06.000Z',
        latitude: 37.7884567,
        longitude: -122.3871327,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:12:06.000Z',
        end_time: '2026-07-29T01:13:06.000Z',
        latitude: 37.7884567,
        longitude: -122.3871327,
        density: 18.75895818975081,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:11:06.000Z',
        end_time: '2026-07-29T01:12:06.000Z',
        latitude: 37.7884467,
        longitude: -122.3871402,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:11:06.000Z',
        end_time: '2026-07-29T01:12:06.000Z',
        latitude: 37.7884467,
        longitude: -122.3871402,
        density: 2.5329412778785088,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:11:06.000Z',
        end_time: '2026-07-29T01:12:06.000Z',
        latitude: 37.7884467,
        longitude: -122.3871402,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:10:06.000Z',
        end_time: '2026-07-29T01:11:06.000Z',
        latitude: 37.788447,
        longitude: -122.3871508,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:10:06.000Z',
        end_time: '2026-07-29T01:11:06.000Z',
        latitude: 37.788447,
        longitude: -122.3871508,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:10:06.000Z',
        end_time: '2026-07-29T01:11:06.000Z',
        latitude: 37.788447,
        longitude: -122.3871508,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T01:04:06.000Z',
        end_time: '2026-07-29T01:09:06.000Z',
        latitude: 37.78845,
        longitude: -122.3870833,
        density: 3.684210526315789,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T01:04:06.000Z',
        end_time: '2026-07-29T01:09:06.000Z',
        latitude: 37.78845,
        longitude: -122.3870833,
        density: 1.287063863035153,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:08:06.000Z',
        end_time: '2026-07-29T01:09:06.000Z',
        latitude: 37.7884322,
        longitude: -122.3871185,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:08:06.000Z',
        end_time: '2026-07-29T01:09:06.000Z',
        latitude: 37.7884322,
        longitude: -122.3871185,
        density: 0.024975281079658185,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:08:06.000Z',
        end_time: '2026-07-29T01:09:06.000Z',
        latitude: 37.7884322,
        longitude: -122.3871185,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T01:04:06.000Z',
        end_time: '2026-07-29T01:09:06.000Z',
        latitude: 37.78845,
        longitude: -122.3870833,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:07:06.000Z',
        end_time: '2026-07-29T01:08:06.000Z',
        latitude: 37.7884505,
        longitude: -122.3871428,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:07:06.000Z',
        end_time: '2026-07-29T01:08:06.000Z',
        latitude: 37.7884505,
        longitude: -122.3871428,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:07:06.000Z',
        end_time: '2026-07-29T01:08:06.000Z',
        latitude: 37.7884505,
        longitude: -122.3871428,
        density: 27.15107881436718,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:06:06.000Z',
        end_time: '2026-07-29T01:07:06.000Z',
        latitude: 37.788462,
        longitude: -122.3871578,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:06:06.000Z',
        end_time: '2026-07-29T01:07:06.000Z',
        latitude: 37.788462,
        longitude: -122.3871578,
        density: 15.344095085625238,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:06:06.000Z',
        end_time: '2026-07-29T01:07:06.000Z',
        latitude: 37.788462,
        longitude: -122.3871578,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:05:06.000Z',
        end_time: '2026-07-29T01:06:06.000Z',
        latitude: 37.7885065,
        longitude: -122.3871643,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:05:06.000Z',
        end_time: '2026-07-29T01:06:06.000Z',
        latitude: 37.7885065,
        longitude: -122.3871643,
        density: 33.46223426450665,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:05:06.000Z',
        end_time: '2026-07-29T01:06:06.000Z',
        latitude: 37.7885065,
        longitude: -122.3871643,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:04:06.000Z',
        end_time: '2026-07-29T01:05:06.000Z',
        latitude: 37.7884678,
        longitude: -122.3871393,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:04:06.000Z',
        end_time: '2026-07-29T01:05:06.000Z',
        latitude: 37.7884678,
        longitude: -122.3871393,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:04:06.000Z',
        end_time: '2026-07-29T01:05:06.000Z',
        latitude: 37.7884678,
        longitude: -122.3871393,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:03:06.000Z',
        end_time: '2026-07-29T01:04:06.000Z',
        latitude: 37.7885268,
        longitude: -122.3870778,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:03:06.000Z',
        end_time: '2026-07-29T01:04:06.000Z',
        latitude: 37.7885268,
        longitude: -122.3870778,
        density: 4.795475236207238,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:03:06.000Z',
        end_time: '2026-07-29T01:04:06.000Z',
        latitude: 37.7885268,
        longitude: -122.3870778,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T00:59:06.000Z',
        end_time: '2026-07-29T01:04:06.000Z',
        latitude: 37.7885,
        longitude: -122.3870333,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T00:59:06.000Z',
        end_time: '2026-07-29T01:04:06.000Z',
        latitude: 37.7885,
        longitude: -122.3870333,
        density: 0.18553333307431696,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T00:59:06.000Z',
        end_time: '2026-07-29T01:04:06.000Z',
        latitude: 37.7885,
        longitude: -122.3870333,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:02:06.000Z',
        end_time: '2026-07-29T01:03:06.000Z',
        latitude: 37.7885332,
        longitude: -122.387036,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:02:06.000Z',
        end_time: '2026-07-29T01:03:06.000Z',
        latitude: 37.7885332,
        longitude: -122.387036,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:02:06.000Z',
        end_time: '2026-07-29T01:03:06.000Z',
        latitude: 37.7885332,
        longitude: -122.387036,
        density: 27.467807906324634,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:01:06.000Z',
        end_time: '2026-07-29T01:02:06.000Z',
        latitude: 37.7888005,
        longitude: -122.3868213,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:01:06.000Z',
        end_time: '2026-07-29T01:02:06.000Z',
        latitude: 37.7888005,
        longitude: -122.3868213,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:01:06.000Z',
        end_time: '2026-07-29T01:02:06.000Z',
        latitude: 37.7888005,
        longitude: -122.3868213,
        density: 21.52433485489307,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T01:00:06.000Z',
        end_time: '2026-07-29T01:01:06.000Z',
        latitude: 37.7885857,
        longitude: -122.3870707,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T01:00:06.000Z',
        end_time: '2026-07-29T01:01:06.000Z',
        latitude: 37.7885857,
        longitude: -122.3870707,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T01:00:06.000Z',
        end_time: '2026-07-29T01:01:06.000Z',
        latitude: 37.7885857,
        longitude: -122.3870707,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:59:06.000Z',
        end_time: '2026-07-29T01:00:06.000Z',
        latitude: 37.7884128,
        longitude: -122.3871428,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:59:06.000Z',
        end_time: '2026-07-29T01:00:06.000Z',
        latitude: 37.7884128,
        longitude: -122.3871428,
        density: 11.13807874350277,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:59:06.000Z',
        end_time: '2026-07-29T01:00:06.000Z',
        latitude: 37.7884128,
        longitude: -122.3871428,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T00:54:06.000Z',
        end_time: '2026-07-29T00:59:06.000Z',
        latitude: 37.7885,
        longitude: -122.3870667,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T00:54:06.000Z',
        end_time: '2026-07-29T00:59:06.000Z',
        latitude: 37.7885,
        longitude: -122.3870667,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:58:06.000Z',
        end_time: '2026-07-29T00:59:06.000Z',
        latitude: 37.7884252,
        longitude: -122.3870978,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:58:06.000Z',
        end_time: '2026-07-29T00:59:06.000Z',
        latitude: 37.7884252,
        longitude: -122.3870978,
        density: 11.225920007090867,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:58:06.000Z',
        end_time: '2026-07-29T00:59:06.000Z',
        latitude: 37.7884252,
        longitude: -122.3870978,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T00:54:06.000Z',
        end_time: '2026-07-29T00:59:06.000Z',
        latitude: 37.7885,
        longitude: -122.3870667,
        density: 0.5263157894736842,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:57:06.000Z',
        end_time: '2026-07-29T00:58:06.000Z',
        latitude: 37.7884618,
        longitude: -122.387051,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:57:06.000Z',
        end_time: '2026-07-29T00:58:06.000Z',
        latitude: 37.7884618,
        longitude: -122.387051,
        density: 5.421090643996944,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:57:06.000Z',
        end_time: '2026-07-29T00:58:06.000Z',
        latitude: 37.7884618,
        longitude: -122.387051,
        density: 2.631578947368421,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:56:06.000Z',
        end_time: '2026-07-29T00:57:06.000Z',
        latitude: 37.7885055,
        longitude: -122.3868807,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:56:06.000Z',
        end_time: '2026-07-29T00:57:06.000Z',
        latitude: 37.7885055,
        longitude: -122.3868807,
        density: 12.659265215876513,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:56:06.000Z',
        end_time: '2026-07-29T00:57:06.000Z',
        latitude: 37.7885055,
        longitude: -122.3868807,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:55:06.000Z',
        end_time: '2026-07-29T00:56:06.000Z',
        latitude: 37.7883867,
        longitude: -122.3871307,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:55:06.000Z',
        end_time: '2026-07-29T00:56:06.000Z',
        latitude: 37.7883867,
        longitude: -122.3871307,
        density: 12.606937277331944,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:55:06.000Z',
        end_time: '2026-07-29T00:56:06.000Z',
        latitude: 37.7883867,
        longitude: -122.3871307,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T00:49:07.000Z',
        end_time: '2026-07-29T00:54:07.000Z',
        latitude: 37.7882833,
        longitude: -122.3871833,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T00:49:07.000Z',
        end_time: '2026-07-29T00:54:07.000Z',
        latitude: 37.7882833,
        longitude: -122.3871833,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T00:49:07.000Z',
        end_time: '2026-07-29T00:54:07.000Z',
        latitude: 37.7882833,
        longitude: -122.3871833,
        density: 17.51569595507863,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:53:06.000Z',
        end_time: '2026-07-29T00:54:06.000Z',
        latitude: 37.7883847,
        longitude: -122.38714,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:53:06.000Z',
        end_time: '2026-07-29T00:54:06.000Z',
        latitude: 37.7883847,
        longitude: -122.38714,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:53:06.000Z',
        end_time: '2026-07-29T00:54:06.000Z',
        latitude: 37.7883847,
        longitude: -122.38714,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:52:06.000Z',
        end_time: '2026-07-29T00:53:06.000Z',
        latitude: 37.788342,
        longitude: -122.3871965,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:52:06.000Z',
        end_time: '2026-07-29T00:53:06.000Z',
        latitude: 37.788342,
        longitude: -122.3871965,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:52:06.000Z',
        end_time: '2026-07-29T00:53:06.000Z',
        latitude: 37.788342,
        longitude: -122.3871965,
        density: 3.9759456806914573,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:51:06.000Z',
        end_time: '2026-07-29T00:52:06.000Z',
        latitude: 37.7885105,
        longitude: -122.3870997,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:51:06.000Z',
        end_time: '2026-07-29T00:52:06.000Z',
        latitude: 37.7885105,
        longitude: -122.3870997,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:51:06.000Z',
        end_time: '2026-07-29T00:52:06.000Z',
        latitude: 37.7885105,
        longitude: -122.3870997,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:50:06.000Z',
        end_time: '2026-07-29T00:51:06.000Z',
        latitude: 37.7891067,
        longitude: -122.3868042,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:50:06.000Z',
        end_time: '2026-07-29T00:51:06.000Z',
        latitude: 37.7891067,
        longitude: -122.3868042,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:50:06.000Z',
        end_time: '2026-07-29T00:51:06.000Z',
        latitude: 37.7891067,
        longitude: -122.3868042,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T00:44:07.000Z',
        end_time: '2026-07-29T00:49:07.000Z',
        latitude: 37.7885,
        longitude: -122.3870833,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T00:44:07.000Z',
        end_time: '2026-07-29T00:49:07.000Z',
        latitude: 37.7885,
        longitude: -122.3870833,
        density: 27.189874367680456,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T00:44:07.000Z',
        end_time: '2026-07-29T00:49:07.000Z',
        latitude: 37.7885,
        longitude: -122.3870833,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:48:06.000Z',
        end_time: '2026-07-29T00:49:06.000Z',
        latitude: 37.7886188,
        longitude: -122.3870075,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:48:06.000Z',
        end_time: '2026-07-29T00:49:06.000Z',
        latitude: 37.7886188,
        longitude: -122.3870075,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:48:06.000Z',
        end_time: '2026-07-29T00:49:06.000Z',
        latitude: 37.7886188,
        longitude: -122.3870075,
        density: 18.606772068376713,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:47:07.000Z',
        end_time: '2026-07-29T00:48:07.000Z',
        latitude: 37.7885823,
        longitude: -122.3870238,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:47:07.000Z',
        end_time: '2026-07-29T00:48:07.000Z',
        latitude: 37.7885823,
        longitude: -122.3870238,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:47:07.000Z',
        end_time: '2026-07-29T00:48:07.000Z',
        latitude: 37.7885823,
        longitude: -122.3870238,
        density: 0.8507589460647003,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:46:07.000Z',
        end_time: '2026-07-29T00:47:07.000Z',
        latitude: 37.7886095,
        longitude: -122.3870327,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:46:07.000Z',
        end_time: '2026-07-29T00:47:07.000Z',
        latitude: 37.7886095,
        longitude: -122.3870327,
        density: 9.11805091837711,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:46:07.000Z',
        end_time: '2026-07-29T00:47:07.000Z',
        latitude: 37.7886095,
        longitude: -122.3870327,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:45:07.000Z',
        end_time: '2026-07-29T00:46:07.000Z',
        latitude: 37.78846,
        longitude: -122.3870705,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:45:07.000Z',
        end_time: '2026-07-29T00:46:07.000Z',
        latitude: 37.78846,
        longitude: -122.3870705,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:45:07.000Z',
        end_time: '2026-07-29T00:46:07.000Z',
        latitude: 37.78846,
        longitude: -122.3870705,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:44:07.000Z',
        end_time: '2026-07-29T00:45:07.000Z',
        latitude: 37.7884547,
        longitude: -122.3871182,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:44:07.000Z',
        end_time: '2026-07-29T00:45:07.000Z',
        latitude: 37.7884547,
        longitude: -122.3871182,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:44:07.000Z',
        end_time: '2026-07-29T00:45:07.000Z',
        latitude: 37.7884547,
        longitude: -122.3871182,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T00:39:07.000Z',
        end_time: '2026-07-29T00:44:07.000Z',
        latitude: 37.7884667,
        longitude: -122.3871167,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T00:39:07.000Z',
        end_time: '2026-07-29T00:44:07.000Z',
        latitude: 37.7884667,
        longitude: -122.3871167,
        density: 5.831254818375831,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:43:07.000Z',
        end_time: '2026-07-29T00:44:07.000Z',
        latitude: 37.7884237,
        longitude: -122.3871053,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:43:07.000Z',
        end_time: '2026-07-29T00:44:07.000Z',
        latitude: 37.7884237,
        longitude: -122.3871053,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:43:07.000Z',
        end_time: '2026-07-29T00:44:07.000Z',
        latitude: 37.7884237,
        longitude: -122.3871053,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T00:39:07.000Z',
        end_time: '2026-07-29T00:44:07.000Z',
        latitude: 37.7884667,
        longitude: -122.3871167,
        density: 1.5789473684210527,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:42:07.000Z',
        end_time: '2026-07-29T00:43:07.000Z',
        latitude: 37.7884477,
        longitude: -122.3870963,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:42:07.000Z',
        end_time: '2026-07-29T00:43:07.000Z',
        latitude: 37.7884477,
        longitude: -122.3870963,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:42:07.000Z',
        end_time: '2026-07-29T00:43:07.000Z',
        latitude: 37.7884477,
        longitude: -122.3870963,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:41:07.000Z',
        end_time: '2026-07-29T00:42:07.000Z',
        latitude: 37.788396,
        longitude: -122.387119,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:41:07.000Z',
        end_time: '2026-07-29T00:42:07.000Z',
        latitude: 37.788396,
        longitude: -122.387119,
        density: 4.836820768584111,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:41:07.000Z',
        end_time: '2026-07-29T00:42:07.000Z',
        latitude: 37.788396,
        longitude: -122.387119,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:40:07.000Z',
        end_time: '2026-07-29T00:41:07.000Z',
        latitude: 37.7883938,
        longitude: -122.38712,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:40:07.000Z',
        end_time: '2026-07-29T00:41:07.000Z',
        latitude: 37.7883938,
        longitude: -122.38712,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:40:07.000Z',
        end_time: '2026-07-29T00:41:07.000Z',
        latitude: 37.7883938,
        longitude: -122.38712,
        density: 5.263157894736842,
        density_threshold: 5,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:39:07.000Z',
        end_time: '2026-07-29T00:40:07.000Z',
        latitude: 37.7883972,
        longitude: -122.3871292,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:39:07.000Z',
        end_time: '2026-07-29T00:40:07.000Z',
        latitude: 37.7883972,
        longitude: -122.3871292,
        density: 28.558087363148672,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:39:07.000Z',
        end_time: '2026-07-29T00:40:07.000Z',
        latitude: 37.7883972,
        longitude: -122.3871292,
        density: 2.631578947368421,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:38:07.000Z',
        end_time: '2026-07-29T00:39:07.000Z',
        latitude: 37.7884213,
        longitude: -122.3871367,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:38:07.000Z',
        end_time: '2026-07-29T00:39:07.000Z',
        latitude: 37.7884213,
        longitude: -122.3871367,
        density: 8.486360462732021,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:38:07.000Z',
        end_time: '2026-07-29T00:39:07.000Z',
        latitude: 37.7884213,
        longitude: -122.3871367,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T00:34:07.000Z',
        end_time: '2026-07-29T00:39:07.000Z',
        latitude: 37.7883833,
        longitude: -122.3871167,
        density: 3.1578947368421053,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T00:34:07.000Z',
        end_time: '2026-07-29T00:39:07.000Z',
        latitude: 37.7883833,
        longitude: -122.3871167,
        density: 23.196760781152697,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T00:34:07.000Z',
        end_time: '2026-07-29T00:39:07.000Z',
        latitude: 37.7883833,
        longitude: -122.3871167,
        density: 5.7894736842105265,
        density_threshold: 5,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:37:07.000Z',
        end_time: '2026-07-29T00:38:07.000Z',
        latitude: 37.7884708,
        longitude: -122.387099,
        density: 7.894736842105263,
        density_threshold: 5,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:37:07.000Z',
        end_time: '2026-07-29T00:38:07.000Z',
        latitude: 37.7884708,
        longitude: -122.387099,
        density: 15.789473684210526,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:37:07.000Z',
        end_time: '2026-07-29T00:38:07.000Z',
        latitude: 37.7884708,
        longitude: -122.387099,
        density: 11.35133408414367,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:36:07.000Z',
        end_time: '2026-07-29T00:37:07.000Z',
        latitude: 37.7884472,
        longitude: -122.3870995,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:36:07.000Z',
        end_time: '2026-07-29T00:37:07.000Z',
        latitude: 37.7884472,
        longitude: -122.3870995,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:36:07.000Z',
        end_time: '2026-07-29T00:37:07.000Z',
        latitude: 37.7884472,
        longitude: -122.3870995,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:35:07.000Z',
        end_time: '2026-07-29T00:36:07.000Z',
        latitude: 37.788372,
        longitude: -122.3872023,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:35:07.000Z',
        end_time: '2026-07-29T00:36:07.000Z',
        latitude: 37.788372,
        longitude: -122.3872023,
        density: 22.303468912452868,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:35:07.000Z',
        end_time: '2026-07-29T00:36:07.000Z',
        latitude: 37.788372,
        longitude: -122.3872023,
        density: 15.789473684210526,
        density_threshold: 5,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:34:07.000Z',
        end_time: '2026-07-29T00:35:07.000Z',
        latitude: 37.7884303,
        longitude: -122.387097,
        density: 5.263157894736842,
        density_threshold: 5,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:34:07.000Z',
        end_time: '2026-07-29T00:35:07.000Z',
        latitude: 37.7884303,
        longitude: -122.387097,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:34:07.000Z',
        end_time: '2026-07-29T00:35:07.000Z',
        latitude: 37.7884303,
        longitude: -122.387097,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T00:29:07.000Z',
        end_time: '2026-07-29T00:34:07.000Z',
        latitude: 37.7884333,
        longitude: -122.3870833,
        density: 1.5789473684210527,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:33:07.000Z',
        end_time: '2026-07-29T00:34:07.000Z',
        latitude: 37.7884918,
        longitude: -122.3870882,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:33:07.000Z',
        end_time: '2026-07-29T00:34:07.000Z',
        latitude: 37.7884918,
        longitude: -122.3870882,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:33:07.000Z',
        end_time: '2026-07-29T00:34:07.000Z',
        latitude: 37.7884918,
        longitude: -122.3870882,
        density: 5.263157894736842,
        density_threshold: 5,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T00:29:07.000Z',
        end_time: '2026-07-29T00:34:07.000Z',
        latitude: 37.7884333,
        longitude: -122.3870833,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T00:29:07.000Z',
        end_time: '2026-07-29T00:34:07.000Z',
        latitude: 37.7884333,
        longitude: -122.3870833,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:32:07.000Z',
        end_time: '2026-07-29T00:33:07.000Z',
        latitude: 37.788373,
        longitude: -122.387152,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:32:07.000Z',
        end_time: '2026-07-29T00:33:07.000Z',
        latitude: 37.788373,
        longitude: -122.387152,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:32:07.000Z',
        end_time: '2026-07-29T00:33:07.000Z',
        latitude: 37.788373,
        longitude: -122.387152,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:31:07.000Z',
        end_time: '2026-07-29T00:32:07.000Z',
        latitude: 37.7884102,
        longitude: -122.3870443,
        density: 10.526315789473683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:31:07.000Z',
        end_time: '2026-07-29T00:32:07.000Z',
        latitude: 37.7884102,
        longitude: -122.3870443,
        density: 32.29961362981829,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:31:07.000Z',
        end_time: '2026-07-29T00:32:07.000Z',
        latitude: 37.7884102,
        longitude: -122.3870443,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:30:07.000Z',
        end_time: '2026-07-29T00:31:07.000Z',
        latitude: 37.7884527,
        longitude: -122.386996,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:30:07.000Z',
        end_time: '2026-07-29T00:31:07.000Z',
        latitude: 37.7884527,
        longitude: -122.386996,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:30:07.000Z',
        end_time: '2026-07-29T00:31:07.000Z',
        latitude: 37.7884527,
        longitude: -122.386996,
        density: 2.631578947368421,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:29:07.000Z',
        end_time: '2026-07-29T00:30:07.000Z',
        latitude: 37.78829,
        longitude: -122.3870465,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:29:07.000Z',
        end_time: '2026-07-29T00:30:07.000Z',
        latitude: 37.78829,
        longitude: -122.3870465,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:29:07.000Z',
        end_time: '2026-07-29T00:30:07.000Z',
        latitude: 37.78829,
        longitude: -122.3870465,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T00:24:07.000Z',
        end_time: '2026-07-29T00:29:07.000Z',
        latitude: 37.7882833,
        longitude: -122.3874,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:28:07.000Z',
        end_time: '2026-07-29T00:29:07.000Z',
        latitude: 37.7884202,
        longitude: -122.3870737,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:28:07.000Z',
        end_time: '2026-07-29T00:29:07.000Z',
        latitude: 37.7884202,
        longitude: -122.3870737,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:28:07.000Z',
        end_time: '2026-07-29T00:29:07.000Z',
        latitude: 37.7884202,
        longitude: -122.3870737,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T00:24:07.000Z',
        end_time: '2026-07-29T00:29:07.000Z',
        latitude: 37.7882833,
        longitude: -122.3874,
        density: 2.1052631578947367,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T00:24:07.000Z',
        end_time: '2026-07-29T00:29:07.000Z',
        latitude: 37.7882833,
        longitude: -122.3874,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:27:07.000Z',
        end_time: '2026-07-29T00:28:07.000Z',
        latitude: 37.7883463,
        longitude: -122.3869762,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:27:07.000Z',
        end_time: '2026-07-29T00:28:07.000Z',
        latitude: 37.7883463,
        longitude: -122.3869762,
        density: 10.526315789473683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:27:07.000Z',
        end_time: '2026-07-29T00:28:07.000Z',
        latitude: 37.7883463,
        longitude: -122.3869762,
        density: 15.14145077355047,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:26:07.000Z',
        end_time: '2026-07-29T00:27:07.000Z',
        latitude: 37.788641,
        longitude: -122.3863622,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:26:07.000Z',
        end_time: '2026-07-29T00:27:07.000Z',
        latitude: 37.788641,
        longitude: -122.3863622,
        density: 27.55558810878916,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:26:07.000Z',
        end_time: '2026-07-29T00:27:07.000Z',
        latitude: 37.788641,
        longitude: -122.3863622,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:25:07.000Z',
        end_time: '2026-07-29T00:26:07.000Z',
        latitude: 37.7884307,
        longitude: -122.3870323,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:25:07.000Z',
        end_time: '2026-07-29T00:26:07.000Z',
        latitude: 37.7884307,
        longitude: -122.3870323,
        density: 9.351587940980878,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:25:07.000Z',
        end_time: '2026-07-29T00:26:07.000Z',
        latitude: 37.7884307,
        longitude: -122.3870323,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:24:07.000Z',
        end_time: '2026-07-29T00:25:07.000Z',
        latitude: 37.7884438,
        longitude: -122.3870783,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:24:07.000Z',
        end_time: '2026-07-29T00:25:07.000Z',
        latitude: 37.7884438,
        longitude: -122.3870783,
        density: 27.137529600564896,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:24:07.000Z',
        end_time: '2026-07-29T00:25:07.000Z',
        latitude: 37.7884438,
        longitude: -122.3870783,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T00:19:07.000Z',
        end_time: '2026-07-29T00:24:07.000Z',
        latitude: 37.7884333,
        longitude: -122.3870167,
        density: 2.1052631578947367,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T00:19:07.000Z',
        end_time: '2026-07-29T00:24:07.000Z',
        latitude: 37.7884333,
        longitude: -122.3870167,
        density: 30.777288468082507,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:23:07.000Z',
        end_time: '2026-07-29T00:24:07.000Z',
        latitude: 37.7884453,
        longitude: -122.3869915,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:23:07.000Z',
        end_time: '2026-07-29T00:24:07.000Z',
        latitude: 37.7884453,
        longitude: -122.3869915,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:23:07.000Z',
        end_time: '2026-07-29T00:24:07.000Z',
        latitude: 37.7884453,
        longitude: -122.3869915,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T00:19:07.000Z',
        end_time: '2026-07-29T00:24:07.000Z',
        latitude: 37.7884333,
        longitude: -122.3870167,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:22:07.000Z',
        end_time: '2026-07-29T00:23:07.000Z',
        latitude: 37.7884098,
        longitude: -122.3860855,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:22:07.000Z',
        end_time: '2026-07-29T00:23:07.000Z',
        latitude: 37.7884098,
        longitude: -122.3860855,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:22:07.000Z',
        end_time: '2026-07-29T00:23:07.000Z',
        latitude: 37.7884098,
        longitude: -122.3860855,
        density: 7.720113913052123,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:21:07.000Z',
        end_time: '2026-07-29T00:22:07.000Z',
        latitude: 37.7882443,
        longitude: -122.3834938,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:21:07.000Z',
        end_time: '2026-07-29T00:22:07.000Z',
        latitude: 37.7882443,
        longitude: -122.3834938,
        density: 15.38617648513208,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:21:07.000Z',
        end_time: '2026-07-29T00:22:07.000Z',
        latitude: 37.7882443,
        longitude: -122.3834938,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:20:07.000Z',
        end_time: '2026-07-29T00:21:07.000Z',
        latitude: 37.788436,
        longitude: -122.3838248,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:20:07.000Z',
        end_time: '2026-07-29T00:21:07.000Z',
        latitude: 37.788436,
        longitude: -122.3838248,
        density: 12.51145359357209,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:20:07.000Z',
        end_time: '2026-07-29T00:21:07.000Z',
        latitude: 37.788436,
        longitude: -122.3838248,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:19:07.000Z',
        end_time: '2026-07-29T00:20:07.000Z',
        latitude: 37.788723,
        longitude: -122.3842148,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:19:07.000Z',
        end_time: '2026-07-29T00:20:07.000Z',
        latitude: 37.788723,
        longitude: -122.3842148,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:19:07.000Z',
        end_time: '2026-07-29T00:20:07.000Z',
        latitude: 37.788723,
        longitude: -122.3842148,
        density: 14.927972279267951,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T00:14:07.000Z',
        end_time: '2026-07-29T00:19:07.000Z',
        latitude: 37.7888,
        longitude: -122.3843667,
        density: 5.263157894736842,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T00:14:07.000Z',
        end_time: '2026-07-29T00:19:07.000Z',
        latitude: 37.7888,
        longitude: -122.3843667,
        density: 3.5770243606564076,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:18:07.000Z',
        end_time: '2026-07-29T00:19:07.000Z',
        latitude: 37.7887733,
        longitude: -122.3849377,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:18:07.000Z',
        end_time: '2026-07-29T00:19:07.000Z',
        latitude: 37.7887733,
        longitude: -122.3849377,
        density: 29.77064767321563,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:18:07.000Z',
        end_time: '2026-07-29T00:19:07.000Z',
        latitude: 37.7887733,
        longitude: -122.3849377,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T00:14:07.000Z',
        end_time: '2026-07-29T00:19:07.000Z',
        latitude: 37.7888,
        longitude: -122.3843667,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:17:07.000Z',
        end_time: '2026-07-29T00:18:07.000Z',
        latitude: 37.7885017,
        longitude: -122.3867493,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:17:07.000Z',
        end_time: '2026-07-29T00:18:07.000Z',
        latitude: 37.7885017,
        longitude: -122.3867493,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:17:07.000Z',
        end_time: '2026-07-29T00:18:07.000Z',
        latitude: 37.7885017,
        longitude: -122.3867493,
        density: 0.9427786937186289,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:16:07.000Z',
        end_time: '2026-07-29T00:17:07.000Z',
        latitude: 37.7884815,
        longitude: -122.3869022,
        density: 2.631578947368421,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:16:07.000Z',
        end_time: '2026-07-29T00:17:07.000Z',
        latitude: 37.7884815,
        longitude: -122.3869022,
        density: 25.237777309939432,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:16:07.000Z',
        end_time: '2026-07-29T00:17:07.000Z',
        latitude: 37.7884815,
        longitude: -122.3869022,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:15:07.000Z',
        end_time: '2026-07-29T00:16:07.000Z',
        latitude: 37.7884332,
        longitude: -122.3855893,
        density: 10.526315789473683,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:15:07.000Z',
        end_time: '2026-07-29T00:16:07.000Z',
        latitude: 37.7884332,
        longitude: -122.3855893,
        density: 15.834721774040236,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:15:07.000Z',
        end_time: '2026-07-29T00:16:07.000Z',
        latitude: 37.7884332,
        longitude: -122.3855893,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:14:07.000Z',
        end_time: '2026-07-29T00:15:07.000Z',
        latitude: 37.7885192,
        longitude: -122.3848612,
        density: 13.157894736842104,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:14:07.000Z',
        end_time: '2026-07-29T00:15:07.000Z',
        latitude: 37.7885192,
        longitude: -122.3848612,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:14:07.000Z',
        end_time: '2026-07-29T00:15:07.000Z',
        latitude: 37.7885192,
        longitude: -122.3848612,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'low',
        start_time: '2026-07-29T00:09:07.000Z',
        end_time: '2026-07-29T00:14:07.000Z',
        latitude: 37.78855,
        longitude: -122.385,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:13:07.000Z',
        end_time: '2026-07-29T00:14:07.000Z',
        latitude: 37.7884687,
        longitude: -122.3867293,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:13:07.000Z',
        end_time: '2026-07-29T00:14:07.000Z',
        latitude: 37.7884687,
        longitude: -122.3867293,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:13:07.000Z',
        end_time: '2026-07-29T00:14:07.000Z',
        latitude: 37.7884687,
        longitude: -122.3867293,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'low',
        start_time: '2026-07-29T00:09:07.000Z',
        end_time: '2026-07-29T00:14:07.000Z',
        latitude: 37.78855,
        longitude: -122.385,
        density: 50,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'low',
        start_time: '2026-07-29T00:09:07.000Z',
        end_time: '2026-07-29T00:14:07.000Z',
        latitude: 37.78855,
        longitude: -122.385,
        density: 63.461696026264065,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:12:07.000Z',
        end_time: '2026-07-29T00:13:07.000Z',
        latitude: 37.788446,
        longitude: -122.3870778,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:12:07.000Z',
        end_time: '2026-07-29T00:13:07.000Z',
        latitude: 37.788446,
        longitude: -122.3870778,
        density: 100,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:12:07.000Z',
        end_time: '2026-07-29T00:13:07.000Z',
        latitude: 37.788446,
        longitude: -122.3870778,
        density: 96.55867427893249,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:11:07.000Z',
        end_time: '2026-07-29T00:12:07.000Z',
        latitude: 37.7884275,
        longitude: -122.3871462,
        density: 28.947368421052634,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:11:07.000Z',
        end_time: '2026-07-29T00:12:07.000Z',
        latitude: 37.7884275,
        longitude: -122.3871462,
        density: 0.7980555335017279,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:11:07.000Z',
        end_time: '2026-07-29T00:12:07.000Z',
        latitude: 37.7884275,
        longitude: -122.3871462,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:10:07.000Z',
        end_time: '2026-07-29T00:11:07.000Z',
        latitude: 37.7884185,
        longitude: -122.3872428,
        density: 100,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:10:07.000Z',
        end_time: '2026-07-29T00:11:07.000Z',
        latitude: 37.7884185,
        longitude: -122.3872428,
        density: 95.87534973834182,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:10:07.000Z',
        end_time: '2026-07-29T00:11:07.000Z',
        latitude: 37.7884185,
        longitude: -122.3872428,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:09:07.000Z',
        end_time: '2026-07-29T00:10:07.000Z',
        latitude: 37.7885175,
        longitude: -122.3924487,
        density: 21.052631578947366,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:09:07.000Z',
        end_time: '2026-07-29T00:10:07.000Z',
        latitude: 37.7885175,
        longitude: -122.3924487,
        density: 45.80264374113953,
        density_threshold: 20,
        is_detection: true,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:09:07.000Z',
        end_time: '2026-07-29T00:10:07.000Z',
        latitude: 37.7885175,
        longitude: -122.3924487,
        density: 0,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:07:14.000Z',
        end_time: '2026-07-29T00:08:14.000Z',
        latitude: 37.7884787,
        longitude: -122.3875135,
        density: 2.631578947368421,
        density_threshold: 5,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:07:14.000Z',
        end_time: '2026-07-29T00:08:14.000Z',
        latitude: 37.7884787,
        longitude: -122.3875135,
        density: 15.789473684210526,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:07:14.000Z',
        end_time: '2026-07-29T00:08:14.000Z',
        latitude: 37.7884787,
        longitude: -122.3875135,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'vessels',
        time_resolution: 'high',
        start_time: '2026-07-29T00:06:14.000Z',
        end_time: '2026-07-29T00:07:14.000Z',
        latitude: 37.7884478,
        longitude: -122.3875745,
        density: 0,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'boats',
        time_resolution: 'high',
        start_time: '2026-07-29T00:06:14.000Z',
        end_time: '2026-07-29T00:07:14.000Z',
        latitude: 37.7884478,
        longitude: -122.3875745,
        density: 1,
        density_threshold: 20,
        is_detection: false,
    },
    {
        bristlemouth_node_id: '0x1c8730e9f6379871',
        sensor_position: 1,
        classification: 'dolphins',
        time_resolution: 'high',
        start_time: '2026-07-29T00:06:14.000Z',
        end_time: '2026-07-29T00:07:14.000Z',
        latitude: 37.7884478,
        longitude: -122.3875745,
        density: 2.631578947368421,
        density_threshold: 5,
        is_detection: false,
    },
] as const;
